/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** @format int32 */
export enum ISystemReportType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
  Value8 = 8,
  Value9 = 9,
  Value10 = 10,
  Value11 = 11,
  Value12 = 12,
}

/** @format int32 */
export enum ISystemLogType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum IRecordSource {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum IRatingType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum IRatingScaleType {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum IRatingProcessGroup {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
  Value8 = 8,
}

/** @format int32 */
export enum IRatingMatrixDocumentStep {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
}

/** @format int32 */
export enum IPosition {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
  Value8 = 8,
  Value9 = 9,
  Value10 = 10,
  Value11 = 11,
  Value12 = 12,
  Value13 = 13,
  Value14 = 14,
  Value15 = 15,
  Value16 = 16,
  Value17 = 17,
  Value18 = 18,
  Value19 = 19,
  Value20 = 20,
  Value21 = 21,
}

/** @format int32 */
export enum IOperationType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
}

/** @format int32 */
export enum IMonitorStatusColor {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

/** @format int32 */
export enum IMessageType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

/** @format int32 */
export enum IMeasurementType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

/** @format int32 */
export enum ILanguageDirection {
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum IFrameworkTemplateStatus {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum IDocumentType {
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum IDirection {
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum IDashboardType {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
}

/** @format int32 */
export enum IContactType {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum IConflictOfIntesestOption {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

export interface IAgenda {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  /** @format int32 */
  protocolID: number;
  protocol: IProtocol | null;
}

export interface IAgreement {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  linkToFile: string | null;
  filePath: string | null;
  remarks: string | null;
  /** @format int32 */
  supplierID: number;
  supplier: ISupplier | null;
}

export interface IApproveRatingProcessStepRequest {
  /** @format int32 */
  ratingProcessID?: number;
  /** @format int32 */
  ratingProcessStepID?: number;
  /** @format int32 */
  clientDecisionID?: number | null;
  /** @format date-time */
  headOfFieldSignatureDate?: string | Date;
}

export interface IApproveTemplateRequest {
  approvedByUserID?: string | null;
  /** @format date-time */
  approvedDate?: string | Date;
}

export interface IBaseCommitteeMaterial {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface IBaseCommitteeResource {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface IBaseCommitteeSignificantChange {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface IBaseReportCheckup {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  /** @format int32 */
  rank: number;
}

export interface IBasisPoint {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  orderID: number;
  /** @format double */
  point: number;
  direction: IDirection | null;
  /** @format double */
  amount: number;
  remarks: string | null;
  order: IOrder | null;
}

export interface ICalculationRequest {
  /** @format int32 */
  templateId?: number;
  inputs?: ISubParameterInput[] | null;
  considerationNotches?: IConsiderationNotch[] | null;
  /** @format int32 */
  seedGradeScoreId?: number | null;
}

export interface ICalculationResult {
  /** @format double */
  matrixScore: number;
  matrixRating: string | null;
  matrixRatingAlpha: string | null;
  /** @format double */
  considerationsSum: number;
  /** @format double */
  finalScore: number;
  finalRating: string | null;
  finalRatingAlpha: string | null;
  parameters: IParameterResult[] | null;
  considerationLayers: IConsiderationLayerSubtotal[] | null;
}

export interface ICategory {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  sectorID: number;
  title: string | null;
  titleEng: string | null;
  sector: ISector | null;
}

export interface ICertificate {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  linkToFile: string | null;
  filePath: string | null;
  remarks: string | null;
  /** @format int32 */
  inventoryID: number;
  inventory: IInventory | null;
}

export interface ICharacteristicsReport {
  /** @format int32 */
  id: number;
  systemReportMessages: ISystemReportMessage[] | null;
  remarks: string | null;
  /** @format int32 */
  ratingPerformanceCategoryID: number | null;
  ratingPerformanceCategoryTitle: string | null;
  creditID: string | null;
  creditName: string | null;
  creditNameEng: string | null;
  sectorTitle: string | null;
  instrumentDescription: string | null;
  instrumentType: string | null;
  instrumentSeniority: string | null;
}

export interface ICheckModelsAssumption {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface IClientDecision {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface IClientInitiateRating {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface IClientPayRating {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface ICloneTemplateOverride {
  title: string | null;
  version: string | null;
}

export interface ICloudFileRemoveViewModel {
  filePath: string | null;
}

export interface ICommitteeManner {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface ICommitteePosition {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  isVoting: boolean;
}

export interface ICommitteeReport {
  /** @format int32 */
  id: number;
  systemReportMessages: ISystemReportMessage[] | null;
  remarks: string | null;
  /** @format int32 */
  ratingProcessNumber: number;
  /** @format int32 */
  ratingProcessTypeID: number;
  ratingProcessName: string | null;
  /** @format int32 */
  ratedEntityID: number;
  ratedEntityName: string | null;
  /** @format int32 */
  departmentID: number;
  departmentName: string | null;
  /** @format int32 */
  sectorID: number;
  sectorName: string | null;
  /** @format int32 */
  categoryID: number;
  categoryName: string | null;
  /** @format int32 */
  ratingID: number | null;
  ratingTitle: string | null;
  /** @format int32 */
  outlookID: number | null;
  outlookTitle: string | null;
  outlookTitleEng: string | null;
  /** @format date-time */
  committeeDate: string | Date;
  /** @format int32 */
  committeeTypeID: number;
  committeeTypeName: string | null;
  isNewCommittee: boolean;
}

export interface ICommitteeSignificantChangeType {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface ICommitteeType {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface ICompany {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  longTermMidroogRatingID: number | null;
  /** @format int32 */
  shortTermMidroogRatingID: number | null;
  /** @format int32 */
  baselineCreditAssesmentRatingID: number | null;
  /** @format int32 */
  bankLawerTier2CapitalRatingID: number | null;
  /** @format int32 */
  bankUpperTier2CapitalRatingID: number | null;
  /** @format int32 */
  bankTier1CapitalRatingID: number | null;
  /** @format int32 */
  bankCocosRatingID: number | null;
  /** @format int32 */
  insuranceFinancialStrengthRatingID: number | null;
  /** @format int32 */
  insuranceTier2CapitalRatingID: number | null;
  /** @format int32 */
  insuranceLawerTier2CapitalRatingID: number | null;
  /** @format int32 */
  insuranceComplexTier2CapitalRatingID: number | null;
  /** @format int32 */
  insuranceComplexTier3CapitalRatingID: number | null;
  /** @format int32 */
  midroogOutlookID: number | null;
  /** @format int32 */
  midroogRatingSymbolID: number | null;
  /** @format int32 */
  moodysRatingID: number | null;
  /** @format int32 */
  moodysOutlookID: number | null;
  /** @format int32 */
  maalotRatingID: number | null;
  /** @format int32 */
  maalotOutlookID: number | null;
  provisional: boolean;
  longTermMidroogRating: IMidroogRating | null;
  shortTermMidroogRating: IMidroogRating | null;
  baselineCreditAssesmentRating: IMidroogRating | null;
  bankLawerTier2CapitalRating: IMidroogRating | null;
  bankUpperTier2CapitalRating: IMidroogRating | null;
  bankTier1CapitalRating: IMidroogRating | null;
  bankCocosRating: IMidroogRating | null;
  insuranceFinancialStrengthRating: IMidroogRating | null;
  insuranceTier2CapitalRating: IMidroogRating | null;
  insuranceLawerTier2CapitalRating: IMidroogRating | null;
  insuranceComplexTier2CapitalRating: IMidroogRating | null;
  insuranceComplexTier3CapitalRating: IMidroogRating | null;
  midroogOutlook: IMidroogOutlook | null;
  midroogRatingSymbol: IMidroogRatingSymbol | null;
  moodysRating: IMoodysRating | null;
  moodysOutlook: IMoodysOutlook | null;
  maalotRating: IMaalotRating | null;
  maalotOutlook: IMaalotOutlook | null;
  /** @format int32 */
  sectorID: number;
  /** @format int32 */
  categoryID: number;
  /** @format int32 */
  companyTypeID: number | null;
  /** @format int32 */
  ratingPerformanceCategoryID: number | null;
  /** @format int32 */
  departmentID: number;
  teamLeaderUserID: string | null;
  analystUserID: string | null;
  /** @format int32 */
  performanceMidroogRatingID: number | null;
  /** @format int32 */
  performanceMidroogOutlookID: number | null;
  name: string | null;
  nameEng: string | null;
  performanceNameHeb: string | null;
  performanceNameEng: string | null;
  priorityKey: string | null;
  companyNumber: string | null;
  address: string | null;
  phone: string | null;
  fax: string | null;
  externalFileSystemLink: string | null;
  remarks: string | null;
  /** @format double */
  monitoringPrice: number | null;
  monitoringPeriod: boolean | null;
  monitoringPriorityOrderNumber: string | null;
  /** @format date-time */
  monitoringOrderDate: string | Date | null;
  base: string | null;
  /** @format double */
  monitoringPercentage: number | null;
  isFinancialInstrument: boolean;
  isPublic: boolean;
  isPublication: boolean;
  isRatedEntity: boolean;
  isIssuer: boolean;
  isInCommercialProcess: boolean;
  isInInitRatingProcess: boolean;
  category: ICategory | null;
  sector: ISector | null;
  companyType: ICompanyType | null;
  ratingPerformanceCategory: IRatingPerformanceCategory | null;
  department: IDepartment | null;
  performanceMidroogRating: IMidroogRating | null;
  performanceMidroogOutlook: IMidroogOutlook | null;
  teamLeader: IUserDetail | null;
  analyst: IUserDetail | null;
}

export interface ICompanyForMagnaReport {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  companyNumber: string | null;
}

export interface ICompanyRatedEntity {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  companyID: number;
  ratedEntityName: string | null;
  company: ICompany | null;
}

export interface ICompanyType {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface IComplianceItem {
  /** @format int32 */
  id: number;
  /** @format int32 */
  departmentID: number;
  departmentTitle: string | null;
  /** @format int32 */
  ratedEntityID: number;
  ratedEntityName: string | null;
  /** @format date-time */
  magnaPublicationDate: string | Date | null;
  /** @format date-time */
  reportDate: string | Date | null;
  /** @format date-time */
  websitePublicationDate: string | Date | null;
  ratingProcessTypeName: string | null;
  /** @format date-time */
  monitorSignatureDate: string | Date | null;
  monitorUserName: string | null;
  reportMessage: string | null;
  optionIsPublishInWebsite: boolean | null;
  optionIsReportedInMagna: boolean | null;
  publicationOptionTitle: string | null;
}

export interface IComplianceOfficerReport {
  /** @format int32 */
  id: number;
  systemReportMessages: ISystemReportMessage[] | null;
  remarks: string | null;
  /** @format int32 */
  ratingProcessID: number;
  /** @format int32 */
  departmentID: number;
  /** @format int32 */
  ratedEntityID: number;
  ratedEntityName: string | null;
  ratedEntityNameEng: string | null;
  /** @format int32 */
  ratingProcessTypeID: number;
  ratingProcessTypeName: string | null;
  ratingProcessTypeNameEng: string | null;
  /** @format date-time */
  committeeDate: string | Date | null;
  /** @format int32 */
  committeeCount: number;
  /** @format int32 */
  reportPublicationOptionID: number | null;
  reportPublicationOptionName: string | null;
  reportPublicationOptionNameEng: string | null;
  /** @format date-time */
  draftRequestDate: string | Date | null;
  /** @format date-time */
  draftResposeDate: string | Date | null;
  /** @format date-time */
  reportDate: string | Date | null;
  /** @format date-time */
  reportSentToClientDate: string | Date | null;
  /** @format date-time */
  magnaPublicationDate: string | Date | null;
  /** @format date-time */
  clientInformedDate: string | Date | null;
  /** @format date-time */
  websitePublicationDate: string | Date | null;
  monitorUserName: string | null;
  /** @format date-time */
  monitorSignatureDate: string | Date | null;
  monitorVotingSheetFilePath: string | null;
  monitorFinancialAnalysisFilePath: string | null;
  monitorOtherFilePath: string | null;
  monitorVotingSheetLinkToFile: string | null;
  monitorFinancialAnalysisLinkToFile: string | null;
  monitorOtherLinkToFile: string | null;
  monitorDescription: string | null;
  monitorStatusColor: string | null;
  isMonitorDone: boolean;
}

export interface IConsiderationLayerSubtotal {
  /** @format int32 */
  layerOrder: number;
  /** @format double */
  sum: number;
}

export interface IConsiderationNotch {
  /** @format int32 */
  considerationId: number;
  /** @format double */
  notch: number;
}

export interface IContact {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  companyID: number;
  contactType: IContactType | null;
  firstName: string | null;
  lastName: string | null;
  fullName: string | null;
  nameEng: string | null;
  email: string | null;
  phone: string | null;
  mobilePhone: string | null;
  position: string | null;
  remarks: string | null;
  company: ICompany | null;
}

export interface IContract {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  linkToFile: string | null;
  filePath: string | null;
  remarks: string | null;
  /** @format int32 */
  orderID: number;
  order: IOrder | null;
}

export interface IControllingGroup {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  /** @format int32 */
  issuerNumber: number | null;
}

export interface IControllingGroupCompany {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  controllingGroupID: number;
  /** @format int32 */
  companyID: number;
  controllingGroup: IControllingGroup | null;
  company: ICompany | null;
}

export interface ICreateRatingProcessRequest {
  /** @format int32 */
  ratedEntityID?: number;
  /** @format int32 */
  ratingProcessTypeID?: number;
  /** @format int32 */
  committeeTypeID?: number;
  /** @format int32 */
  linkedRatingProcessID?: number | null;
  /** @format int32 */
  orderID?: number | null;
  ratingProcessStepTypeIDs?: number[] | null;
}

export interface ICreditReviewItem {
  /** @format int32 */
  id: number;
  /** @format int32 */
  ratingProcessNumber: number;
  /** @format int32 */
  ratedEntityID: number;
  ratedEntityName: string | null;
  /** @format int32 */
  totalDaysFromLastRatingProcess: number;
  /** @format int32 */
  totalDaysInCreditReview: number;
  flag: boolean;
  message: string | null;
}

export interface ICreditReviewReport {
  /** @format int32 */
  id: number;
  systemReportMessages: ISystemReportMessage[] | null;
  remarks: string | null;
  /** @format int32 */
  ratingProcessNumber: number;
  /** @format int32 */
  departmentID: number;
  departmentName: string | null;
  /** @format int32 */
  sectorID: number;
  sectorName: string | null;
  /** @format int32 */
  ratedEntityID: number;
  ratedEntityName: string | null;
  /** @format int32 */
  totalDaysFromLastRatingProcess: number;
  /** @format int32 */
  totalDaysInCreditReview: number;
}

export interface ICurrentUserPermission {
  position: IPosition | null;
  isAllowToAddRatingProcess: boolean;
  isAllowToViewSettings: boolean;
  isAllowToViewOrders: boolean;
  isAllowToViewRatingProcesses: boolean;
  isAllowToViewMethodologies: boolean;
  isAllowToViewReports: boolean;
  isAllowToViewSeries: boolean;
  isAllowToViewTrainings: boolean;
  isAllowToViewEmployees: boolean;
  isAllowToViewSuppliers: boolean;
  isAllowToViewTasks: boolean;
  isAllowToViewDepartments: boolean;
  isAllowToViewContacts: boolean;
  isAllowToViewControllingGroups: boolean;
  isAllowToViewSectors: boolean;
  isAllowToViewProfessionalDocuments: boolean;
  isAllowToViewMethodologyProtocols: boolean;
  isAllowToViewMethodologyMemorandums: boolean;
  isAllowToViewProducts: boolean;
  isAllowToViewPaymentTransactions: boolean;
  isAllowToViewComercialProcesses: boolean;
  isAllowToViewOfficeAdministrations: boolean;
  isAllowToViewBoardMeetings: boolean;
  isAllowToViewInventories: boolean;
  isAllowToViewClients: boolean;
  isAllowToViewWebSitePublication: boolean;
  isAllowToViewQuarterlyMonitoring: boolean;
  isAllowToEditMethodologies: boolean;
  isAllowToDeleteRatingProcess: boolean;
  isAllowToViewComplianceReports: boolean;
  isAllowToViewCompanyReports: boolean;
  isAllowToViewSupportTicket: boolean;
  isAllowToEditSupportTicket: boolean;
  isAllowToViewSupportTicketBilling: boolean;
  isAllowToEditReports: boolean;
  isAllowToEditRatingPerformance: boolean;
  isAllowToViewRatingPerformance: boolean;
  isAllowToEditCompany: boolean;
  isAllowToEditSeries: boolean;
  isAllowToEditSeriesDetail: boolean;
  isAllowToViewCommitteeReports: boolean;
  isAllowToViewSeriesReports: boolean;
  isAllowToViewPreliminaryRatingReports: boolean;
  isAllowToViewRaisingCapitalReports: boolean;
  isAllowToViewTrainingReports: boolean;
  isAllowToViewMonitoringReports: boolean;
  isAllowToViewFinanceReports: boolean;
  isAllowToEditCompanyCommercial: boolean;
  isAllowToEditRatingProcess: boolean;
  isAllowToViewRatingPerformanceDashboard: boolean;
}

export interface ICurrentUserProfileResponse {
  userID?: string | null;
  /** @format int32 */
  departmentID?: number | null;
  departmentTitle?: string | null;
  /** @format int32 */
  positionID?: number;
  /** @format date-time */
  startDate?: string | Date;
  firstName?: string | null;
  lastName?: string | null;
  fullName?: string | null;
  nameEng?: string | null;
  picture?: string | null;
  positionTitle?: string | null;
  isDev?: boolean;
  dashboardType?: IDashboardType;
  currentUserPermission?: ICurrentUserPermission;
}

export interface IDefaultCommitteeMember {
  userID: string | null;
  fullName: string | null;
  /** @format int32 */
  positionID: number | null;
  /** @format int32 */
  departmentID: number | null;
  /** @format int32 */
  committeePositionID: number;
  roleTitle: string | null;
  /** @format int32 */
  votingOrder: number;
  isResolved: boolean;
}

export interface IDefaultCommitteeResult {
  /** @format int32 */
  companyID: number;
  companyName: string | null;
  /** @format int32 */
  departmentID: number | null;
  members: IDefaultCommitteeMember[] | null;
}

export interface IDepartment {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  isProfessional: boolean;
}

export interface IDepartmentAndDateRangeRequest {
  /** @format int32 */
  departmentID?: number | null;
  /** @format date-time */
  fromDate?: string | Date;
  /** @format date-time */
  toDate?: string | Date;
}

export interface IDepartmentDateRangeDynamicRequest {
  select?: string | null;
  filter?: string | null;
  orderBy?: string | null;
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
  count?: boolean;
  /** @format int32 */
  departmentID?: number | null;
  /** @format date-time */
  fromDate?: string | Date;
  /** @format date-time */
  toDate?: string | Date;
}

export interface IDepartmentDaysRangeDynamicRequest {
  select?: string | null;
  filter?: string | null;
  orderBy?: string | null;
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
  count?: boolean;
  /** @format int32 */
  departmentID?: number | null;
  /** @format int32 */
  fromDays?: number;
  /** @format int32 */
  toDays?: number;
}

export interface IDepartmentDynamicRequest {
  select?: string | null;
  filter?: string | null;
  orderBy?: string | null;
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
  count?: boolean;
  /** @format int32 */
  departmentID?: number | null;
}

export interface IDepartmentResponse {
  /** @format int32 */
  id?: number;
  title?: string | null;
}

export interface IDifferentThanForecast {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface IDiploma {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  linkToFile: string | null;
  filePath: string | null;
  remarks: string | null;
  userID: string | null;
  userDetail: IUserDetail | null;
}

export interface IDocumentationStatus {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  /** @format int32 */
  rank: number;
  monitorApproval1RatingProcesses: IRatingProcess[] | null;
  monitorApproval2RatingProcesses: IRatingProcess[] | null;
  monitorApproval3RatingProcesses: IRatingProcess[] | null;
  monitorApproval4RatingProcesses: IRatingProcess[] | null;
}

export interface IFinancialConventionType {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface IFinancialStatementTrendType {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface IGeneratePasswordRequest {
  email?: string | null;
}

export interface IGetListDynamic {
  select: string | null;
  filter: string | null;
  orderBy: string | null;
  /** @format int32 */
  take: number;
  /** @format int32 */
  skip: number;
  count: boolean;
  includeArchived: boolean;
}

export interface IGradeLadderResult {
  /** @format int32 */
  templateId: number;
  /** @format double */
  scoreRangeMin: number;
  /** @format double */
  scoreRangeMax: number;
  steps: IGradeLadderStep[] | null;
}

export interface IGradeLadderStep {
  /** @format int32 */
  ladderIndex: number;
  ladderLabel: string | null;
  /** @format double */
  scoreFrom: number;
  /** @format double */
  scoreTo: number;
  /** @format double */
  seedScore: number;
  /** @format int32 */
  gradeScoreId: number;
  gradeLabel: string | null;
}

export interface IHtmlFetchRequest {
  fileName?: string | null;
}

export interface IInventory {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  userID: string | null;
  /** @format int32 */
  supplierID: number | null;
  /** @format date-time */
  purchaseDate: string | Date;
  /** @format date-time */
  warrantyDate: string | Date | null;
  licenceKey: string | null;
  remarks: string | null;
  userDetail: IUserDetail | null;
  supplier: ISupplier | null;
}

export interface IJwtResponse {
  token?: string | null;
  refreshToken?: string | null;
}

export interface IKPIsResponse {
  /** @format int32 */
  totalOpenRatingProcesses?: number;
  /** @format int32 */
  totalRatingProcesses?: number;
}

export interface ILabel {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  /** @format int32 */
  languageID: number;
  labelKey: string | null;
  language: ILanguage | null;
}

export interface ILanguage {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  direction: ILanguageDirection | null;
  culture: string | null;
  icon: string | null;
  currency: string | null;
  /** @format int32 */
  rank: number;
  labels: ILabel[] | null;
}

export interface ILayoutMetaData {
  viewPermission?: string | null;
  editPermission?: string | null;
  deletePermission?: string | null;
}

export interface ILeadAnalystPerformanceItem {
  teamLeaderUserID: string | null;
  teamLeaderUserName: string | null;
  /** @format int32 */
  departmentID: number;
  departmentTitle: string | null;
  /** @format int32 */
  totalOpenRPs: number;
  /** @format int32 */
  totalCompanies: number;
}

export interface ILinkageBasisType {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface ILoginRequest {
  email?: string | null;
  code?: string | null;
}

export interface ILoginResponse {
  jwt?: IJwtResponse;
  /** @format date-time */
  expires?: string | Date;
}

export interface IMaalotOutlook {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  ratingMatrixes: IRatingMatrix[] | null;
}

export interface IMaalotRating {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  /** @format int32 */
  rank: number;
  ratingMatrixes: IRatingMatrix[] | null;
}

export interface IMagnaExportReportRequest {
  /** @format int32 */
  ratingProcessID?: number;
  leadAnalystID?: string | null;
  secondaryAnalystID?: string | null;
}

export interface IMagnaReport {
  /** @format int32 */
  id: number;
  systemReportMessages: ISystemReportMessage[] | null;
  remarks: string | null;
  /** @format int32 */
  ratingProcessID: number | null;
  ratingProcessName: string | null;
  /** @format date-time */
  ratingDate: string | Date;
  departmentTitle: string | null;
  ratedEntityType: string | null;
  companyNumber: string | null;
  /** @format int32 */
  ratedEntityID: number | null;
  issuerName: string | null;
  reportedOnEntityID: string | null;
  /** @format int32 */
  seriesID: number;
  seriesTitle: string | null;
  ratingSubject: string | null;
  rating: string | null;
  stablePositiveNegative: string | null;
  ratingSymbol: string | null;
  leadAnalyst: string | null;
  secondaryAnalyst: string | null;
  companyForMagnaReportTitle: string | null;
  /** @format date-time */
  ratingFirstPublicationDate: string | Date | null;
  /** @format date-time */
  ratingLastUpdateDate: string | Date | null;
  ratingSubjectTitle: string | null;
  ratingSubjectDetails: string | null;
  ratingInitiativeTitle: string | null;
  ratingInitiativeDetails: string | null;
  symbol: string | null;
  ratingAndTrackingMessageTitle: string | null;
  ratingAndTrackingMessageDetails: string | null;
  ratingStoppedReasonTitle: string | null;
  ratingStoppedReasonDetails: string | null;
  /** @format int32 */
  reportPublicationOptionID: number | null;
  reportPublicationOptionTitle: string | null;
  reportInMagna: boolean;
  includeInMagnaReportForPrivate: boolean;
}

export interface IMagnaSeries {
  /** @format int32 */
  seriesID: number;
  /** @format int32 */
  seriesDetailID: number;
  seriesTitle: string | null;
  symbol: string | null;
  /** @format date-time */
  ratingFirstPublicationDate: string | Date | null;
  /** @format date-time */
  ratingLastUpdateDate: string | Date | null;
  reportInMagna: boolean;
  /** @format int32 */
  companyForMagnaReportID: number | null;
  companyForMagnaReportName: string | null;
  /** @format int32 */
  ratingInitiativeID: number | null;
  ratingInitiativeDetails: string | null;
  /** @format int32 */
  ratingSubjectID: number | null;
  ratingSubjectDetails: string | null;
  /** @format int32 */
  ratingAndTrackingMessageID: number | null;
  ratingAndTrackingMessageDetails: string | null;
  /** @format int32 */
  ratingStoppedReasonID: number | null;
  ratingStoppedReasonDetails: string | null;
  /** @format int32 */
  ratingID: number | null;
  ratingTitle: string | null;
  /** @format int32 */
  outlookID: number | null;
  outlookTitle: string | null;
  /** @format int32 */
  ratingSymbolID: number | null;
  ratingSymbolTitle: string | null;
}

export interface IMeeting {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  companyID: number;
  /** @format int32 */
  meetingTypeID: number;
  /** @format date-time */
  meetingDate: string | Date;
  clientAttendees: string | null;
  comments: string | null;
  company: ICompany | null;
  meetingType: IMeetingType | null;
}

export interface IMeetingType {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface IMeetingUser {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  meetingID: number;
  userID: string | null;
  meeting: IMeeting | null;
  user: IUserDetail | null;
}

export interface IMemo {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  typeID: number;
  /** @format int32 */
  categoryID: number;
  headOfFieldID: string | null;
  teamMemberID: string | null;
  chiefCreditOfficerID: string | null;
  title: string | null;
  /** @format date-time */
  examinationDate: string | Date;
  /** @format date-time */
  methodologyPublishDate: string | Date;
  /** @format int32 */
  numberOfIssuers: number;
  remarks: string | null;
  memoType: IMemoType | null;
  category: ICategory | null;
  headOfField: IUserDetail | null;
  teamMember: IUserDetail | null;
  chiefCreditOfficer: IUserDetail | null;
}

export interface IMemoCommitteeMember {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  memoID: number;
  userID: string | null;
  memo: IMemo | null;
  user: IUserDetail | null;
}

export interface IMemoDocument {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  linkToFile: string | null;
  filePath: string | null;
  remarks: string | null;
  /** @format int32 */
  memoID: number;
  memo: IMemo | null;
}

export interface IMemoMethodology {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  methodologyID: number;
  /** @format int32 */
  memoID: number;
  methodology: IMethodology | null;
  memo: IMemo | null;
}

export interface IMemoQuestionAnswer {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  memoID: number;
  question: string | null;
  answer: string | null;
  memo: IMemo | null;
}

export interface IMemoSubMethodology {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  methodologyID: number;
  /** @format int32 */
  memoID: number;
  methodology: IMethodology | null;
  memo: IMemo | null;
}

export interface IMemoType {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface IMethodology {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  sectorID: number;
  /** @format int32 */
  categoryID: number;
  title: string | null;
  titleEng: string | null;
  description: string | null;
  descriptionEng: string | null;
  isMainMethodologyForCategory: boolean;
  category: ICategory | null;
  sector: ISector | null;
}

export interface IMethodologyDocument {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  linkToFile: string | null;
  filePath: string | null;
  remarks: string | null;
  /** @format int32 */
  methodologyID: number;
  methodology: IMethodology | null;
}

export interface IMethodologyProfessionalDocument {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  linkToFile: string | null;
  filePath: string | null;
  remarks: string | null;
}

export interface IMidroogOutlook {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  reported: boolean;
  titleExternalSystem: string | null;
}

export interface IMidroogRating {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  /** @format int32 */
  rank: number;
  longTermRating: boolean;
  bca: boolean;
  reported: boolean;
}

export interface IMidroogRatingSymbol {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface IMonitorDecisionType {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface IMonitorStatus {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  monitorStatusColor: IMonitorStatusColor | null;
}

export interface IMonitoringFinanceReport {
  /** @format int32 */
  id: number;
  systemReportMessages: ISystemReportMessage[] | null;
  remarks: string | null;
  /** @format int32 */
  ratedEntityID: number;
  ratedEntityName: string | null;
  /** @format int32 */
  sectorID: number;
  sectorName: string | null;
  /** @format int32 */
  categoryID: number;
  categoryName: string | null;
  /** @format int32 */
  departmentID: number;
  departmentName: string | null;
  controllingGroupNames: string | null;
  priorityOrderID: string | null;
  companyPriorityID: string | null;
  /** @format date-time */
  monitoringOrderDate: string | Date | null;
  /** @format double */
  monitoringPrice: number | null;
  ratedEntityIsActive: boolean;
}

export interface IMonitoringReport {
  /** @format int32 */
  id: number;
  systemReportMessages: ISystemReportMessage[] | null;
  remarks: string | null;
  /** @format int32 */
  ratedEntityID: number;
  ratedEntityName: string | null;
  /** @format int32 */
  departmentID: number;
  departmentName: string | null;
  /** @format int32 */
  lastRatingProcessID: number | null;
  /** @format int32 */
  lastRatingProcessTypeID: number | null;
  lastRatingProcessTypeName: string | null;
  /** @format date-time */
  lastRatingProcessDate: string | Date | null;
  /** @format int32 */
  lastMonitoringRatingProcessID: number | null;
  /** @format int32 */
  lastMonitoringRatingProcessTypeID: number | null;
  lastMonitoringRatingProcessTypeName: string | null;
  /** @format date-time */
  lastMonitoringRatingProcessDate: string | Date | null;
  /** @format int32 */
  nextMonitoringRatingProcessID: number | null;
  /** @format int32 */
  nextMonitoringRatingProcessTypeID: number | null;
  nextMonitoringRatingProcessTypeName: string | null;
  /** @format date-time */
  nextMonitoringRatingProcessDate: string | Date | null;
  /** @format int32 */
  reportPublicationOptionID: number | null;
  reportPublicationOptionName: string | null;
  /** @format date-time */
  reportDate: string | Date | null;
  /** @format int32 */
  orderRank: number;
}

export interface IMonitorsToOpenItem {
  /** @format int32 */
  companyID: number;
  companyName: string | null;
  /** @format int32 */
  departmentID: number;
  departmentTitle: string | null;
  /** @format date-time */
  lastReportDate: string | Date | null;
  /** @format double */
  nextRatingProcessDays: number | null;
}

export interface IMoodysOutlook {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface IMoodysRating {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  /** @format int32 */
  rank: number;
}

export interface INotification {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  message: string | null;
  /** @format date-time */
  startDate: string | Date;
  /** @format date-time */
  endDate: string | Date;
}

export interface INotificationUser {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  notificationID: number;
  userID: string | null;
  isRead: boolean;
  notification: INotification | null;
  userDetail: IUserDetail | null;
}

export interface IOpenRPsByCurrentStepItem {
  /** @format int32 */
  ratingProcessID: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format int32 */
  companyID: number;
  companyName: string | null;
  /** @format int32 */
  departmentID: number;
  departmentTitle: string | null;
  /** @format int32 */
  ratingProcessTypeID: number;
  ratingProcessTypeTitle: string | null;
}

export interface IOpenRPsByCurrentStepTotalItem {
  /** @format int32 */
  stepID: number;
  stepTitle: string | null;
  /** @format int32 */
  total: number;
}

export interface IOpenRPsByTypeItem {
  /** @format int32 */
  ratingProcessID: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format int32 */
  companyID: number;
  companyName: string | null;
  /** @format int32 */
  departmentID: number;
  departmentTitle: string | null;
  /** @format int32 */
  ratingProcessStepID: number;
  ratingProcessStepTitle: string | null;
}

export interface IOpenRPsByTypeTotalItem {
  /** @format int32 */
  typeID: number;
  typeTitle: string | null;
  /** @format int32 */
  total: number;
}

export interface IOperation {
  operationType?: IOperationType;
  path?: string | null;
  op?: string | null;
  from?: string | null;
  value?: any | null;
}

export interface IOrder {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  clientPayRatingID: number | null;
  /** @format int32 */
  clientInitiateRatingID: number | null;
  /** @format int32 */
  ratedEntityID: number;
  /** @format int32 */
  orderStatusID: number;
  /** @format int32 */
  orderStepID: number;
  /** @format int32 */
  orderSourceID: number;
  /** @format int32 */
  departmentID: number;
  title: string | null;
  /** @format date-time */
  orderDate: string | Date;
  /** @format date-time */
  leadDate: string | Date;
  priorityOrderID: string | null;
  agreementFilePath: string | null;
  remarks: string | null;
  /** @format double */
  monitoringPrice: number | null;
  /** @format double */
  capitalRaised: number | null;
  /** @format date-time */
  capitalRaiseDate: string | Date | null;
  issueCertificateFilePath: string | null;
  structuredFinance: boolean;
  internalUse: boolean;
  isPrivate: boolean;
  startMonitoring: boolean | null;
  isFavorite: boolean;
  isCompleted: boolean;
  clientPayRating: IClientPayRating | null;
  clientInitiateRating: IClientInitiateRating | null;
  ratedEntity: ICompany | null;
  orderStatus: IOrderStatus | null;
  orderStep: IOrderStep | null;
  orderSource: IOrderSource | null;
  department: IDepartment | null;
}

export interface IOrderDetail {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  orderID: number;
  /** @format int32 */
  productID: number;
  /** @format int32 */
  productStepID: number | null;
  title: string | null;
  /** @format double */
  price: number;
  remarks: string | null;
  order: IOrder | null;
  product: IProduct | null;
  productStep: IProductStep | null;
  hasRelatedTransaction: boolean;
}

export interface IOrderReport {
  /** @format int32 */
  id: number;
  systemReportMessages: ISystemReportMessage[] | null;
  remarks: string | null;
  /** @format int32 */
  orderID: number;
  /** @format int32 */
  ratedEntityID: number;
  ratedEntityName: string | null;
  /** @format int32 */
  departmentID: number;
  departmentName: string | null;
  priorityOrderID: string | null;
  companyPriorityID: string | null;
  /** @format date-time */
  orderDate: string | Date;
  productTitle: string | null;
  ratingProcessStatusTypeTitle: string | null;
  lastRatingProcessStepTitle: string | null;
  /** @format date-time */
  lastRatingProcessStepDate: string | Date | null;
  step1Title: string | null;
  /** @format double */
  step1Amount: number | null;
  /** @format date-time */
  step1Date: string | Date | null;
  step2Title: string | null;
  /** @format double */
  step2Amount: number | null;
  /** @format date-time */
  step2Date: string | Date | null;
  step3Title: string | null;
  /** @format double */
  step3Amount: number | null;
  /** @format date-time */
  step3Date: string | Date | null;
  step4Title: string | null;
  /** @format double */
  step4Amount: number | null;
  /** @format date-time */
  step4Date: string | Date | null;
  hasBasisPoint: boolean;
  basisPointTitle: string | null;
  /** @format double */
  basisPointAmount: number | null;
}

export interface IOrderSource {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface IOrderStatus {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  remarks: string | null;
}

export interface IOrderStep {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface IParameterResult {
  /** @format int32 */
  parameterId: number;
  /** @format double */
  weightedScore: number;
  derivedRating: string | null;
  derivedRatingAlpha: string | null;
  subParameters: ISubParameterResult[] | null;
}

export interface IPaymentTerm {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface IPaymentTransaction {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  clientID: number;
  /** @format int32 */
  orderID: number | null;
  /** @format int32 */
  orderDetailID: number | null;
  /** @format int32 */
  orderBasisPointID: number | null;
  /** @format int32 */
  productID: number;
  priorityOrderID: string | null;
  title: string | null;
  titleEng: string | null;
  porformaNumber: string | null;
  invoiceNumber: string | null;
  /** @format date-time */
  porformaDate: string | Date;
  /** @format date-time */
  invoiceDate: string | Date | null;
  /** @format date-time */
  nextPaymentDate: string | Date | null;
  /** @format double */
  amount: number;
  remarks: string | null;
  /** @format date-time */
  paymentDate: string | Date | null;
  isPaid: boolean;
  client: ICompany | null;
  order: IOrder | null;
  orderDetail: IOrderDetail | null;
  basisPoint: IBasisPoint | null;
  product: IProduct | null;
  lastRatingProcessStep: string | null;
  alertFlagColor: string | null;
}

export interface IPreliminaryRatingReport {
  /** @format int32 */
  id: number;
  systemReportMessages: ISystemReportMessage[] | null;
  remarks: string | null;
  /** @format int32 */
  ratingProcessNumber: number;
  ratingProcessName: string | null;
  /** @format int32 */
  ratingProcessTypeID: number;
  ratingProcessTypeName: string | null;
  /** @format int32 */
  ratedEntityID: number;
  ratedEntityName: string | null;
  /** @format int32 */
  departmentID: number;
  departmentName: string | null;
  /** @format int32 */
  sectorID: number;
  sectorName: string | null;
  /** @format int32 */
  categoryID: number;
  categoryName: string | null;
  /** @format date-time */
  ratingProcessStepDate: string | Date | null;
  /** @format int32 */
  ratingID: number | null;
  /** @format int32 */
  outlookID: number | null;
  ratingTitle: string | null;
  outlookTitle: string | null;
  outlookTitleEng: string | null;
  isReviewCompleted: boolean;
  isCommitteeCompleted: boolean;
  isOnlyReview: boolean;
}

export interface IProduct {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  remarks: string | null;
}

export interface IProductStep {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  /** @format int32 */
  productID: number;
  /** @format int32 */
  ratingProcessStepTypeID: number | null;
  /** @format double */
  defaultPrice: number;
  /** @format int32 */
  rank: number;
  product: IProduct | null;
  ratingProcessStepType: IRatingProcessStepType | null;
}

export interface IProtocol {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  protocolNumber: string | null;
  title: string | null;
  /** @format date-time */
  protocolDate: string | Date;
}

export interface IProtocolCommitteeMember {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  protocolID: number;
  userID: string | null;
  protocol: IProtocol | null;
  user: IUserDetail | null;
}

export interface IProtocolDocument {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  linkToFile: string | null;
  filePath: string | null;
  remarks: string | null;
  /** @format int32 */
  protocolID: number;
  protocol: IProtocol | null;
}

export interface IProtocolMemo {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  protocolID: number;
  /** @format int32 */
  memoID: number;
  protocol: IProtocol | null;
  memo: IMemo | null;
}

export interface IProtocolSubject {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  protocolID: number;
  title: string | null;
  discussion: string | null;
  decided: string | null;
  isMethodologyReport: boolean;
  isPublished: boolean;
  isMethodologyPeriodicReview: boolean;
  isApprovedMethodology: boolean;
  isPortfolioRatings: boolean;
  protocol: IProtocol | null;
}

export interface IProtocolSubjectDocument {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  linkToFile: string | null;
  filePath: string | null;
  remarks: string | null;
  /** @format int32 */
  protocolSubjectID: number;
  protocolSubject: IProtocolSubject | null;
}

export interface IProtocolViewer {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  protocolID: number;
  userID: string | null;
  protocol: IProtocol | null;
  user: IUserDetail | null;
}

export interface IPublicationApprovalType {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface IPublishType {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface IQuarterlyMonitoring {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  quarterlyMonitoringPeriodID: number;
  /** @format int32 */
  ratedEntityID: number;
  analystUserID: string | null;
  /** @format int32 */
  financialStatementTrendTypeID: number | null;
  financialStatementTrendTypeMark: boolean | null;
  financialStatementTrendTypeDescription: string | null;
  /** @format int32 */
  financialConventionTypeID: number | null;
  financialConventionTypeMark: boolean | null;
  financialConventionTypeDescription: string | null;
  immediateRepayment: string | null;
  immediateRepaymentMark: boolean | null;
  immediateRepaymentDescription: string | null;
  bdiLastCheckResult: string | null;
  bdiLastCheckResultMark: boolean | null;
  bdiLastCheckResultDescription: string | null;
  /** @format date-time */
  bdiCheckDate: string | Date | null;
  bdiCheckDateMark: boolean | null;
  bdiCheckDateDescription: string | null;
  /** @format double */
  bondRepayment: number | null;
  bondRepaymentMark: boolean | null;
  bondRepaymentDescription: string | null;
  /** @format double */
  cashBalance: number | null;
  cashBalanceMark: boolean | null;
  cashBalanceDescription: string | null;
  isCPARemark: boolean | null;
  isCPARemarkMark: boolean | null;
  isCPARemarkDescription: string | null;
  isImmediateRepaymentGroundsExamined: boolean | null;
  isImmediateRepaymentGroundsExaminedMark: boolean | null;
  isImmediateRepaymentGroundsExaminedDescription: string | null;
  isSeriesExaminedForQuarterlyMonitoring: boolean | null;
  isSeriesExaminedForQuarterlyMonitoringMark: boolean | null;
  isSeriesExaminedForQuarterlyMonitoringDescription: string | null;
  isNeedRatingReview: boolean | null;
  isNeedRatingReviewMark: boolean | null;
  isNeedRatingReviewDescription: string | null;
  remarks: string | null;
  ratedEntityMark: boolean | null;
  trusteeName: string | null;
  trusteeNameMark: boolean | null;
  trusteeNameDescription: string | null;
  trusteeComments: string | null;
  trusteeCommentsMark: boolean | null;
  trusteeCommentsDescription: string | null;
  substantiveIssues: string | null;
  substantiveIssuesMark: boolean | null;
  substantiveIssuesDescription: string | null;
  /** @format date-time */
  lastFinancialReport: string | Date | null;
  lastFinancialReportMark: boolean | null;
  lastFinancialReportDescription: string | null;
  /** @format int32 */
  signedOfficerStatementID: number | null;
  signedOfficerStatementMark: boolean | null;
  signedOfficerStatementDescription: string | null;
  /** @format int32 */
  securityPadsFullID: number | null;
  securityPadsFullMark: boolean | null;
  securityPadsFullDescription: string | null;
  /** @format int32 */
  differentThanForecastID: number | null;
  differentThanForecastMark: boolean | null;
  differentThanForecastDescription: string | null;
  /** @format int32 */
  checkModelsAssumptionID: number | null;
  checkModelsAssumptionMark: boolean | null;
  checkModelsAssumptionDescription: string | null;
  isMonitoredInLastQuarter: boolean;
  isIgnored: boolean;
  isCompleted: boolean;
  updateByLastQuarterly: string | null;
  updateByLastQuarterlyMark: boolean | null;
  bdiLastCheckChange: string | null;
  bdiLastCheckChangeMark: boolean | null;
  mainSeriesName: string | null;
  mainSeriesNameMark: boolean | null;
  mainSeriesNumber: string | null;
  mainSeriesNumberMark: boolean | null;
  /** @format int32 */
  linkageBasisTypeID: number | null;
  linkageBasisTypeMark: boolean | null;
  /** @format double */
  durationBruto: number | null;
  durationBrutoMark: boolean | null;
  /** @format double */
  yieldBruto: number | null;
  yieldBrutoMark: boolean | null;
  /** @format double */
  yieldBrutoYear: number | null;
  yieldBrutoYearMark: boolean | null;
  /** @format double */
  stockYield: number | null;
  stockYieldMark: boolean | null;
  isMark: boolean;
  quarterlyMonitoringPeriod: IQuarterlyMonitoringPeriod | null;
  ratedEntity: ICompany | null;
  analyst: IUserDetail | null;
  financialStatementTrendType: IFinancialStatementTrendType | null;
  financialConventionType: IFinancialConventionType | null;
  linkageBasisType: ILinkageBasisType | null;
  signedOfficerStatement: ISignedOfficerStatement | null;
  securityPadsFull: ISecurityPadsFull | null;
  checkModelsAssumption: ICheckModelsAssumption | null;
  differentThanForecast: IDifferentThanForecast | null;
}

export interface IQuarterlyMonitoringPeriod {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  departmentID: number;
  /** @format date-time */
  monitoringDate: string | Date;
  /** @format date-time */
  headOfFieldSignatureDate: string | Date | null;
  /** @format date-time */
  ceoSignatureDate: string | Date | null;
  meetingSummary: string | null;
  yieldsFilePath: string | null;
  isCompleted: boolean;
  department: IDepartment | null;
  isAnalystsStepCompleted: boolean | null;
}

export interface IQuarterlyMonitoringPeriodUser {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  quarterlyMonitoringPeriodID: number;
  userID: string | null;
  quarterlyMonitoringPeriod: IQuarterlyMonitoringPeriod | null;
  user: IUserDetail | null;
}

export interface IQueryOption {
  select?: string | null;
  filter?: string | null;
  orderBy?: string | null;
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
  count?: boolean;
}

export interface IRPCommercialItem {
  /** @format int32 */
  id: number;
  /** @format int32 */
  orderID: number | null;
  /** @format int32 */
  departmentID: number;
  departmentTitle: string | null;
  /** @format int32 */
  ratedEntityID: number;
  ratedEntityName: string | null;
  /** @format date-time */
  date: string | Date | null;
  title: string | null;
  priorityOrderID: string | null;
  /** @format int32 */
  statusID: number;
  status: string | null;
  instructions: string | null;
  dateType: string | null;
}

export interface IRaisedCapitalOrderItem {
  /** @format int32 */
  orderID: number;
  /** @format int32 */
  departmentID: number;
  departmentTitle: string | null;
  /** @format int32 */
  ratedEntityID: number;
  ratedEntityName: string | null;
  /** @format date-time */
  reportIssueDate: string | Date | null;
  title: string | null;
  priorityOrderID: string | null;
  /** @format double */
  capitalRaised: number | null;
  /** @format date-time */
  capitalRaiseDate: string | Date | null;
}

export interface IRaisingCapitalReport {
  /** @format int32 */
  id: number;
  systemReportMessages: ISystemReportMessage[] | null;
  remarks: string | null;
  /** @format int32 */
  ratedEntityID: number;
  ratedEntityName: string | null;
  /** @format int32 */
  departmentID: number;
  departmentName: string | null;
  /** @format int32 */
  ratingProcessNumber: number;
  /** @format int32 */
  ratingProcessTypeID: number;
  ratingProcessName: string | null;
  /** @format int32 */
  ratingProcessStatusID: number;
  ratingProcessStatusTitle: string | null;
  /** @format int32 */
  sectorID: number;
  sectorName: string | null;
  /** @format int32 */
  categoryID: number;
  categoryName: string | null;
  /** @format int32 */
  ratingProcessStepCommitteeID: number;
  /** @format int32 */
  ratingProcessStepReportID: number;
  /** @format date-time */
  committeeDate: string | Date;
  /** @format double */
  shortTermCapitalApproved: number | null;
  /** @format double */
  shortTermCapital: number | null;
  /** @format double */
  shortTermCapitalRaised: number | null;
  /** @format double */
  longTermCapitalApproved: number | null;
  /** @format double */
  longTermCapital: number | null;
  /** @format double */
  longTermCapitalRaised: number | null;
  /** @format double */
  longTermCapitalBalance: number | null;
  /** @format double */
  shortTermCapitalBalance: number | null;
}

export interface IRatedEntityReport {
  /** @format int32 */
  id: number;
  systemReportMessages: ISystemReportMessage[] | null;
  remarks: string | null;
  /** @format int32 */
  ratedEntityID: number;
  ratedEntityName: string | null;
  companyType: string | null;
  /** @format int32 */
  departmentID: number;
  departmentName: string | null;
  /** @format int32 */
  sectorID: number;
  sectorName: string | null;
  /** @format int32 */
  categoryID: number;
  categoryName: string | null;
  /** @format int32 */
  ratingID: number | null;
  ratingTitle: string | null;
  /** @format int32 */
  outlookID: number | null;
  /** @format date-time */
  lastTrackingDate: string | Date | null;
  outlookTitle: string | null;
  outlookTitleEng: string | null;
  controllingGroups: string | null;
  companyRatedEntities: string | null;
  /** @format int32 */
  companyRatedEntitiesTotal: number;
  teamLeaderUserID: string | null;
  teamLeaderUserName: string | null;
  analystUserID: string | null;
  analystUserName: string | null;
  isActive: boolean;
}

export interface IRatingAndTrackingMessage {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  moreInfo: boolean;
}

export interface IRatingHistory {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  creditID: string | null;
  /** @format int32 */
  keyID: number | null;
  /** @format int32 */
  midroogRatingID: number | null;
  /** @format int32 */
  companyID: number | null;
  /** @format int32 */
  midroogOutlookID: number | null;
  /** @format date-time */
  ratingStartDate: string | Date | null;
  ratingType: IRatingType | null;
  symbol: string | null;
  /** @format date-time */
  ratingEndDate: string | Date | null;
  company: ICompany | null;
  midroogRating: IMidroogRating | null;
  midroogOutlook: IMidroogOutlook | null;
  /** @format int32 */
  ratingPerformanceCategoryID: number | null;
}

export interface IRatingHistoryReport {
  /** @format int32 */
  id: number;
  systemReportMessages: ISystemReportMessage[] | null;
  remarks: string | null;
  /** @format int32 */
  ratingPerformanceCategoryID: number | null;
  creditID: string | null;
  creditName: string | null;
  creditNameEng: string | null;
  /** @format date-time */
  ratingStartDate: string | Date | null;
  rating: string | null;
  outlook: string | null;
  stockCode: string | null;
  /** @format date-time */
  ratingEndDate: string | Date | null;
}

export interface IRatingInitiative {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  moreInfo: boolean;
}

export interface IRatingMatrix {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  recordSource: IRecordSource | null;
  fileKey: string | null;
  creditID: string | null;
  keyID: string | null;
  /** @format int32 */
  companyID: number | null;
  /** @format int32 */
  ratingPerformanceCategoryID: number | null;
  /** @format int32 */
  seriesID: number | null;
  /** @format int32 */
  ratingToolID: number | null;
  /** @format int32 */
  midroogRatingID: number | null;
  /** @format int32 */
  midroogOutlookID: number | null;
  /** @format int32 */
  midroogRatingSymbolID: number | null;
  /** @format date-time */
  ratingDate: string | Date;
  /** @format date-time */
  initRatingDate: string | Date | null;
  /** @format date-time */
  lastRatingDate: string | Date | null;
  hebrewName: string | null;
  hebrewNameOld: string | null;
  englishName: string | null;
  englishNameOld: string | null;
  ratingPerformanceCategoryTitle: string | null;
  sector: string | null;
  category: string | null;
  ratedEntity: string | null;
  ratingToolTitle: string | null;
  seriesTitle: string | null;
  remarks: string | null;
  wizSector: string | null;
  wizCategory: string | null;
  wizRatedEntityTitle: string | null;
  wizRatedEntityTitleEng: string | null;
  wizSeriesTitle: string | null;
  wizRatingIsActive: boolean | null;
  /** @format date-time */
  wizLastCommitteeDate: string | Date | null;
  /** @format date-time */
  wizLastPublicationDate: string | Date | null;
  /** @format int32 */
  wizCurrentRatingID: number | null;
  /** @format int32 */
  wizCurrentOutlookID: number | null;
  /** @format int32 */
  wizCurrentRatingSymbolID: number | null;
  /** @format int32 */
  wizCurrentPerformanceRatingID: number | null;
  /** @format int32 */
  wizCurrentPerformanceOutlookID: number | null;
  /** @format int32 */
  wizMaalotRatingID: number | null;
  /** @format int32 */
  wizMaalotOutlookID: number | null;
  /** @format int32 */
  wizLastRatingProcessTypeID: number | null;
  company: ICompany | null;
  series: ISeries | null;
  ratingTool: IRatingTool | null;
  midroogRating: IMidroogRating | null;
  midroogOutlook: IMidroogOutlook | null;
  midroogRatingSymbol: IMidroogRatingSymbol | null;
  wizCurrentMidroogRating: IMidroogRating | null;
  wizCurrentMidroogOutlook: IMidroogOutlook | null;
  wizCurrentMidroogRatingSymbol: IMidroogRatingSymbol | null;
  wizCurrentPerformanceRating: IMidroogRating | null;
  wizCurrentPerformanceOutlook: IMidroogOutlook | null;
  maalotRating: IMaalotRating | null;
  maalotOutlook: IMaalotOutlook | null;
  ratingPerformanceCategory: IRatingPerformanceCategory | null;
  ratingProcessType: IRatingProcessType | null;
}

export interface IRatingMatrixDocument {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  /** @format int32 */
  ratingPerformanceCategoryID: number;
  step: IRatingMatrixDocumentStep | null;
  /** @format date-time */
  exportDate: string | Date;
  ratingsExcel: string | null;
  outlooksExcel: string | null;
  sectorExcel: string | null;
  ratingPerformanceCategory: IRatingPerformanceCategory | null;
}

export interface IRatingMatrixFramework {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  /** @format int32 */
  methodologyID: number | null;
  isArchived: boolean;
  createdByUserID: string | null;
  updatedByUserID: string | null;
  createdByName: string | null;
  updatedByName: string | null;
  methodology: IMethodology | null;
}

export interface IRatingMatrixFrameworkConsideration {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  frameworkTemplateID: number;
  title: string | null;
  description: string | null;
  /** @format int32 */
  sortOrder: number;
  /** @format int32 */
  notchLayerOrder: number | null;
  isOther: boolean;
  createdByUserID: string | null;
  updatedByUserID: string | null;
  createdByName: string | null;
  updatedByName: string | null;
  frameworkTemplate: IRatingMatrixFrameworkTemplate | null;
}

export interface IRatingMatrixFrameworkGradeScore {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  frameworkTemplateID: number;
  gradeLabel: string | null;
  /** @format double */
  numericScore: number;
  /** @format int32 */
  sortOrder: number;
  frameworkTemplate: IRatingMatrixFrameworkTemplate | null;
}

export interface IRatingMatrixFrameworkOption {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  subParameterID: number;
  /** @format int32 */
  gradeScoreID: number;
  description: string | null;
  subParameter: IRatingMatrixFrameworkSubParameter | null;
  gradeScore: IRatingMatrixFrameworkGradeScore | null;
}

export interface IRatingMatrixFrameworkParameter {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  frameworkTemplateID: number;
  title: string | null;
  /** @format double */
  weight: number;
  /** @format int32 */
  sortOrder: number;
  categoryTitle: string | null;
  /** @format int32 */
  categorySortOrder: number | null;
  frameworkTemplate: IRatingMatrixFrameworkTemplate | null;
  subParameters: IRatingMatrixFrameworkSubParameter[] | null;
}

export interface IRatingMatrixFrameworkRange {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  subParameterID: number;
  /** @format int32 */
  gradeScoreID: number;
  /** @format double */
  boundaryValue: number | null;
  subParameter: IRatingMatrixFrameworkSubParameter | null;
  gradeScore: IRatingMatrixFrameworkGradeScore | null;
}

export interface IRatingMatrixFrameworkSubParameter {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  parameterID: number;
  title: string | null;
  /** @format double */
  weight: number;
  /** @format int32 */
  sortOrder: number;
  measurementType: IMeasurementType | null;
  unit: string | null;
  isHigherBetter: boolean;
  hasConsiderations: boolean;
  groupTitle: string | null;
  /** @format int32 */
  groupSortOrder: number | null;
  /** @format int32 */
  derivedFromTemplateID: number | null;
  allowMultipleInstances: boolean;
  parameter: IRatingMatrixFrameworkParameter | null;
  derivedFromTemplate: IRatingMatrixFrameworkTemplate | null;
}

export interface IRatingMatrixFrameworkTemplate {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  ratingMatrixFrameworkID: number;
  version: string | null;
  title: string | null;
  status: IFrameworkTemplateStatus | null;
  /** @format double */
  scoreRangeMin: number;
  /** @format double */
  scoreRangeMax: number;
  ratingScaleType: IRatingScaleType | null;
  /** @format double */
  notchStep: number;
  /** @format double */
  maxNotchAdjustment: number;
  /** @format double */
  baseScenarioWeight: number | null;
  isSubSheet: boolean;
  /** @format int32 */
  clonedFromID: number | null;
  isArchived: boolean;
  createdByUserID: string | null;
  updatedByUserID: string | null;
  lockedByUserID: string | null;
  /** @format date-time */
  lockedDate: string | Date | null;
  approvedByUserID: string | null;
  /** @format date-time */
  approvedDate: string | Date | null;
  createdByName: string | null;
  updatedByName: string | null;
  lockedByName: string | null;
  approvedByName: string | null;
  ratingMatrixFramework: IRatingMatrixFramework | null;
  clonedFrom: IRatingMatrixFrameworkTemplate | null;
}

export interface IRatingMatrixImportPreviewResult {
  isValid: boolean;
  errors: string[] | null;
  warnings: string[] | null;
  previewHtml: string | null;
  suggestedTitle: string | null;
  suggestedVersionCode: string | null;
  /** @format int32 */
  variantCount: number;
  variantTitles: string[] | null;
}

export interface IRatingPerformanceCategory {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  ratingType: IRatingType | null;
  ratingMatrixDocuments: IRatingMatrixDocument[] | null;
}

export interface IRatingProcess {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  ratingProcessStatusID: number;
  /** @format int32 */
  orderID: number | null;
  /** @format int32 */
  ratedEntityID: number;
  /** @format int32 */
  departmentID: number;
  /** @format int32 */
  methodologyID: number | null;
  /** @format int32 */
  subMethodologyID: number | null;
  /** @format int32 */
  ratingProcessTypeID: number;
  headOfFieldUserID: string | null;
  teamLeaderUserID: string | null;
  analystUserID: string | null;
  /** @format int32 */
  monitorDecisionTypeID: number | null;
  /** @format int32 */
  monitorStatusID: number | null;
  monitorUserID: string | null;
  /** @format date-time */
  monitorSignatureDate: string | Date | null;
  monitorVotingSheetFilePath: string | null;
  monitorFinancialAnalysisFilePath: string | null;
  monitorOtherFilePath: string | null;
  monitorVotingSheetLinkToFile: string | null;
  monitorFinancialAnalysisLinkToFile: string | null;
  monitorOtherLinkToFile: string | null;
  monitorDescription: string | null;
  /** @format int32 */
  monitorApproval1DocumentationStatusID: number | null;
  /** @format int32 */
  monitorApproval2DocumentationStatusID: number | null;
  /** @format int32 */
  monitorApproval3DocumentationStatusID: number | null;
  /** @format int32 */
  monitorApproval4DocumentationStatusID: number | null;
  isMonitorDone: boolean;
  title: string | null;
  titleEng: string | null;
  /** @format date-time */
  discussionDate: string | Date | null;
  /** @format date-time */
  requestMaterialsDate: string | Date | null;
  /** @format date-time */
  responseMaterialsDate: string | Date | null;
  /** @format date-time */
  committeeDate: string | Date | null;
  /** @format date-time */
  reportIssueDate: string | Date | null;
  isCompleted: boolean;
  isUpdated: boolean;
  /** @format date-time */
  completeRatingProcessDate: string | Date | null;
  ratingProcessStatus: IRatingProcessStatus | null;
  order: IOrder | null;
  ratedEntity: ICompany | null;
  department: IDepartment | null;
  methodology: IMethodology | null;
  subMethodology: IMethodology | null;
  ratingProcessType: IRatingProcessType | null;
  headOfField: IUserDetail | null;
  teamLeader: IUserDetail | null;
  analyst: IUserDetail | null;
  monitorUser: IUserDetail | null;
  monitorApproval1DocumentationStatus: IDocumentationStatus | null;
  monitorApproval2DocumentationStatus: IDocumentationStatus | null;
  monitorApproval3DocumentationStatus: IDocumentationStatus | null;
  monitorApproval4DocumentationStatus: IDocumentationStatus | null;
  monitorDecisionType: IMonitorDecisionType | null;
  monitorStatus: IMonitorStatus | null;
  /** @format date-time */
  reportDate: string | Date | null;
}

export interface IRatingProcessDocumentation {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  linkToFile: string | null;
  filePath: string | null;
  remarks: string | null;
  /** @format int32 */
  ratingProcessID: number;
  userID: string | null;
  documentType: IDocumentType | null;
  ratingProcess: IRatingProcess | null;
  userDetail: IUserDetail | null;
}

export interface IRatingProcessFinanceReport {
  /** @format int32 */
  id: number;
  systemReportMessages: ISystemReportMessage[] | null;
  remarks: string | null;
  /** @format int32 */
  ratedEntityID: number;
  ratedEntityName: string | null;
  /** @format int32 */
  sectorID: number;
  sectorName: string | null;
  /** @format int32 */
  categoryID: number;
  categoryName: string | null;
  /** @format int32 */
  departmentID: number;
  departmentName: string | null;
  controllingGroupNames: string | null;
  priorityOrderID: string | null;
  companyPriorityID: string | null;
  clientPayRatingName: string | null;
  /** @format date-time */
  statusDate: string | Date | null;
  status: string | null;
  /** @format int32 */
  ratingProcessTypeID: number;
  /** @format int32 */
  orderID: number | null;
  ratingProcessTypeTitle: string | null;
  instractions: string | null;
}

export interface IRatingProcessForRatingPerformance {
  /** @format int32 */
  ratingPerformanceCategoryID: number | null;
  /** @format int32 */
  performanceMidroogRatingID: number | null;
  /** @format int32 */
  performanceMidroogOutlookID: number | null;
  /** @format int32 */
  midroogRatingID: number | null;
  /** @format int32 */
  midroogOutlookID: number | null;
  /** @format int32 */
  ratedEntityMidroogRatingID: number | null;
  /** @format int32 */
  ratedEntityMidroogOutlookID: number | null;
  /** @format int32 */
  id: number;
  /** @format int32 */
  ratingProcessTypeID: number;
  ratingProcessSubject: string | null;
  /** @format int32 */
  ratingProcessStatusID: number;
  ratingProcessStatusTitle: string | null;
  /** @format int32 */
  ratedEntityID: number;
  ratedEntityName: string | null;
  /** @format int32 */
  departmentID: number;
  departmentTitle: string | null;
  ratingPerformanceCategoryTitle: string | null;
  performanceMidroogRatingTitle: string | null;
  performanceMidroogOutlookTitle: string | null;
  midroogRatingTitle: string | null;
  midroogOutlookTitle: string | null;
  ratedEntityMidroogRatingTitle: string | null;
  ratedEntityMidroogOutlookTitle: string | null;
  /** @format date-time */
  reportDate: string | Date | null;
}

export interface IRatingProcessForRatingPerformanceBase {
  /** @format int32 */
  ratingPerformanceCategoryID: number | null;
  /** @format int32 */
  performanceMidroogRatingID: number | null;
  /** @format int32 */
  performanceMidroogOutlookID: number | null;
  /** @format int32 */
  midroogRatingID: number | null;
  /** @format int32 */
  midroogOutlookID: number | null;
  /** @format int32 */
  ratedEntityMidroogRatingID: number | null;
  /** @format int32 */
  ratedEntityMidroogOutlookID: number | null;
}

export interface IRatingProcessReport {
  /** @format int32 */
  id: number;
  systemReportMessages: ISystemReportMessage[] | null;
  remarks: string | null;
  /** @format int32 */
  ratingProcessNumber: number;
  /** @format int32 */
  departmentID: number;
  departmentName: string | null;
  /** @format int32 */
  ratingProcessTypeID: number;
  ratingProcessTypeName: string | null;
  /** @format date-time */
  ratingProcessDate: string | Date;
  /** @format int32 */
  ratingProcessStatusID: number;
  ratingProcessStatusTitle: string | null;
  teamLeaderUserID: string | null;
  teamLeaderName: string | null;
  /** @format date-time */
  reportDate: string | Date | null;
  /** @format int32 */
  reportPublicationOptionID: number | null;
  reportPublicationOptionTitle: string | null;
  /** @format int32 */
  ratedEntityID: number;
  ratedEntityName: string | null;
  priorityKey: string | null;
  clientPayRatingNames: string | null;
  clientInitiateRatingNames: string | null;
  /** @format int32 */
  sectorID: number;
  sectorName: string | null;
  /** @format int32 */
  orderID: number | null;
  priorityOrderID: string | null;
  currentProcessStep: string | null;
  /** @format date-time */
  committeeDate: string | Date | null;
  /** @format int32 */
  ratingID: number | null;
  /** @format int32 */
  outlookID: number | null;
  ratingTitle: string | null;
  outlookTitle: string | null;
  outlookTitleEng: string | null;
  isReportPublished: boolean;
  isCompleted: boolean;
}

export interface IRatingProcessStatus {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface IRatingProcessStep {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  ratingProcessID: number;
  /** @format int32 */
  ratingProcessStepTypeID: number;
  headOfFieldSignatureCode: string | null;
  /** @format date-time */
  headOfFieldSignatureDate: string | Date | null;
  /** @format date-time */
  clientUpdateDate: string | Date | null;
  /** @format int32 */
  clientDecisionID: number | null;
  isCompleted: boolean;
  ratingProcess: IRatingProcess | null;
  ratingProcessStepType: IRatingProcessStepType | null;
  clientDecision: IClientDecision | null;
  isUpdateCompleted: boolean | null;
}

export interface IRatingProcessStepCommittee {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  longTermMidroogRatingID: number | null;
  /** @format int32 */
  shortTermMidroogRatingID: number | null;
  /** @format int32 */
  baselineCreditAssesmentRatingID: number | null;
  /** @format int32 */
  bankLawerTier2CapitalRatingID: number | null;
  /** @format int32 */
  bankUpperTier2CapitalRatingID: number | null;
  /** @format int32 */
  bankTier1CapitalRatingID: number | null;
  /** @format int32 */
  bankCocosRatingID: number | null;
  /** @format int32 */
  insuranceFinancialStrengthRatingID: number | null;
  /** @format int32 */
  insuranceTier2CapitalRatingID: number | null;
  /** @format int32 */
  insuranceLawerTier2CapitalRatingID: number | null;
  /** @format int32 */
  insuranceComplexTier2CapitalRatingID: number | null;
  /** @format int32 */
  insuranceComplexTier3CapitalRatingID: number | null;
  /** @format int32 */
  midroogOutlookID: number | null;
  /** @format int32 */
  midroogRatingSymbolID: number | null;
  /** @format int32 */
  moodysRatingID: number | null;
  /** @format int32 */
  moodysOutlookID: number | null;
  /** @format int32 */
  maalotRatingID: number | null;
  /** @format int32 */
  maalotOutlookID: number | null;
  provisional: boolean;
  longTermMidroogRating: IMidroogRating | null;
  shortTermMidroogRating: IMidroogRating | null;
  baselineCreditAssesmentRating: IMidroogRating | null;
  bankLawerTier2CapitalRating: IMidroogRating | null;
  bankUpperTier2CapitalRating: IMidroogRating | null;
  bankTier1CapitalRating: IMidroogRating | null;
  bankCocosRating: IMidroogRating | null;
  insuranceFinancialStrengthRating: IMidroogRating | null;
  insuranceTier2CapitalRating: IMidroogRating | null;
  insuranceLawerTier2CapitalRating: IMidroogRating | null;
  insuranceComplexTier2CapitalRating: IMidroogRating | null;
  insuranceComplexTier3CapitalRating: IMidroogRating | null;
  midroogOutlook: IMidroogOutlook | null;
  midroogRatingSymbol: IMidroogRatingSymbol | null;
  moodysRating: IMoodysRating | null;
  moodysOutlook: IMoodysOutlook | null;
  maalotRating: IMaalotRating | null;
  maalotOutlook: IMaalotOutlook | null;
  /** @format int32 */
  ratingProcessStepID: number;
  /** @format int32 */
  committeeMannerID: number;
  /** @format int32 */
  committeeTypeID: number;
  /** @format date-time */
  lastVotingDate: string | Date | null;
  /** @format date-time */
  committeeDate: string | Date;
  restrictions: string | null;
  discussionIssueses: string | null;
  remarks: string | null;
  /** @format int32 */
  performanceMidroogRatingID: number | null;
  /** @format int32 */
  performanceMidroogOutlookID: number | null;
  /** @format date-time */
  examinedFinancialStatementDate: string | Date | null;
  isAdditionalPublications: boolean;
  isAdditionalMaterialsLate: boolean;
  additionalMaterialsLateRemarks: string | null;
  isMaterialsUpdated: boolean;
  isMaterialsVolumeEnough: boolean;
  isMaterialsReliable: boolean;
  materialsReservations: string | null;
  isChangeRatingMethod: boolean;
  changeRatingMethodRemarks: string | null;
  isRatingChangeImpact: boolean;
  isMatrixModelSaved: boolean;
  isHeadOfFieldFormulaAndParamsApproved: boolean;
  ratingChangeImpactRemarks: string | null;
  /** @format double */
  shortTermCapital: number | null;
  /** @format double */
  longTermCapitalApproved: number | null;
  /** @format double */
  shortTermCapitalApproved: number | null;
  /** @format double */
  longTermCapital: number | null;
  ratingDecisionRemarks: string | null;
  ratingProcessStep: IRatingProcessStep | null;
  committeeManner: ICommitteeManner | null;
  committeeType: ICommitteeType | null;
  performanceMidroogRating: IMidroogRating | null;
  performanceMidroogOutlook: IMidroogOutlook | null;
}

export interface IRatingProcessStepCommitteeMaterial {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  /** @format int32 */
  ratingProcessStepCommitteeID: number;
  isInclude: boolean;
  remarks: string | null;
  ratingProcessStepCommittee: IRatingProcessStepCommittee | null;
}

export interface IRatingProcessStepCommitteeMatrixBallot {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  committeeRatingMatrixFrameworkID: number;
  userID: string | null;
  /** @format int32 */
  committeePositionID: number;
  /** @format double */
  totalScore: number | null;
  /** @format int32 */
  midroogRatingID: number | null;
  /** @format int32 */
  midroogOutlookID: number | null;
  isSubmitted: boolean;
  /** @format date-time */
  submittedDate: string | Date | null;
  remarks: string | null;
  committeeRatingMatrixFramework: IRatingProcessStepCommitteeRatingMatrixFramework | null;
  user: IUserDetail | null;
  committeePosition: ICommitteePosition | null;
  midroogRating: IMidroogRating | null;
  midroogOutlook: IMidroogOutlook | null;
}

export interface IRatingProcessStepCommitteeMatrixBallotConsideration {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  ballotID: number;
  /** @format int32 */
  considerationID: number;
  /** @format double */
  notches: number | null;
  justification: string | null;
  ballot: IRatingProcessStepCommitteeMatrixBallot | null;
  consideration: IRatingMatrixFrameworkConsideration | null;
}

export interface IRatingProcessStepCommitteeMatrixBallotScore {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  ballotID: number;
  /** @format int32 */
  subParameterID: number;
  /** @format double */
  baseScore: number | null;
  /** @format double */
  score: number | null;
  isDeviation: boolean;
  deviationJustification: string | null;
  ballot: IRatingProcessStepCommitteeMatrixBallot | null;
  subParameter: IRatingMatrixFrameworkSubParameter | null;
}

export interface IRatingProcessStepCommitteeMatrixValue {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  committeeRatingMatrixFrameworkID: number;
  /** @format int32 */
  subParameterID: number;
  /** @format double */
  metricValue: number | null;
  remarks: string | null;
  committeeRatingMatrixFramework: IRatingProcessStepCommitteeRatingMatrixFramework | null;
  subParameter: IRatingMatrixFrameworkSubParameter | null;
}

export interface IRatingProcessStepCommitteeRatingMatrixFramework {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  ratingProcessStepCommitteeID: number;
  /** @format int32 */
  ratingMatrixFrameworkID: number;
  /** @format int32 */
  ratingMatrixFrameworkTemplateID: number | null;
  ratingProcessStepCommittee: IRatingProcessStepCommittee | null;
  ratingMatrixFramework: IRatingMatrixFramework | null;
  ratingMatrixFrameworkTemplate: IRatingMatrixFrameworkTemplate | null;
}

export interface IRatingProcessStepCommitteeResource {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  /** @format int32 */
  ratingProcessStepCommitteeID: number;
  isInclude: boolean;
  remarks: string | null;
  ratingProcessStepCommittee: IRatingProcessStepCommittee | null;
}

export interface IRatingProcessStepCommitteeScenario {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  /** @format int32 */
  ratingProcessStepCommitteeID: number;
  /** @format int32 */
  midroogRatingID: number | null;
  /** @format int32 */
  midroogOutlookID: number | null;
  isDecision: boolean;
  midroogRating: IMidroogRating | null;
  midroogOutlook: IMidroogOutlook | null;
  ratingProcessStepCommittee: IRatingProcessStepCommittee | null;
}

export interface IRatingProcessStepCommitteeSeriesRating {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  ratingProcessStepCommitteeID: number;
  /** @format int32 */
  seriesID: number;
  /** @format int32 */
  midroogRatingID: number | null;
  /** @format int32 */
  midroogOutlookID: number | null;
  /** @format int32 */
  midroogRatingSymbolID: number | null;
  provisional: boolean | null;
  ratingRemarks: string | null;
  ratingProcessStepCommittee: IRatingProcessStepCommittee | null;
  series: ISeries | null;
  midroogRating: IMidroogRating | null;
  midroogOutlook: IMidroogOutlook | null;
  midroogRatingSymbol: IMidroogRatingSymbol | null;
}

export interface IRatingProcessStepCommitteeSignificantChange {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  /** @format int32 */
  ratingProcessStepCommitteeID: number;
  /** @format int32 */
  committeeSignificantChangeTypeID: number;
  remarks: string | null;
  ratingProcessStepCommittee: IRatingProcessStepCommittee | null;
  committeeSignificantChangeType: ICommitteeSignificantChangeType | null;
}

export interface IRatingProcessStepCommitteeUser {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  ratingProcessStepCommitteeID: number;
  userID: string | null;
  /** @format int32 */
  committeePositionID: number;
  /** @format int32 */
  votingOrder: number;
  isAllowedToVote: boolean;
  conflictOfInterestsInfo: string | null;
  isNotConflictOfInterests: boolean | null;
  isConflictOfInterests: IConflictOfIntesestOption | null;
  ratingProcessStepCommittee: IRatingProcessStepCommittee | null;
  user: IUserDetail | null;
  committeePosition: ICommitteePosition | null;
}

export interface IRatingProcessStepCommitteeUserRatesEntityVoting {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  longTermMidroogRatingID: number | null;
  /** @format int32 */
  shortTermMidroogRatingID: number | null;
  /** @format int32 */
  baselineCreditAssesmentRatingID: number | null;
  /** @format int32 */
  bankLawerTier2CapitalRatingID: number | null;
  /** @format int32 */
  bankUpperTier2CapitalRatingID: number | null;
  /** @format int32 */
  bankTier1CapitalRatingID: number | null;
  /** @format int32 */
  bankCocosRatingID: number | null;
  /** @format int32 */
  insuranceFinancialStrengthRatingID: number | null;
  /** @format int32 */
  insuranceTier2CapitalRatingID: number | null;
  /** @format int32 */
  insuranceLawerTier2CapitalRatingID: number | null;
  /** @format int32 */
  insuranceComplexTier2CapitalRatingID: number | null;
  /** @format int32 */
  insuranceComplexTier3CapitalRatingID: number | null;
  /** @format int32 */
  midroogOutlookID: number | null;
  /** @format int32 */
  midroogRatingSymbolID: number | null;
  /** @format int32 */
  moodysRatingID: number | null;
  /** @format int32 */
  moodysOutlookID: number | null;
  /** @format int32 */
  maalotRatingID: number | null;
  /** @format int32 */
  maalotOutlookID: number | null;
  provisional: boolean;
  longTermMidroogRating: IMidroogRating | null;
  shortTermMidroogRating: IMidroogRating | null;
  baselineCreditAssesmentRating: IMidroogRating | null;
  bankLawerTier2CapitalRating: IMidroogRating | null;
  bankUpperTier2CapitalRating: IMidroogRating | null;
  bankTier1CapitalRating: IMidroogRating | null;
  bankCocosRating: IMidroogRating | null;
  insuranceFinancialStrengthRating: IMidroogRating | null;
  insuranceTier2CapitalRating: IMidroogRating | null;
  insuranceLawerTier2CapitalRating: IMidroogRating | null;
  insuranceComplexTier2CapitalRating: IMidroogRating | null;
  insuranceComplexTier3CapitalRating: IMidroogRating | null;
  midroogOutlook: IMidroogOutlook | null;
  midroogRatingSymbol: IMidroogRatingSymbol | null;
  moodysRating: IMoodysRating | null;
  moodysOutlook: IMoodysOutlook | null;
  maalotRating: IMaalotRating | null;
  maalotOutlook: IMaalotOutlook | null;
  /** @format int32 */
  ratingProcessStepCommitteeID: number;
  userID: string | null;
  /** @format int32 */
  committeePositionID: number;
  /** @format double */
  shortTermCapital: number | null;
  /** @format double */
  longTermCapital: number | null;
  ratingDecisionRemarks: string | null;
  ratingProcessStepCommittee: IRatingProcessStepCommittee | null;
  user: IUserDetail | null;
  committeePosition: ICommitteePosition | null;
}

export interface IRatingProcessStepCommitteeUserScenarioVoting {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  userID: string | null;
  /** @format int32 */
  ratingProcessStepCommitteeScenarioID: number;
  /** @format int32 */
  midroogRatingID: number | null;
  /** @format int32 */
  midroogOutlookID: number | null;
  user: IUserDetail | null;
  ratingProcessStepCommitteeScenario: IRatingProcessStepCommitteeScenario | null;
  midroogRating: IMidroogRating | null;
  midroogOutlook: IMidroogOutlook | null;
}

export interface IRatingProcessStepCommitteeUserSeriesVoting {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  ratingProcessStepCommitteeID: number;
  userID: string | null;
  /** @format int32 */
  seriesID: number;
  /** @format int32 */
  midroogRatingID: number | null;
  /** @format int32 */
  midroogOutlookID: number | null;
  ratingRemarks: string | null;
  ratingProcessStepCommittee: IRatingProcessStepCommittee | null;
  user: IUserDetail | null;
  series: ISeries | null;
  midroogRating: IMidroogRating | null;
  midroogOutlook: IMidroogOutlook | null;
}

export interface IRatingProcessStepPublication {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  ratingProcessStepID: number;
  /** @format int32 */
  reportID: number | null;
  headOfFieldUserID: string | null;
  teamLeaderUserID: string | null;
  analystUserID: string | null;
  /** @format int32 */
  reportPublicationOptionID: number | null;
  /** @format int32 */
  publicationApprovalTypeID: number | null;
  /** @format date-time */
  headOfFieldSignatureDate: string | Date | null;
  /** @format date-time */
  analystSignatureDate: string | Date | null;
  /** @format date-time */
  teamLeaderSignatureDate: string | Date | null;
  /** @format date-time */
  magnaPublicationDate: string | Date | null;
  /** @format date-time */
  websitePublicationDate: string | Date | null;
  confirmationFilePath: string | null;
  remarks: string | null;
  ratingProcessStep: IRatingProcessStep | null;
  report: IReport | null;
  reportPublicationOption: IReportPublicationOption | null;
  publicationApprovalType: IPublicationApprovalType | null;
  headOfField: IUserDetail | null;
  teamLeader: IUserDetail | null;
  analyst: IUserDetail | null;
}

export interface IRatingProcessStepPublicationCheckup {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  /** @format int32 */
  ratingProcessStepPublicationID: number;
  /** @format int32 */
  reportCheckupTypeID: number | null;
  headOfFieldApproval: boolean;
  analystApproval: boolean;
  remarks: string | null;
  /** @format int32 */
  rank: number;
  ratingProcessStepPublication: IRatingProcessStepPublication | null;
  reportCheckupType: IReportCheckupType | null;
}

export interface IRatingProcessStepQuarterlyMonitoring {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  ratingProcessStepID: number;
  analystUserID: string | null;
  /** @format date-time */
  monitoringDate: string | Date;
  /** @format int32 */
  financialStatementTrendTypeID: number | null;
  financialStatementTrendTypeMark: boolean | null;
  updateByLastQuarterly: string | null;
  updateByLastQuarterlyMark: boolean | null;
  /** @format int32 */
  financialConventionTypeID: number | null;
  financialConventionTypeMark: boolean | null;
  immediateRepayment: string | null;
  immediateRepaymentMark: boolean | null;
  bdiLastCheckResult: string | null;
  bdiLastCheckResultMark: boolean | null;
  bdiLastCheckChange: string | null;
  bdiLastCheckChangeMark: boolean | null;
  /** @format double */
  bondRepayment: number | null;
  bondRepaymentMark: boolean | null;
  /** @format double */
  cashBalance: number | null;
  cashBalanceMark: boolean | null;
  isCPARemark: boolean | null;
  isCPARemarkMark: boolean | null;
  /** @format double */
  stockYield: number | null;
  stockYieldMark: boolean | null;
  mainSeriesName: string | null;
  mainSeriesNameMark: boolean | null;
  mainSeriesNumber: string | null;
  mainSeriesNumberMark: boolean | null;
  /** @format int32 */
  linkageBasisTypeID: number | null;
  linkageBasisTypeMark: boolean | null;
  /** @format double */
  durationBruto: number | null;
  durationBrutoMark: boolean | null;
  /** @format double */
  yieldBruto: number | null;
  yieldBrutoMark: boolean | null;
  /** @format double */
  yieldBrutoYear: number | null;
  yieldBrutoYearMark: boolean | null;
  remarks: string | null;
  analyst: IUserDetail | null;
  ratingProcessStep: IRatingProcessStep | null;
  financialStatementTrendType: IFinancialStatementTrendType | null;
  financialConventionType: IFinancialConventionType | null;
  linkageBasisType: ILinkageBasisType | null;
}

export interface IRatingProcessStepReport {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  ratingProcessStepID: number;
  /** @format int32 */
  reportID: number | null;
  teamLeaderUserID: string | null;
  analystUserID: string | null;
  /** @format date-time */
  teamLeaderSignatureDate: string | Date | null;
  /** @format date-time */
  analystSignatureDate: string | Date | null;
  /** @format date-time */
  draftRequestDate: string | Date | null;
  /** @format date-time */
  draftResposeDate: string | Date | null;
  issuerContactName: string | null;
  isIssuerContactSeniorOfficer: boolean;
  issuerContactCertificate: string | null;
  /** @format double */
  shortTermCapital: number | null;
  /** @format double */
  shortTermCapitalRaised: number | null;
  /** @format double */
  longTermCapital: number | null;
  /** @format double */
  longTermCapitalRaised: number | null;
  remarks: string | null;
  isClientNotResponse: boolean;
  ratingProcessStep: IRatingProcessStep | null;
  report: IReport | null;
  teamLeader: IUserDetail | null;
  analyst: IUserDetail | null;
}

export interface IRatingProcessStepRequest {
  select?: string | null;
  filter?: string | null;
  orderBy?: string | null;
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
  count?: boolean;
  /** @format int32 */
  departmentID?: number | null;
  /** @format date-time */
  fromDate?: string | Date;
  /** @format date-time */
  toDate?: string | Date;
  /** @format int32 */
  ratingProcessStepID?: number;
}

export interface IRatingProcessStepReview {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  ratingProcessStepID: number;
  /** @format int32 */
  midroogRatingID: number | null;
  /** @format int32 */
  minRangeMidroogRatingID: number | null;
  /** @format int32 */
  maxRangeMidroogRatingID: number | null;
  review: string | null;
  /** @format date-time */
  reviewDate: string | Date;
  ratingProcessStep: IRatingProcessStep | null;
  midroogRating: IMidroogRating | null;
  minRangeMidroogRating: IMidroogRating | null;
  maxRangeMidroogRating: IMidroogRating | null;
}

export interface IRatingProcessStepReviewUser {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  ratingProcessStepReviewID: number;
  userID: string | null;
  ratingProcessStepReview: IRatingProcessStepReview | null;
  user: IUserDetail | null;
}

export interface IRatingProcessStepType {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface IRatingProcessStepUpdate {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  ratingProcessStepID: number;
  /** @format int32 */
  ratingProcessStepUpdateStatusID: number;
  headOfFieldSignatureCode: string | null;
  /** @format date-time */
  headOfFieldSignatureDate: string | Date | null;
  /** @format date-time */
  clientUpdateDate: string | Date | null;
  /** @format int32 */
  clientDecisionID: number | null;
  updateDescription: string | null;
  isCompleted: boolean;
  ratingProcessStep: IRatingProcessStep | null;
  ratingProcessStepUpdateStatus: IRatingProcessStepUpdateStatus | null;
  clientDecision: IClientDecision | null;
}

export interface IRatingProcessStepUpdateStatus {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface IRatingProcessType {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  /** @format int32 */
  ratingProcessTypeGroupID: number;
  isCommercial: boolean;
  isProfessional: boolean;
  ratingProcessTypeGroup: IRatingProcessTypeGroup | null;
}

export interface IRatingProcessTypeGroup {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  ratingProcessGroup: IRatingProcessGroup | null;
}

export interface IRatingProcessTypeOption {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  /** @format int32 */
  ratingProcessTypeID: number;
  /** @format int32 */
  ratingProcessStepTypeID: number;
  isMust: boolean;
  /** @format int32 */
  rank: number;
  ratingProcessType: IRatingProcessType | null;
  ratingProcessStepType: IRatingProcessStepType | null;
}

export interface IRatingProcessTypeRequest {
  select?: string | null;
  filter?: string | null;
  orderBy?: string | null;
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
  count?: boolean;
  /** @format int32 */
  departmentID?: number | null;
  /** @format date-time */
  fromDate?: string | Date;
  /** @format date-time */
  toDate?: string | Date;
  /** @format int32 */
  ratingProcessTypeID?: number;
}

export interface IRatingProcessUser {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  ratingProcessID: number;
  userID: string | null;
  ratingProcess: IRatingProcess | null;
  user: IUserDetail | null;
}

export interface IRatingStatus {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  isValidForRatingProcess: boolean;
}

export interface IRatingStoppedReason {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  moreInfo: boolean;
}

export interface IRatingSubject {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  moreInfo: boolean;
}

export interface IRatingTool {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface IRejectRatingProcessRequest {
  /** @format int32 */
  ratingProcessID?: number;
  /** @format int32 */
  stepID?: number;
  /** @format date-time */
  completeRatingProcessDate?: string | Date;
}

export interface IReport {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  longTermMidroogRatingID: number | null;
  /** @format int32 */
  shortTermMidroogRatingID: number | null;
  /** @format int32 */
  baselineCreditAssesmentRatingID: number | null;
  /** @format int32 */
  bankLawerTier2CapitalRatingID: number | null;
  /** @format int32 */
  bankUpperTier2CapitalRatingID: number | null;
  /** @format int32 */
  bankTier1CapitalRatingID: number | null;
  /** @format int32 */
  bankCocosRatingID: number | null;
  /** @format int32 */
  insuranceFinancialStrengthRatingID: number | null;
  /** @format int32 */
  insuranceTier2CapitalRatingID: number | null;
  /** @format int32 */
  insuranceLawerTier2CapitalRatingID: number | null;
  /** @format int32 */
  insuranceComplexTier2CapitalRatingID: number | null;
  /** @format int32 */
  insuranceComplexTier3CapitalRatingID: number | null;
  /** @format int32 */
  midroogOutlookID: number | null;
  /** @format int32 */
  midroogRatingSymbolID: number | null;
  /** @format int32 */
  moodysRatingID: number | null;
  /** @format int32 */
  moodysOutlookID: number | null;
  /** @format int32 */
  maalotRatingID: number | null;
  /** @format int32 */
  maalotOutlookID: number | null;
  provisional: boolean;
  longTermMidroogRating: IMidroogRating | null;
  shortTermMidroogRating: IMidroogRating | null;
  baselineCreditAssesmentRating: IMidroogRating | null;
  bankLawerTier2CapitalRating: IMidroogRating | null;
  bankUpperTier2CapitalRating: IMidroogRating | null;
  bankTier1CapitalRating: IMidroogRating | null;
  bankCocosRating: IMidroogRating | null;
  insuranceFinancialStrengthRating: IMidroogRating | null;
  insuranceTier2CapitalRating: IMidroogRating | null;
  insuranceLawerTier2CapitalRating: IMidroogRating | null;
  insuranceComplexTier2CapitalRating: IMidroogRating | null;
  insuranceComplexTier3CapitalRating: IMidroogRating | null;
  midroogOutlook: IMidroogOutlook | null;
  midroogRatingSymbol: IMidroogRatingSymbol | null;
  moodysRating: IMoodysRating | null;
  moodysOutlook: IMoodysOutlook | null;
  maalotRating: IMaalotRating | null;
  maalotOutlook: IMaalotOutlook | null;
  /** @format int32 */
  ratedEntityID: number;
  title: string | null;
  titleEng: string | null;
  /** @format date-time */
  reportDate: string | Date;
  linkToFile: string | null;
  filePath: string | null;
  remarks: string | null;
  isDraft: boolean;
  ratedEntity: ICompany | null;
}

export interface IReportCheckupType {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface IReportPublicationOption {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  isReportedInMagna: boolean;
  isPublishInWebSite: boolean;
}

export interface IReportSeries {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  reportID: number;
  /** @format int32 */
  seriesID: number;
  report: IReport | null;
  series: ISeries | null;
}

export interface IRequestedOrderItem {
  /** @format int32 */
  orderID: number;
  /** @format int32 */
  departmentID: number;
  departmentTitle: string | null;
  /** @format int32 */
  ratedEntityID: number;
  ratedEntityName: string | null;
  /** @format date-time */
  orderDate: string | Date;
  product: string | null;
  /** @format int32 */
  ratingProcessID: number;
  ratingProcessStatusTitle: string | null;
}

export interface ISector {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  /** @format int32 */
  departmentID: number;
  department: IDepartment | null;
}

export interface ISecurityPadsFull {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface ISeries {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  ratingToolID: number;
  /** @format int32 */
  publishTypeID: number;
  /** @format int32 */
  ratingStatusID: number;
  /** @format int32 */
  ratedEntityID: number | null;
  /** @format int32 */
  ratingInitiativeID: number | null;
  /** @format int32 */
  ratingSubjectID: number | null;
  /** @format int32 */
  companyForMagnaReportID: number | null;
  title: string | null;
  titleEng: string | null;
  titleExchange: string | null;
  performanceTitleHeb: string | null;
  performanceTitleEng: string | null;
  symbol: string | null;
  /** @format date-time */
  issueDate: string | Date | null;
  /** @format date-time */
  expirationDate: string | Date | null;
  /** @format date-time */
  ratingFirstPublicationDate: string | Date | null;
  /** @format date-time */
  ratingLastUpdateDate: string | Date | null;
  remarks: string | null;
  immediateRepaymentGrounds: string | null;
  ratingSubjectDetails: string | null;
  ratingInitiativeDetails: string | null;
  instrumentDescription: string | null;
  instrumentSeniority: string | null;
  instrumentType: string | null;
  reportInMagna: boolean;
  isDraft: boolean;
  includeInRatingPerformance: boolean;
  includeInMagnaReportForPublic: boolean;
  includeInMagnaReportForPrivate: boolean;
  companyForMagnaReport: ICompanyForMagnaReport | null;
  ratingTool: IRatingTool | null;
  publishType: IPublishType | null;
  ratingStatus: IRatingStatus | null;
  ratingInitiative: IRatingInitiative | null;
  ratingSubject: IRatingSubject | null;
  ratedEntity: ICompany | null;
  seriesClientPayRatingTitles: string | null;
  seriesClientInitiateRatingTitles: string | null;
}

export interface ISeriesClientInitiateRating {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  seriesID: number;
  /** @format int32 */
  clientInitiateRatingID: number;
  series: ISeries | null;
  clientInitiateRating: IClientInitiateRating | null;
}

export interface ISeriesClientPayRating {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  seriesID: number;
  /** @format int32 */
  clientPayRatingID: number;
  series: ISeries | null;
  clientPayRating: IClientPayRating | null;
}

export interface ISeriesDetail {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  longTermMidroogRatingID: number | null;
  /** @format int32 */
  shortTermMidroogRatingID: number | null;
  /** @format int32 */
  baselineCreditAssesmentRatingID: number | null;
  /** @format int32 */
  bankLawerTier2CapitalRatingID: number | null;
  /** @format int32 */
  bankUpperTier2CapitalRatingID: number | null;
  /** @format int32 */
  bankTier1CapitalRatingID: number | null;
  /** @format int32 */
  bankCocosRatingID: number | null;
  /** @format int32 */
  insuranceFinancialStrengthRatingID: number | null;
  /** @format int32 */
  insuranceTier2CapitalRatingID: number | null;
  /** @format int32 */
  insuranceLawerTier2CapitalRatingID: number | null;
  /** @format int32 */
  insuranceComplexTier2CapitalRatingID: number | null;
  /** @format int32 */
  insuranceComplexTier3CapitalRatingID: number | null;
  /** @format int32 */
  midroogOutlookID: number | null;
  /** @format int32 */
  midroogRatingSymbolID: number | null;
  /** @format int32 */
  moodysRatingID: number | null;
  /** @format int32 */
  moodysOutlookID: number | null;
  /** @format int32 */
  maalotRatingID: number | null;
  /** @format int32 */
  maalotOutlookID: number | null;
  provisional: boolean;
  longTermMidroogRating: IMidroogRating | null;
  shortTermMidroogRating: IMidroogRating | null;
  baselineCreditAssesmentRating: IMidroogRating | null;
  bankLawerTier2CapitalRating: IMidroogRating | null;
  bankUpperTier2CapitalRating: IMidroogRating | null;
  bankTier1CapitalRating: IMidroogRating | null;
  bankCocosRating: IMidroogRating | null;
  insuranceFinancialStrengthRating: IMidroogRating | null;
  insuranceTier2CapitalRating: IMidroogRating | null;
  insuranceLawerTier2CapitalRating: IMidroogRating | null;
  insuranceComplexTier2CapitalRating: IMidroogRating | null;
  insuranceComplexTier3CapitalRating: IMidroogRating | null;
  midroogOutlook: IMidroogOutlook | null;
  midroogRatingSymbol: IMidroogRatingSymbol | null;
  moodysRating: IMoodysRating | null;
  moodysOutlook: IMoodysOutlook | null;
  maalotRating: IMaalotRating | null;
  maalotOutlook: IMaalotOutlook | null;
  /** @format int32 */
  seriesID: number;
  /** @format int32 */
  ratingProcessID: number | null;
  /** @format int32 */
  performanceMidroogRatingID: number | null;
  /** @format int32 */
  performanceMidroogOutlookID: number | null;
  /** @format int32 */
  ratingAndTrackingMessageID: number | null;
  /** @format int32 */
  ratingStoppedReasonID: number | null;
  /** @format date-time */
  ratingDate: string | Date;
  /** @format double */
  initSize: number | null;
  /** @format double */
  outstandingDebtNominal: number | null;
  /** @format double */
  outstandingDebtNis: number | null;
  remarks: string | null;
  ratingAndTrackingMessageDetails: string | null;
  ratingStoppedReasonDetails: string | null;
  isInProgress: boolean;
  series: ISeries | null;
  ratingProcess: IRatingProcess | null;
  performanceMidroogRating: IMidroogRating | null;
  performanceMidroogOutlook: IMidroogOutlook | null;
  ratingAndTrackingMessage: IRatingAndTrackingMessage | null;
  ratingStoppedReason: IRatingStoppedReason | null;
}

export interface ISeriesDetailForRatingPerformanceBase {
  /** @format int32 */
  performanceMidroogRatingID: number | null;
  /** @format int32 */
  performanceMidroogOutlookID: number | null;
  includeInRatingPerformance: boolean;
  performanceTitleEng: string | null;
  instrumentType: string | null;
  instrumentSeniority: string | null;
  instrumentDescription: string | null;
}

export interface ISeriesReport {
  /** @format int32 */
  id: number;
  systemReportMessages: ISystemReportMessage[] | null;
  remarks: string | null;
  /** @format int32 */
  ratedEntityID: number;
  ratedEntityName: string | null;
  isRatedEntity: boolean;
  itemType: string | null;
  /** @format int32 */
  departmentID: number;
  departmentName: string | null;
  /** @format int32 */
  sectorID: number;
  sectorName: string | null;
  /** @format int32 */
  categoryID: number;
  categoryName: string | null;
  /** @format int32 */
  seriesID: number | null;
  seriesName: string | null;
  titleExchange: string | null;
  symbol: string | null;
  /** @format date-time */
  expirationDate: string | Date | null;
  /** @format int32 */
  ratingToolID: number | null;
  ratingToolTitle: string | null;
  /** @format int32 */
  publishTypeID: number | null;
  publishTypeTitle: string | null;
  /** @format int32 */
  ratingStatusID: number | null;
  ratingStatusTitle: string | null;
  isMaalotRating: boolean;
  /** @format int32 */
  ratingID: number | null;
  /** @format int32 */
  outlookID: number | null;
  ratingTitle: string | null;
  outlookTitle: string | null;
  outlookTitleEng: string | null;
  isPublicPublication: boolean;
}

export interface ISignedOfficerStatement {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface ISubParameterInput {
  /** @format int32 */
  subParameterId: number;
  /** @format double */
  rawValue: number | null;
  /** @format double */
  rawValueHistorical: number | null;
  /** @format int32 */
  selectedGradeScoreId: number | null;
  /** @format double */
  directScore: number | null;
  /** @format double */
  subParameterNotch: number | null;
  /** @format double */
  scoreOverride: number | null;
}

export interface ISubParameterResult {
  /** @format int32 */
  subParameterId: number;
  /** @format double */
  derivedScore: number;
  /** @format double */
  scoreAfterNotch: number;
  /** @format double */
  seededRawValue: number | null;
  /** @format int32 */
  seededGradeScoreId: number | null;
}

export interface ISupplier {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  paymentTermID: number;
  name: string | null;
  nameEng: string | null;
  priorityKey: string | null;
  address: string | null;
  phone: string | null;
  fax: string | null;
  contactFirstName: string | null;
  contactLastName: string | null;
  contactPhone: string | null;
  contactEmail: string | null;
  /** @format date-time */
  aggreementDate: string | Date | null;
  remarks: string | null;
  paymentTerm: IPaymentTerm | null;
}

export interface ISupportTicket {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  linkToFile: string | null;
  filePath: string | null;
  remarks: string | null;
  requestedByUserID: string | null;
  /** @format int32 */
  supportTicketStatusID: number;
  /** @format int32 */
  supportTicketApplicationID: number;
  /** @format int32 */
  supportTicketPriorityID: number;
  /** @format int32 */
  supportTicketTypeID: number;
  /** @format date-time */
  billingDate: string | Date;
  /** @format double */
  billableHours: number | null;
  /** @format double */
  workHours: number | null;
  /** @format double */
  estimatedHours: number | null;
  /** @format date-time */
  closeDate: string | Date | null;
  comments: string | null;
  isCompleted: boolean;
  requestedByUser: IUserDetail | null;
  supportTicketType: ISupportTicketType | null;
  supportTicketStatus: ISupportTicketStatus | null;
  supportTicketApplication: ISupportTicketApplication | null;
  supportTicketPriority: ISupportTicketPriority | null;
}

export interface ISupportTicketApplication {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface ISupportTicketDocument {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  linkToFile: string | null;
  filePath: string | null;
  remarks: string | null;
  /** @format int32 */
  supportTicketID: number;
  supportTicket: ISupportTicket | null;
}

export interface ISupportTicketPriority {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface ISupportTicketStatus {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface ISupportTicketType {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
}

export interface ISupportTicketUser {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  /** @format int32 */
  supportTicketID: number;
  userID: string | null;
  supportTicket: ISupportTicket | null;
  user: IUserDetail | null;
}

export interface ISystemLog {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  userID: string | null;
  message: string | null;
  controllerName: string | null;
  methodName: string | null;
  systemLogType: ISystemLogType | null;
  userDetail: IUserDetail | null;
}

export interface ISystemReport {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  linkToFile: string | null;
  filePath: string | null;
  remarks: string | null;
  userID: string | null;
  systemReportType: ISystemReportType | null;
  /** @format date-time */
  reportDate: string | Date;
  isLock: boolean;
  userDetail: IUserDetail | null;
}

export interface ISystemReportMessage {
  flag: boolean;
  messageType: IMessageType | null;
  message: string | null;
  messageEng: string | null;
}

export interface ITraining {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  instructors: string | null;
  /** @format date-time */
  trainingDate: string | Date;
  /** @format int32 */
  duration: number | null;
  remarks: string | null;
  isExternal: boolean;
}

export interface ITrainingReport {
  /** @format int32 */
  id: number;
  systemReportMessages: ISystemReportMessage[] | null;
  remarks: string | null;
  /** @format int32 */
  departmentID: number | null;
  departmentName: string | null;
  userID: string | null;
  userName: string | null;
  /** @format date-time */
  trainingDate: string | Date;
  /** @format int32 */
  trainingID: number;
  trainingTitle: string | null;
  instructors: string | null;
  /** @format int32 */
  duration: number | null;
  isExternal: boolean;
}

export interface IUserCategoryVotingCertification {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  userID: string | null;
  /** @format int32 */
  categoryID: number;
  /** @format date-time */
  empowerDate: string | Date;
  remarks: string | null;
  isCommitteeLeader: boolean;
  userDetail: IUserDetail | null;
  category: ICategory | null;
}

export interface IUserCompanyConflictOfInterest {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  userID: string | null;
  /** @format int32 */
  companyID: number;
  remarks: string | null;
  userDetail: IUserDetail | null;
  company: ICompany | null;
}

export interface IUserDepartmentVotingCertification {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  userID: string | null;
  /** @format int32 */
  departmentID: number;
  userDetail: IUserDetail | null;
  department: IDepartment | null;
}

export interface IUserDetail {
  userID: string | null;
  /** @format date-time */
  startDate: string | Date;
  email: string | null;
  mobilePhone: string | null;
  firstName: string | null;
  lastName: string | null;
  fullName: string | null;
  nameEng: string | null;
  phone: string | null;
  isActive: boolean;
  isSystemUser: boolean;
  /** @format date-time */
  generatePasswordEndDate: string | Date | null;
  /** @format int32 */
  departmentID: number | null;
  /** @format int32 */
  positionID: number;
  education: string | null;
  experience: string | null;
  picture: string | null;
  conflictOfInterestsInfo: string | null;
  isConflictOfInterests: boolean;
  department: IDepartment | null;
  userPosition: IUserPosition | null;
}

export interface IUserPosition {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  title: string | null;
  titleEng: string | null;
  position: IPosition | null;
  /** @format int32 */
  votingOrder: number;
  isAllowToAddRatingProcess: boolean;
  isAllowToViewSettings: boolean;
  isAllowToViewOrders: boolean;
  isAllowToViewRatingProcesses: boolean;
  isAllowToViewMethodologies: boolean;
  isAllowToViewReports: boolean;
  isAllowToViewSeries: boolean;
  isAllowToViewTrainings: boolean;
  isAllowToViewEmployees: boolean;
  isAllowToViewSuppliers: boolean;
  isAllowToViewTasks: boolean;
  isAllowToViewDepartments: boolean;
  isAllowToViewContacts: boolean;
  isAllowToViewControllingGroups: boolean;
  isAllowToViewSectors: boolean;
  isAllowToViewProfessionalDocuments: boolean;
  isAllowToViewMethodologyProtocols: boolean;
  isAllowToViewMethodologyMemorandums: boolean;
  isAllowToViewProducts: boolean;
  isAllowToViewPaymentTransactions: boolean;
  isAllowToViewComercialProcesses: boolean;
  isAllowToViewOfficeAdministrations: boolean;
  isAllowToViewBoardMeetings: boolean;
  isAllowToViewInventories: boolean;
  isAllowToViewClients: boolean;
  isAllowToViewWebSitePublication: boolean;
  isAllowToViewQuarterlyMonitoring: boolean;
  isAllowToEditMethodologies: boolean;
  isAllowToDeleteRatingProcess: boolean;
  isAllowToViewComplianceReports: boolean;
  isAllowToViewCompanyReports: boolean;
  isAllowToViewSupportTicket: boolean;
  isAllowToEditSupportTicket: boolean;
  isAllowToViewSupportTicketBilling: boolean;
  isAllowToEditReports: boolean;
  isAllowToEditRatingPerformance: boolean;
  isAllowToViewRatingPerformance: boolean;
  isAllowToEditCompany: boolean;
  isAllowToEditSeries: boolean;
  isAllowToEditSeriesDetail: boolean;
  isAllowToViewCommitteeReports: boolean;
  isAllowToViewSeriesReports: boolean;
  isAllowToViewPreliminaryRatingReports: boolean;
  isAllowToViewRaisingCapitalReports: boolean;
  isAllowToViewTrainingReports: boolean;
  isAllowToViewMonitoringReports: boolean;
  isAllowToViewFinanceReports: boolean;
  isAllowToEditCompanyCommercial: boolean;
  isAllowToEditRatingProcess: boolean;
  isAllowToViewRatingPerformanceDashboard: boolean;
  userDetails: IUserDetail[] | null;
}

export interface IUserTraining {
  /** @format int32 */
  id: number;
  /** @format date-time */
  createdDate: string | Date;
  /** @format date-time */
  updatedDate: string | Date | null;
  externalSystemKey: string | null;
  isActive: boolean;
  userID: string | null;
  /** @format int32 */
  trainingID: number;
  userDetail: IUserDetail | null;
  training: ITraining | null;
}

export interface IWebsitePublicationItem {
  /** @format int32 */
  id: number;
  /** @format int32 */
  departmentID: number;
  departmentTitle: string | null;
  /** @format int32 */
  ratedEntityID: number;
  ratedEntityName: string | null;
  /** @format date-time */
  magnaPublicationDate: string | Date | null;
  reportTitle: string | null;
  reportPublicationOptionTitle: string | null;
}

export interface IWithdrawalRatingProcessItem {
  /** @format int32 */
  id: number;
  /** @format int32 */
  ratingProcessNumber: number;
  /** @format int32 */
  departmentID: number;
  departmentName: string | null;
  /** @format int32 */
  ratingProcessTypeID: number;
  ratingProcessTypeName: string | null;
  /** @format date-time */
  completeRatingProcessDate: string | Date | null;
  /** @format int32 */
  ratedEntityID: number;
  ratedEntityName: string | null;
  /** @format int32 */
  orderID: number | null;
  priorityOrderID: string | null;
  currentProcessStep: string | null;
}

export interface IBaseCommitteeMaterialPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IBaseCommitteeMaterialDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IBaseCommitteeResourcePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IBaseCommitteeResourceDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IBaseCommitteeSignificantChangePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IBaseCommitteeSignificantChangeDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IBaseReportCheckupPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IBaseReportCheckupDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IBasisPointPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IBasisPointDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface ICategoryPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface ICategoryDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface ICheckModelsAssumptionPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface ICheckModelsAssumptionDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IClientDecisionPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IClientDecisionDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IClientInitiateRatingPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IClientInitiateRatingDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IClientPayRatingPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IClientPayRatingDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface ICommitteeMannerPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface ICommitteeMannerDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface ICommitteePositionPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface ICommitteePositionDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface ICommitteeSignificantChangeTypePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface ICommitteeSignificantChangeTypeDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface ICommitteeTypePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface ICommitteeTypeDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface ICompanyPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface ICompanyDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface ICompanyForMagnaReportPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface ICompanyForMagnaReportDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface ICompanyRatedEntityPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface ICompanyRatedEntityDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface ICompanyTypePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface ICompanyTypeDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IContactPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IContactDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IControllingGroupPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IControllingGroupDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IControllingGroupCompanyPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IControllingGroupCompanyDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IDepartmentPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IDepartmentDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IDifferentThanForecastPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IDifferentThanForecastDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IDiplomaPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IDiplomaDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IDocumentationStatusPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IDocumentationStatusDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IFinancialConventionTypePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IFinancialConventionTypeDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IFinancialStatementTrendTypePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IFinancialStatementTrendTypeDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface ILabelPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface ILabelDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface ILanguagePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface ILanguageDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface ILinkageBasisTypePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface ILinkageBasisTypeDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IMaalotOutlookPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IMaalotOutlookDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IMaalotRatingPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IMaalotRatingDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IMagnaReportHelperExportMagnaReportForRatingProcessDetailParams {
  /** @format int32 */
  ratingProcessId: number;
}

export interface IMagnaReportHelperGetExportMagnaReportForRatingProcessFileNameDetailParams {
  /** @format int32 */
  ratingProcessId: number;
}

export interface IMagnaReportHelperExportMagnaReportForReportDetailParams {
  /** @format date-time */
  fromDate: string | Date;
  /** @format date-time */
  toDate: string | Date;
}

export interface IMagnaReportHelperGetExportMagnaReportForReportFileNameDetailParams {
  /** @format date-time */
  fromDate: string | Date;
  /** @format date-time */
  toDate: string | Date;
}

export interface IMagnaReportHelperAttachToRatingProcessDetailParams {
  /** @format int32 */
  seriesDetailId: number;
  /** @format int32 */
  ratingProcessId: number;
}

export interface IMagnaReportHelperGetMagnaReportForRatingProcessDetailParams {
  /** @format int32 */
  ratingProcessId: number;
}

export interface IMeetingPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IMeetingDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IMeetingTypePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IMeetingTypeDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IMeetingUserPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IMeetingUserDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IMethodologyPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IMethodologyDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IMethodologyDocumentPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IMethodologyDocumentDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IMethodologyProfessionalDocumentPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IMethodologyProfessionalDocumentDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IMidroogOutlookPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IMidroogOutlookDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IMidroogRatingPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IMidroogRatingDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IMidroogRatingSymbolPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IMidroogRatingSymbolDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IMonitorDecisionTypePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IMonitorDecisionTypeDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IMonitorStatusPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IMonitorStatusDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IMoodysOutlookPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IMoodysOutlookDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IMoodysRatingPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IMoodysRatingDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IOrderPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IOrderDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IOrderDetailPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IOrderDetailDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IOrderHelperCalculatePaymentFromCapitalRaisedDetailParams {
  /** @format int32 */
  orderId: number;
  /** @format double */
  capitalRaised: number;
}

export interface IOrderHelperCheckDuplicateOrderPriorityIdDetailParams {
  priorityOrderId: string;
  /** @format int32 */
  currentOrderId: number;
}

export interface IOrderSourcePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IOrderSourceDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IOrderStatusPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IOrderStatusDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IPaymentTransactionPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IPaymentTransactionDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IPaymentTransactionHelperAddFromBasisPointDetailParams {
  /** @format int32 */
  orderId: number;
  /** @format double */
  amount: number;
}

export interface IProductPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IProductDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IProductStepPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IProductStepDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IPublicationApprovalTypePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IPublicationApprovalTypeDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IPublishTypePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IPublishTypeDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IQuarterlyMonitoringPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IQuarterlyMonitoringDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IQuarterlyMonitoringPeriodPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IQuarterlyMonitoringPeriodDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IQuarterlyMonitoringPeriodSyncQuarterlyMonitoringDetailParams {
  /** @format int32 */
  id: number;
}

export interface IQuarterlyMonitoringPeriodCompleteQuarterlyMonitoringDetailParams {
  /** @format int32 */
  id: number;
}

export interface IQuarterlyMonitoringPeriodInitQuarterlyMonitoringCreateParams {
  duplicate: boolean;
}

export interface IQuarterlyMonitoringPeriodUserPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IQuarterlyMonitoringPeriodUserDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingAndTrackingMessagePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingAndTrackingMessageDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingHistoryPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingHistoryDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingInitiativePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingInitiativeDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixDocumentPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixDocumentDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkGetFullFrameworkDetailParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkCloneCreateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkArchiveCreateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkConsiderationPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkConsiderationDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkGradeScorePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkGradeScoreDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkOptionPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkOptionDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkParameterPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkParameterDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkRangePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkRangeDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkSubParameterPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkSubParameterDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkTemplateGetFullTemplateDetailParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkTemplatePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkTemplateDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkTemplateCloneCreateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkTemplateActivateCreateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkTemplateLockCreateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkTemplateUnlockCreateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkTemplateApproveCreateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkTemplateArchiveCreateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkTemplateUnarchiveCreateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkTemplateValidateWeightsDetailParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkTemplateCalculateCreateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkTemplateGradeLadderDetailParams {
  /** @format int32 */
  id: number;
}

export interface IRatingMatrixFrameworkTemplateImportPreviewCreateParams {
  /** @format int32 */
  frameworkId: number;
}

export interface IRatingPerformanceCategoryPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingPerformanceCategoryDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingPerformanceHelperUpdateForRatingPerformanceUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingPerformanceHelperUpdateSeriesForRatingPerformanceUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingPerformanceHelperExportMatrixListParams {
  /** @format int32 */
  ratingPerformanceCategoryID?: number;
  rating?: boolean;
  companyIsActive?: string;
}

export interface IRatingPerformanceHelperCloneRatingMatrixDetailParams {
  /** @format int32 */
  id: number;
}

export interface IRatingPerformanceHelperUpdateRatingMatrixUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingPerformanceHelperDeleteRatingMatrixDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessDocumentationPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessDocumentationDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessHelperInitRatingProcessListParams {
  /** @format int32 */
  ratingProcessID?: number;
}

export interface IRatingProcessHelperInitRatingProcessForUpdateListParams {
  /** @format int32 */
  ratingProcessID?: number;
}

export interface IRatingProcessHelperAddNewReviewListParams {
  /** @format int32 */
  ratingProcessID?: number;
}

export interface IRatingProcessHelperAddNewCommitteeListParams {
  /** @format int32 */
  ratingProcessID?: number;
}

export interface IRatingProcessHelperUpdateRatingProcessTypeListParams {
  /** @format int32 */
  ratingProcessID?: number;
  /** @format int32 */
  ratingProcessTypeID?: number;
}

export interface IRatingProcessHelperAddNewDraftReportListParams {
  /** @format int32 */
  ratingProcessID?: number;
  /** @format int32 */
  decisionID?: number;
}

export interface IRatingProcessHelperImportUsersForCommitteeRatedEntityVotingsListParams {
  /** @format int32 */
  ratingProcessStepCommitteeID?: number;
}

export interface IRatingProcessHelperImportUsersForCommitteeSeriesVotingsListParams {
  /** @format int32 */
  ratedEntityID?: number;
  /** @format int32 */
  ratingProcessStepCommitteeID?: number;
}

export interface IRatingProcessHelperApplyVotingForCommitteeSeriesListParams {
  /** @format int32 */
  ratingProcessStepCommitteeID?: number;
  /** @format int32 */
  midroogRatingID?: number;
  /** @format int32 */
  midroogOutlookID?: number;
}

export interface IRatingProcessHelperApplyUserVotingForCommitteeSeriesListParams {
  /** @format int32 */
  ratingProcessStepCommitteeID?: number;
  userID?: string;
  /** @format int32 */
  midroogRatingID?: number;
  /** @format int32 */
  midroogOutlookID?: number;
}

export interface IRatingProcessHelperApplyAllUsersVotingForCommitteeSeriesListParams {
  /** @format int32 */
  ratingProcessStepCommitteeID?: number;
  /** @format int32 */
  midroogRatingID?: number;
  /** @format int32 */
  midroogOutlookID?: number;
}

export interface IRatingProcessHelperFinishRatingProcessListParams {
  /** @format int32 */
  ratingProcessID?: number;
}

export interface IRatingProcessHelperFinishRatingProcessForUpdateListParams {
  /** @format int32 */
  ratingProcessID?: number;
}

export interface IRatingProcessHelperGetDefaultCommitteeDetailParams {
  /** @format int32 */
  companyId: number;
}

export interface IRatingProcessStatusPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStatusDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepCommitteePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepCommitteeDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepCommitteeMaterialPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepCommitteeMaterialDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepCommitteeRatingMatrixFrameworkDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepCommitteeRatingMatrixFrameworkPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepCommitteeResourcePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepCommitteeResourceDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepCommitteeScenarioPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepCommitteeScenarioDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepCommitteeSeriesRatingPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepCommitteeSeriesRatingDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepCommitteeSignificantChangePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepCommitteeSignificantChangeDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepCommitteeUserPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepCommitteeUserDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepCommitteeUserRatesEntityVotingPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepCommitteeUserRatesEntityVotingDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepCommitteeUserScenarioVotingPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepCommitteeUserScenarioVotingDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepCommitteeUserSeriesVotingPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepCommitteeUserSeriesVotingDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepPublicationPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepPublicationDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepPublicationCheckupPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepPublicationCheckupDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepReportPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepReportDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepReviewPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepReviewDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepReviewUserPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepReviewUserDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepTypePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepTypeDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepUpdatePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepUpdateDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepUpdateStatusPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessStepUpdateStatusDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessTypePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessTypeDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessTypeGroupPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessTypeGroupDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessTypeOptionPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessTypeOptionDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessUserPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingProcessUserDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingStatusPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingStatusDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingStoppedReasonPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingStoppedReasonDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingSubjectPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingSubjectDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IRatingToolPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IRatingToolDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IReportPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IReportDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IReportCheckupTypePatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IReportCheckupTypeDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IReportPublicationOptionPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IReportPublicationOptionDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IReportSeriesPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IReportSeriesDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface ISectorPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface ISectorDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface ISecurityPadsFullPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface ISecurityPadsFullDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface ISeriesPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface ISeriesDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface ISeriesClientInitiateRatingPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface ISeriesClientInitiateRatingDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface ISeriesClientPayRatingPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface ISeriesClientPayRatingDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface ISeriesDetailPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface ISeriesDetailDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface ISignedOfficerStatementPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface ISignedOfficerStatementDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface ISystemLogPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface ISystemLogDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface ITrainingPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface ITrainingDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IUserCategoryVotingCertificationPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IUserCategoryVotingCertificationDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IUserCompanyConflictOfInterestPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IUserCompanyConflictOfInterestDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IUserDepartmentVotingCertificationPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IUserDepartmentVotingCertificationDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IUserDetailPatchPartialUpdateParams {
  id: string;
}

export interface IUserDetailDeleteDeleteParams {
  id: string;
}

export interface IUserPositionPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IUserPositionDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

export interface IUserTrainingPatchPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface IUserTrainingDeleteDeleteParams {
  /** @format int32 */
  id: number;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title WIZ Api
 * @version v1
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Account
     * @name AccountGetCurrentAppUserList
     * @request GET:/api/Account/GetCurrentAppUser
     * @secure
     */
    accountGetCurrentAppUserList: (params: RequestParams = {}) =>
      this.request<ICurrentUserProfileResponse, any>({
        path: `/Account/GetCurrentAppUser`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthGeneratePasswordCreate
     * @request POST:/api/Auth/GeneratePassword
     * @secure
     */
    authGeneratePasswordCreate: (
      data: Partial<IGeneratePasswordRequest>,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/Auth/GeneratePassword`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthLoginWithCodeCreate
     * @request POST:/api/Auth/LoginWithCode
     * @secure
     */
    authLoginWithCodeCreate: (
      data: Partial<ILoginRequest>,
      params: RequestParams = {},
    ) =>
      this.request<ILoginResponse, any>({
        path: `/Auth/LoginWithCode`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthRefreshTokenCreate
     * @request POST:/api/Auth/RefreshToken
     * @secure
     */
    authRefreshTokenCreate: (
      data: Partial<IJwtResponse>,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/Auth/RefreshToken`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthLogoutCreate
     * @request POST:/api/Auth/Logout
     * @secure
     */
    authLogoutCreate: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/Auth/Logout`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthCheckAuthList
     * @request GET:/api/Auth/CheckAuth
     * @secure
     */
    authCheckAuthList: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/Auth/CheckAuth`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BaseCommitteeMaterial
     * @name BaseCommitteeMaterialGetMetaDataList
     * @request GET:/api/BaseCommitteeMaterial/GetMetaData
     * @secure
     */
    baseCommitteeMaterialGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/BaseCommitteeMaterial/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BaseCommitteeMaterial
     * @name BaseCommitteeMaterialGetAllDynamicCreate
     * @request POST:/api/BaseCommitteeMaterial/GetAllDynamic
     * @secure
     */
    baseCommitteeMaterialGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IBaseCommitteeMaterial[], any>({
        path: `/BaseCommitteeMaterial/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BaseCommitteeMaterial
     * @name BaseCommitteeMaterialCreateCreate
     * @request POST:/api/BaseCommitteeMaterial/Create
     * @secure
     */
    baseCommitteeMaterialCreateCreate: (
      data: Partial<IBaseCommitteeMaterial>,
      params: RequestParams = {},
    ) =>
      this.request<IBaseCommitteeMaterial, any>({
        path: `/BaseCommitteeMaterial/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BaseCommitteeMaterial
     * @name BaseCommitteeMaterialPatchPartialUpdate
     * @request PATCH:/api/BaseCommitteeMaterial/Patch/{id}
     * @secure
     */
    baseCommitteeMaterialPatchPartialUpdate: (
      { id }: IBaseCommitteeMaterialPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/BaseCommitteeMaterial/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BaseCommitteeMaterial
     * @name BaseCommitteeMaterialDeleteDelete
     * @request DELETE:/api/BaseCommitteeMaterial/Delete/{id}
     * @secure
     */
    baseCommitteeMaterialDeleteDelete: (
      { id }: IBaseCommitteeMaterialDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IBaseCommitteeMaterial, any>({
        path: `/BaseCommitteeMaterial/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BaseCommitteeResource
     * @name BaseCommitteeResourceGetMetaDataList
     * @request GET:/api/BaseCommitteeResource/GetMetaData
     * @secure
     */
    baseCommitteeResourceGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/BaseCommitteeResource/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BaseCommitteeResource
     * @name BaseCommitteeResourceGetAllDynamicCreate
     * @request POST:/api/BaseCommitteeResource/GetAllDynamic
     * @secure
     */
    baseCommitteeResourceGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IBaseCommitteeResource[], any>({
        path: `/BaseCommitteeResource/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BaseCommitteeResource
     * @name BaseCommitteeResourceCreateCreate
     * @request POST:/api/BaseCommitteeResource/Create
     * @secure
     */
    baseCommitteeResourceCreateCreate: (
      data: Partial<IBaseCommitteeResource>,
      params: RequestParams = {},
    ) =>
      this.request<IBaseCommitteeResource, any>({
        path: `/BaseCommitteeResource/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BaseCommitteeResource
     * @name BaseCommitteeResourcePatchPartialUpdate
     * @request PATCH:/api/BaseCommitteeResource/Patch/{id}
     * @secure
     */
    baseCommitteeResourcePatchPartialUpdate: (
      { id }: IBaseCommitteeResourcePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/BaseCommitteeResource/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BaseCommitteeResource
     * @name BaseCommitteeResourceDeleteDelete
     * @request DELETE:/api/BaseCommitteeResource/Delete/{id}
     * @secure
     */
    baseCommitteeResourceDeleteDelete: (
      { id }: IBaseCommitteeResourceDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IBaseCommitteeResource, any>({
        path: `/BaseCommitteeResource/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BaseCommitteeSignificantChange
     * @name BaseCommitteeSignificantChangeGetMetaDataList
     * @request GET:/api/BaseCommitteeSignificantChange/GetMetaData
     * @secure
     */
    baseCommitteeSignificantChangeGetMetaDataList: (
      params: RequestParams = {},
    ) =>
      this.request<ILayoutMetaData, any>({
        path: `/BaseCommitteeSignificantChange/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BaseCommitteeSignificantChange
     * @name BaseCommitteeSignificantChangeGetAllDynamicCreate
     * @request POST:/api/BaseCommitteeSignificantChange/GetAllDynamic
     * @secure
     */
    baseCommitteeSignificantChangeGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IBaseCommitteeSignificantChange[], any>({
        path: `/BaseCommitteeSignificantChange/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BaseCommitteeSignificantChange
     * @name BaseCommitteeSignificantChangeCreateCreate
     * @request POST:/api/BaseCommitteeSignificantChange/Create
     * @secure
     */
    baseCommitteeSignificantChangeCreateCreate: (
      data: Partial<IBaseCommitteeSignificantChange>,
      params: RequestParams = {},
    ) =>
      this.request<IBaseCommitteeSignificantChange, any>({
        path: `/BaseCommitteeSignificantChange/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BaseCommitteeSignificantChange
     * @name BaseCommitteeSignificantChangePatchPartialUpdate
     * @request PATCH:/api/BaseCommitteeSignificantChange/Patch/{id}
     * @secure
     */
    baseCommitteeSignificantChangePatchPartialUpdate: (
      { id }: IBaseCommitteeSignificantChangePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/BaseCommitteeSignificantChange/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BaseCommitteeSignificantChange
     * @name BaseCommitteeSignificantChangeDeleteDelete
     * @request DELETE:/api/BaseCommitteeSignificantChange/Delete/{id}
     * @secure
     */
    baseCommitteeSignificantChangeDeleteDelete: (
      { id }: IBaseCommitteeSignificantChangeDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IBaseCommitteeSignificantChange, any>({
        path: `/BaseCommitteeSignificantChange/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BaseReportCheckup
     * @name BaseReportCheckupGetMetaDataList
     * @request GET:/api/BaseReportCheckup/GetMetaData
     * @secure
     */
    baseReportCheckupGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/BaseReportCheckup/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BaseReportCheckup
     * @name BaseReportCheckupGetAllDynamicCreate
     * @request POST:/api/BaseReportCheckup/GetAllDynamic
     * @secure
     */
    baseReportCheckupGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IBaseReportCheckup[], any>({
        path: `/BaseReportCheckup/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BaseReportCheckup
     * @name BaseReportCheckupCreateCreate
     * @request POST:/api/BaseReportCheckup/Create
     * @secure
     */
    baseReportCheckupCreateCreate: (
      data: Partial<IBaseReportCheckup>,
      params: RequestParams = {},
    ) =>
      this.request<IBaseReportCheckup, any>({
        path: `/BaseReportCheckup/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BaseReportCheckup
     * @name BaseReportCheckupPatchPartialUpdate
     * @request PATCH:/api/BaseReportCheckup/Patch/{id}
     * @secure
     */
    baseReportCheckupPatchPartialUpdate: (
      { id }: IBaseReportCheckupPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/BaseReportCheckup/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BaseReportCheckup
     * @name BaseReportCheckupDeleteDelete
     * @request DELETE:/api/BaseReportCheckup/Delete/{id}
     * @secure
     */
    baseReportCheckupDeleteDelete: (
      { id }: IBaseReportCheckupDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IBaseReportCheckup, any>({
        path: `/BaseReportCheckup/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BasisPoint
     * @name BasisPointGetMetaDataList
     * @request GET:/api/BasisPoint/GetMetaData
     * @secure
     */
    basisPointGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/BasisPoint/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BasisPoint
     * @name BasisPointGetAllDynamicCreate
     * @request POST:/api/BasisPoint/GetAllDynamic
     * @secure
     */
    basisPointGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IBasisPoint[], any>({
        path: `/BasisPoint/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BasisPoint
     * @name BasisPointCreateCreate
     * @request POST:/api/BasisPoint/Create
     * @secure
     */
    basisPointCreateCreate: (
      data: Partial<IBasisPoint>,
      params: RequestParams = {},
    ) =>
      this.request<IBasisPoint, any>({
        path: `/BasisPoint/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BasisPoint
     * @name BasisPointPatchPartialUpdate
     * @request PATCH:/api/BasisPoint/Patch/{id}
     * @secure
     */
    basisPointPatchPartialUpdate: (
      { id }: IBasisPointPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/BasisPoint/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BasisPoint
     * @name BasisPointDeleteDelete
     * @request DELETE:/api/BasisPoint/Delete/{id}
     * @secure
     */
    basisPointDeleteDelete: (
      { id }: IBasisPointDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IBasisPoint, any>({
        path: `/BasisPoint/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Category
     * @name CategoryGetMetaDataList
     * @request GET:/api/Category/GetMetaData
     * @secure
     */
    categoryGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/Category/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Category
     * @name CategoryGetAllDynamicCreate
     * @request POST:/api/Category/GetAllDynamic
     * @secure
     */
    categoryGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ICategory[], any>({
        path: `/Category/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Category
     * @name CategoryCreateCreate
     * @request POST:/api/Category/Create
     * @secure
     */
    categoryCreateCreate: (
      data: Partial<ICategory>,
      params: RequestParams = {},
    ) =>
      this.request<ICategory, any>({
        path: `/Category/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Category
     * @name CategoryPatchPartialUpdate
     * @request PATCH:/api/Category/Patch/{id}
     * @secure
     */
    categoryPatchPartialUpdate: (
      { id }: ICategoryPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/Category/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Category
     * @name CategoryDeleteDelete
     * @request DELETE:/api/Category/Delete/{id}
     * @secure
     */
    categoryDeleteDelete: (
      { id }: ICategoryDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<ICategory, any>({
        path: `/Category/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CheckModelsAssumption
     * @name CheckModelsAssumptionGetMetaDataList
     * @request GET:/api/CheckModelsAssumption/GetMetaData
     * @secure
     */
    checkModelsAssumptionGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/CheckModelsAssumption/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CheckModelsAssumption
     * @name CheckModelsAssumptionGetAllDynamicCreate
     * @request POST:/api/CheckModelsAssumption/GetAllDynamic
     * @secure
     */
    checkModelsAssumptionGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ICheckModelsAssumption[], any>({
        path: `/CheckModelsAssumption/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CheckModelsAssumption
     * @name CheckModelsAssumptionCreateCreate
     * @request POST:/api/CheckModelsAssumption/Create
     * @secure
     */
    checkModelsAssumptionCreateCreate: (
      data: Partial<ICheckModelsAssumption>,
      params: RequestParams = {},
    ) =>
      this.request<ICheckModelsAssumption, any>({
        path: `/CheckModelsAssumption/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CheckModelsAssumption
     * @name CheckModelsAssumptionPatchPartialUpdate
     * @request PATCH:/api/CheckModelsAssumption/Patch/{id}
     * @secure
     */
    checkModelsAssumptionPatchPartialUpdate: (
      { id }: ICheckModelsAssumptionPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/CheckModelsAssumption/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CheckModelsAssumption
     * @name CheckModelsAssumptionDeleteDelete
     * @request DELETE:/api/CheckModelsAssumption/Delete/{id}
     * @secure
     */
    checkModelsAssumptionDeleteDelete: (
      { id }: ICheckModelsAssumptionDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<ICheckModelsAssumption, any>({
        path: `/CheckModelsAssumption/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClientDecision
     * @name ClientDecisionGetMetaDataList
     * @request GET:/api/ClientDecision/GetMetaData
     * @secure
     */
    clientDecisionGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/ClientDecision/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClientDecision
     * @name ClientDecisionGetAllDynamicCreate
     * @request POST:/api/ClientDecision/GetAllDynamic
     * @secure
     */
    clientDecisionGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IClientDecision[], any>({
        path: `/ClientDecision/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClientDecision
     * @name ClientDecisionCreateCreate
     * @request POST:/api/ClientDecision/Create
     * @secure
     */
    clientDecisionCreateCreate: (
      data: Partial<IClientDecision>,
      params: RequestParams = {},
    ) =>
      this.request<IClientDecision, any>({
        path: `/ClientDecision/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClientDecision
     * @name ClientDecisionPatchPartialUpdate
     * @request PATCH:/api/ClientDecision/Patch/{id}
     * @secure
     */
    clientDecisionPatchPartialUpdate: (
      { id }: IClientDecisionPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/ClientDecision/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClientDecision
     * @name ClientDecisionDeleteDelete
     * @request DELETE:/api/ClientDecision/Delete/{id}
     * @secure
     */
    clientDecisionDeleteDelete: (
      { id }: IClientDecisionDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IClientDecision, any>({
        path: `/ClientDecision/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClientInitiateRating
     * @name ClientInitiateRatingGetMetaDataList
     * @request GET:/api/ClientInitiateRating/GetMetaData
     * @secure
     */
    clientInitiateRatingGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/ClientInitiateRating/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClientInitiateRating
     * @name ClientInitiateRatingGetAllDynamicCreate
     * @request POST:/api/ClientInitiateRating/GetAllDynamic
     * @secure
     */
    clientInitiateRatingGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IClientInitiateRating[], any>({
        path: `/ClientInitiateRating/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClientInitiateRating
     * @name ClientInitiateRatingCreateCreate
     * @request POST:/api/ClientInitiateRating/Create
     * @secure
     */
    clientInitiateRatingCreateCreate: (
      data: Partial<IClientInitiateRating>,
      params: RequestParams = {},
    ) =>
      this.request<IClientInitiateRating, any>({
        path: `/ClientInitiateRating/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClientInitiateRating
     * @name ClientInitiateRatingPatchPartialUpdate
     * @request PATCH:/api/ClientInitiateRating/Patch/{id}
     * @secure
     */
    clientInitiateRatingPatchPartialUpdate: (
      { id }: IClientInitiateRatingPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/ClientInitiateRating/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClientInitiateRating
     * @name ClientInitiateRatingDeleteDelete
     * @request DELETE:/api/ClientInitiateRating/Delete/{id}
     * @secure
     */
    clientInitiateRatingDeleteDelete: (
      { id }: IClientInitiateRatingDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IClientInitiateRating, any>({
        path: `/ClientInitiateRating/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClientPayRating
     * @name ClientPayRatingGetMetaDataList
     * @request GET:/api/ClientPayRating/GetMetaData
     * @secure
     */
    clientPayRatingGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/ClientPayRating/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClientPayRating
     * @name ClientPayRatingGetAllDynamicCreate
     * @request POST:/api/ClientPayRating/GetAllDynamic
     * @secure
     */
    clientPayRatingGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IClientPayRating[], any>({
        path: `/ClientPayRating/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClientPayRating
     * @name ClientPayRatingCreateCreate
     * @request POST:/api/ClientPayRating/Create
     * @secure
     */
    clientPayRatingCreateCreate: (
      data: Partial<IClientPayRating>,
      params: RequestParams = {},
    ) =>
      this.request<IClientPayRating, any>({
        path: `/ClientPayRating/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClientPayRating
     * @name ClientPayRatingPatchPartialUpdate
     * @request PATCH:/api/ClientPayRating/Patch/{id}
     * @secure
     */
    clientPayRatingPatchPartialUpdate: (
      { id }: IClientPayRatingPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/ClientPayRating/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClientPayRating
     * @name ClientPayRatingDeleteDelete
     * @request DELETE:/api/ClientPayRating/Delete/{id}
     * @secure
     */
    clientPayRatingDeleteDelete: (
      { id }: IClientPayRatingDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IClientPayRating, any>({
        path: `/ClientPayRating/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommitteeManner
     * @name CommitteeMannerGetMetaDataList
     * @request GET:/api/CommitteeManner/GetMetaData
     * @secure
     */
    committeeMannerGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/CommitteeManner/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommitteeManner
     * @name CommitteeMannerGetAllDynamicCreate
     * @request POST:/api/CommitteeManner/GetAllDynamic
     * @secure
     */
    committeeMannerGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ICommitteeManner[], any>({
        path: `/CommitteeManner/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommitteeManner
     * @name CommitteeMannerCreateCreate
     * @request POST:/api/CommitteeManner/Create
     * @secure
     */
    committeeMannerCreateCreate: (
      data: Partial<ICommitteeManner>,
      params: RequestParams = {},
    ) =>
      this.request<ICommitteeManner, any>({
        path: `/CommitteeManner/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommitteeManner
     * @name CommitteeMannerPatchPartialUpdate
     * @request PATCH:/api/CommitteeManner/Patch/{id}
     * @secure
     */
    committeeMannerPatchPartialUpdate: (
      { id }: ICommitteeMannerPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/CommitteeManner/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommitteeManner
     * @name CommitteeMannerDeleteDelete
     * @request DELETE:/api/CommitteeManner/Delete/{id}
     * @secure
     */
    committeeMannerDeleteDelete: (
      { id }: ICommitteeMannerDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<ICommitteeManner, any>({
        path: `/CommitteeManner/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommitteePosition
     * @name CommitteePositionGetMetaDataList
     * @request GET:/api/CommitteePosition/GetMetaData
     * @secure
     */
    committeePositionGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/CommitteePosition/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommitteePosition
     * @name CommitteePositionGetAllDynamicCreate
     * @request POST:/api/CommitteePosition/GetAllDynamic
     * @secure
     */
    committeePositionGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ICommitteePosition[], any>({
        path: `/CommitteePosition/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommitteePosition
     * @name CommitteePositionCreateCreate
     * @request POST:/api/CommitteePosition/Create
     * @secure
     */
    committeePositionCreateCreate: (
      data: Partial<ICommitteePosition>,
      params: RequestParams = {},
    ) =>
      this.request<ICommitteePosition, any>({
        path: `/CommitteePosition/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommitteePosition
     * @name CommitteePositionPatchPartialUpdate
     * @request PATCH:/api/CommitteePosition/Patch/{id}
     * @secure
     */
    committeePositionPatchPartialUpdate: (
      { id }: ICommitteePositionPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/CommitteePosition/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommitteePosition
     * @name CommitteePositionDeleteDelete
     * @request DELETE:/api/CommitteePosition/Delete/{id}
     * @secure
     */
    committeePositionDeleteDelete: (
      { id }: ICommitteePositionDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<ICommitteePosition, any>({
        path: `/CommitteePosition/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommitteeSignificantChangeType
     * @name CommitteeSignificantChangeTypeGetMetaDataList
     * @request GET:/api/CommitteeSignificantChangeType/GetMetaData
     * @secure
     */
    committeeSignificantChangeTypeGetMetaDataList: (
      params: RequestParams = {},
    ) =>
      this.request<ILayoutMetaData, any>({
        path: `/CommitteeSignificantChangeType/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommitteeSignificantChangeType
     * @name CommitteeSignificantChangeTypeGetAllDynamicCreate
     * @request POST:/api/CommitteeSignificantChangeType/GetAllDynamic
     * @secure
     */
    committeeSignificantChangeTypeGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ICommitteeSignificantChangeType[], any>({
        path: `/CommitteeSignificantChangeType/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommitteeSignificantChangeType
     * @name CommitteeSignificantChangeTypeCreateCreate
     * @request POST:/api/CommitteeSignificantChangeType/Create
     * @secure
     */
    committeeSignificantChangeTypeCreateCreate: (
      data: Partial<ICommitteeSignificantChangeType>,
      params: RequestParams = {},
    ) =>
      this.request<ICommitteeSignificantChangeType, any>({
        path: `/CommitteeSignificantChangeType/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommitteeSignificantChangeType
     * @name CommitteeSignificantChangeTypePatchPartialUpdate
     * @request PATCH:/api/CommitteeSignificantChangeType/Patch/{id}
     * @secure
     */
    committeeSignificantChangeTypePatchPartialUpdate: (
      { id }: ICommitteeSignificantChangeTypePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/CommitteeSignificantChangeType/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommitteeSignificantChangeType
     * @name CommitteeSignificantChangeTypeDeleteDelete
     * @request DELETE:/api/CommitteeSignificantChangeType/Delete/{id}
     * @secure
     */
    committeeSignificantChangeTypeDeleteDelete: (
      { id }: ICommitteeSignificantChangeTypeDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<ICommitteeSignificantChangeType, any>({
        path: `/CommitteeSignificantChangeType/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommitteeType
     * @name CommitteeTypeGetMetaDataList
     * @request GET:/api/CommitteeType/GetMetaData
     * @secure
     */
    committeeTypeGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/CommitteeType/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommitteeType
     * @name CommitteeTypeGetAllDynamicCreate
     * @request POST:/api/CommitteeType/GetAllDynamic
     * @secure
     */
    committeeTypeGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ICommitteeType[], any>({
        path: `/CommitteeType/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommitteeType
     * @name CommitteeTypeCreateCreate
     * @request POST:/api/CommitteeType/Create
     * @secure
     */
    committeeTypeCreateCreate: (
      data: Partial<ICommitteeType>,
      params: RequestParams = {},
    ) =>
      this.request<ICommitteeType, any>({
        path: `/CommitteeType/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommitteeType
     * @name CommitteeTypePatchPartialUpdate
     * @request PATCH:/api/CommitteeType/Patch/{id}
     * @secure
     */
    committeeTypePatchPartialUpdate: (
      { id }: ICommitteeTypePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/CommitteeType/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommitteeType
     * @name CommitteeTypeDeleteDelete
     * @request DELETE:/api/CommitteeType/Delete/{id}
     * @secure
     */
    committeeTypeDeleteDelete: (
      { id }: ICommitteeTypeDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<ICommitteeType, any>({
        path: `/CommitteeType/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company
     * @name CompanyGetMetaDataList
     * @request GET:/api/Company/GetMetaData
     * @secure
     */
    companyGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/Company/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company
     * @name CompanyGetAllDynamicCreate
     * @request POST:/api/Company/GetAllDynamic
     * @secure
     */
    companyGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ICompany[], any>({
        path: `/Company/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company
     * @name CompanyCreateCreate
     * @request POST:/api/Company/Create
     * @secure
     */
    companyCreateCreate: (
      data: Partial<ICompany>,
      params: RequestParams = {},
    ) =>
      this.request<ICompany, any>({
        path: `/Company/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company
     * @name CompanyPatchPartialUpdate
     * @request PATCH:/api/Company/Patch/{id}
     * @secure
     */
    companyPatchPartialUpdate: (
      { id }: ICompanyPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/Company/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company
     * @name CompanyDeleteDelete
     * @request DELETE:/api/Company/Delete/{id}
     * @secure
     */
    companyDeleteDelete: (
      { id }: ICompanyDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<ICompany, any>({
        path: `/Company/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyForMagnaReport
     * @name CompanyForMagnaReportGetMetaDataList
     * @request GET:/api/CompanyForMagnaReport/GetMetaData
     * @secure
     */
    companyForMagnaReportGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/CompanyForMagnaReport/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyForMagnaReport
     * @name CompanyForMagnaReportGetAllDynamicCreate
     * @request POST:/api/CompanyForMagnaReport/GetAllDynamic
     * @secure
     */
    companyForMagnaReportGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ICompanyForMagnaReport[], any>({
        path: `/CompanyForMagnaReport/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyForMagnaReport
     * @name CompanyForMagnaReportCreateCreate
     * @request POST:/api/CompanyForMagnaReport/Create
     * @secure
     */
    companyForMagnaReportCreateCreate: (
      data: Partial<ICompanyForMagnaReport>,
      params: RequestParams = {},
    ) =>
      this.request<ICompanyForMagnaReport, any>({
        path: `/CompanyForMagnaReport/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyForMagnaReport
     * @name CompanyForMagnaReportPatchPartialUpdate
     * @request PATCH:/api/CompanyForMagnaReport/Patch/{id}
     * @secure
     */
    companyForMagnaReportPatchPartialUpdate: (
      { id }: ICompanyForMagnaReportPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/CompanyForMagnaReport/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyForMagnaReport
     * @name CompanyForMagnaReportDeleteDelete
     * @request DELETE:/api/CompanyForMagnaReport/Delete/{id}
     * @secure
     */
    companyForMagnaReportDeleteDelete: (
      { id }: ICompanyForMagnaReportDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<ICompanyForMagnaReport, any>({
        path: `/CompanyForMagnaReport/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyRatedEntity
     * @name CompanyRatedEntityGetMetaDataList
     * @request GET:/api/CompanyRatedEntity/GetMetaData
     * @secure
     */
    companyRatedEntityGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/CompanyRatedEntity/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyRatedEntity
     * @name CompanyRatedEntityGetAllDynamicCreate
     * @request POST:/api/CompanyRatedEntity/GetAllDynamic
     * @secure
     */
    companyRatedEntityGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ICompanyRatedEntity[], any>({
        path: `/CompanyRatedEntity/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyRatedEntity
     * @name CompanyRatedEntityCreateCreate
     * @request POST:/api/CompanyRatedEntity/Create
     * @secure
     */
    companyRatedEntityCreateCreate: (
      data: Partial<ICompanyRatedEntity>,
      params: RequestParams = {},
    ) =>
      this.request<ICompanyRatedEntity, any>({
        path: `/CompanyRatedEntity/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyRatedEntity
     * @name CompanyRatedEntityPatchPartialUpdate
     * @request PATCH:/api/CompanyRatedEntity/Patch/{id}
     * @secure
     */
    companyRatedEntityPatchPartialUpdate: (
      { id }: ICompanyRatedEntityPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/CompanyRatedEntity/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyRatedEntity
     * @name CompanyRatedEntityDeleteDelete
     * @request DELETE:/api/CompanyRatedEntity/Delete/{id}
     * @secure
     */
    companyRatedEntityDeleteDelete: (
      { id }: ICompanyRatedEntityDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<ICompanyRatedEntity, any>({
        path: `/CompanyRatedEntity/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyType
     * @name CompanyTypeGetMetaDataList
     * @request GET:/api/CompanyType/GetMetaData
     * @secure
     */
    companyTypeGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/CompanyType/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyType
     * @name CompanyTypeGetAllDynamicCreate
     * @request POST:/api/CompanyType/GetAllDynamic
     * @secure
     */
    companyTypeGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ICompanyType[], any>({
        path: `/CompanyType/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyType
     * @name CompanyTypeCreateCreate
     * @request POST:/api/CompanyType/Create
     * @secure
     */
    companyTypeCreateCreate: (
      data: Partial<ICompanyType>,
      params: RequestParams = {},
    ) =>
      this.request<ICompanyType, any>({
        path: `/CompanyType/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyType
     * @name CompanyTypePatchPartialUpdate
     * @request PATCH:/api/CompanyType/Patch/{id}
     * @secure
     */
    companyTypePatchPartialUpdate: (
      { id }: ICompanyTypePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/CompanyType/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyType
     * @name CompanyTypeDeleteDelete
     * @request DELETE:/api/CompanyType/Delete/{id}
     * @secure
     */
    companyTypeDeleteDelete: (
      { id }: ICompanyTypeDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<ICompanyType, any>({
        path: `/CompanyType/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contact
     * @name ContactGetMetaDataList
     * @request GET:/api/Contact/GetMetaData
     * @secure
     */
    contactGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/Contact/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contact
     * @name ContactGetAllDynamicCreate
     * @request POST:/api/Contact/GetAllDynamic
     * @secure
     */
    contactGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IContact[], any>({
        path: `/Contact/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contact
     * @name ContactCreateCreate
     * @request POST:/api/Contact/Create
     * @secure
     */
    contactCreateCreate: (
      data: Partial<IContact>,
      params: RequestParams = {},
    ) =>
      this.request<IContact, any>({
        path: `/Contact/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contact
     * @name ContactPatchPartialUpdate
     * @request PATCH:/api/Contact/Patch/{id}
     * @secure
     */
    contactPatchPartialUpdate: (
      { id }: IContactPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/Contact/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contact
     * @name ContactDeleteDelete
     * @request DELETE:/api/Contact/Delete/{id}
     * @secure
     */
    contactDeleteDelete: (
      { id }: IContactDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IContact, any>({
        path: `/Contact/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ControllingGroup
     * @name ControllingGroupGetMetaDataList
     * @request GET:/api/ControllingGroup/GetMetaData
     * @secure
     */
    controllingGroupGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/ControllingGroup/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ControllingGroup
     * @name ControllingGroupGetAllDynamicCreate
     * @request POST:/api/ControllingGroup/GetAllDynamic
     * @secure
     */
    controllingGroupGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IControllingGroup[], any>({
        path: `/ControllingGroup/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ControllingGroup
     * @name ControllingGroupCreateCreate
     * @request POST:/api/ControllingGroup/Create
     * @secure
     */
    controllingGroupCreateCreate: (
      data: Partial<IControllingGroup>,
      params: RequestParams = {},
    ) =>
      this.request<IControllingGroup, any>({
        path: `/ControllingGroup/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ControllingGroup
     * @name ControllingGroupPatchPartialUpdate
     * @request PATCH:/api/ControllingGroup/Patch/{id}
     * @secure
     */
    controllingGroupPatchPartialUpdate: (
      { id }: IControllingGroupPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/ControllingGroup/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ControllingGroup
     * @name ControllingGroupDeleteDelete
     * @request DELETE:/api/ControllingGroup/Delete/{id}
     * @secure
     */
    controllingGroupDeleteDelete: (
      { id }: IControllingGroupDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IControllingGroup, any>({
        path: `/ControllingGroup/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ControllingGroupCompany
     * @name ControllingGroupCompanyGetMetaDataList
     * @request GET:/api/ControllingGroupCompany/GetMetaData
     * @secure
     */
    controllingGroupCompanyGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/ControllingGroupCompany/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ControllingGroupCompany
     * @name ControllingGroupCompanyGetAllDynamicCreate
     * @request POST:/api/ControllingGroupCompany/GetAllDynamic
     * @secure
     */
    controllingGroupCompanyGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IControllingGroupCompany[], any>({
        path: `/ControllingGroupCompany/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ControllingGroupCompany
     * @name ControllingGroupCompanyCreateCreate
     * @request POST:/api/ControllingGroupCompany/Create
     * @secure
     */
    controllingGroupCompanyCreateCreate: (
      data: Partial<IControllingGroupCompany>,
      params: RequestParams = {},
    ) =>
      this.request<IControllingGroupCompany, any>({
        path: `/ControllingGroupCompany/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ControllingGroupCompany
     * @name ControllingGroupCompanyPatchPartialUpdate
     * @request PATCH:/api/ControllingGroupCompany/Patch/{id}
     * @secure
     */
    controllingGroupCompanyPatchPartialUpdate: (
      { id }: IControllingGroupCompanyPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/ControllingGroupCompany/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ControllingGroupCompany
     * @name ControllingGroupCompanyDeleteDelete
     * @request DELETE:/api/ControllingGroupCompany/Delete/{id}
     * @secure
     */
    controllingGroupCompanyDeleteDelete: (
      { id }: IControllingGroupCompanyDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IControllingGroupCompany, any>({
        path: `/ControllingGroupCompany/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardReports
     * @name DashboardReportsGetKpIsCreate
     * @request POST:/api/DashboardReports/GetKPIs
     * @secure
     */
    dashboardReportsGetKpIsCreate: (
      data: Partial<IDepartmentAndDateRangeRequest>,
      params: RequestParams = {},
    ) =>
      this.request<IKPIsResponse, any>({
        path: `/DashboardReports/GetKPIs`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardReports
     * @name DashboardReportsGetDepartmentsForProfessionalList
     * @request GET:/api/DashboardReports/GetDepartmentsForProfessional
     * @secure
     */
    dashboardReportsGetDepartmentsForProfessionalList: (
      params: RequestParams = {},
    ) =>
      this.request<IDepartmentResponse[], any>({
        path: `/DashboardReports/GetDepartmentsForProfessional`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardReports
     * @name DashboardReportsGetDepartmentsList
     * @request GET:/api/DashboardReports/GetDepartments
     * @secure
     */
    dashboardReportsGetDepartmentsList: (params: RequestParams = {}) =>
      this.request<IDepartmentResponse[], any>({
        path: `/DashboardReports/GetDepartments`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardReports
     * @name DashboardReportsGetOpenRPsByCurrentStepTotalsCreate
     * @request POST:/api/DashboardReports/GetOpenRPsByCurrentStepTotals
     * @secure
     */
    dashboardReportsGetOpenRPsByCurrentStepTotalsCreate: (
      data: Partial<IDepartmentAndDateRangeRequest>,
      params: RequestParams = {},
    ) =>
      this.request<IOpenRPsByCurrentStepTotalItem[], any>({
        path: `/DashboardReports/GetOpenRPsByCurrentStepTotals`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardReports
     * @name DashboardReportsGetOpenRPsByCurrentStepItemsCreate
     * @request POST:/api/DashboardReports/GetOpenRPsByCurrentStepItems
     * @secure
     */
    dashboardReportsGetOpenRPsByCurrentStepItemsCreate: (
      data: Partial<IRatingProcessStepRequest>,
      params: RequestParams = {},
    ) =>
      this.request<IOpenRPsByCurrentStepItem[], any>({
        path: `/DashboardReports/GetOpenRPsByCurrentStepItems`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardReports
     * @name DashboardReportsGetOpenRPsByTypeTotalsCreate
     * @request POST:/api/DashboardReports/GetOpenRPsByTypeTotals
     * @secure
     */
    dashboardReportsGetOpenRPsByTypeTotalsCreate: (
      data: Partial<IDepartmentAndDateRangeRequest>,
      params: RequestParams = {},
    ) =>
      this.request<IOpenRPsByTypeTotalItem[], any>({
        path: `/DashboardReports/GetOpenRPsByTypeTotals`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardReports
     * @name DashboardReportsGetOpenRPsByTypeItemsCreate
     * @request POST:/api/DashboardReports/GetOpenRPsByTypeItems
     * @secure
     */
    dashboardReportsGetOpenRPsByTypeItemsCreate: (
      data: Partial<IRatingProcessTypeRequest>,
      params: RequestParams = {},
    ) =>
      this.request<IOpenRPsByTypeItem[], any>({
        path: `/DashboardReports/GetOpenRPsByTypeItems`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardReports
     * @name DashboardReportsGetMonitorsToOpenItemsCreate
     * @request POST:/api/DashboardReports/GetMonitorsToOpenItems
     * @secure
     */
    dashboardReportsGetMonitorsToOpenItemsCreate: (
      data: Partial<IDepartmentDaysRangeDynamicRequest>,
      params: RequestParams = {},
    ) =>
      this.request<IMonitorsToOpenItem[], any>({
        path: `/DashboardReports/GetMonitorsToOpenItems`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardReports
     * @name DashboardReportsGetLeadAnalystPerformanceItemsCreate
     * @request POST:/api/DashboardReports/GetLeadAnalystPerformanceItems
     * @secure
     */
    dashboardReportsGetLeadAnalystPerformanceItemsCreate: (
      data: Partial<IDepartmentDynamicRequest>,
      params: RequestParams = {},
    ) =>
      this.request<ILeadAnalystPerformanceItem[], any>({
        path: `/DashboardReports/GetLeadAnalystPerformanceItems`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardReports
     * @name DashboardReportsGetRaisedCapitalOrderItemsCreate
     * @request POST:/api/DashboardReports/GetRaisedCapitalOrderItems
     * @secure
     */
    dashboardReportsGetRaisedCapitalOrderItemsCreate: (
      data: Partial<IDepartmentDateRangeDynamicRequest>,
      params: RequestParams = {},
    ) =>
      this.request<IRaisedCapitalOrderItem[], any>({
        path: `/DashboardReports/GetRaisedCapitalOrderItems`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardReports
     * @name DashboardReportsGetRequestedOrderItemsCreate
     * @request POST:/api/DashboardReports/GetRequestedOrderItems
     * @secure
     */
    dashboardReportsGetRequestedOrderItemsCreate: (
      data: Partial<IDepartmentDateRangeDynamicRequest>,
      params: RequestParams = {},
    ) =>
      this.request<IRequestedOrderItem[], any>({
        path: `/DashboardReports/GetRequestedOrderItems`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardReports
     * @name DashboardReportsGetRpCommercialItemsCreate
     * @request POST:/api/DashboardReports/GetRPCommercialItems
     * @secure
     */
    dashboardReportsGetRpCommercialItemsCreate: (
      data: Partial<IDepartmentDateRangeDynamicRequest>,
      params: RequestParams = {},
    ) =>
      this.request<IRPCommercialItem[], any>({
        path: `/DashboardReports/GetRPCommercialItems`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardReports
     * @name DashboardReportsGetWebsitePublicationItemsCreate
     * @request POST:/api/DashboardReports/GetWebsitePublicationItems
     * @secure
     */
    dashboardReportsGetWebsitePublicationItemsCreate: (
      data: Partial<IDepartmentDateRangeDynamicRequest>,
      params: RequestParams = {},
    ) =>
      this.request<IWebsitePublicationItem[], any>({
        path: `/DashboardReports/GetWebsitePublicationItems`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardReports
     * @name DashboardReportsGetWithdrawalRatingProcessesCreate
     * @request POST:/api/DashboardReports/GetWithdrawalRatingProcesses
     * @secure
     */
    dashboardReportsGetWithdrawalRatingProcessesCreate: (
      data: Partial<IDepartmentDateRangeDynamicRequest>,
      params: RequestParams = {},
    ) =>
      this.request<IWithdrawalRatingProcessItem[], any>({
        path: `/DashboardReports/GetWithdrawalRatingProcesses`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardReports
     * @name DashboardReportsGetComplianceItemsCreate
     * @request POST:/api/DashboardReports/GetComplianceItems
     * @secure
     */
    dashboardReportsGetComplianceItemsCreate: (
      data: Partial<IDepartmentDateRangeDynamicRequest>,
      params: RequestParams = {},
    ) =>
      this.request<IComplianceItem[], any>({
        path: `/DashboardReports/GetComplianceItems`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardReports
     * @name DashboardReportsGetCreditReviewReportItemsCreate
     * @request POST:/api/DashboardReports/GetCreditReviewReportItems
     * @secure
     */
    dashboardReportsGetCreditReviewReportItemsCreate: (
      data: Partial<IDepartmentDynamicRequest>,
      params: RequestParams = {},
    ) =>
      this.request<ICreditReviewItem[], any>({
        path: `/DashboardReports/GetCreditReviewReportItems`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Department
     * @name DepartmentGetMetaDataList
     * @request GET:/api/Department/GetMetaData
     * @secure
     */
    departmentGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/Department/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Department
     * @name DepartmentGetAllDynamicCreate
     * @request POST:/api/Department/GetAllDynamic
     * @secure
     */
    departmentGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IDepartment[], any>({
        path: `/Department/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Department
     * @name DepartmentCreateCreate
     * @request POST:/api/Department/Create
     * @secure
     */
    departmentCreateCreate: (
      data: Partial<IDepartment>,
      params: RequestParams = {},
    ) =>
      this.request<IDepartment, any>({
        path: `/Department/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Department
     * @name DepartmentPatchPartialUpdate
     * @request PATCH:/api/Department/Patch/{id}
     * @secure
     */
    departmentPatchPartialUpdate: (
      { id }: IDepartmentPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/Department/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Department
     * @name DepartmentDeleteDelete
     * @request DELETE:/api/Department/Delete/{id}
     * @secure
     */
    departmentDeleteDelete: (
      { id }: IDepartmentDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IDepartment, any>({
        path: `/Department/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DifferentThanForecast
     * @name DifferentThanForecastGetMetaDataList
     * @request GET:/api/DifferentThanForecast/GetMetaData
     * @secure
     */
    differentThanForecastGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/DifferentThanForecast/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DifferentThanForecast
     * @name DifferentThanForecastGetAllDynamicCreate
     * @request POST:/api/DifferentThanForecast/GetAllDynamic
     * @secure
     */
    differentThanForecastGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IDifferentThanForecast[], any>({
        path: `/DifferentThanForecast/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DifferentThanForecast
     * @name DifferentThanForecastCreateCreate
     * @request POST:/api/DifferentThanForecast/Create
     * @secure
     */
    differentThanForecastCreateCreate: (
      data: Partial<IDifferentThanForecast>,
      params: RequestParams = {},
    ) =>
      this.request<IDifferentThanForecast, any>({
        path: `/DifferentThanForecast/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DifferentThanForecast
     * @name DifferentThanForecastPatchPartialUpdate
     * @request PATCH:/api/DifferentThanForecast/Patch/{id}
     * @secure
     */
    differentThanForecastPatchPartialUpdate: (
      { id }: IDifferentThanForecastPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/DifferentThanForecast/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DifferentThanForecast
     * @name DifferentThanForecastDeleteDelete
     * @request DELETE:/api/DifferentThanForecast/Delete/{id}
     * @secure
     */
    differentThanForecastDeleteDelete: (
      { id }: IDifferentThanForecastDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IDifferentThanForecast, any>({
        path: `/DifferentThanForecast/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diploma
     * @name DiplomaGetMetaDataList
     * @request GET:/api/Diploma/GetMetaData
     * @secure
     */
    diplomaGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/Diploma/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diploma
     * @name DiplomaGetAllDynamicCreate
     * @request POST:/api/Diploma/GetAllDynamic
     * @secure
     */
    diplomaGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IDiploma[], any>({
        path: `/Diploma/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diploma
     * @name DiplomaCreateCreate
     * @request POST:/api/Diploma/Create
     * @secure
     */
    diplomaCreateCreate: (
      data: Partial<IDiploma>,
      params: RequestParams = {},
    ) =>
      this.request<IDiploma, any>({
        path: `/Diploma/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diploma
     * @name DiplomaPatchPartialUpdate
     * @request PATCH:/api/Diploma/Patch/{id}
     * @secure
     */
    diplomaPatchPartialUpdate: (
      { id }: IDiplomaPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/Diploma/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diploma
     * @name DiplomaDeleteDelete
     * @request DELETE:/api/Diploma/Delete/{id}
     * @secure
     */
    diplomaDeleteDelete: (
      { id }: IDiplomaDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IDiploma, any>({
        path: `/Diploma/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentationStatus
     * @name DocumentationStatusGetMetaDataList
     * @request GET:/api/DocumentationStatus/GetMetaData
     * @secure
     */
    documentationStatusGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/DocumentationStatus/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentationStatus
     * @name DocumentationStatusGetAllDynamicCreate
     * @request POST:/api/DocumentationStatus/GetAllDynamic
     * @secure
     */
    documentationStatusGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IDocumentationStatus[], any>({
        path: `/DocumentationStatus/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentationStatus
     * @name DocumentationStatusCreateCreate
     * @request POST:/api/DocumentationStatus/Create
     * @secure
     */
    documentationStatusCreateCreate: (
      data: Partial<IDocumentationStatus>,
      params: RequestParams = {},
    ) =>
      this.request<IDocumentationStatus, any>({
        path: `/DocumentationStatus/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentationStatus
     * @name DocumentationStatusPatchPartialUpdate
     * @request PATCH:/api/DocumentationStatus/Patch/{id}
     * @secure
     */
    documentationStatusPatchPartialUpdate: (
      { id }: IDocumentationStatusPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/DocumentationStatus/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentationStatus
     * @name DocumentationStatusDeleteDelete
     * @request DELETE:/api/DocumentationStatus/Delete/{id}
     * @secure
     */
    documentationStatusDeleteDelete: (
      { id }: IDocumentationStatusDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IDocumentationStatus, any>({
        path: `/DocumentationStatus/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FinancialConventionType
     * @name FinancialConventionTypeGetMetaDataList
     * @request GET:/api/FinancialConventionType/GetMetaData
     * @secure
     */
    financialConventionTypeGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/FinancialConventionType/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FinancialConventionType
     * @name FinancialConventionTypeGetAllDynamicCreate
     * @request POST:/api/FinancialConventionType/GetAllDynamic
     * @secure
     */
    financialConventionTypeGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IFinancialConventionType[], any>({
        path: `/FinancialConventionType/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FinancialConventionType
     * @name FinancialConventionTypeCreateCreate
     * @request POST:/api/FinancialConventionType/Create
     * @secure
     */
    financialConventionTypeCreateCreate: (
      data: Partial<IFinancialConventionType>,
      params: RequestParams = {},
    ) =>
      this.request<IFinancialConventionType, any>({
        path: `/FinancialConventionType/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FinancialConventionType
     * @name FinancialConventionTypePatchPartialUpdate
     * @request PATCH:/api/FinancialConventionType/Patch/{id}
     * @secure
     */
    financialConventionTypePatchPartialUpdate: (
      { id }: IFinancialConventionTypePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/FinancialConventionType/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FinancialConventionType
     * @name FinancialConventionTypeDeleteDelete
     * @request DELETE:/api/FinancialConventionType/Delete/{id}
     * @secure
     */
    financialConventionTypeDeleteDelete: (
      { id }: IFinancialConventionTypeDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IFinancialConventionType, any>({
        path: `/FinancialConventionType/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FinancialStatementTrendType
     * @name FinancialStatementTrendTypeGetMetaDataList
     * @request GET:/api/FinancialStatementTrendType/GetMetaData
     * @secure
     */
    financialStatementTrendTypeGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/FinancialStatementTrendType/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FinancialStatementTrendType
     * @name FinancialStatementTrendTypeGetAllDynamicCreate
     * @request POST:/api/FinancialStatementTrendType/GetAllDynamic
     * @secure
     */
    financialStatementTrendTypeGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IFinancialStatementTrendType[], any>({
        path: `/FinancialStatementTrendType/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FinancialStatementTrendType
     * @name FinancialStatementTrendTypeCreateCreate
     * @request POST:/api/FinancialStatementTrendType/Create
     * @secure
     */
    financialStatementTrendTypeCreateCreate: (
      data: Partial<IFinancialStatementTrendType>,
      params: RequestParams = {},
    ) =>
      this.request<IFinancialStatementTrendType, any>({
        path: `/FinancialStatementTrendType/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FinancialStatementTrendType
     * @name FinancialStatementTrendTypePatchPartialUpdate
     * @request PATCH:/api/FinancialStatementTrendType/Patch/{id}
     * @secure
     */
    financialStatementTrendTypePatchPartialUpdate: (
      { id }: IFinancialStatementTrendTypePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/FinancialStatementTrendType/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FinancialStatementTrendType
     * @name FinancialStatementTrendTypeDeleteDelete
     * @request DELETE:/api/FinancialStatementTrendType/Delete/{id}
     * @secure
     */
    financialStatementTrendTypeDeleteDelete: (
      { id }: IFinancialStatementTrendTypeDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IFinancialStatementTrendType, any>({
        path: `/FinancialStatementTrendType/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Label
     * @name LabelGetMetaDataList
     * @request GET:/api/Label/GetMetaData
     * @secure
     */
    labelGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/Label/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Label
     * @name LabelGetAllDynamicCreate
     * @request POST:/api/Label/GetAllDynamic
     * @secure
     */
    labelGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ILabel[], any>({
        path: `/Label/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Label
     * @name LabelCreateCreate
     * @request POST:/api/Label/Create
     * @secure
     */
    labelCreateCreate: (data: Partial<ILabel>, params: RequestParams = {}) =>
      this.request<ILabel, any>({
        path: `/Label/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Label
     * @name LabelPatchPartialUpdate
     * @request PATCH:/api/Label/Patch/{id}
     * @secure
     */
    labelPatchPartialUpdate: (
      { id }: ILabelPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/Label/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Label
     * @name LabelDeleteDelete
     * @request DELETE:/api/Label/Delete/{id}
     * @secure
     */
    labelDeleteDelete: (
      { id }: ILabelDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<ILabel, any>({
        path: `/Label/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Label
     * @name LabelCreateBulkCreate
     * @request POST:/api/Label/CreateBulk
     * @secure
     */
    labelCreateBulkCreate: (
      data: Partial<ILabel[]>,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/Label/CreateBulk`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Language
     * @name LanguageGetMetaDataList
     * @request GET:/api/Language/GetMetaData
     * @secure
     */
    languageGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/Language/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Language
     * @name LanguageGetAllDynamicCreate
     * @request POST:/api/Language/GetAllDynamic
     * @secure
     */
    languageGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ILanguage[], any>({
        path: `/Language/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Language
     * @name LanguageCreateCreate
     * @request POST:/api/Language/Create
     * @secure
     */
    languageCreateCreate: (
      data: Partial<ILanguage>,
      params: RequestParams = {},
    ) =>
      this.request<ILanguage, any>({
        path: `/Language/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Language
     * @name LanguagePatchPartialUpdate
     * @request PATCH:/api/Language/Patch/{id}
     * @secure
     */
    languagePatchPartialUpdate: (
      { id }: ILanguagePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/Language/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Language
     * @name LanguageDeleteDelete
     * @request DELETE:/api/Language/Delete/{id}
     * @secure
     */
    languageDeleteDelete: (
      { id }: ILanguageDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<ILanguage, any>({
        path: `/Language/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LinkageBasisType
     * @name LinkageBasisTypeGetMetaDataList
     * @request GET:/api/LinkageBasisType/GetMetaData
     * @secure
     */
    linkageBasisTypeGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/LinkageBasisType/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LinkageBasisType
     * @name LinkageBasisTypeGetAllDynamicCreate
     * @request POST:/api/LinkageBasisType/GetAllDynamic
     * @secure
     */
    linkageBasisTypeGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ILinkageBasisType[], any>({
        path: `/LinkageBasisType/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LinkageBasisType
     * @name LinkageBasisTypeCreateCreate
     * @request POST:/api/LinkageBasisType/Create
     * @secure
     */
    linkageBasisTypeCreateCreate: (
      data: Partial<ILinkageBasisType>,
      params: RequestParams = {},
    ) =>
      this.request<ILinkageBasisType, any>({
        path: `/LinkageBasisType/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LinkageBasisType
     * @name LinkageBasisTypePatchPartialUpdate
     * @request PATCH:/api/LinkageBasisType/Patch/{id}
     * @secure
     */
    linkageBasisTypePatchPartialUpdate: (
      { id }: ILinkageBasisTypePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/LinkageBasisType/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LinkageBasisType
     * @name LinkageBasisTypeDeleteDelete
     * @request DELETE:/api/LinkageBasisType/Delete/{id}
     * @secure
     */
    linkageBasisTypeDeleteDelete: (
      { id }: ILinkageBasisTypeDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<ILinkageBasisType, any>({
        path: `/LinkageBasisType/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MaalotOutlook
     * @name MaalotOutlookGetMetaDataList
     * @request GET:/api/MaalotOutlook/GetMetaData
     * @secure
     */
    maalotOutlookGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/MaalotOutlook/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MaalotOutlook
     * @name MaalotOutlookGetAllDynamicCreate
     * @request POST:/api/MaalotOutlook/GetAllDynamic
     * @secure
     */
    maalotOutlookGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IMaalotOutlook[], any>({
        path: `/MaalotOutlook/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MaalotOutlook
     * @name MaalotOutlookCreateCreate
     * @request POST:/api/MaalotOutlook/Create
     * @secure
     */
    maalotOutlookCreateCreate: (
      data: Partial<IMaalotOutlook>,
      params: RequestParams = {},
    ) =>
      this.request<IMaalotOutlook, any>({
        path: `/MaalotOutlook/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MaalotOutlook
     * @name MaalotOutlookPatchPartialUpdate
     * @request PATCH:/api/MaalotOutlook/Patch/{id}
     * @secure
     */
    maalotOutlookPatchPartialUpdate: (
      { id }: IMaalotOutlookPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/MaalotOutlook/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MaalotOutlook
     * @name MaalotOutlookDeleteDelete
     * @request DELETE:/api/MaalotOutlook/Delete/{id}
     * @secure
     */
    maalotOutlookDeleteDelete: (
      { id }: IMaalotOutlookDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IMaalotOutlook, any>({
        path: `/MaalotOutlook/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MaalotRating
     * @name MaalotRatingGetMetaDataList
     * @request GET:/api/MaalotRating/GetMetaData
     * @secure
     */
    maalotRatingGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/MaalotRating/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MaalotRating
     * @name MaalotRatingGetAllDynamicCreate
     * @request POST:/api/MaalotRating/GetAllDynamic
     * @secure
     */
    maalotRatingGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IMaalotRating[], any>({
        path: `/MaalotRating/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MaalotRating
     * @name MaalotRatingCreateCreate
     * @request POST:/api/MaalotRating/Create
     * @secure
     */
    maalotRatingCreateCreate: (
      data: Partial<IMaalotRating>,
      params: RequestParams = {},
    ) =>
      this.request<IMaalotRating, any>({
        path: `/MaalotRating/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MaalotRating
     * @name MaalotRatingPatchPartialUpdate
     * @request PATCH:/api/MaalotRating/Patch/{id}
     * @secure
     */
    maalotRatingPatchPartialUpdate: (
      { id }: IMaalotRatingPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/MaalotRating/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MaalotRating
     * @name MaalotRatingDeleteDelete
     * @request DELETE:/api/MaalotRating/Delete/{id}
     * @secure
     */
    maalotRatingDeleteDelete: (
      { id }: IMaalotRatingDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IMaalotRating, any>({
        path: `/MaalotRating/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MagnaReportHelper
     * @name MagnaReportHelperExportMagnaReportForRatingProcessDetail
     * @request GET:/api/MagnaReportHelper/ExportMagnaReportForRatingProcess/{ratingProcessID}
     * @secure
     */
    magnaReportHelperExportMagnaReportForRatingProcessDetail: (
      {
        ratingProcessId,
      }: IMagnaReportHelperExportMagnaReportForRatingProcessDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/MagnaReportHelper/ExportMagnaReportForRatingProcess/${ratingProcessId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MagnaReportHelper
     * @name MagnaReportHelperExportMagnaReportForRatingProcessFullCreate
     * @request POST:/api/MagnaReportHelper/ExportMagnaReportForRatingProcessFull
     * @secure
     */
    magnaReportHelperExportMagnaReportForRatingProcessFullCreate: (
      data: Partial<IMagnaExportReportRequest>,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/MagnaReportHelper/ExportMagnaReportForRatingProcessFull`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MagnaReportHelper
     * @name MagnaReportHelperGetExportMagnaReportForRatingProcessFileNameDetail
     * @request GET:/api/MagnaReportHelper/GetExportMagnaReportForRatingProcessFileName/{ratingProcessID}
     * @secure
     */
    magnaReportHelperGetExportMagnaReportForRatingProcessFileNameDetail: (
      {
        ratingProcessId,
      }: IMagnaReportHelperGetExportMagnaReportForRatingProcessFileNameDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/MagnaReportHelper/GetExportMagnaReportForRatingProcessFileName/${ratingProcessId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MagnaReportHelper
     * @name MagnaReportHelperExportMagnaReportForReportDetail
     * @request GET:/api/MagnaReportHelper/ExportMagnaReportForReport/{fromDate}/{toDate}
     * @secure
     */
    magnaReportHelperExportMagnaReportForReportDetail: (
      {
        fromDate,
        toDate,
      }: IMagnaReportHelperExportMagnaReportForReportDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/MagnaReportHelper/ExportMagnaReportForReport/${fromDate}/${toDate}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MagnaReportHelper
     * @name MagnaReportHelperGetExportMagnaReportForReportFileNameDetail
     * @request GET:/api/MagnaReportHelper/GetExportMagnaReportForReportFileName/{fromDate}/{toDate}
     * @secure
     */
    magnaReportHelperGetExportMagnaReportForReportFileNameDetail: (
      {
        fromDate,
        toDate,
      }: IMagnaReportHelperGetExportMagnaReportForReportFileNameDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/MagnaReportHelper/GetExportMagnaReportForReportFileName/${fromDate}/${toDate}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MagnaReportHelper
     * @name MagnaReportHelperAttachToRatingProcessDetail
     * @request GET:/api/MagnaReportHelper/AttachToRatingProcess/{seriesDetailID}/{ratingProcessID}
     * @secure
     */
    magnaReportHelperAttachToRatingProcessDetail: (
      {
        seriesDetailId,
        ratingProcessId,
      }: IMagnaReportHelperAttachToRatingProcessDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<ISeriesDetail, any>({
        path: `/MagnaReportHelper/AttachToRatingProcess/${seriesDetailId}/${ratingProcessId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MagnaReportHelper
     * @name MagnaReportHelperGetMagnaReportForRatingProcessDetail
     * @request GET:/api/MagnaReportHelper/GetMagnaReportForRatingProcess/{ratingProcessID}
     * @secure
     */
    magnaReportHelperGetMagnaReportForRatingProcessDetail: (
      {
        ratingProcessId,
      }: IMagnaReportHelperGetMagnaReportForRatingProcessDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<IMagnaSeries[], any>({
        path: `/MagnaReportHelper/GetMagnaReportForRatingProcess/${ratingProcessId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MediaUpload
     * @name MediaUploadUploadFileToCloudCreate
     * @request POST:/api/MediaUpload/UploadFileToCloud
     * @secure
     */
    mediaUploadUploadFileToCloudCreate: (
      data: Partial<{
        /** @format binary */
        file?: File;
      }>,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/MediaUpload/UploadFileToCloud`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MediaUpload
     * @name MediaUploadRemoveFileFromCloudUpdate
     * @request PUT:/api/MediaUpload/RemoveFileFromCloud
     * @secure
     */
    mediaUploadRemoveFileFromCloudUpdate: (
      data: ICloudFileRemoveViewModel,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/MediaUpload/RemoveFileFromCloud`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MediaUpload
     * @name MediaUploadGetHtmlFromCloudCreate
     * @request POST:/api/MediaUpload/GetHtmlFromCloud
     * @secure
     */
    mediaUploadGetHtmlFromCloudCreate: (
      data: Partial<IHtmlFetchRequest>,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/MediaUpload/GetHtmlFromCloud`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingGetMetaDataList
     * @request GET:/api/Meeting/GetMetaData
     * @deprecated
     * @secure
     */
    meetingGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/Meeting/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingGetAllDynamicCreate
     * @request POST:/api/Meeting/GetAllDynamic
     * @deprecated
     * @secure
     */
    meetingGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IMeeting[], any>({
        path: `/Meeting/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingCreateCreate
     * @request POST:/api/Meeting/Create
     * @deprecated
     * @secure
     */
    meetingCreateCreate: (
      data: Partial<IMeeting>,
      params: RequestParams = {},
    ) =>
      this.request<IMeeting, any>({
        path: `/Meeting/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingPatchPartialUpdate
     * @request PATCH:/api/Meeting/Patch/{id}
     * @deprecated
     * @secure
     */
    meetingPatchPartialUpdate: (
      { id }: IMeetingPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/Meeting/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingDeleteDelete
     * @request DELETE:/api/Meeting/Delete/{id}
     * @deprecated
     * @secure
     */
    meetingDeleteDelete: (
      { id }: IMeetingDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IMeeting, any>({
        path: `/Meeting/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MeetingType
     * @name MeetingTypeGetMetaDataList
     * @request GET:/api/MeetingType/GetMetaData
     * @deprecated
     * @secure
     */
    meetingTypeGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/MeetingType/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MeetingType
     * @name MeetingTypeGetAllDynamicCreate
     * @request POST:/api/MeetingType/GetAllDynamic
     * @deprecated
     * @secure
     */
    meetingTypeGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IMeetingType[], any>({
        path: `/MeetingType/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MeetingType
     * @name MeetingTypeCreateCreate
     * @request POST:/api/MeetingType/Create
     * @deprecated
     * @secure
     */
    meetingTypeCreateCreate: (
      data: Partial<IMeetingType>,
      params: RequestParams = {},
    ) =>
      this.request<IMeetingType, any>({
        path: `/MeetingType/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MeetingType
     * @name MeetingTypePatchPartialUpdate
     * @request PATCH:/api/MeetingType/Patch/{id}
     * @deprecated
     * @secure
     */
    meetingTypePatchPartialUpdate: (
      { id }: IMeetingTypePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/MeetingType/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MeetingType
     * @name MeetingTypeDeleteDelete
     * @request DELETE:/api/MeetingType/Delete/{id}
     * @deprecated
     * @secure
     */
    meetingTypeDeleteDelete: (
      { id }: IMeetingTypeDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IMeetingType, any>({
        path: `/MeetingType/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MeetingUser
     * @name MeetingUserGetMetaDataList
     * @request GET:/api/MeetingUser/GetMetaData
     * @deprecated
     * @secure
     */
    meetingUserGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/MeetingUser/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MeetingUser
     * @name MeetingUserGetAllDynamicCreate
     * @request POST:/api/MeetingUser/GetAllDynamic
     * @deprecated
     * @secure
     */
    meetingUserGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IMeetingUser[], any>({
        path: `/MeetingUser/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MeetingUser
     * @name MeetingUserCreateCreate
     * @request POST:/api/MeetingUser/Create
     * @deprecated
     * @secure
     */
    meetingUserCreateCreate: (
      data: Partial<IMeetingUser>,
      params: RequestParams = {},
    ) =>
      this.request<IMeetingUser, any>({
        path: `/MeetingUser/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MeetingUser
     * @name MeetingUserPatchPartialUpdate
     * @request PATCH:/api/MeetingUser/Patch/{id}
     * @deprecated
     * @secure
     */
    meetingUserPatchPartialUpdate: (
      { id }: IMeetingUserPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/MeetingUser/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MeetingUser
     * @name MeetingUserDeleteDelete
     * @request DELETE:/api/MeetingUser/Delete/{id}
     * @deprecated
     * @secure
     */
    meetingUserDeleteDelete: (
      { id }: IMeetingUserDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IMeetingUser, any>({
        path: `/MeetingUser/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Methodology
     * @name MethodologyGetMetaDataList
     * @request GET:/api/Methodology/GetMetaData
     * @secure
     */
    methodologyGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/Methodology/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Methodology
     * @name MethodologyGetAllDynamicCreate
     * @request POST:/api/Methodology/GetAllDynamic
     * @secure
     */
    methodologyGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IMethodology[], any>({
        path: `/Methodology/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Methodology
     * @name MethodologyCreateCreate
     * @request POST:/api/Methodology/Create
     * @secure
     */
    methodologyCreateCreate: (
      data: Partial<IMethodology>,
      params: RequestParams = {},
    ) =>
      this.request<IMethodology, any>({
        path: `/Methodology/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Methodology
     * @name MethodologyPatchPartialUpdate
     * @request PATCH:/api/Methodology/Patch/{id}
     * @secure
     */
    methodologyPatchPartialUpdate: (
      { id }: IMethodologyPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/Methodology/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Methodology
     * @name MethodologyDeleteDelete
     * @request DELETE:/api/Methodology/Delete/{id}
     * @secure
     */
    methodologyDeleteDelete: (
      { id }: IMethodologyDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IMethodology, any>({
        path: `/Methodology/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MethodologyDocument
     * @name MethodologyDocumentGetMetaDataList
     * @request GET:/api/MethodologyDocument/GetMetaData
     * @secure
     */
    methodologyDocumentGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/MethodologyDocument/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MethodologyDocument
     * @name MethodologyDocumentGetAllDynamicCreate
     * @request POST:/api/MethodologyDocument/GetAllDynamic
     * @secure
     */
    methodologyDocumentGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IMethodologyDocument[], any>({
        path: `/MethodologyDocument/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MethodologyDocument
     * @name MethodologyDocumentCreateCreate
     * @request POST:/api/MethodologyDocument/Create
     * @secure
     */
    methodologyDocumentCreateCreate: (
      data: Partial<IMethodologyDocument>,
      params: RequestParams = {},
    ) =>
      this.request<IMethodologyDocument, any>({
        path: `/MethodologyDocument/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MethodologyDocument
     * @name MethodologyDocumentPatchPartialUpdate
     * @request PATCH:/api/MethodologyDocument/Patch/{id}
     * @secure
     */
    methodologyDocumentPatchPartialUpdate: (
      { id }: IMethodologyDocumentPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/MethodologyDocument/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MethodologyDocument
     * @name MethodologyDocumentDeleteDelete
     * @request DELETE:/api/MethodologyDocument/Delete/{id}
     * @secure
     */
    methodologyDocumentDeleteDelete: (
      { id }: IMethodologyDocumentDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IMethodologyDocument, any>({
        path: `/MethodologyDocument/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MethodologyProfessionalDocument
     * @name MethodologyProfessionalDocumentGetMetaDataList
     * @request GET:/api/MethodologyProfessionalDocument/GetMetaData
     * @secure
     */
    methodologyProfessionalDocumentGetMetaDataList: (
      params: RequestParams = {},
    ) =>
      this.request<ILayoutMetaData, any>({
        path: `/MethodologyProfessionalDocument/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MethodologyProfessionalDocument
     * @name MethodologyProfessionalDocumentGetAllDynamicCreate
     * @request POST:/api/MethodologyProfessionalDocument/GetAllDynamic
     * @secure
     */
    methodologyProfessionalDocumentGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IMethodologyProfessionalDocument[], any>({
        path: `/MethodologyProfessionalDocument/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MethodologyProfessionalDocument
     * @name MethodologyProfessionalDocumentCreateCreate
     * @request POST:/api/MethodologyProfessionalDocument/Create
     * @secure
     */
    methodologyProfessionalDocumentCreateCreate: (
      data: Partial<IMethodologyProfessionalDocument>,
      params: RequestParams = {},
    ) =>
      this.request<IMethodologyProfessionalDocument, any>({
        path: `/MethodologyProfessionalDocument/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MethodologyProfessionalDocument
     * @name MethodologyProfessionalDocumentPatchPartialUpdate
     * @request PATCH:/api/MethodologyProfessionalDocument/Patch/{id}
     * @secure
     */
    methodologyProfessionalDocumentPatchPartialUpdate: (
      { id }: IMethodologyProfessionalDocumentPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/MethodologyProfessionalDocument/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MethodologyProfessionalDocument
     * @name MethodologyProfessionalDocumentDeleteDelete
     * @request DELETE:/api/MethodologyProfessionalDocument/Delete/{id}
     * @secure
     */
    methodologyProfessionalDocumentDeleteDelete: (
      { id }: IMethodologyProfessionalDocumentDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IMethodologyProfessionalDocument, any>({
        path: `/MethodologyProfessionalDocument/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MidroogOutlook
     * @name MidroogOutlookGetMetaDataList
     * @request GET:/api/MidroogOutlook/GetMetaData
     * @secure
     */
    midroogOutlookGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/MidroogOutlook/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MidroogOutlook
     * @name MidroogOutlookGetAllDynamicCreate
     * @request POST:/api/MidroogOutlook/GetAllDynamic
     * @secure
     */
    midroogOutlookGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IMidroogOutlook[], any>({
        path: `/MidroogOutlook/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MidroogOutlook
     * @name MidroogOutlookCreateCreate
     * @request POST:/api/MidroogOutlook/Create
     * @secure
     */
    midroogOutlookCreateCreate: (
      data: Partial<IMidroogOutlook>,
      params: RequestParams = {},
    ) =>
      this.request<IMidroogOutlook, any>({
        path: `/MidroogOutlook/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MidroogOutlook
     * @name MidroogOutlookPatchPartialUpdate
     * @request PATCH:/api/MidroogOutlook/Patch/{id}
     * @secure
     */
    midroogOutlookPatchPartialUpdate: (
      { id }: IMidroogOutlookPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/MidroogOutlook/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MidroogOutlook
     * @name MidroogOutlookDeleteDelete
     * @request DELETE:/api/MidroogOutlook/Delete/{id}
     * @secure
     */
    midroogOutlookDeleteDelete: (
      { id }: IMidroogOutlookDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IMidroogOutlook, any>({
        path: `/MidroogOutlook/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MidroogRating
     * @name MidroogRatingGetMetaDataList
     * @request GET:/api/MidroogRating/GetMetaData
     * @secure
     */
    midroogRatingGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/MidroogRating/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MidroogRating
     * @name MidroogRatingGetAllDynamicCreate
     * @request POST:/api/MidroogRating/GetAllDynamic
     * @secure
     */
    midroogRatingGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IMidroogRating[], any>({
        path: `/MidroogRating/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MidroogRating
     * @name MidroogRatingCreateCreate
     * @request POST:/api/MidroogRating/Create
     * @secure
     */
    midroogRatingCreateCreate: (
      data: Partial<IMidroogRating>,
      params: RequestParams = {},
    ) =>
      this.request<IMidroogRating, any>({
        path: `/MidroogRating/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MidroogRating
     * @name MidroogRatingPatchPartialUpdate
     * @request PATCH:/api/MidroogRating/Patch/{id}
     * @secure
     */
    midroogRatingPatchPartialUpdate: (
      { id }: IMidroogRatingPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/MidroogRating/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MidroogRating
     * @name MidroogRatingDeleteDelete
     * @request DELETE:/api/MidroogRating/Delete/{id}
     * @secure
     */
    midroogRatingDeleteDelete: (
      { id }: IMidroogRatingDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IMidroogRating, any>({
        path: `/MidroogRating/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MidroogRatingSymbol
     * @name MidroogRatingSymbolGetMetaDataList
     * @request GET:/api/MidroogRatingSymbol/GetMetaData
     * @secure
     */
    midroogRatingSymbolGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/MidroogRatingSymbol/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MidroogRatingSymbol
     * @name MidroogRatingSymbolGetAllDynamicCreate
     * @request POST:/api/MidroogRatingSymbol/GetAllDynamic
     * @secure
     */
    midroogRatingSymbolGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IMidroogRatingSymbol[], any>({
        path: `/MidroogRatingSymbol/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MidroogRatingSymbol
     * @name MidroogRatingSymbolCreateCreate
     * @request POST:/api/MidroogRatingSymbol/Create
     * @secure
     */
    midroogRatingSymbolCreateCreate: (
      data: Partial<IMidroogRatingSymbol>,
      params: RequestParams = {},
    ) =>
      this.request<IMidroogRatingSymbol, any>({
        path: `/MidroogRatingSymbol/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MidroogRatingSymbol
     * @name MidroogRatingSymbolPatchPartialUpdate
     * @request PATCH:/api/MidroogRatingSymbol/Patch/{id}
     * @secure
     */
    midroogRatingSymbolPatchPartialUpdate: (
      { id }: IMidroogRatingSymbolPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/MidroogRatingSymbol/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MidroogRatingSymbol
     * @name MidroogRatingSymbolDeleteDelete
     * @request DELETE:/api/MidroogRatingSymbol/Delete/{id}
     * @secure
     */
    midroogRatingSymbolDeleteDelete: (
      { id }: IMidroogRatingSymbolDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IMidroogRatingSymbol, any>({
        path: `/MidroogRatingSymbol/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MonitorDecisionType
     * @name MonitorDecisionTypeGetMetaDataList
     * @request GET:/api/MonitorDecisionType/GetMetaData
     * @secure
     */
    monitorDecisionTypeGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/MonitorDecisionType/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MonitorDecisionType
     * @name MonitorDecisionTypeGetAllDynamicCreate
     * @request POST:/api/MonitorDecisionType/GetAllDynamic
     * @secure
     */
    monitorDecisionTypeGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IMonitorDecisionType[], any>({
        path: `/MonitorDecisionType/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MonitorDecisionType
     * @name MonitorDecisionTypeCreateCreate
     * @request POST:/api/MonitorDecisionType/Create
     * @secure
     */
    monitorDecisionTypeCreateCreate: (
      data: Partial<IMonitorDecisionType>,
      params: RequestParams = {},
    ) =>
      this.request<IMonitorDecisionType, any>({
        path: `/MonitorDecisionType/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MonitorDecisionType
     * @name MonitorDecisionTypePatchPartialUpdate
     * @request PATCH:/api/MonitorDecisionType/Patch/{id}
     * @secure
     */
    monitorDecisionTypePatchPartialUpdate: (
      { id }: IMonitorDecisionTypePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/MonitorDecisionType/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MonitorDecisionType
     * @name MonitorDecisionTypeDeleteDelete
     * @request DELETE:/api/MonitorDecisionType/Delete/{id}
     * @secure
     */
    monitorDecisionTypeDeleteDelete: (
      { id }: IMonitorDecisionTypeDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IMonitorDecisionType, any>({
        path: `/MonitorDecisionType/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MonitorStatus
     * @name MonitorStatusGetMetaDataList
     * @request GET:/api/MonitorStatus/GetMetaData
     * @secure
     */
    monitorStatusGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/MonitorStatus/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MonitorStatus
     * @name MonitorStatusGetAllDynamicCreate
     * @request POST:/api/MonitorStatus/GetAllDynamic
     * @secure
     */
    monitorStatusGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IMonitorStatus[], any>({
        path: `/MonitorStatus/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MonitorStatus
     * @name MonitorStatusCreateCreate
     * @request POST:/api/MonitorStatus/Create
     * @secure
     */
    monitorStatusCreateCreate: (
      data: Partial<IMonitorStatus>,
      params: RequestParams = {},
    ) =>
      this.request<IMonitorStatus, any>({
        path: `/MonitorStatus/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MonitorStatus
     * @name MonitorStatusPatchPartialUpdate
     * @request PATCH:/api/MonitorStatus/Patch/{id}
     * @secure
     */
    monitorStatusPatchPartialUpdate: (
      { id }: IMonitorStatusPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/MonitorStatus/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MonitorStatus
     * @name MonitorStatusDeleteDelete
     * @request DELETE:/api/MonitorStatus/Delete/{id}
     * @secure
     */
    monitorStatusDeleteDelete: (
      { id }: IMonitorStatusDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IMonitorStatus, any>({
        path: `/MonitorStatus/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MoodysOutlook
     * @name MoodysOutlookGetMetaDataList
     * @request GET:/api/MoodysOutlook/GetMetaData
     * @secure
     */
    moodysOutlookGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/MoodysOutlook/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MoodysOutlook
     * @name MoodysOutlookGetAllDynamicCreate
     * @request POST:/api/MoodysOutlook/GetAllDynamic
     * @secure
     */
    moodysOutlookGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IMoodysOutlook[], any>({
        path: `/MoodysOutlook/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MoodysOutlook
     * @name MoodysOutlookCreateCreate
     * @request POST:/api/MoodysOutlook/Create
     * @secure
     */
    moodysOutlookCreateCreate: (
      data: Partial<IMoodysOutlook>,
      params: RequestParams = {},
    ) =>
      this.request<IMoodysOutlook, any>({
        path: `/MoodysOutlook/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MoodysOutlook
     * @name MoodysOutlookPatchPartialUpdate
     * @request PATCH:/api/MoodysOutlook/Patch/{id}
     * @secure
     */
    moodysOutlookPatchPartialUpdate: (
      { id }: IMoodysOutlookPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/MoodysOutlook/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MoodysOutlook
     * @name MoodysOutlookDeleteDelete
     * @request DELETE:/api/MoodysOutlook/Delete/{id}
     * @secure
     */
    moodysOutlookDeleteDelete: (
      { id }: IMoodysOutlookDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IMoodysOutlook, any>({
        path: `/MoodysOutlook/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MoodysRating
     * @name MoodysRatingGetMetaDataList
     * @request GET:/api/MoodysRating/GetMetaData
     * @secure
     */
    moodysRatingGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/MoodysRating/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MoodysRating
     * @name MoodysRatingGetAllDynamicCreate
     * @request POST:/api/MoodysRating/GetAllDynamic
     * @secure
     */
    moodysRatingGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IMoodysRating[], any>({
        path: `/MoodysRating/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MoodysRating
     * @name MoodysRatingCreateCreate
     * @request POST:/api/MoodysRating/Create
     * @secure
     */
    moodysRatingCreateCreate: (
      data: Partial<IMoodysRating>,
      params: RequestParams = {},
    ) =>
      this.request<IMoodysRating, any>({
        path: `/MoodysRating/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MoodysRating
     * @name MoodysRatingPatchPartialUpdate
     * @request PATCH:/api/MoodysRating/Patch/{id}
     * @secure
     */
    moodysRatingPatchPartialUpdate: (
      { id }: IMoodysRatingPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/MoodysRating/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MoodysRating
     * @name MoodysRatingDeleteDelete
     * @request DELETE:/api/MoodysRating/Delete/{id}
     * @secure
     */
    moodysRatingDeleteDelete: (
      { id }: IMoodysRatingDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IMoodysRating, any>({
        path: `/MoodysRating/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Order
     * @name OrderGetMetaDataList
     * @request GET:/api/Order/GetMetaData
     * @secure
     */
    orderGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/Order/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Order
     * @name OrderGetAllDynamicCreate
     * @request POST:/api/Order/GetAllDynamic
     * @secure
     */
    orderGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IOrder[], any>({
        path: `/Order/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Order
     * @name OrderCreateCreate
     * @request POST:/api/Order/Create
     * @secure
     */
    orderCreateCreate: (data: Partial<IOrder>, params: RequestParams = {}) =>
      this.request<IOrder, any>({
        path: `/Order/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Order
     * @name OrderPatchPartialUpdate
     * @request PATCH:/api/Order/Patch/{id}
     * @secure
     */
    orderPatchPartialUpdate: (
      { id }: IOrderPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/Order/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Order
     * @name OrderDeleteDelete
     * @request DELETE:/api/Order/Delete/{id}
     * @secure
     */
    orderDeleteDelete: (
      { id }: IOrderDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IOrder, any>({
        path: `/Order/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderDetail
     * @name OrderDetailGetMetaDataList
     * @request GET:/api/OrderDetail/GetMetaData
     * @secure
     */
    orderDetailGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/OrderDetail/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderDetail
     * @name OrderDetailGetAllDynamicCreate
     * @request POST:/api/OrderDetail/GetAllDynamic
     * @secure
     */
    orderDetailGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IOrderDetail[], any>({
        path: `/OrderDetail/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderDetail
     * @name OrderDetailCreateCreate
     * @request POST:/api/OrderDetail/Create
     * @secure
     */
    orderDetailCreateCreate: (
      data: Partial<IOrderDetail>,
      params: RequestParams = {},
    ) =>
      this.request<IOrderDetail, any>({
        path: `/OrderDetail/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderDetail
     * @name OrderDetailPatchPartialUpdate
     * @request PATCH:/api/OrderDetail/Patch/{id}
     * @secure
     */
    orderDetailPatchPartialUpdate: (
      { id }: IOrderDetailPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/OrderDetail/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderDetail
     * @name OrderDetailDeleteDelete
     * @request DELETE:/api/OrderDetail/Delete/{id}
     * @secure
     */
    orderDetailDeleteDelete: (
      { id }: IOrderDetailDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IOrderDetail, any>({
        path: `/OrderDetail/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderHelper
     * @name OrderHelperGetOrdersDynamicCreate
     * @request POST:/api/OrderHelper/GetOrdersDynamic
     * @secure
     */
    orderHelperGetOrdersDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IOrder[], any>({
        path: `/OrderHelper/GetOrdersDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderHelper
     * @name OrderHelperCalculatePaymentFromCapitalRaisedDetail
     * @request GET:/api/OrderHelper/CalculatePaymentFromCapitalRaised/{orderID}/{capitalRaised}
     * @secure
     */
    orderHelperCalculatePaymentFromCapitalRaisedDetail: (
      {
        orderId,
        capitalRaised,
      }: IOrderHelperCalculatePaymentFromCapitalRaisedDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<number, any>({
        path: `/OrderHelper/CalculatePaymentFromCapitalRaised/${orderId}/${capitalRaised}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderHelper
     * @name OrderHelperCheckDuplicateOrderPriorityIdDetail
     * @request GET:/api/OrderHelper/CheckDuplicateOrderPriorityID/{priorityOrderID}/{currentOrderID}
     * @secure
     */
    orderHelperCheckDuplicateOrderPriorityIdDetail: (
      {
        priorityOrderId,
        currentOrderId,
      }: IOrderHelperCheckDuplicateOrderPriorityIdDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/OrderHelper/CheckDuplicateOrderPriorityID/${priorityOrderId}/${currentOrderId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderSource
     * @name OrderSourceGetMetaDataList
     * @request GET:/api/OrderSource/GetMetaData
     * @secure
     */
    orderSourceGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/OrderSource/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderSource
     * @name OrderSourceGetAllDynamicCreate
     * @request POST:/api/OrderSource/GetAllDynamic
     * @secure
     */
    orderSourceGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IOrderSource[], any>({
        path: `/OrderSource/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderSource
     * @name OrderSourceCreateCreate
     * @request POST:/api/OrderSource/Create
     * @secure
     */
    orderSourceCreateCreate: (
      data: Partial<IOrderSource>,
      params: RequestParams = {},
    ) =>
      this.request<IOrderSource, any>({
        path: `/OrderSource/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderSource
     * @name OrderSourcePatchPartialUpdate
     * @request PATCH:/api/OrderSource/Patch/{id}
     * @secure
     */
    orderSourcePatchPartialUpdate: (
      { id }: IOrderSourcePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/OrderSource/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderSource
     * @name OrderSourceDeleteDelete
     * @request DELETE:/api/OrderSource/Delete/{id}
     * @secure
     */
    orderSourceDeleteDelete: (
      { id }: IOrderSourceDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IOrderSource, any>({
        path: `/OrderSource/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderStatus
     * @name OrderStatusGetMetaDataList
     * @request GET:/api/OrderStatus/GetMetaData
     * @secure
     */
    orderStatusGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/OrderStatus/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderStatus
     * @name OrderStatusGetAllDynamicCreate
     * @request POST:/api/OrderStatus/GetAllDynamic
     * @secure
     */
    orderStatusGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IOrderStatus[], any>({
        path: `/OrderStatus/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderStatus
     * @name OrderStatusCreateCreate
     * @request POST:/api/OrderStatus/Create
     * @secure
     */
    orderStatusCreateCreate: (
      data: Partial<IOrderStatus>,
      params: RequestParams = {},
    ) =>
      this.request<IOrderStatus, any>({
        path: `/OrderStatus/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderStatus
     * @name OrderStatusPatchPartialUpdate
     * @request PATCH:/api/OrderStatus/Patch/{id}
     * @secure
     */
    orderStatusPatchPartialUpdate: (
      { id }: IOrderStatusPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/OrderStatus/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderStatus
     * @name OrderStatusDeleteDelete
     * @request DELETE:/api/OrderStatus/Delete/{id}
     * @secure
     */
    orderStatusDeleteDelete: (
      { id }: IOrderStatusDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IOrderStatus, any>({
        path: `/OrderStatus/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PaymentTransaction
     * @name PaymentTransactionGetMetaDataList
     * @request GET:/api/PaymentTransaction/GetMetaData
     * @secure
     */
    paymentTransactionGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/PaymentTransaction/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PaymentTransaction
     * @name PaymentTransactionGetAllDynamicCreate
     * @request POST:/api/PaymentTransaction/GetAllDynamic
     * @secure
     */
    paymentTransactionGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IPaymentTransaction[], any>({
        path: `/PaymentTransaction/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PaymentTransaction
     * @name PaymentTransactionCreateCreate
     * @request POST:/api/PaymentTransaction/Create
     * @secure
     */
    paymentTransactionCreateCreate: (
      data: Partial<IPaymentTransaction>,
      params: RequestParams = {},
    ) =>
      this.request<IPaymentTransaction, any>({
        path: `/PaymentTransaction/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PaymentTransaction
     * @name PaymentTransactionPatchPartialUpdate
     * @request PATCH:/api/PaymentTransaction/Patch/{id}
     * @secure
     */
    paymentTransactionPatchPartialUpdate: (
      { id }: IPaymentTransactionPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/PaymentTransaction/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PaymentTransaction
     * @name PaymentTransactionDeleteDelete
     * @request DELETE:/api/PaymentTransaction/Delete/{id}
     * @secure
     */
    paymentTransactionDeleteDelete: (
      { id }: IPaymentTransactionDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IPaymentTransaction, any>({
        path: `/PaymentTransaction/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PaymentTransactionHelper
     * @name PaymentTransactionHelperSyncMonitorPaymentsList
     * @request GET:/api/PaymentTransactionHelper/SyncMonitorPayments
     * @secure
     */
    paymentTransactionHelperSyncMonitorPaymentsList: (
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/PaymentTransactionHelper/SyncMonitorPayments`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PaymentTransactionHelper
     * @name PaymentTransactionHelperAddFromBasisPointDetail
     * @request GET:/api/PaymentTransactionHelper/AddFromBasisPoint/{orderID}/{amount}
     * @secure
     */
    paymentTransactionHelperAddFromBasisPointDetail: (
      {
        orderId,
        amount,
      }: IPaymentTransactionHelperAddFromBasisPointDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/PaymentTransactionHelper/AddFromBasisPoint/${orderId}/${amount}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PdfGeneratorHelper
     * @name PdfGeneratorHelperGetPdfFromFileCreate
     * @request POST:/api/PdfGeneratorHelper/GetPdfFromFile
     * @secure
     */
    pdfGeneratorHelperGetPdfFromFileCreate: (
      data: Partial<{
        encodedHtml?: string;
      }>,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/PdfGeneratorHelper/GetPdfFromFile`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product
     * @name ProductGetMetaDataList
     * @request GET:/api/Product/GetMetaData
     * @secure
     */
    productGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/Product/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product
     * @name ProductGetAllDynamicCreate
     * @request POST:/api/Product/GetAllDynamic
     * @secure
     */
    productGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IProduct[], any>({
        path: `/Product/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product
     * @name ProductCreateCreate
     * @request POST:/api/Product/Create
     * @secure
     */
    productCreateCreate: (
      data: Partial<IProduct>,
      params: RequestParams = {},
    ) =>
      this.request<IProduct, any>({
        path: `/Product/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product
     * @name ProductPatchPartialUpdate
     * @request PATCH:/api/Product/Patch/{id}
     * @secure
     */
    productPatchPartialUpdate: (
      { id }: IProductPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/Product/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product
     * @name ProductDeleteDelete
     * @request DELETE:/api/Product/Delete/{id}
     * @secure
     */
    productDeleteDelete: (
      { id }: IProductDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IProduct, any>({
        path: `/Product/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductStep
     * @name ProductStepGetMetaDataList
     * @request GET:/api/ProductStep/GetMetaData
     * @secure
     */
    productStepGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/ProductStep/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductStep
     * @name ProductStepGetAllDynamicCreate
     * @request POST:/api/ProductStep/GetAllDynamic
     * @secure
     */
    productStepGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IProductStep[], any>({
        path: `/ProductStep/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductStep
     * @name ProductStepCreateCreate
     * @request POST:/api/ProductStep/Create
     * @secure
     */
    productStepCreateCreate: (
      data: Partial<IProductStep>,
      params: RequestParams = {},
    ) =>
      this.request<IProductStep, any>({
        path: `/ProductStep/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductStep
     * @name ProductStepPatchPartialUpdate
     * @request PATCH:/api/ProductStep/Patch/{id}
     * @secure
     */
    productStepPatchPartialUpdate: (
      { id }: IProductStepPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/ProductStep/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductStep
     * @name ProductStepDeleteDelete
     * @request DELETE:/api/ProductStep/Delete/{id}
     * @secure
     */
    productStepDeleteDelete: (
      { id }: IProductStepDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IProductStep, any>({
        path: `/ProductStep/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicationApprovalType
     * @name PublicationApprovalTypeGetMetaDataList
     * @request GET:/api/PublicationApprovalType/GetMetaData
     * @secure
     */
    publicationApprovalTypeGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/PublicationApprovalType/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicationApprovalType
     * @name PublicationApprovalTypeGetAllDynamicCreate
     * @request POST:/api/PublicationApprovalType/GetAllDynamic
     * @secure
     */
    publicationApprovalTypeGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IPublicationApprovalType[], any>({
        path: `/PublicationApprovalType/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicationApprovalType
     * @name PublicationApprovalTypeCreateCreate
     * @request POST:/api/PublicationApprovalType/Create
     * @secure
     */
    publicationApprovalTypeCreateCreate: (
      data: Partial<IPublicationApprovalType>,
      params: RequestParams = {},
    ) =>
      this.request<IPublicationApprovalType, any>({
        path: `/PublicationApprovalType/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicationApprovalType
     * @name PublicationApprovalTypePatchPartialUpdate
     * @request PATCH:/api/PublicationApprovalType/Patch/{id}
     * @secure
     */
    publicationApprovalTypePatchPartialUpdate: (
      { id }: IPublicationApprovalTypePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/PublicationApprovalType/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicationApprovalType
     * @name PublicationApprovalTypeDeleteDelete
     * @request DELETE:/api/PublicationApprovalType/Delete/{id}
     * @secure
     */
    publicationApprovalTypeDeleteDelete: (
      { id }: IPublicationApprovalTypeDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IPublicationApprovalType, any>({
        path: `/PublicationApprovalType/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublishType
     * @name PublishTypeGetMetaDataList
     * @request GET:/api/PublishType/GetMetaData
     * @secure
     */
    publishTypeGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/PublishType/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublishType
     * @name PublishTypeGetAllDynamicCreate
     * @request POST:/api/PublishType/GetAllDynamic
     * @secure
     */
    publishTypeGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IPublishType[], any>({
        path: `/PublishType/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublishType
     * @name PublishTypeCreateCreate
     * @request POST:/api/PublishType/Create
     * @secure
     */
    publishTypeCreateCreate: (
      data: Partial<IPublishType>,
      params: RequestParams = {},
    ) =>
      this.request<IPublishType, any>({
        path: `/PublishType/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublishType
     * @name PublishTypePatchPartialUpdate
     * @request PATCH:/api/PublishType/Patch/{id}
     * @secure
     */
    publishTypePatchPartialUpdate: (
      { id }: IPublishTypePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/PublishType/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublishType
     * @name PublishTypeDeleteDelete
     * @request DELETE:/api/PublishType/Delete/{id}
     * @secure
     */
    publishTypeDeleteDelete: (
      { id }: IPublishTypeDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IPublishType, any>({
        path: `/PublishType/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuarterlyMonitoring
     * @name QuarterlyMonitoringGetMetaDataList
     * @request GET:/api/QuarterlyMonitoring/GetMetaData
     * @secure
     */
    quarterlyMonitoringGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/QuarterlyMonitoring/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuarterlyMonitoring
     * @name QuarterlyMonitoringGetAllDynamicCreate
     * @request POST:/api/QuarterlyMonitoring/GetAllDynamic
     * @secure
     */
    quarterlyMonitoringGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IQuarterlyMonitoring[], any>({
        path: `/QuarterlyMonitoring/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuarterlyMonitoring
     * @name QuarterlyMonitoringCreateCreate
     * @request POST:/api/QuarterlyMonitoring/Create
     * @secure
     */
    quarterlyMonitoringCreateCreate: (
      data: Partial<IQuarterlyMonitoring>,
      params: RequestParams = {},
    ) =>
      this.request<IQuarterlyMonitoring, any>({
        path: `/QuarterlyMonitoring/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuarterlyMonitoring
     * @name QuarterlyMonitoringPatchPartialUpdate
     * @request PATCH:/api/QuarterlyMonitoring/Patch/{id}
     * @secure
     */
    quarterlyMonitoringPatchPartialUpdate: (
      { id }: IQuarterlyMonitoringPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/QuarterlyMonitoring/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuarterlyMonitoring
     * @name QuarterlyMonitoringDeleteDelete
     * @request DELETE:/api/QuarterlyMonitoring/Delete/{id}
     * @secure
     */
    quarterlyMonitoringDeleteDelete: (
      { id }: IQuarterlyMonitoringDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IQuarterlyMonitoring, any>({
        path: `/QuarterlyMonitoring/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuarterlyMonitoringPeriod
     * @name QuarterlyMonitoringPeriodGetMetaDataList
     * @request GET:/api/QuarterlyMonitoringPeriod/GetMetaData
     * @secure
     */
    quarterlyMonitoringPeriodGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/QuarterlyMonitoringPeriod/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuarterlyMonitoringPeriod
     * @name QuarterlyMonitoringPeriodGetAllDynamicCreate
     * @request POST:/api/QuarterlyMonitoringPeriod/GetAllDynamic
     * @secure
     */
    quarterlyMonitoringPeriodGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IQuarterlyMonitoringPeriod[], any>({
        path: `/QuarterlyMonitoringPeriod/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuarterlyMonitoringPeriod
     * @name QuarterlyMonitoringPeriodCreateCreate
     * @request POST:/api/QuarterlyMonitoringPeriod/Create
     * @secure
     */
    quarterlyMonitoringPeriodCreateCreate: (
      data: Partial<IQuarterlyMonitoringPeriod>,
      params: RequestParams = {},
    ) =>
      this.request<IQuarterlyMonitoringPeriod, any>({
        path: `/QuarterlyMonitoringPeriod/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuarterlyMonitoringPeriod
     * @name QuarterlyMonitoringPeriodPatchPartialUpdate
     * @request PATCH:/api/QuarterlyMonitoringPeriod/Patch/{id}
     * @secure
     */
    quarterlyMonitoringPeriodPatchPartialUpdate: (
      { id }: IQuarterlyMonitoringPeriodPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/QuarterlyMonitoringPeriod/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuarterlyMonitoringPeriod
     * @name QuarterlyMonitoringPeriodDeleteDelete
     * @request DELETE:/api/QuarterlyMonitoringPeriod/Delete/{id}
     * @secure
     */
    quarterlyMonitoringPeriodDeleteDelete: (
      { id }: IQuarterlyMonitoringPeriodDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IQuarterlyMonitoringPeriod, any>({
        path: `/QuarterlyMonitoringPeriod/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuarterlyMonitoringPeriod
     * @name QuarterlyMonitoringPeriodSyncQuarterlyMonitoringDetail
     * @request GET:/api/QuarterlyMonitoringPeriod/SyncQuarterlyMonitoring/{id}
     * @secure
     */
    quarterlyMonitoringPeriodSyncQuarterlyMonitoringDetail: (
      { id }: IQuarterlyMonitoringPeriodSyncQuarterlyMonitoringDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<IQuarterlyMonitoringPeriod, any>({
        path: `/QuarterlyMonitoringPeriod/SyncQuarterlyMonitoring/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuarterlyMonitoringPeriod
     * @name QuarterlyMonitoringPeriodCompleteQuarterlyMonitoringDetail
     * @request GET:/api/QuarterlyMonitoringPeriod/CompleteQuarterlyMonitoring/{id}
     * @secure
     */
    quarterlyMonitoringPeriodCompleteQuarterlyMonitoringDetail: (
      { id }: IQuarterlyMonitoringPeriodCompleteQuarterlyMonitoringDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<IQuarterlyMonitoringPeriod, any>({
        path: `/QuarterlyMonitoringPeriod/CompleteQuarterlyMonitoring/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuarterlyMonitoringPeriod
     * @name QuarterlyMonitoringPeriodInitQuarterlyMonitoringCreate
     * @request POST:/api/QuarterlyMonitoringPeriod/InitQuarterlyMonitoring/{duplicate}
     * @secure
     */
    quarterlyMonitoringPeriodInitQuarterlyMonitoringCreate: (
      {
        duplicate,
      }: IQuarterlyMonitoringPeriodInitQuarterlyMonitoringCreateParams,
      data: Partial<IQuarterlyMonitoringPeriod>,
      params: RequestParams = {},
    ) =>
      this.request<IQuarterlyMonitoringPeriod, any>({
        path: `/QuarterlyMonitoringPeriod/InitQuarterlyMonitoring/${duplicate}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuarterlyMonitoringPeriodUser
     * @name QuarterlyMonitoringPeriodUserGetMetaDataList
     * @request GET:/api/QuarterlyMonitoringPeriodUser/GetMetaData
     * @secure
     */
    quarterlyMonitoringPeriodUserGetMetaDataList: (
      params: RequestParams = {},
    ) =>
      this.request<ILayoutMetaData, any>({
        path: `/QuarterlyMonitoringPeriodUser/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuarterlyMonitoringPeriodUser
     * @name QuarterlyMonitoringPeriodUserGetAllDynamicCreate
     * @request POST:/api/QuarterlyMonitoringPeriodUser/GetAllDynamic
     * @secure
     */
    quarterlyMonitoringPeriodUserGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IQuarterlyMonitoringPeriodUser[], any>({
        path: `/QuarterlyMonitoringPeriodUser/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuarterlyMonitoringPeriodUser
     * @name QuarterlyMonitoringPeriodUserCreateCreate
     * @request POST:/api/QuarterlyMonitoringPeriodUser/Create
     * @secure
     */
    quarterlyMonitoringPeriodUserCreateCreate: (
      data: Partial<IQuarterlyMonitoringPeriodUser>,
      params: RequestParams = {},
    ) =>
      this.request<IQuarterlyMonitoringPeriodUser, any>({
        path: `/QuarterlyMonitoringPeriodUser/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuarterlyMonitoringPeriodUser
     * @name QuarterlyMonitoringPeriodUserPatchPartialUpdate
     * @request PATCH:/api/QuarterlyMonitoringPeriodUser/Patch/{id}
     * @secure
     */
    quarterlyMonitoringPeriodUserPatchPartialUpdate: (
      { id }: IQuarterlyMonitoringPeriodUserPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/QuarterlyMonitoringPeriodUser/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuarterlyMonitoringPeriodUser
     * @name QuarterlyMonitoringPeriodUserDeleteDelete
     * @request DELETE:/api/QuarterlyMonitoringPeriodUser/Delete/{id}
     * @secure
     */
    quarterlyMonitoringPeriodUserDeleteDelete: (
      { id }: IQuarterlyMonitoringPeriodUserDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IQuarterlyMonitoringPeriodUser, any>({
        path: `/QuarterlyMonitoringPeriodUser/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingAndTrackingMessage
     * @name RatingAndTrackingMessageGetMetaDataList
     * @request GET:/api/RatingAndTrackingMessage/GetMetaData
     * @secure
     */
    ratingAndTrackingMessageGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingAndTrackingMessage/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingAndTrackingMessage
     * @name RatingAndTrackingMessageGetAllDynamicCreate
     * @request POST:/api/RatingAndTrackingMessage/GetAllDynamic
     * @secure
     */
    ratingAndTrackingMessageGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingAndTrackingMessage[], any>({
        path: `/RatingAndTrackingMessage/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingAndTrackingMessage
     * @name RatingAndTrackingMessageCreateCreate
     * @request POST:/api/RatingAndTrackingMessage/Create
     * @secure
     */
    ratingAndTrackingMessageCreateCreate: (
      data: Partial<IRatingAndTrackingMessage>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingAndTrackingMessage, any>({
        path: `/RatingAndTrackingMessage/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingAndTrackingMessage
     * @name RatingAndTrackingMessagePatchPartialUpdate
     * @request PATCH:/api/RatingAndTrackingMessage/Patch/{id}
     * @secure
     */
    ratingAndTrackingMessagePatchPartialUpdate: (
      { id }: IRatingAndTrackingMessagePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingAndTrackingMessage/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingAndTrackingMessage
     * @name RatingAndTrackingMessageDeleteDelete
     * @request DELETE:/api/RatingAndTrackingMessage/Delete/{id}
     * @secure
     */
    ratingAndTrackingMessageDeleteDelete: (
      { id }: IRatingAndTrackingMessageDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingAndTrackingMessage, any>({
        path: `/RatingAndTrackingMessage/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingHistory
     * @name RatingHistoryGetMetaDataList
     * @request GET:/api/RatingHistory/GetMetaData
     * @secure
     */
    ratingHistoryGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingHistory/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingHistory
     * @name RatingHistoryGetAllDynamicCreate
     * @request POST:/api/RatingHistory/GetAllDynamic
     * @secure
     */
    ratingHistoryGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingHistory[], any>({
        path: `/RatingHistory/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingHistory
     * @name RatingHistoryCreateCreate
     * @request POST:/api/RatingHistory/Create
     * @secure
     */
    ratingHistoryCreateCreate: (
      data: Partial<IRatingHistory>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingHistory, any>({
        path: `/RatingHistory/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingHistory
     * @name RatingHistoryPatchPartialUpdate
     * @request PATCH:/api/RatingHistory/Patch/{id}
     * @secure
     */
    ratingHistoryPatchPartialUpdate: (
      { id }: IRatingHistoryPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingHistory/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingHistory
     * @name RatingHistoryDeleteDelete
     * @request DELETE:/api/RatingHistory/Delete/{id}
     * @secure
     */
    ratingHistoryDeleteDelete: (
      { id }: IRatingHistoryDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingHistory, any>({
        path: `/RatingHistory/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingInitiative
     * @name RatingInitiativeGetMetaDataList
     * @request GET:/api/RatingInitiative/GetMetaData
     * @secure
     */
    ratingInitiativeGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingInitiative/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingInitiative
     * @name RatingInitiativeGetAllDynamicCreate
     * @request POST:/api/RatingInitiative/GetAllDynamic
     * @secure
     */
    ratingInitiativeGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingInitiative[], any>({
        path: `/RatingInitiative/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingInitiative
     * @name RatingInitiativeCreateCreate
     * @request POST:/api/RatingInitiative/Create
     * @secure
     */
    ratingInitiativeCreateCreate: (
      data: Partial<IRatingInitiative>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingInitiative, any>({
        path: `/RatingInitiative/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingInitiative
     * @name RatingInitiativePatchPartialUpdate
     * @request PATCH:/api/RatingInitiative/Patch/{id}
     * @secure
     */
    ratingInitiativePatchPartialUpdate: (
      { id }: IRatingInitiativePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingInitiative/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingInitiative
     * @name RatingInitiativeDeleteDelete
     * @request DELETE:/api/RatingInitiative/Delete/{id}
     * @secure
     */
    ratingInitiativeDeleteDelete: (
      { id }: IRatingInitiativeDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingInitiative, any>({
        path: `/RatingInitiative/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrix
     * @name RatingMatrixGetMetaDataList
     * @request GET:/api/RatingMatrix/GetMetaData
     * @secure
     */
    ratingMatrixGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingMatrix/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrix
     * @name RatingMatrixGetAllDynamicCreate
     * @request POST:/api/RatingMatrix/GetAllDynamic
     * @secure
     */
    ratingMatrixGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrix[], any>({
        path: `/RatingMatrix/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrix
     * @name RatingMatrixCreateCreate
     * @request POST:/api/RatingMatrix/Create
     * @secure
     */
    ratingMatrixCreateCreate: (
      data: Partial<IRatingMatrix>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrix, any>({
        path: `/RatingMatrix/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrix
     * @name RatingMatrixPatchPartialUpdate
     * @request PATCH:/api/RatingMatrix/Patch/{id}
     * @secure
     */
    ratingMatrixPatchPartialUpdate: (
      { id }: IRatingMatrixPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingMatrix/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrix
     * @name RatingMatrixDeleteDelete
     * @request DELETE:/api/RatingMatrix/Delete/{id}
     * @secure
     */
    ratingMatrixDeleteDelete: (
      { id }: IRatingMatrixDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrix, any>({
        path: `/RatingMatrix/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixDocument
     * @name RatingMatrixDocumentGetMetaDataList
     * @request GET:/api/RatingMatrixDocument/GetMetaData
     * @secure
     */
    ratingMatrixDocumentGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingMatrixDocument/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixDocument
     * @name RatingMatrixDocumentGetAllDynamicCreate
     * @request POST:/api/RatingMatrixDocument/GetAllDynamic
     * @secure
     */
    ratingMatrixDocumentGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixDocument[], any>({
        path: `/RatingMatrixDocument/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixDocument
     * @name RatingMatrixDocumentCreateCreate
     * @request POST:/api/RatingMatrixDocument/Create
     * @secure
     */
    ratingMatrixDocumentCreateCreate: (
      data: Partial<IRatingMatrixDocument>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixDocument, any>({
        path: `/RatingMatrixDocument/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixDocument
     * @name RatingMatrixDocumentPatchPartialUpdate
     * @request PATCH:/api/RatingMatrixDocument/Patch/{id}
     * @secure
     */
    ratingMatrixDocumentPatchPartialUpdate: (
      { id }: IRatingMatrixDocumentPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingMatrixDocument/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixDocument
     * @name RatingMatrixDocumentDeleteDelete
     * @request DELETE:/api/RatingMatrixDocument/Delete/{id}
     * @secure
     */
    ratingMatrixDocumentDeleteDelete: (
      { id }: IRatingMatrixDocumentDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixDocument, any>({
        path: `/RatingMatrixDocument/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixDocumentHelper
     * @name RatingMatrixDocumentHelperExportRatingMatrixCreate
     * @request POST:/api/RatingMatrixDocumentHelper/ExportRatingMatrix
     * @secure
     */
    ratingMatrixDocumentHelperExportRatingMatrixCreate: (
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingMatrixDocumentHelper/ExportRatingMatrix`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFramework
     * @name RatingMatrixFrameworkGetMetaDataList
     * @request GET:/api/RatingMatrixFramework/GetMetaData
     * @secure
     */
    ratingMatrixFrameworkGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingMatrixFramework/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFramework
     * @name RatingMatrixFrameworkGetAllDynamicCreate
     * @request POST:/api/RatingMatrixFramework/GetAllDynamic
     * @secure
     */
    ratingMatrixFrameworkGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFramework[], any>({
        path: `/RatingMatrixFramework/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFramework
     * @name RatingMatrixFrameworkGetListDynamicCreate
     * @request POST:/api/RatingMatrixFramework/GetListDynamic
     * @secure
     */
    ratingMatrixFrameworkGetListDynamicCreate: (
      data: Partial<IGetListDynamic>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFramework[], any>({
        path: `/RatingMatrixFramework/GetListDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFramework
     * @name RatingMatrixFrameworkGetFullFrameworkDetail
     * @request GET:/api/RatingMatrixFramework/GetFullFramework/{id}
     * @secure
     */
    ratingMatrixFrameworkGetFullFrameworkDetail: (
      { id }: IRatingMatrixFrameworkGetFullFrameworkDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFramework, any>({
        path: `/RatingMatrixFramework/GetFullFramework/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFramework
     * @name RatingMatrixFrameworkDeleteDelete
     * @request DELETE:/api/RatingMatrixFramework/Delete/{id}
     * @secure
     */
    ratingMatrixFrameworkDeleteDelete: (
      { id }: IRatingMatrixFrameworkDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFramework, any>({
        path: `/RatingMatrixFramework/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFramework
     * @name RatingMatrixFrameworkCreateCreate
     * @request POST:/api/RatingMatrixFramework/Create
     * @secure
     */
    ratingMatrixFrameworkCreateCreate: (
      data: Partial<IRatingMatrixFramework>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFramework, any>({
        path: `/RatingMatrixFramework/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFramework
     * @name RatingMatrixFrameworkPatchPartialUpdate
     * @request PATCH:/api/RatingMatrixFramework/Patch/{id}
     * @secure
     */
    ratingMatrixFrameworkPatchPartialUpdate: (
      { id }: IRatingMatrixFrameworkPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingMatrixFramework/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFramework
     * @name RatingMatrixFrameworkCloneCreate
     * @request POST:/api/RatingMatrixFramework/Clone/{id}
     * @secure
     */
    ratingMatrixFrameworkCloneCreate: (
      { id }: IRatingMatrixFrameworkCloneCreateParams,
      params: RequestParams = {},
    ) =>
      this.request<number, any>({
        path: `/RatingMatrixFramework/Clone/${id}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFramework
     * @name RatingMatrixFrameworkArchiveCreate
     * @request POST:/api/RatingMatrixFramework/Archive/{id}
     * @secure
     */
    ratingMatrixFrameworkArchiveCreate: (
      { id }: IRatingMatrixFrameworkArchiveCreateParams,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingMatrixFramework/Archive/${id}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkConsideration
     * @name RatingMatrixFrameworkConsiderationGetMetaDataList
     * @request GET:/api/RatingMatrixFrameworkConsideration/GetMetaData
     * @secure
     */
    ratingMatrixFrameworkConsiderationGetMetaDataList: (
      params: RequestParams = {},
    ) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingMatrixFrameworkConsideration/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkConsideration
     * @name RatingMatrixFrameworkConsiderationGetAllDynamicCreate
     * @request POST:/api/RatingMatrixFrameworkConsideration/GetAllDynamic
     * @secure
     */
    ratingMatrixFrameworkConsiderationGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFrameworkConsideration[], any>({
        path: `/RatingMatrixFrameworkConsideration/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkConsideration
     * @name RatingMatrixFrameworkConsiderationCreateCreate
     * @request POST:/api/RatingMatrixFrameworkConsideration/Create
     * @secure
     */
    ratingMatrixFrameworkConsiderationCreateCreate: (
      data: Partial<IRatingMatrixFrameworkConsideration>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFrameworkConsideration, any>({
        path: `/RatingMatrixFrameworkConsideration/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkConsideration
     * @name RatingMatrixFrameworkConsiderationPatchPartialUpdate
     * @request PATCH:/api/RatingMatrixFrameworkConsideration/Patch/{id}
     * @secure
     */
    ratingMatrixFrameworkConsiderationPatchPartialUpdate: (
      { id }: IRatingMatrixFrameworkConsiderationPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingMatrixFrameworkConsideration/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkConsideration
     * @name RatingMatrixFrameworkConsiderationDeleteDelete
     * @request DELETE:/api/RatingMatrixFrameworkConsideration/Delete/{id}
     * @secure
     */
    ratingMatrixFrameworkConsiderationDeleteDelete: (
      { id }: IRatingMatrixFrameworkConsiderationDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFrameworkConsideration, any>({
        path: `/RatingMatrixFrameworkConsideration/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkGradeScore
     * @name RatingMatrixFrameworkGradeScoreGetMetaDataList
     * @request GET:/api/RatingMatrixFrameworkGradeScore/GetMetaData
     * @secure
     */
    ratingMatrixFrameworkGradeScoreGetMetaDataList: (
      params: RequestParams = {},
    ) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingMatrixFrameworkGradeScore/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkGradeScore
     * @name RatingMatrixFrameworkGradeScoreGetAllDynamicCreate
     * @request POST:/api/RatingMatrixFrameworkGradeScore/GetAllDynamic
     * @secure
     */
    ratingMatrixFrameworkGradeScoreGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFrameworkGradeScore[], any>({
        path: `/RatingMatrixFrameworkGradeScore/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkGradeScore
     * @name RatingMatrixFrameworkGradeScoreCreateCreate
     * @request POST:/api/RatingMatrixFrameworkGradeScore/Create
     * @secure
     */
    ratingMatrixFrameworkGradeScoreCreateCreate: (
      data: Partial<IRatingMatrixFrameworkGradeScore>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFrameworkGradeScore, any>({
        path: `/RatingMatrixFrameworkGradeScore/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkGradeScore
     * @name RatingMatrixFrameworkGradeScoreSaveScoreMapCreate
     * @request POST:/api/RatingMatrixFrameworkGradeScore/SaveScoreMap
     * @secure
     */
    ratingMatrixFrameworkGradeScoreSaveScoreMapCreate: (
      data: Partial<IRatingMatrixFrameworkGradeScore[]>,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingMatrixFrameworkGradeScore/SaveScoreMap`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkGradeScore
     * @name RatingMatrixFrameworkGradeScorePatchPartialUpdate
     * @request PATCH:/api/RatingMatrixFrameworkGradeScore/Patch/{id}
     * @secure
     */
    ratingMatrixFrameworkGradeScorePatchPartialUpdate: (
      { id }: IRatingMatrixFrameworkGradeScorePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingMatrixFrameworkGradeScore/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkGradeScore
     * @name RatingMatrixFrameworkGradeScoreDeleteDelete
     * @request DELETE:/api/RatingMatrixFrameworkGradeScore/Delete/{id}
     * @secure
     */
    ratingMatrixFrameworkGradeScoreDeleteDelete: (
      { id }: IRatingMatrixFrameworkGradeScoreDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFrameworkGradeScore, any>({
        path: `/RatingMatrixFrameworkGradeScore/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkOption
     * @name RatingMatrixFrameworkOptionGetMetaDataList
     * @request GET:/api/RatingMatrixFrameworkOption/GetMetaData
     * @secure
     */
    ratingMatrixFrameworkOptionGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingMatrixFrameworkOption/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkOption
     * @name RatingMatrixFrameworkOptionGetAllDynamicCreate
     * @request POST:/api/RatingMatrixFrameworkOption/GetAllDynamic
     * @secure
     */
    ratingMatrixFrameworkOptionGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFrameworkOption[], any>({
        path: `/RatingMatrixFrameworkOption/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkOption
     * @name RatingMatrixFrameworkOptionCreateCreate
     * @request POST:/api/RatingMatrixFrameworkOption/Create
     * @secure
     */
    ratingMatrixFrameworkOptionCreateCreate: (
      data: Partial<IRatingMatrixFrameworkOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFrameworkOption, any>({
        path: `/RatingMatrixFrameworkOption/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkOption
     * @name RatingMatrixFrameworkOptionSaveBulkCreate
     * @request POST:/api/RatingMatrixFrameworkOption/SaveBulk
     * @secure
     */
    ratingMatrixFrameworkOptionSaveBulkCreate: (
      data: Partial<IRatingMatrixFrameworkOption[]>,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingMatrixFrameworkOption/SaveBulk`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkOption
     * @name RatingMatrixFrameworkOptionPatchPartialUpdate
     * @request PATCH:/api/RatingMatrixFrameworkOption/Patch/{id}
     * @secure
     */
    ratingMatrixFrameworkOptionPatchPartialUpdate: (
      { id }: IRatingMatrixFrameworkOptionPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingMatrixFrameworkOption/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkOption
     * @name RatingMatrixFrameworkOptionDeleteDelete
     * @request DELETE:/api/RatingMatrixFrameworkOption/Delete/{id}
     * @secure
     */
    ratingMatrixFrameworkOptionDeleteDelete: (
      { id }: IRatingMatrixFrameworkOptionDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFrameworkOption, any>({
        path: `/RatingMatrixFrameworkOption/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkParameter
     * @name RatingMatrixFrameworkParameterGetMetaDataList
     * @request GET:/api/RatingMatrixFrameworkParameter/GetMetaData
     * @secure
     */
    ratingMatrixFrameworkParameterGetMetaDataList: (
      params: RequestParams = {},
    ) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingMatrixFrameworkParameter/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkParameter
     * @name RatingMatrixFrameworkParameterGetAllDynamicCreate
     * @request POST:/api/RatingMatrixFrameworkParameter/GetAllDynamic
     * @secure
     */
    ratingMatrixFrameworkParameterGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFrameworkParameter[], any>({
        path: `/RatingMatrixFrameworkParameter/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkParameter
     * @name RatingMatrixFrameworkParameterCreateCreate
     * @request POST:/api/RatingMatrixFrameworkParameter/Create
     * @secure
     */
    ratingMatrixFrameworkParameterCreateCreate: (
      data: Partial<IRatingMatrixFrameworkParameter>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFrameworkParameter, any>({
        path: `/RatingMatrixFrameworkParameter/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkParameter
     * @name RatingMatrixFrameworkParameterPatchPartialUpdate
     * @request PATCH:/api/RatingMatrixFrameworkParameter/Patch/{id}
     * @secure
     */
    ratingMatrixFrameworkParameterPatchPartialUpdate: (
      { id }: IRatingMatrixFrameworkParameterPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingMatrixFrameworkParameter/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkParameter
     * @name RatingMatrixFrameworkParameterDeleteDelete
     * @request DELETE:/api/RatingMatrixFrameworkParameter/Delete/{id}
     * @secure
     */
    ratingMatrixFrameworkParameterDeleteDelete: (
      { id }: IRatingMatrixFrameworkParameterDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFrameworkParameter, any>({
        path: `/RatingMatrixFrameworkParameter/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkRange
     * @name RatingMatrixFrameworkRangeGetMetaDataList
     * @request GET:/api/RatingMatrixFrameworkRange/GetMetaData
     * @secure
     */
    ratingMatrixFrameworkRangeGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingMatrixFrameworkRange/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkRange
     * @name RatingMatrixFrameworkRangeGetAllDynamicCreate
     * @request POST:/api/RatingMatrixFrameworkRange/GetAllDynamic
     * @secure
     */
    ratingMatrixFrameworkRangeGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFrameworkRange[], any>({
        path: `/RatingMatrixFrameworkRange/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkRange
     * @name RatingMatrixFrameworkRangeCreateCreate
     * @request POST:/api/RatingMatrixFrameworkRange/Create
     * @secure
     */
    ratingMatrixFrameworkRangeCreateCreate: (
      data: Partial<IRatingMatrixFrameworkRange>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFrameworkRange, any>({
        path: `/RatingMatrixFrameworkRange/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkRange
     * @name RatingMatrixFrameworkRangeSaveBulkCreate
     * @request POST:/api/RatingMatrixFrameworkRange/SaveBulk
     * @secure
     */
    ratingMatrixFrameworkRangeSaveBulkCreate: (
      data: Partial<IRatingMatrixFrameworkRange[]>,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingMatrixFrameworkRange/SaveBulk`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkRange
     * @name RatingMatrixFrameworkRangePatchPartialUpdate
     * @request PATCH:/api/RatingMatrixFrameworkRange/Patch/{id}
     * @secure
     */
    ratingMatrixFrameworkRangePatchPartialUpdate: (
      { id }: IRatingMatrixFrameworkRangePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingMatrixFrameworkRange/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkRange
     * @name RatingMatrixFrameworkRangeDeleteDelete
     * @request DELETE:/api/RatingMatrixFrameworkRange/Delete/{id}
     * @secure
     */
    ratingMatrixFrameworkRangeDeleteDelete: (
      { id }: IRatingMatrixFrameworkRangeDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFrameworkRange, any>({
        path: `/RatingMatrixFrameworkRange/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkSubParameter
     * @name RatingMatrixFrameworkSubParameterGetMetaDataList
     * @request GET:/api/RatingMatrixFrameworkSubParameter/GetMetaData
     * @secure
     */
    ratingMatrixFrameworkSubParameterGetMetaDataList: (
      params: RequestParams = {},
    ) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingMatrixFrameworkSubParameter/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkSubParameter
     * @name RatingMatrixFrameworkSubParameterGetAllDynamicCreate
     * @request POST:/api/RatingMatrixFrameworkSubParameter/GetAllDynamic
     * @secure
     */
    ratingMatrixFrameworkSubParameterGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFrameworkSubParameter[], any>({
        path: `/RatingMatrixFrameworkSubParameter/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkSubParameter
     * @name RatingMatrixFrameworkSubParameterCreateCreate
     * @request POST:/api/RatingMatrixFrameworkSubParameter/Create
     * @secure
     */
    ratingMatrixFrameworkSubParameterCreateCreate: (
      data: Partial<IRatingMatrixFrameworkSubParameter>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFrameworkSubParameter, any>({
        path: `/RatingMatrixFrameworkSubParameter/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkSubParameter
     * @name RatingMatrixFrameworkSubParameterPatchPartialUpdate
     * @request PATCH:/api/RatingMatrixFrameworkSubParameter/Patch/{id}
     * @secure
     */
    ratingMatrixFrameworkSubParameterPatchPartialUpdate: (
      { id }: IRatingMatrixFrameworkSubParameterPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingMatrixFrameworkSubParameter/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkSubParameter
     * @name RatingMatrixFrameworkSubParameterDeleteDelete
     * @request DELETE:/api/RatingMatrixFrameworkSubParameter/Delete/{id}
     * @secure
     */
    ratingMatrixFrameworkSubParameterDeleteDelete: (
      { id }: IRatingMatrixFrameworkSubParameterDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFrameworkSubParameter, any>({
        path: `/RatingMatrixFrameworkSubParameter/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkTemplate
     * @name RatingMatrixFrameworkTemplateGetMetaDataList
     * @request GET:/api/RatingMatrixFrameworkTemplate/GetMetaData
     * @secure
     */
    ratingMatrixFrameworkTemplateGetMetaDataList: (
      params: RequestParams = {},
    ) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingMatrixFrameworkTemplate/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkTemplate
     * @name RatingMatrixFrameworkTemplateGetAllDynamicCreate
     * @request POST:/api/RatingMatrixFrameworkTemplate/GetAllDynamic
     * @secure
     */
    ratingMatrixFrameworkTemplateGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFrameworkTemplate[], any>({
        path: `/RatingMatrixFrameworkTemplate/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkTemplate
     * @name RatingMatrixFrameworkTemplateGetFullTemplateDetail
     * @request GET:/api/RatingMatrixFrameworkTemplate/GetFullTemplate/{id}
     * @secure
     */
    ratingMatrixFrameworkTemplateGetFullTemplateDetail: (
      { id }: IRatingMatrixFrameworkTemplateGetFullTemplateDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFrameworkTemplate, any>({
        path: `/RatingMatrixFrameworkTemplate/GetFullTemplate/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkTemplate
     * @name RatingMatrixFrameworkTemplateCreateCreate
     * @request POST:/api/RatingMatrixFrameworkTemplate/Create
     * @secure
     */
    ratingMatrixFrameworkTemplateCreateCreate: (
      data: Partial<IRatingMatrixFrameworkTemplate>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFrameworkTemplate, any>({
        path: `/RatingMatrixFrameworkTemplate/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkTemplate
     * @name RatingMatrixFrameworkTemplatePatchPartialUpdate
     * @request PATCH:/api/RatingMatrixFrameworkTemplate/Patch/{id}
     * @secure
     */
    ratingMatrixFrameworkTemplatePatchPartialUpdate: (
      { id }: IRatingMatrixFrameworkTemplatePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingMatrixFrameworkTemplate/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkTemplate
     * @name RatingMatrixFrameworkTemplateDeleteDelete
     * @request DELETE:/api/RatingMatrixFrameworkTemplate/Delete/{id}
     * @secure
     */
    ratingMatrixFrameworkTemplateDeleteDelete: (
      { id }: IRatingMatrixFrameworkTemplateDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFrameworkTemplate, any>({
        path: `/RatingMatrixFrameworkTemplate/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkTemplate
     * @name RatingMatrixFrameworkTemplateCloneCreate
     * @request POST:/api/RatingMatrixFrameworkTemplate/Clone/{id}
     * @secure
     */
    ratingMatrixFrameworkTemplateCloneCreate: (
      { id }: IRatingMatrixFrameworkTemplateCloneCreateParams,
      data: Partial<ICloneTemplateOverride>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixFrameworkTemplate, any>({
        path: `/RatingMatrixFrameworkTemplate/Clone/${id}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkTemplate
     * @name RatingMatrixFrameworkTemplateActivateCreate
     * @request POST:/api/RatingMatrixFrameworkTemplate/Activate/{id}
     * @secure
     */
    ratingMatrixFrameworkTemplateActivateCreate: (
      { id }: IRatingMatrixFrameworkTemplateActivateCreateParams,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingMatrixFrameworkTemplate/Activate/${id}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkTemplate
     * @name RatingMatrixFrameworkTemplateLockCreate
     * @request POST:/api/RatingMatrixFrameworkTemplate/Lock/{id}
     * @secure
     */
    ratingMatrixFrameworkTemplateLockCreate: (
      { id }: IRatingMatrixFrameworkTemplateLockCreateParams,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingMatrixFrameworkTemplate/Lock/${id}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkTemplate
     * @name RatingMatrixFrameworkTemplateUnlockCreate
     * @request POST:/api/RatingMatrixFrameworkTemplate/Unlock/{id}
     * @secure
     */
    ratingMatrixFrameworkTemplateUnlockCreate: (
      { id }: IRatingMatrixFrameworkTemplateUnlockCreateParams,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingMatrixFrameworkTemplate/Unlock/${id}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkTemplate
     * @name RatingMatrixFrameworkTemplateApproveCreate
     * @request POST:/api/RatingMatrixFrameworkTemplate/Approve/{id}
     * @secure
     */
    ratingMatrixFrameworkTemplateApproveCreate: (
      { id }: IRatingMatrixFrameworkTemplateApproveCreateParams,
      data: Partial<IApproveTemplateRequest>,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingMatrixFrameworkTemplate/Approve/${id}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkTemplate
     * @name RatingMatrixFrameworkTemplateArchiveCreate
     * @request POST:/api/RatingMatrixFrameworkTemplate/Archive/{id}
     * @secure
     */
    ratingMatrixFrameworkTemplateArchiveCreate: (
      { id }: IRatingMatrixFrameworkTemplateArchiveCreateParams,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingMatrixFrameworkTemplate/Archive/${id}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkTemplate
     * @name RatingMatrixFrameworkTemplateUnarchiveCreate
     * @request POST:/api/RatingMatrixFrameworkTemplate/Unarchive/{id}
     * @secure
     */
    ratingMatrixFrameworkTemplateUnarchiveCreate: (
      { id }: IRatingMatrixFrameworkTemplateUnarchiveCreateParams,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingMatrixFrameworkTemplate/Unarchive/${id}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkTemplate
     * @name RatingMatrixFrameworkTemplateValidateWeightsDetail
     * @request GET:/api/RatingMatrixFrameworkTemplate/ValidateWeights/{id}
     * @secure
     */
    ratingMatrixFrameworkTemplateValidateWeightsDetail: (
      { id }: IRatingMatrixFrameworkTemplateValidateWeightsDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/RatingMatrixFrameworkTemplate/ValidateWeights/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkTemplate
     * @name RatingMatrixFrameworkTemplateCalculateCreate
     * @request POST:/api/RatingMatrixFrameworkTemplate/Calculate/{id}
     * @secure
     */
    ratingMatrixFrameworkTemplateCalculateCreate: (
      { id }: IRatingMatrixFrameworkTemplateCalculateCreateParams,
      data: Partial<ICalculationRequest>,
      params: RequestParams = {},
    ) =>
      this.request<ICalculationResult, any>({
        path: `/RatingMatrixFrameworkTemplate/Calculate/${id}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkTemplate
     * @name RatingMatrixFrameworkTemplateGradeLadderDetail
     * @request GET:/api/RatingMatrixFrameworkTemplate/GradeLadder/{id}
     * @secure
     */
    ratingMatrixFrameworkTemplateGradeLadderDetail: (
      { id }: IRatingMatrixFrameworkTemplateGradeLadderDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<IGradeLadderResult, any>({
        path: `/RatingMatrixFrameworkTemplate/GradeLadder/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingMatrixFrameworkTemplate
     * @name RatingMatrixFrameworkTemplateImportPreviewCreate
     * @request POST:/api/RatingMatrixFrameworkTemplate/ImportPreview/{frameworkId}
     * @secure
     */
    ratingMatrixFrameworkTemplateImportPreviewCreate: (
      { frameworkId }: IRatingMatrixFrameworkTemplateImportPreviewCreateParams,
      data: Partial<{
        /** @format binary */
        file?: File;
      }>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrixImportPreviewResult, any>({
        path: `/RatingMatrixFrameworkTemplate/ImportPreview/${frameworkId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingPerformanceCategory
     * @name RatingPerformanceCategoryGetMetaDataList
     * @request GET:/api/RatingPerformanceCategory/GetMetaData
     * @secure
     */
    ratingPerformanceCategoryGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingPerformanceCategory/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingPerformanceCategory
     * @name RatingPerformanceCategoryGetAllDynamicCreate
     * @request POST:/api/RatingPerformanceCategory/GetAllDynamic
     * @secure
     */
    ratingPerformanceCategoryGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingPerformanceCategory[], any>({
        path: `/RatingPerformanceCategory/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingPerformanceCategory
     * @name RatingPerformanceCategoryCreateCreate
     * @request POST:/api/RatingPerformanceCategory/Create
     * @secure
     */
    ratingPerformanceCategoryCreateCreate: (
      data: Partial<IRatingPerformanceCategory>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingPerformanceCategory, any>({
        path: `/RatingPerformanceCategory/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingPerformanceCategory
     * @name RatingPerformanceCategoryPatchPartialUpdate
     * @request PATCH:/api/RatingPerformanceCategory/Patch/{id}
     * @secure
     */
    ratingPerformanceCategoryPatchPartialUpdate: (
      { id }: IRatingPerformanceCategoryPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingPerformanceCategory/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingPerformanceCategory
     * @name RatingPerformanceCategoryDeleteDelete
     * @request DELETE:/api/RatingPerformanceCategory/Delete/{id}
     * @secure
     */
    ratingPerformanceCategoryDeleteDelete: (
      { id }: IRatingPerformanceCategoryDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingPerformanceCategory, any>({
        path: `/RatingPerformanceCategory/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingPerformanceHelper
     * @name RatingPerformanceHelperGetAllForRatingPerformanceDynamicCreate
     * @request POST:/api/RatingPerformanceHelper/GetAllForRatingPerformanceDynamic
     * @secure
     */
    ratingPerformanceHelperGetAllForRatingPerformanceDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessForRatingPerformance[], any>({
        path: `/RatingPerformanceHelper/GetAllForRatingPerformanceDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingPerformanceHelper
     * @name RatingPerformanceHelperUpdateForRatingPerformanceUpdate
     * @request PUT:/api/RatingPerformanceHelper/UpdateForRatingPerformance/{id}
     * @secure
     */
    ratingPerformanceHelperUpdateForRatingPerformanceUpdate: (
      { id }: IRatingPerformanceHelperUpdateForRatingPerformanceUpdateParams,
      data: IRatingProcessForRatingPerformanceBase,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingPerformanceHelper/UpdateForRatingPerformance/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingPerformanceHelper
     * @name RatingPerformanceHelperUpdateSeriesForRatingPerformanceUpdate
     * @request PUT:/api/RatingPerformanceHelper/UpdateSeriesForRatingPerformance/{id}
     * @secure
     */
    ratingPerformanceHelperUpdateSeriesForRatingPerformanceUpdate: (
      {
        id,
      }: IRatingPerformanceHelperUpdateSeriesForRatingPerformanceUpdateParams,
      data: ISeriesDetailForRatingPerformanceBase,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingPerformanceHelper/UpdateSeriesForRatingPerformance/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingPerformanceHelper
     * @name RatingPerformanceHelperSyncRatingMatrixList
     * @request GET:/api/RatingPerformanceHelper/SyncRatingMatrix
     * @secure
     */
    ratingPerformanceHelperSyncRatingMatrixList: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/RatingPerformanceHelper/SyncRatingMatrix`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingPerformanceHelper
     * @name RatingPerformanceHelperExportMatrixList
     * @request GET:/api/RatingPerformanceHelper/ExportMatrix
     * @secure
     */
    ratingPerformanceHelperExportMatrixList: (
      query: IRatingPerformanceHelperExportMatrixListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/RatingPerformanceHelper/ExportMatrix`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingPerformanceHelper
     * @name RatingPerformanceHelperSyncRatingPerformanceList
     * @request GET:/api/RatingPerformanceHelper/SyncRatingPerformance
     * @secure
     */
    ratingPerformanceHelperSyncRatingPerformanceList: (
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingPerformanceHelper/SyncRatingPerformance`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingPerformanceHelper
     * @name RatingPerformanceHelperCloneRatingMatrixDetail
     * @request GET:/api/RatingPerformanceHelper/CloneRatingMatrix/{id}
     * @secure
     */
    ratingPerformanceHelperCloneRatingMatrixDetail: (
      { id }: IRatingPerformanceHelperCloneRatingMatrixDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingPerformanceHelper/CloneRatingMatrix/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingPerformanceHelper
     * @name RatingPerformanceHelperUpdateRatingMatrixUpdate
     * @request PUT:/api/RatingPerformanceHelper/UpdateRatingMatrix/{id}
     * @secure
     */
    ratingPerformanceHelperUpdateRatingMatrixUpdate: (
      { id }: IRatingPerformanceHelperUpdateRatingMatrixUpdateParams,
      data: IRatingMatrix,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingPerformanceHelper/UpdateRatingMatrix/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingPerformanceHelper
     * @name RatingPerformanceHelperDeleteRatingMatrixDelete
     * @request DELETE:/api/RatingPerformanceHelper/DeleteRatingMatrix/{id}
     * @secure
     */
    ratingPerformanceHelperDeleteRatingMatrixDelete: (
      { id }: IRatingPerformanceHelperDeleteRatingMatrixDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingMatrix, any>({
        path: `/RatingPerformanceHelper/DeleteRatingMatrix/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcess
     * @name RatingProcessGetMetaDataList
     * @request GET:/api/RatingProcess/GetMetaData
     * @secure
     */
    ratingProcessGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcess/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcess
     * @name RatingProcessGetAllDynamicCreate
     * @request POST:/api/RatingProcess/GetAllDynamic
     * @secure
     */
    ratingProcessGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcess[], any>({
        path: `/RatingProcess/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcess
     * @name RatingProcessCreateCreate
     * @request POST:/api/RatingProcess/Create
     * @secure
     */
    ratingProcessCreateCreate: (
      data: Partial<IRatingProcess>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcess, any>({
        path: `/RatingProcess/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcess
     * @name RatingProcessPatchPartialUpdate
     * @request PATCH:/api/RatingProcess/Patch/{id}
     * @secure
     */
    ratingProcessPatchPartialUpdate: (
      { id }: IRatingProcessPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcess/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcess
     * @name RatingProcessDeleteDelete
     * @request DELETE:/api/RatingProcess/Delete/{id}
     * @secure
     */
    ratingProcessDeleteDelete: (
      { id }: IRatingProcessDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcess, any>({
        path: `/RatingProcess/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessDocumentation
     * @name RatingProcessDocumentationGetMetaDataList
     * @request GET:/api/RatingProcessDocumentation/GetMetaData
     * @secure
     */
    ratingProcessDocumentationGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessDocumentation/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessDocumentation
     * @name RatingProcessDocumentationGetAllDynamicCreate
     * @request POST:/api/RatingProcessDocumentation/GetAllDynamic
     * @secure
     */
    ratingProcessDocumentationGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessDocumentation[], any>({
        path: `/RatingProcessDocumentation/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessDocumentation
     * @name RatingProcessDocumentationCreateCreate
     * @request POST:/api/RatingProcessDocumentation/Create
     * @secure
     */
    ratingProcessDocumentationCreateCreate: (
      data: Partial<IRatingProcessDocumentation>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessDocumentation, any>({
        path: `/RatingProcessDocumentation/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessDocumentation
     * @name RatingProcessDocumentationPatchPartialUpdate
     * @request PATCH:/api/RatingProcessDocumentation/Patch/{id}
     * @secure
     */
    ratingProcessDocumentationPatchPartialUpdate: (
      { id }: IRatingProcessDocumentationPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessDocumentation/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessDocumentation
     * @name RatingProcessDocumentationDeleteDelete
     * @request DELETE:/api/RatingProcessDocumentation/Delete/{id}
     * @secure
     */
    ratingProcessDocumentationDeleteDelete: (
      { id }: IRatingProcessDocumentationDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessDocumentation, any>({
        path: `/RatingProcessDocumentation/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessHelper
     * @name RatingProcessHelperCreateRatingProcessCreate
     * @request POST:/api/RatingProcessHelper/CreateRatingProcess
     * @secure
     */
    ratingProcessHelperCreateRatingProcessCreate: (
      data: Partial<ICreateRatingProcessRequest>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcess, any>({
        path: `/RatingProcessHelper/CreateRatingProcess`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessHelper
     * @name RatingProcessHelperInitRatingProcessList
     * @request GET:/api/RatingProcessHelper/InitRatingProcess
     * @secure
     */
    ratingProcessHelperInitRatingProcessList: (
      query: IRatingProcessHelperInitRatingProcessListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessHelper/InitRatingProcess`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessHelper
     * @name RatingProcessHelperInitRatingProcessForUpdateList
     * @request GET:/api/RatingProcessHelper/InitRatingProcessForUpdate
     * @secure
     */
    ratingProcessHelperInitRatingProcessForUpdateList: (
      query: IRatingProcessHelperInitRatingProcessForUpdateListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessHelper/InitRatingProcessForUpdate`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessHelper
     * @name RatingProcessHelperRejectRatingProcessCreate
     * @request POST:/api/RatingProcessHelper/RejectRatingProcess
     * @secure
     */
    ratingProcessHelperRejectRatingProcessCreate: (
      data: Partial<IRejectRatingProcessRequest>,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessHelper/RejectRatingProcess`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessHelper
     * @name RatingProcessHelperApproveRatingProcessStepCreate
     * @request POST:/api/RatingProcessHelper/ApproveRatingProcessStep
     * @secure
     */
    ratingProcessHelperApproveRatingProcessStepCreate: (
      data: Partial<IApproveRatingProcessStepRequest>,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessHelper/ApproveRatingProcessStep`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessHelper
     * @name RatingProcessHelperAddNewReviewList
     * @request GET:/api/RatingProcessHelper/AddNewReview
     * @secure
     */
    ratingProcessHelperAddNewReviewList: (
      query: IRatingProcessHelperAddNewReviewListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessHelper/AddNewReview`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessHelper
     * @name RatingProcessHelperAddNewCommitteeList
     * @request GET:/api/RatingProcessHelper/AddNewCommittee
     * @secure
     */
    ratingProcessHelperAddNewCommitteeList: (
      query: IRatingProcessHelperAddNewCommitteeListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessHelper/AddNewCommittee`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessHelper
     * @name RatingProcessHelperUpdateRatingProcessTypeList
     * @request GET:/api/RatingProcessHelper/UpdateRatingProcessType
     * @secure
     */
    ratingProcessHelperUpdateRatingProcessTypeList: (
      query: IRatingProcessHelperUpdateRatingProcessTypeListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessHelper/UpdateRatingProcessType`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessHelper
     * @name RatingProcessHelperAddNewDraftReportList
     * @request GET:/api/RatingProcessHelper/AddNewDraftReport
     * @secure
     */
    ratingProcessHelperAddNewDraftReportList: (
      query: IRatingProcessHelperAddNewDraftReportListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessHelper/AddNewDraftReport`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessHelper
     * @name RatingProcessHelperImportUsersForCommitteeRatedEntityVotingsList
     * @request GET:/api/RatingProcessHelper/ImportUsersForCommitteeRatedEntityVotings
     * @secure
     */
    ratingProcessHelperImportUsersForCommitteeRatedEntityVotingsList: (
      query: IRatingProcessHelperImportUsersForCommitteeRatedEntityVotingsListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessHelper/ImportUsersForCommitteeRatedEntityVotings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessHelper
     * @name RatingProcessHelperImportUsersForCommitteeSeriesVotingsList
     * @request GET:/api/RatingProcessHelper/ImportUsersForCommitteeSeriesVotings
     * @secure
     */
    ratingProcessHelperImportUsersForCommitteeSeriesVotingsList: (
      query: IRatingProcessHelperImportUsersForCommitteeSeriesVotingsListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessHelper/ImportUsersForCommitteeSeriesVotings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessHelper
     * @name RatingProcessHelperApplyVotingForCommitteeSeriesList
     * @request GET:/api/RatingProcessHelper/ApplyVotingForCommitteeSeries
     * @secure
     */
    ratingProcessHelperApplyVotingForCommitteeSeriesList: (
      query: IRatingProcessHelperApplyVotingForCommitteeSeriesListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessHelper/ApplyVotingForCommitteeSeries`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessHelper
     * @name RatingProcessHelperApplyUserVotingForCommitteeSeriesList
     * @request GET:/api/RatingProcessHelper/ApplyUserVotingForCommitteeSeries
     * @secure
     */
    ratingProcessHelperApplyUserVotingForCommitteeSeriesList: (
      query: IRatingProcessHelperApplyUserVotingForCommitteeSeriesListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessHelper/ApplyUserVotingForCommitteeSeries`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessHelper
     * @name RatingProcessHelperApplyAllUsersVotingForCommitteeSeriesList
     * @request GET:/api/RatingProcessHelper/ApplyAllUsersVotingForCommitteeSeries
     * @secure
     */
    ratingProcessHelperApplyAllUsersVotingForCommitteeSeriesList: (
      query: IRatingProcessHelperApplyAllUsersVotingForCommitteeSeriesListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessHelper/ApplyAllUsersVotingForCommitteeSeries`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessHelper
     * @name RatingProcessHelperFinishRatingProcessList
     * @request GET:/api/RatingProcessHelper/FinishRatingProcess
     * @secure
     */
    ratingProcessHelperFinishRatingProcessList: (
      query: IRatingProcessHelperFinishRatingProcessListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessHelper/FinishRatingProcess`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessHelper
     * @name RatingProcessHelperFinishRatingProcessForUpdateList
     * @request GET:/api/RatingProcessHelper/FinishRatingProcessForUpdate
     * @secure
     */
    ratingProcessHelperFinishRatingProcessForUpdateList: (
      query: IRatingProcessHelperFinishRatingProcessForUpdateListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessHelper/FinishRatingProcessForUpdate`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessHelper
     * @name RatingProcessHelperGetDefaultCommitteeDetail
     * @request GET:/api/RatingProcessHelper/GetDefaultCommittee/{companyId}
     * @secure
     */
    ratingProcessHelperGetDefaultCommitteeDetail: (
      { companyId }: IRatingProcessHelperGetDefaultCommitteeDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<IDefaultCommitteeResult, any>({
        path: `/RatingProcessHelper/GetDefaultCommittee/${companyId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStatus
     * @name RatingProcessStatusGetMetaDataList
     * @request GET:/api/RatingProcessStatus/GetMetaData
     * @secure
     */
    ratingProcessStatusGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessStatus/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStatus
     * @name RatingProcessStatusGetAllDynamicCreate
     * @request POST:/api/RatingProcessStatus/GetAllDynamic
     * @secure
     */
    ratingProcessStatusGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStatus[], any>({
        path: `/RatingProcessStatus/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStatus
     * @name RatingProcessStatusCreateCreate
     * @request POST:/api/RatingProcessStatus/Create
     * @secure
     */
    ratingProcessStatusCreateCreate: (
      data: Partial<IRatingProcessStatus>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStatus, any>({
        path: `/RatingProcessStatus/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStatus
     * @name RatingProcessStatusPatchPartialUpdate
     * @request PATCH:/api/RatingProcessStatus/Patch/{id}
     * @secure
     */
    ratingProcessStatusPatchPartialUpdate: (
      { id }: IRatingProcessStatusPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessStatus/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStatus
     * @name RatingProcessStatusDeleteDelete
     * @request DELETE:/api/RatingProcessStatus/Delete/{id}
     * @secure
     */
    ratingProcessStatusDeleteDelete: (
      { id }: IRatingProcessStatusDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStatus, any>({
        path: `/RatingProcessStatus/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStep
     * @name RatingProcessStepGetMetaDataList
     * @request GET:/api/RatingProcessStep/GetMetaData
     * @secure
     */
    ratingProcessStepGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessStep/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStep
     * @name RatingProcessStepGetAllDynamicCreate
     * @request POST:/api/RatingProcessStep/GetAllDynamic
     * @secure
     */
    ratingProcessStepGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStep[], any>({
        path: `/RatingProcessStep/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStep
     * @name RatingProcessStepCreateCreate
     * @request POST:/api/RatingProcessStep/Create
     * @secure
     */
    ratingProcessStepCreateCreate: (
      data: Partial<IRatingProcessStep>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStep, any>({
        path: `/RatingProcessStep/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStep
     * @name RatingProcessStepPatchPartialUpdate
     * @request PATCH:/api/RatingProcessStep/Patch/{id}
     * @secure
     */
    ratingProcessStepPatchPartialUpdate: (
      { id }: IRatingProcessStepPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessStep/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStep
     * @name RatingProcessStepDeleteDelete
     * @request DELETE:/api/RatingProcessStep/Delete/{id}
     * @secure
     */
    ratingProcessStepDeleteDelete: (
      { id }: IRatingProcessStepDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStep, any>({
        path: `/RatingProcessStep/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommittee
     * @name RatingProcessStepCommitteeGetMetaDataList
     * @request GET:/api/RatingProcessStepCommittee/GetMetaData
     * @secure
     */
    ratingProcessStepCommitteeGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessStepCommittee/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommittee
     * @name RatingProcessStepCommitteeGetAllDynamicCreate
     * @request POST:/api/RatingProcessStepCommittee/GetAllDynamic
     * @secure
     */
    ratingProcessStepCommitteeGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommittee[], any>({
        path: `/RatingProcessStepCommittee/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommittee
     * @name RatingProcessStepCommitteeCreateCreate
     * @request POST:/api/RatingProcessStepCommittee/Create
     * @secure
     */
    ratingProcessStepCommitteeCreateCreate: (
      data: Partial<IRatingProcessStepCommittee>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommittee, any>({
        path: `/RatingProcessStepCommittee/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommittee
     * @name RatingProcessStepCommitteePatchPartialUpdate
     * @request PATCH:/api/RatingProcessStepCommittee/Patch/{id}
     * @secure
     */
    ratingProcessStepCommitteePatchPartialUpdate: (
      { id }: IRatingProcessStepCommitteePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessStepCommittee/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommittee
     * @name RatingProcessStepCommitteeDeleteDelete
     * @request DELETE:/api/RatingProcessStepCommittee/Delete/{id}
     * @secure
     */
    ratingProcessStepCommitteeDeleteDelete: (
      { id }: IRatingProcessStepCommitteeDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommittee, any>({
        path: `/RatingProcessStepCommittee/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeMaterial
     * @name RatingProcessStepCommitteeMaterialGetMetaDataList
     * @request GET:/api/RatingProcessStepCommitteeMaterial/GetMetaData
     * @secure
     */
    ratingProcessStepCommitteeMaterialGetMetaDataList: (
      params: RequestParams = {},
    ) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessStepCommitteeMaterial/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeMaterial
     * @name RatingProcessStepCommitteeMaterialGetAllDynamicCreate
     * @request POST:/api/RatingProcessStepCommitteeMaterial/GetAllDynamic
     * @secure
     */
    ratingProcessStepCommitteeMaterialGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeMaterial[], any>({
        path: `/RatingProcessStepCommitteeMaterial/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeMaterial
     * @name RatingProcessStepCommitteeMaterialCreateCreate
     * @request POST:/api/RatingProcessStepCommitteeMaterial/Create
     * @secure
     */
    ratingProcessStepCommitteeMaterialCreateCreate: (
      data: Partial<IRatingProcessStepCommitteeMaterial>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeMaterial, any>({
        path: `/RatingProcessStepCommitteeMaterial/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeMaterial
     * @name RatingProcessStepCommitteeMaterialPatchPartialUpdate
     * @request PATCH:/api/RatingProcessStepCommitteeMaterial/Patch/{id}
     * @secure
     */
    ratingProcessStepCommitteeMaterialPatchPartialUpdate: (
      { id }: IRatingProcessStepCommitteeMaterialPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessStepCommitteeMaterial/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeMaterial
     * @name RatingProcessStepCommitteeMaterialDeleteDelete
     * @request DELETE:/api/RatingProcessStepCommitteeMaterial/Delete/{id}
     * @secure
     */
    ratingProcessStepCommitteeMaterialDeleteDelete: (
      { id }: IRatingProcessStepCommitteeMaterialDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeMaterial, any>({
        path: `/RatingProcessStepCommitteeMaterial/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeRatingMatrixFramework
     * @name RatingProcessStepCommitteeRatingMatrixFrameworkGetMetaDataList
     * @request GET:/api/RatingProcessStepCommitteeRatingMatrixFramework/GetMetaData
     * @secure
     */
    ratingProcessStepCommitteeRatingMatrixFrameworkGetMetaDataList: (
      params: RequestParams = {},
    ) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessStepCommitteeRatingMatrixFramework/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeRatingMatrixFramework
     * @name RatingProcessStepCommitteeRatingMatrixFrameworkGetAllDynamicCreate
     * @request POST:/api/RatingProcessStepCommitteeRatingMatrixFramework/GetAllDynamic
     * @secure
     */
    ratingProcessStepCommitteeRatingMatrixFrameworkGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeRatingMatrixFramework[], any>({
        path: `/RatingProcessStepCommitteeRatingMatrixFramework/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeRatingMatrixFramework
     * @name RatingProcessStepCommitteeRatingMatrixFrameworkDeleteDelete
     * @request DELETE:/api/RatingProcessStepCommitteeRatingMatrixFramework/Delete/{id}
     * @secure
     */
    ratingProcessStepCommitteeRatingMatrixFrameworkDeleteDelete: (
      {
        id,
      }: IRatingProcessStepCommitteeRatingMatrixFrameworkDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeRatingMatrixFramework, any>({
        path: `/RatingProcessStepCommitteeRatingMatrixFramework/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeRatingMatrixFramework
     * @name RatingProcessStepCommitteeRatingMatrixFrameworkCreateCreate
     * @request POST:/api/RatingProcessStepCommitteeRatingMatrixFramework/Create
     * @secure
     */
    ratingProcessStepCommitteeRatingMatrixFrameworkCreateCreate: (
      data: Partial<IRatingProcessStepCommitteeRatingMatrixFramework>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeRatingMatrixFramework, any>({
        path: `/RatingProcessStepCommitteeRatingMatrixFramework/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeRatingMatrixFramework
     * @name RatingProcessStepCommitteeRatingMatrixFrameworkPatchPartialUpdate
     * @request PATCH:/api/RatingProcessStepCommitteeRatingMatrixFramework/Patch/{id}
     * @secure
     */
    ratingProcessStepCommitteeRatingMatrixFrameworkPatchPartialUpdate: (
      {
        id,
      }: IRatingProcessStepCommitteeRatingMatrixFrameworkPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessStepCommitteeRatingMatrixFramework/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeResource
     * @name RatingProcessStepCommitteeResourceGetMetaDataList
     * @request GET:/api/RatingProcessStepCommitteeResource/GetMetaData
     * @secure
     */
    ratingProcessStepCommitteeResourceGetMetaDataList: (
      params: RequestParams = {},
    ) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessStepCommitteeResource/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeResource
     * @name RatingProcessStepCommitteeResourceGetAllDynamicCreate
     * @request POST:/api/RatingProcessStepCommitteeResource/GetAllDynamic
     * @secure
     */
    ratingProcessStepCommitteeResourceGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeResource[], any>({
        path: `/RatingProcessStepCommitteeResource/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeResource
     * @name RatingProcessStepCommitteeResourceCreateCreate
     * @request POST:/api/RatingProcessStepCommitteeResource/Create
     * @secure
     */
    ratingProcessStepCommitteeResourceCreateCreate: (
      data: Partial<IRatingProcessStepCommitteeResource>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeResource, any>({
        path: `/RatingProcessStepCommitteeResource/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeResource
     * @name RatingProcessStepCommitteeResourcePatchPartialUpdate
     * @request PATCH:/api/RatingProcessStepCommitteeResource/Patch/{id}
     * @secure
     */
    ratingProcessStepCommitteeResourcePatchPartialUpdate: (
      { id }: IRatingProcessStepCommitteeResourcePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessStepCommitteeResource/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeResource
     * @name RatingProcessStepCommitteeResourceDeleteDelete
     * @request DELETE:/api/RatingProcessStepCommitteeResource/Delete/{id}
     * @secure
     */
    ratingProcessStepCommitteeResourceDeleteDelete: (
      { id }: IRatingProcessStepCommitteeResourceDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeResource, any>({
        path: `/RatingProcessStepCommitteeResource/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeScenario
     * @name RatingProcessStepCommitteeScenarioGetMetaDataList
     * @request GET:/api/RatingProcessStepCommitteeScenario/GetMetaData
     * @secure
     */
    ratingProcessStepCommitteeScenarioGetMetaDataList: (
      params: RequestParams = {},
    ) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessStepCommitteeScenario/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeScenario
     * @name RatingProcessStepCommitteeScenarioGetAllDynamicCreate
     * @request POST:/api/RatingProcessStepCommitteeScenario/GetAllDynamic
     * @secure
     */
    ratingProcessStepCommitteeScenarioGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeScenario[], any>({
        path: `/RatingProcessStepCommitteeScenario/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeScenario
     * @name RatingProcessStepCommitteeScenarioCreateCreate
     * @request POST:/api/RatingProcessStepCommitteeScenario/Create
     * @secure
     */
    ratingProcessStepCommitteeScenarioCreateCreate: (
      data: Partial<IRatingProcessStepCommitteeScenario>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeScenario, any>({
        path: `/RatingProcessStepCommitteeScenario/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeScenario
     * @name RatingProcessStepCommitteeScenarioPatchPartialUpdate
     * @request PATCH:/api/RatingProcessStepCommitteeScenario/Patch/{id}
     * @secure
     */
    ratingProcessStepCommitteeScenarioPatchPartialUpdate: (
      { id }: IRatingProcessStepCommitteeScenarioPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessStepCommitteeScenario/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeScenario
     * @name RatingProcessStepCommitteeScenarioDeleteDelete
     * @request DELETE:/api/RatingProcessStepCommitteeScenario/Delete/{id}
     * @secure
     */
    ratingProcessStepCommitteeScenarioDeleteDelete: (
      { id }: IRatingProcessStepCommitteeScenarioDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeScenario, any>({
        path: `/RatingProcessStepCommitteeScenario/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeSeriesRating
     * @name RatingProcessStepCommitteeSeriesRatingGetMetaDataList
     * @request GET:/api/RatingProcessStepCommitteeSeriesRating/GetMetaData
     * @secure
     */
    ratingProcessStepCommitteeSeriesRatingGetMetaDataList: (
      params: RequestParams = {},
    ) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessStepCommitteeSeriesRating/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeSeriesRating
     * @name RatingProcessStepCommitteeSeriesRatingGetAllDynamicCreate
     * @request POST:/api/RatingProcessStepCommitteeSeriesRating/GetAllDynamic
     * @secure
     */
    ratingProcessStepCommitteeSeriesRatingGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeSeriesRating[], any>({
        path: `/RatingProcessStepCommitteeSeriesRating/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeSeriesRating
     * @name RatingProcessStepCommitteeSeriesRatingCreateCreate
     * @request POST:/api/RatingProcessStepCommitteeSeriesRating/Create
     * @secure
     */
    ratingProcessStepCommitteeSeriesRatingCreateCreate: (
      data: Partial<IRatingProcessStepCommitteeSeriesRating>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeSeriesRating, any>({
        path: `/RatingProcessStepCommitteeSeriesRating/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeSeriesRating
     * @name RatingProcessStepCommitteeSeriesRatingPatchPartialUpdate
     * @request PATCH:/api/RatingProcessStepCommitteeSeriesRating/Patch/{id}
     * @secure
     */
    ratingProcessStepCommitteeSeriesRatingPatchPartialUpdate: (
      { id }: IRatingProcessStepCommitteeSeriesRatingPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessStepCommitteeSeriesRating/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeSeriesRating
     * @name RatingProcessStepCommitteeSeriesRatingDeleteDelete
     * @request DELETE:/api/RatingProcessStepCommitteeSeriesRating/Delete/{id}
     * @secure
     */
    ratingProcessStepCommitteeSeriesRatingDeleteDelete: (
      { id }: IRatingProcessStepCommitteeSeriesRatingDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeSeriesRating, any>({
        path: `/RatingProcessStepCommitteeSeriesRating/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeSignificantChange
     * @name RatingProcessStepCommitteeSignificantChangeGetMetaDataList
     * @request GET:/api/RatingProcessStepCommitteeSignificantChange/GetMetaData
     * @secure
     */
    ratingProcessStepCommitteeSignificantChangeGetMetaDataList: (
      params: RequestParams = {},
    ) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessStepCommitteeSignificantChange/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeSignificantChange
     * @name RatingProcessStepCommitteeSignificantChangeGetAllDynamicCreate
     * @request POST:/api/RatingProcessStepCommitteeSignificantChange/GetAllDynamic
     * @secure
     */
    ratingProcessStepCommitteeSignificantChangeGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeSignificantChange[], any>({
        path: `/RatingProcessStepCommitteeSignificantChange/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeSignificantChange
     * @name RatingProcessStepCommitteeSignificantChangeCreateCreate
     * @request POST:/api/RatingProcessStepCommitteeSignificantChange/Create
     * @secure
     */
    ratingProcessStepCommitteeSignificantChangeCreateCreate: (
      data: Partial<IRatingProcessStepCommitteeSignificantChange>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeSignificantChange, any>({
        path: `/RatingProcessStepCommitteeSignificantChange/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeSignificantChange
     * @name RatingProcessStepCommitteeSignificantChangePatchPartialUpdate
     * @request PATCH:/api/RatingProcessStepCommitteeSignificantChange/Patch/{id}
     * @secure
     */
    ratingProcessStepCommitteeSignificantChangePatchPartialUpdate: (
      {
        id,
      }: IRatingProcessStepCommitteeSignificantChangePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessStepCommitteeSignificantChange/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeSignificantChange
     * @name RatingProcessStepCommitteeSignificantChangeDeleteDelete
     * @request DELETE:/api/RatingProcessStepCommitteeSignificantChange/Delete/{id}
     * @secure
     */
    ratingProcessStepCommitteeSignificantChangeDeleteDelete: (
      { id }: IRatingProcessStepCommitteeSignificantChangeDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeSignificantChange, any>({
        path: `/RatingProcessStepCommitteeSignificantChange/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeUser
     * @name RatingProcessStepCommitteeUserGetMetaDataList
     * @request GET:/api/RatingProcessStepCommitteeUser/GetMetaData
     * @secure
     */
    ratingProcessStepCommitteeUserGetMetaDataList: (
      params: RequestParams = {},
    ) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessStepCommitteeUser/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeUser
     * @name RatingProcessStepCommitteeUserGetAllDynamicCreate
     * @request POST:/api/RatingProcessStepCommitteeUser/GetAllDynamic
     * @secure
     */
    ratingProcessStepCommitteeUserGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeUser[], any>({
        path: `/RatingProcessStepCommitteeUser/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeUser
     * @name RatingProcessStepCommitteeUserCreateCreate
     * @request POST:/api/RatingProcessStepCommitteeUser/Create
     * @secure
     */
    ratingProcessStepCommitteeUserCreateCreate: (
      data: Partial<IRatingProcessStepCommitteeUser>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeUser, any>({
        path: `/RatingProcessStepCommitteeUser/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeUser
     * @name RatingProcessStepCommitteeUserPatchPartialUpdate
     * @request PATCH:/api/RatingProcessStepCommitteeUser/Patch/{id}
     * @secure
     */
    ratingProcessStepCommitteeUserPatchPartialUpdate: (
      { id }: IRatingProcessStepCommitteeUserPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessStepCommitteeUser/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeUser
     * @name RatingProcessStepCommitteeUserDeleteDelete
     * @request DELETE:/api/RatingProcessStepCommitteeUser/Delete/{id}
     * @secure
     */
    ratingProcessStepCommitteeUserDeleteDelete: (
      { id }: IRatingProcessStepCommitteeUserDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeUser, any>({
        path: `/RatingProcessStepCommitteeUser/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeUserRatesEntityVoting
     * @name RatingProcessStepCommitteeUserRatesEntityVotingGetMetaDataList
     * @request GET:/api/RatingProcessStepCommitteeUserRatesEntityVoting/GetMetaData
     * @secure
     */
    ratingProcessStepCommitteeUserRatesEntityVotingGetMetaDataList: (
      params: RequestParams = {},
    ) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessStepCommitteeUserRatesEntityVoting/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeUserRatesEntityVoting
     * @name RatingProcessStepCommitteeUserRatesEntityVotingGetAllDynamicCreate
     * @request POST:/api/RatingProcessStepCommitteeUserRatesEntityVoting/GetAllDynamic
     * @secure
     */
    ratingProcessStepCommitteeUserRatesEntityVotingGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeUserRatesEntityVoting[], any>({
        path: `/RatingProcessStepCommitteeUserRatesEntityVoting/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeUserRatesEntityVoting
     * @name RatingProcessStepCommitteeUserRatesEntityVotingCreateCreate
     * @request POST:/api/RatingProcessStepCommitteeUserRatesEntityVoting/Create
     * @secure
     */
    ratingProcessStepCommitteeUserRatesEntityVotingCreateCreate: (
      data: Partial<IRatingProcessStepCommitteeUserRatesEntityVoting>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeUserRatesEntityVoting, any>({
        path: `/RatingProcessStepCommitteeUserRatesEntityVoting/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeUserRatesEntityVoting
     * @name RatingProcessStepCommitteeUserRatesEntityVotingPatchPartialUpdate
     * @request PATCH:/api/RatingProcessStepCommitteeUserRatesEntityVoting/Patch/{id}
     * @secure
     */
    ratingProcessStepCommitteeUserRatesEntityVotingPatchPartialUpdate: (
      {
        id,
      }: IRatingProcessStepCommitteeUserRatesEntityVotingPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessStepCommitteeUserRatesEntityVoting/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeUserRatesEntityVoting
     * @name RatingProcessStepCommitteeUserRatesEntityVotingDeleteDelete
     * @request DELETE:/api/RatingProcessStepCommitteeUserRatesEntityVoting/Delete/{id}
     * @secure
     */
    ratingProcessStepCommitteeUserRatesEntityVotingDeleteDelete: (
      {
        id,
      }: IRatingProcessStepCommitteeUserRatesEntityVotingDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeUserRatesEntityVoting, any>({
        path: `/RatingProcessStepCommitteeUserRatesEntityVoting/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeUserScenarioVoting
     * @name RatingProcessStepCommitteeUserScenarioVotingGetMetaDataList
     * @request GET:/api/RatingProcessStepCommitteeUserScenarioVoting/GetMetaData
     * @secure
     */
    ratingProcessStepCommitteeUserScenarioVotingGetMetaDataList: (
      params: RequestParams = {},
    ) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessStepCommitteeUserScenarioVoting/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeUserScenarioVoting
     * @name RatingProcessStepCommitteeUserScenarioVotingGetAllDynamicCreate
     * @request POST:/api/RatingProcessStepCommitteeUserScenarioVoting/GetAllDynamic
     * @secure
     */
    ratingProcessStepCommitteeUserScenarioVotingGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeUserScenarioVoting[], any>({
        path: `/RatingProcessStepCommitteeUserScenarioVoting/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeUserScenarioVoting
     * @name RatingProcessStepCommitteeUserScenarioVotingCreateCreate
     * @request POST:/api/RatingProcessStepCommitteeUserScenarioVoting/Create
     * @secure
     */
    ratingProcessStepCommitteeUserScenarioVotingCreateCreate: (
      data: Partial<IRatingProcessStepCommitteeUserScenarioVoting>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeUserScenarioVoting, any>({
        path: `/RatingProcessStepCommitteeUserScenarioVoting/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeUserScenarioVoting
     * @name RatingProcessStepCommitteeUserScenarioVotingPatchPartialUpdate
     * @request PATCH:/api/RatingProcessStepCommitteeUserScenarioVoting/Patch/{id}
     * @secure
     */
    ratingProcessStepCommitteeUserScenarioVotingPatchPartialUpdate: (
      {
        id,
      }: IRatingProcessStepCommitteeUserScenarioVotingPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessStepCommitteeUserScenarioVoting/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeUserScenarioVoting
     * @name RatingProcessStepCommitteeUserScenarioVotingDeleteDelete
     * @request DELETE:/api/RatingProcessStepCommitteeUserScenarioVoting/Delete/{id}
     * @secure
     */
    ratingProcessStepCommitteeUserScenarioVotingDeleteDelete: (
      { id }: IRatingProcessStepCommitteeUserScenarioVotingDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeUserScenarioVoting, any>({
        path: `/RatingProcessStepCommitteeUserScenarioVoting/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeUserSeriesVoting
     * @name RatingProcessStepCommitteeUserSeriesVotingGetMetaDataList
     * @request GET:/api/RatingProcessStepCommitteeUserSeriesVoting/GetMetaData
     * @secure
     */
    ratingProcessStepCommitteeUserSeriesVotingGetMetaDataList: (
      params: RequestParams = {},
    ) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessStepCommitteeUserSeriesVoting/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeUserSeriesVoting
     * @name RatingProcessStepCommitteeUserSeriesVotingGetAllDynamicCreate
     * @request POST:/api/RatingProcessStepCommitteeUserSeriesVoting/GetAllDynamic
     * @secure
     */
    ratingProcessStepCommitteeUserSeriesVotingGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeUserSeriesVoting[], any>({
        path: `/RatingProcessStepCommitteeUserSeriesVoting/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeUserSeriesVoting
     * @name RatingProcessStepCommitteeUserSeriesVotingCreateCreate
     * @request POST:/api/RatingProcessStepCommitteeUserSeriesVoting/Create
     * @secure
     */
    ratingProcessStepCommitteeUserSeriesVotingCreateCreate: (
      data: Partial<IRatingProcessStepCommitteeUserSeriesVoting>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeUserSeriesVoting, any>({
        path: `/RatingProcessStepCommitteeUserSeriesVoting/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeUserSeriesVoting
     * @name RatingProcessStepCommitteeUserSeriesVotingPatchPartialUpdate
     * @request PATCH:/api/RatingProcessStepCommitteeUserSeriesVoting/Patch/{id}
     * @secure
     */
    ratingProcessStepCommitteeUserSeriesVotingPatchPartialUpdate: (
      {
        id,
      }: IRatingProcessStepCommitteeUserSeriesVotingPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessStepCommitteeUserSeriesVoting/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepCommitteeUserSeriesVoting
     * @name RatingProcessStepCommitteeUserSeriesVotingDeleteDelete
     * @request DELETE:/api/RatingProcessStepCommitteeUserSeriesVoting/Delete/{id}
     * @secure
     */
    ratingProcessStepCommitteeUserSeriesVotingDeleteDelete: (
      { id }: IRatingProcessStepCommitteeUserSeriesVotingDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepCommitteeUserSeriesVoting, any>({
        path: `/RatingProcessStepCommitteeUserSeriesVoting/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepPublication
     * @name RatingProcessStepPublicationGetMetaDataList
     * @request GET:/api/RatingProcessStepPublication/GetMetaData
     * @secure
     */
    ratingProcessStepPublicationGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessStepPublication/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepPublication
     * @name RatingProcessStepPublicationGetAllDynamicCreate
     * @request POST:/api/RatingProcessStepPublication/GetAllDynamic
     * @secure
     */
    ratingProcessStepPublicationGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepPublication[], any>({
        path: `/RatingProcessStepPublication/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepPublication
     * @name RatingProcessStepPublicationCreateCreate
     * @request POST:/api/RatingProcessStepPublication/Create
     * @secure
     */
    ratingProcessStepPublicationCreateCreate: (
      data: Partial<IRatingProcessStepPublication>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepPublication, any>({
        path: `/RatingProcessStepPublication/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepPublication
     * @name RatingProcessStepPublicationPatchPartialUpdate
     * @request PATCH:/api/RatingProcessStepPublication/Patch/{id}
     * @secure
     */
    ratingProcessStepPublicationPatchPartialUpdate: (
      { id }: IRatingProcessStepPublicationPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessStepPublication/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepPublication
     * @name RatingProcessStepPublicationDeleteDelete
     * @request DELETE:/api/RatingProcessStepPublication/Delete/{id}
     * @secure
     */
    ratingProcessStepPublicationDeleteDelete: (
      { id }: IRatingProcessStepPublicationDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepPublication, any>({
        path: `/RatingProcessStepPublication/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepPublicationCheckup
     * @name RatingProcessStepPublicationCheckupGetMetaDataList
     * @request GET:/api/RatingProcessStepPublicationCheckup/GetMetaData
     * @secure
     */
    ratingProcessStepPublicationCheckupGetMetaDataList: (
      params: RequestParams = {},
    ) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessStepPublicationCheckup/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepPublicationCheckup
     * @name RatingProcessStepPublicationCheckupGetAllDynamicCreate
     * @request POST:/api/RatingProcessStepPublicationCheckup/GetAllDynamic
     * @secure
     */
    ratingProcessStepPublicationCheckupGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepPublicationCheckup[], any>({
        path: `/RatingProcessStepPublicationCheckup/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepPublicationCheckup
     * @name RatingProcessStepPublicationCheckupCreateCreate
     * @request POST:/api/RatingProcessStepPublicationCheckup/Create
     * @secure
     */
    ratingProcessStepPublicationCheckupCreateCreate: (
      data: Partial<IRatingProcessStepPublicationCheckup>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepPublicationCheckup, any>({
        path: `/RatingProcessStepPublicationCheckup/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepPublicationCheckup
     * @name RatingProcessStepPublicationCheckupPatchPartialUpdate
     * @request PATCH:/api/RatingProcessStepPublicationCheckup/Patch/{id}
     * @secure
     */
    ratingProcessStepPublicationCheckupPatchPartialUpdate: (
      { id }: IRatingProcessStepPublicationCheckupPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessStepPublicationCheckup/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepPublicationCheckup
     * @name RatingProcessStepPublicationCheckupDeleteDelete
     * @request DELETE:/api/RatingProcessStepPublicationCheckup/Delete/{id}
     * @secure
     */
    ratingProcessStepPublicationCheckupDeleteDelete: (
      { id }: IRatingProcessStepPublicationCheckupDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepPublicationCheckup, any>({
        path: `/RatingProcessStepPublicationCheckup/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepReport
     * @name RatingProcessStepReportGetMetaDataList
     * @request GET:/api/RatingProcessStepReport/GetMetaData
     * @secure
     */
    ratingProcessStepReportGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessStepReport/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepReport
     * @name RatingProcessStepReportGetAllDynamicCreate
     * @request POST:/api/RatingProcessStepReport/GetAllDynamic
     * @secure
     */
    ratingProcessStepReportGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepReport[], any>({
        path: `/RatingProcessStepReport/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepReport
     * @name RatingProcessStepReportCreateCreate
     * @request POST:/api/RatingProcessStepReport/Create
     * @secure
     */
    ratingProcessStepReportCreateCreate: (
      data: Partial<IRatingProcessStepReport>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepReport, any>({
        path: `/RatingProcessStepReport/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepReport
     * @name RatingProcessStepReportPatchPartialUpdate
     * @request PATCH:/api/RatingProcessStepReport/Patch/{id}
     * @secure
     */
    ratingProcessStepReportPatchPartialUpdate: (
      { id }: IRatingProcessStepReportPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessStepReport/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepReport
     * @name RatingProcessStepReportDeleteDelete
     * @request DELETE:/api/RatingProcessStepReport/Delete/{id}
     * @secure
     */
    ratingProcessStepReportDeleteDelete: (
      { id }: IRatingProcessStepReportDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepReport, any>({
        path: `/RatingProcessStepReport/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepReview
     * @name RatingProcessStepReviewGetMetaDataList
     * @request GET:/api/RatingProcessStepReview/GetMetaData
     * @secure
     */
    ratingProcessStepReviewGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessStepReview/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepReview
     * @name RatingProcessStepReviewGetAllDynamicCreate
     * @request POST:/api/RatingProcessStepReview/GetAllDynamic
     * @secure
     */
    ratingProcessStepReviewGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepReview[], any>({
        path: `/RatingProcessStepReview/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepReview
     * @name RatingProcessStepReviewCreateCreate
     * @request POST:/api/RatingProcessStepReview/Create
     * @secure
     */
    ratingProcessStepReviewCreateCreate: (
      data: Partial<IRatingProcessStepReview>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepReview, any>({
        path: `/RatingProcessStepReview/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepReview
     * @name RatingProcessStepReviewPatchPartialUpdate
     * @request PATCH:/api/RatingProcessStepReview/Patch/{id}
     * @secure
     */
    ratingProcessStepReviewPatchPartialUpdate: (
      { id }: IRatingProcessStepReviewPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessStepReview/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepReview
     * @name RatingProcessStepReviewDeleteDelete
     * @request DELETE:/api/RatingProcessStepReview/Delete/{id}
     * @secure
     */
    ratingProcessStepReviewDeleteDelete: (
      { id }: IRatingProcessStepReviewDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepReview, any>({
        path: `/RatingProcessStepReview/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepReviewUser
     * @name RatingProcessStepReviewUserGetMetaDataList
     * @request GET:/api/RatingProcessStepReviewUser/GetMetaData
     * @secure
     */
    ratingProcessStepReviewUserGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessStepReviewUser/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepReviewUser
     * @name RatingProcessStepReviewUserGetAllDynamicCreate
     * @request POST:/api/RatingProcessStepReviewUser/GetAllDynamic
     * @secure
     */
    ratingProcessStepReviewUserGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepReviewUser[], any>({
        path: `/RatingProcessStepReviewUser/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepReviewUser
     * @name RatingProcessStepReviewUserCreateCreate
     * @request POST:/api/RatingProcessStepReviewUser/Create
     * @secure
     */
    ratingProcessStepReviewUserCreateCreate: (
      data: Partial<IRatingProcessStepReviewUser>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepReviewUser, any>({
        path: `/RatingProcessStepReviewUser/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepReviewUser
     * @name RatingProcessStepReviewUserPatchPartialUpdate
     * @request PATCH:/api/RatingProcessStepReviewUser/Patch/{id}
     * @secure
     */
    ratingProcessStepReviewUserPatchPartialUpdate: (
      { id }: IRatingProcessStepReviewUserPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessStepReviewUser/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepReviewUser
     * @name RatingProcessStepReviewUserDeleteDelete
     * @request DELETE:/api/RatingProcessStepReviewUser/Delete/{id}
     * @secure
     */
    ratingProcessStepReviewUserDeleteDelete: (
      { id }: IRatingProcessStepReviewUserDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepReviewUser, any>({
        path: `/RatingProcessStepReviewUser/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepType
     * @name RatingProcessStepTypeGetMetaDataList
     * @request GET:/api/RatingProcessStepType/GetMetaData
     * @secure
     */
    ratingProcessStepTypeGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessStepType/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepType
     * @name RatingProcessStepTypeGetAllDynamicCreate
     * @request POST:/api/RatingProcessStepType/GetAllDynamic
     * @secure
     */
    ratingProcessStepTypeGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepType[], any>({
        path: `/RatingProcessStepType/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepType
     * @name RatingProcessStepTypeCreateCreate
     * @request POST:/api/RatingProcessStepType/Create
     * @secure
     */
    ratingProcessStepTypeCreateCreate: (
      data: Partial<IRatingProcessStepType>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepType, any>({
        path: `/RatingProcessStepType/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepType
     * @name RatingProcessStepTypePatchPartialUpdate
     * @request PATCH:/api/RatingProcessStepType/Patch/{id}
     * @secure
     */
    ratingProcessStepTypePatchPartialUpdate: (
      { id }: IRatingProcessStepTypePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessStepType/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepType
     * @name RatingProcessStepTypeDeleteDelete
     * @request DELETE:/api/RatingProcessStepType/Delete/{id}
     * @secure
     */
    ratingProcessStepTypeDeleteDelete: (
      { id }: IRatingProcessStepTypeDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepType, any>({
        path: `/RatingProcessStepType/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepUpdate
     * @name RatingProcessStepUpdateGetMetaDataList
     * @request GET:/api/RatingProcessStepUpdate/GetMetaData
     * @secure
     */
    ratingProcessStepUpdateGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessStepUpdate/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepUpdate
     * @name RatingProcessStepUpdateGetAllDynamicCreate
     * @request POST:/api/RatingProcessStepUpdate/GetAllDynamic
     * @secure
     */
    ratingProcessStepUpdateGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepUpdate[], any>({
        path: `/RatingProcessStepUpdate/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepUpdate
     * @name RatingProcessStepUpdateCreateCreate
     * @request POST:/api/RatingProcessStepUpdate/Create
     * @secure
     */
    ratingProcessStepUpdateCreateCreate: (
      data: Partial<IRatingProcessStepUpdate>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepUpdate, any>({
        path: `/RatingProcessStepUpdate/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepUpdate
     * @name RatingProcessStepUpdatePatchPartialUpdate
     * @request PATCH:/api/RatingProcessStepUpdate/Patch/{id}
     * @secure
     */
    ratingProcessStepUpdatePatchPartialUpdate: (
      { id }: IRatingProcessStepUpdatePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessStepUpdate/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepUpdate
     * @name RatingProcessStepUpdateDeleteDelete
     * @request DELETE:/api/RatingProcessStepUpdate/Delete/{id}
     * @secure
     */
    ratingProcessStepUpdateDeleteDelete: (
      { id }: IRatingProcessStepUpdateDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepUpdate, any>({
        path: `/RatingProcessStepUpdate/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepUpdateStatus
     * @name RatingProcessStepUpdateStatusGetMetaDataList
     * @request GET:/api/RatingProcessStepUpdateStatus/GetMetaData
     * @secure
     */
    ratingProcessStepUpdateStatusGetMetaDataList: (
      params: RequestParams = {},
    ) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessStepUpdateStatus/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepUpdateStatus
     * @name RatingProcessStepUpdateStatusGetAllDynamicCreate
     * @request POST:/api/RatingProcessStepUpdateStatus/GetAllDynamic
     * @secure
     */
    ratingProcessStepUpdateStatusGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepUpdateStatus[], any>({
        path: `/RatingProcessStepUpdateStatus/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepUpdateStatus
     * @name RatingProcessStepUpdateStatusCreateCreate
     * @request POST:/api/RatingProcessStepUpdateStatus/Create
     * @secure
     */
    ratingProcessStepUpdateStatusCreateCreate: (
      data: Partial<IRatingProcessStepUpdateStatus>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepUpdateStatus, any>({
        path: `/RatingProcessStepUpdateStatus/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepUpdateStatus
     * @name RatingProcessStepUpdateStatusPatchPartialUpdate
     * @request PATCH:/api/RatingProcessStepUpdateStatus/Patch/{id}
     * @secure
     */
    ratingProcessStepUpdateStatusPatchPartialUpdate: (
      { id }: IRatingProcessStepUpdateStatusPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessStepUpdateStatus/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessStepUpdateStatus
     * @name RatingProcessStepUpdateStatusDeleteDelete
     * @request DELETE:/api/RatingProcessStepUpdateStatus/Delete/{id}
     * @secure
     */
    ratingProcessStepUpdateStatusDeleteDelete: (
      { id }: IRatingProcessStepUpdateStatusDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessStepUpdateStatus, any>({
        path: `/RatingProcessStepUpdateStatus/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessType
     * @name RatingProcessTypeGetMetaDataList
     * @request GET:/api/RatingProcessType/GetMetaData
     * @secure
     */
    ratingProcessTypeGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessType/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessType
     * @name RatingProcessTypeGetAllDynamicCreate
     * @request POST:/api/RatingProcessType/GetAllDynamic
     * @secure
     */
    ratingProcessTypeGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessType[], any>({
        path: `/RatingProcessType/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessType
     * @name RatingProcessTypeCreateCreate
     * @request POST:/api/RatingProcessType/Create
     * @secure
     */
    ratingProcessTypeCreateCreate: (
      data: Partial<IRatingProcessType>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessType, any>({
        path: `/RatingProcessType/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessType
     * @name RatingProcessTypePatchPartialUpdate
     * @request PATCH:/api/RatingProcessType/Patch/{id}
     * @secure
     */
    ratingProcessTypePatchPartialUpdate: (
      { id }: IRatingProcessTypePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessType/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessType
     * @name RatingProcessTypeDeleteDelete
     * @request DELETE:/api/RatingProcessType/Delete/{id}
     * @secure
     */
    ratingProcessTypeDeleteDelete: (
      { id }: IRatingProcessTypeDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessType, any>({
        path: `/RatingProcessType/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessTypeGroup
     * @name RatingProcessTypeGroupGetMetaDataList
     * @request GET:/api/RatingProcessTypeGroup/GetMetaData
     * @secure
     */
    ratingProcessTypeGroupGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessTypeGroup/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessTypeGroup
     * @name RatingProcessTypeGroupGetAllDynamicCreate
     * @request POST:/api/RatingProcessTypeGroup/GetAllDynamic
     * @secure
     */
    ratingProcessTypeGroupGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessTypeGroup[], any>({
        path: `/RatingProcessTypeGroup/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessTypeGroup
     * @name RatingProcessTypeGroupCreateCreate
     * @request POST:/api/RatingProcessTypeGroup/Create
     * @secure
     */
    ratingProcessTypeGroupCreateCreate: (
      data: Partial<IRatingProcessTypeGroup>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessTypeGroup, any>({
        path: `/RatingProcessTypeGroup/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessTypeGroup
     * @name RatingProcessTypeGroupPatchPartialUpdate
     * @request PATCH:/api/RatingProcessTypeGroup/Patch/{id}
     * @secure
     */
    ratingProcessTypeGroupPatchPartialUpdate: (
      { id }: IRatingProcessTypeGroupPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessTypeGroup/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessTypeGroup
     * @name RatingProcessTypeGroupDeleteDelete
     * @request DELETE:/api/RatingProcessTypeGroup/Delete/{id}
     * @secure
     */
    ratingProcessTypeGroupDeleteDelete: (
      { id }: IRatingProcessTypeGroupDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessTypeGroup, any>({
        path: `/RatingProcessTypeGroup/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessTypeOption
     * @name RatingProcessTypeOptionGetMetaDataList
     * @request GET:/api/RatingProcessTypeOption/GetMetaData
     * @secure
     */
    ratingProcessTypeOptionGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessTypeOption/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessTypeOption
     * @name RatingProcessTypeOptionGetAllDynamicCreate
     * @request POST:/api/RatingProcessTypeOption/GetAllDynamic
     * @secure
     */
    ratingProcessTypeOptionGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessTypeOption[], any>({
        path: `/RatingProcessTypeOption/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessTypeOption
     * @name RatingProcessTypeOptionCreateCreate
     * @request POST:/api/RatingProcessTypeOption/Create
     * @secure
     */
    ratingProcessTypeOptionCreateCreate: (
      data: Partial<IRatingProcessTypeOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessTypeOption, any>({
        path: `/RatingProcessTypeOption/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessTypeOption
     * @name RatingProcessTypeOptionPatchPartialUpdate
     * @request PATCH:/api/RatingProcessTypeOption/Patch/{id}
     * @secure
     */
    ratingProcessTypeOptionPatchPartialUpdate: (
      { id }: IRatingProcessTypeOptionPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessTypeOption/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessTypeOption
     * @name RatingProcessTypeOptionDeleteDelete
     * @request DELETE:/api/RatingProcessTypeOption/Delete/{id}
     * @secure
     */
    ratingProcessTypeOptionDeleteDelete: (
      { id }: IRatingProcessTypeOptionDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessTypeOption, any>({
        path: `/RatingProcessTypeOption/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessUser
     * @name RatingProcessUserGetMetaDataList
     * @request GET:/api/RatingProcessUser/GetMetaData
     * @secure
     */
    ratingProcessUserGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingProcessUser/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessUser
     * @name RatingProcessUserGetAllDynamicCreate
     * @request POST:/api/RatingProcessUser/GetAllDynamic
     * @secure
     */
    ratingProcessUserGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessUser[], any>({
        path: `/RatingProcessUser/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessUser
     * @name RatingProcessUserCreateCreate
     * @request POST:/api/RatingProcessUser/Create
     * @secure
     */
    ratingProcessUserCreateCreate: (
      data: Partial<IRatingProcessUser>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessUser, any>({
        path: `/RatingProcessUser/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessUser
     * @name RatingProcessUserPatchPartialUpdate
     * @request PATCH:/api/RatingProcessUser/Patch/{id}
     * @secure
     */
    ratingProcessUserPatchPartialUpdate: (
      { id }: IRatingProcessUserPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingProcessUser/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingProcessUser
     * @name RatingProcessUserDeleteDelete
     * @request DELETE:/api/RatingProcessUser/Delete/{id}
     * @secure
     */
    ratingProcessUserDeleteDelete: (
      { id }: IRatingProcessUserDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessUser, any>({
        path: `/RatingProcessUser/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingStatus
     * @name RatingStatusGetMetaDataList
     * @request GET:/api/RatingStatus/GetMetaData
     * @secure
     */
    ratingStatusGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingStatus/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingStatus
     * @name RatingStatusGetAllDynamicCreate
     * @request POST:/api/RatingStatus/GetAllDynamic
     * @secure
     */
    ratingStatusGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingStatus[], any>({
        path: `/RatingStatus/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingStatus
     * @name RatingStatusCreateCreate
     * @request POST:/api/RatingStatus/Create
     * @secure
     */
    ratingStatusCreateCreate: (
      data: Partial<IRatingStatus>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingStatus, any>({
        path: `/RatingStatus/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingStatus
     * @name RatingStatusPatchPartialUpdate
     * @request PATCH:/api/RatingStatus/Patch/{id}
     * @secure
     */
    ratingStatusPatchPartialUpdate: (
      { id }: IRatingStatusPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingStatus/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingStatus
     * @name RatingStatusDeleteDelete
     * @request DELETE:/api/RatingStatus/Delete/{id}
     * @secure
     */
    ratingStatusDeleteDelete: (
      { id }: IRatingStatusDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingStatus, any>({
        path: `/RatingStatus/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingStoppedReason
     * @name RatingStoppedReasonGetMetaDataList
     * @request GET:/api/RatingStoppedReason/GetMetaData
     * @secure
     */
    ratingStoppedReasonGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingStoppedReason/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingStoppedReason
     * @name RatingStoppedReasonGetAllDynamicCreate
     * @request POST:/api/RatingStoppedReason/GetAllDynamic
     * @secure
     */
    ratingStoppedReasonGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingStoppedReason[], any>({
        path: `/RatingStoppedReason/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingStoppedReason
     * @name RatingStoppedReasonCreateCreate
     * @request POST:/api/RatingStoppedReason/Create
     * @secure
     */
    ratingStoppedReasonCreateCreate: (
      data: Partial<IRatingStoppedReason>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingStoppedReason, any>({
        path: `/RatingStoppedReason/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingStoppedReason
     * @name RatingStoppedReasonPatchPartialUpdate
     * @request PATCH:/api/RatingStoppedReason/Patch/{id}
     * @secure
     */
    ratingStoppedReasonPatchPartialUpdate: (
      { id }: IRatingStoppedReasonPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingStoppedReason/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingStoppedReason
     * @name RatingStoppedReasonDeleteDelete
     * @request DELETE:/api/RatingStoppedReason/Delete/{id}
     * @secure
     */
    ratingStoppedReasonDeleteDelete: (
      { id }: IRatingStoppedReasonDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingStoppedReason, any>({
        path: `/RatingStoppedReason/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingSubject
     * @name RatingSubjectGetMetaDataList
     * @request GET:/api/RatingSubject/GetMetaData
     * @secure
     */
    ratingSubjectGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingSubject/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingSubject
     * @name RatingSubjectGetAllDynamicCreate
     * @request POST:/api/RatingSubject/GetAllDynamic
     * @secure
     */
    ratingSubjectGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingSubject[], any>({
        path: `/RatingSubject/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingSubject
     * @name RatingSubjectCreateCreate
     * @request POST:/api/RatingSubject/Create
     * @secure
     */
    ratingSubjectCreateCreate: (
      data: Partial<IRatingSubject>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingSubject, any>({
        path: `/RatingSubject/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingSubject
     * @name RatingSubjectPatchPartialUpdate
     * @request PATCH:/api/RatingSubject/Patch/{id}
     * @secure
     */
    ratingSubjectPatchPartialUpdate: (
      { id }: IRatingSubjectPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingSubject/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingSubject
     * @name RatingSubjectDeleteDelete
     * @request DELETE:/api/RatingSubject/Delete/{id}
     * @secure
     */
    ratingSubjectDeleteDelete: (
      { id }: IRatingSubjectDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingSubject, any>({
        path: `/RatingSubject/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingTool
     * @name RatingToolGetMetaDataList
     * @request GET:/api/RatingTool/GetMetaData
     * @secure
     */
    ratingToolGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/RatingTool/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingTool
     * @name RatingToolGetAllDynamicCreate
     * @request POST:/api/RatingTool/GetAllDynamic
     * @secure
     */
    ratingToolGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingTool[], any>({
        path: `/RatingTool/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingTool
     * @name RatingToolCreateCreate
     * @request POST:/api/RatingTool/Create
     * @secure
     */
    ratingToolCreateCreate: (
      data: Partial<IRatingTool>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingTool, any>({
        path: `/RatingTool/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingTool
     * @name RatingToolPatchPartialUpdate
     * @request PATCH:/api/RatingTool/Patch/{id}
     * @secure
     */
    ratingToolPatchPartialUpdate: (
      { id }: IRatingToolPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/RatingTool/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RatingTool
     * @name RatingToolDeleteDelete
     * @request DELETE:/api/RatingTool/Delete/{id}
     * @secure
     */
    ratingToolDeleteDelete: (
      { id }: IRatingToolDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IRatingTool, any>({
        path: `/RatingTool/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Report
     * @name ReportGetMetaDataList
     * @request GET:/api/Report/GetMetaData
     * @secure
     */
    reportGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/Report/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Report
     * @name ReportGetAllDynamicCreate
     * @request POST:/api/Report/GetAllDynamic
     * @secure
     */
    reportGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IReport[], any>({
        path: `/Report/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Report
     * @name ReportCreateCreate
     * @request POST:/api/Report/Create
     * @secure
     */
    reportCreateCreate: (data: Partial<IReport>, params: RequestParams = {}) =>
      this.request<IReport, any>({
        path: `/Report/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Report
     * @name ReportPatchPartialUpdate
     * @request PATCH:/api/Report/Patch/{id}
     * @secure
     */
    reportPatchPartialUpdate: (
      { id }: IReportPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/Report/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Report
     * @name ReportDeleteDelete
     * @request DELETE:/api/Report/Delete/{id}
     * @secure
     */
    reportDeleteDelete: (
      { id }: IReportDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IReport, any>({
        path: `/Report/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportCheckupType
     * @name ReportCheckupTypeGetMetaDataList
     * @request GET:/api/ReportCheckupType/GetMetaData
     * @secure
     */
    reportCheckupTypeGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/ReportCheckupType/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportCheckupType
     * @name ReportCheckupTypeGetAllDynamicCreate
     * @request POST:/api/ReportCheckupType/GetAllDynamic
     * @secure
     */
    reportCheckupTypeGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IReportCheckupType[], any>({
        path: `/ReportCheckupType/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportCheckupType
     * @name ReportCheckupTypeCreateCreate
     * @request POST:/api/ReportCheckupType/Create
     * @secure
     */
    reportCheckupTypeCreateCreate: (
      data: Partial<IReportCheckupType>,
      params: RequestParams = {},
    ) =>
      this.request<IReportCheckupType, any>({
        path: `/ReportCheckupType/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportCheckupType
     * @name ReportCheckupTypePatchPartialUpdate
     * @request PATCH:/api/ReportCheckupType/Patch/{id}
     * @secure
     */
    reportCheckupTypePatchPartialUpdate: (
      { id }: IReportCheckupTypePatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/ReportCheckupType/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportCheckupType
     * @name ReportCheckupTypeDeleteDelete
     * @request DELETE:/api/ReportCheckupType/Delete/{id}
     * @secure
     */
    reportCheckupTypeDeleteDelete: (
      { id }: IReportCheckupTypeDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IReportCheckupType, any>({
        path: `/ReportCheckupType/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportPublicationOption
     * @name ReportPublicationOptionGetMetaDataList
     * @request GET:/api/ReportPublicationOption/GetMetaData
     * @secure
     */
    reportPublicationOptionGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/ReportPublicationOption/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportPublicationOption
     * @name ReportPublicationOptionGetAllDynamicCreate
     * @request POST:/api/ReportPublicationOption/GetAllDynamic
     * @secure
     */
    reportPublicationOptionGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IReportPublicationOption[], any>({
        path: `/ReportPublicationOption/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportPublicationOption
     * @name ReportPublicationOptionCreateCreate
     * @request POST:/api/ReportPublicationOption/Create
     * @secure
     */
    reportPublicationOptionCreateCreate: (
      data: Partial<IReportPublicationOption>,
      params: RequestParams = {},
    ) =>
      this.request<IReportPublicationOption, any>({
        path: `/ReportPublicationOption/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportPublicationOption
     * @name ReportPublicationOptionPatchPartialUpdate
     * @request PATCH:/api/ReportPublicationOption/Patch/{id}
     * @secure
     */
    reportPublicationOptionPatchPartialUpdate: (
      { id }: IReportPublicationOptionPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/ReportPublicationOption/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportPublicationOption
     * @name ReportPublicationOptionDeleteDelete
     * @request DELETE:/api/ReportPublicationOption/Delete/{id}
     * @secure
     */
    reportPublicationOptionDeleteDelete: (
      { id }: IReportPublicationOptionDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IReportPublicationOption, any>({
        path: `/ReportPublicationOption/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportSeries
     * @name ReportSeriesGetMetaDataList
     * @request GET:/api/ReportSeries/GetMetaData
     * @secure
     */
    reportSeriesGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/ReportSeries/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportSeries
     * @name ReportSeriesGetAllDynamicCreate
     * @request POST:/api/ReportSeries/GetAllDynamic
     * @secure
     */
    reportSeriesGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IReportSeries[], any>({
        path: `/ReportSeries/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportSeries
     * @name ReportSeriesCreateCreate
     * @request POST:/api/ReportSeries/Create
     * @secure
     */
    reportSeriesCreateCreate: (
      data: Partial<IReportSeries>,
      params: RequestParams = {},
    ) =>
      this.request<IReportSeries, any>({
        path: `/ReportSeries/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportSeries
     * @name ReportSeriesPatchPartialUpdate
     * @request PATCH:/api/ReportSeries/Patch/{id}
     * @secure
     */
    reportSeriesPatchPartialUpdate: (
      { id }: IReportSeriesPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/ReportSeries/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportSeries
     * @name ReportSeriesDeleteDelete
     * @request DELETE:/api/ReportSeries/Delete/{id}
     * @secure
     */
    reportSeriesDeleteDelete: (
      { id }: IReportSeriesDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IReportSeries, any>({
        path: `/ReportSeries/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sector
     * @name SectorGetMetaDataList
     * @request GET:/api/Sector/GetMetaData
     * @secure
     */
    sectorGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/Sector/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sector
     * @name SectorGetAllDynamicCreate
     * @request POST:/api/Sector/GetAllDynamic
     * @secure
     */
    sectorGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ISector[], any>({
        path: `/Sector/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sector
     * @name SectorCreateCreate
     * @request POST:/api/Sector/Create
     * @secure
     */
    sectorCreateCreate: (data: Partial<ISector>, params: RequestParams = {}) =>
      this.request<ISector, any>({
        path: `/Sector/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sector
     * @name SectorPatchPartialUpdate
     * @request PATCH:/api/Sector/Patch/{id}
     * @secure
     */
    sectorPatchPartialUpdate: (
      { id }: ISectorPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/Sector/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sector
     * @name SectorDeleteDelete
     * @request DELETE:/api/Sector/Delete/{id}
     * @secure
     */
    sectorDeleteDelete: (
      { id }: ISectorDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<ISector, any>({
        path: `/Sector/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SecurityPadsFull
     * @name SecurityPadsFullGetMetaDataList
     * @request GET:/api/SecurityPadsFull/GetMetaData
     * @secure
     */
    securityPadsFullGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/SecurityPadsFull/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SecurityPadsFull
     * @name SecurityPadsFullGetAllDynamicCreate
     * @request POST:/api/SecurityPadsFull/GetAllDynamic
     * @secure
     */
    securityPadsFullGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ISecurityPadsFull[], any>({
        path: `/SecurityPadsFull/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SecurityPadsFull
     * @name SecurityPadsFullCreateCreate
     * @request POST:/api/SecurityPadsFull/Create
     * @secure
     */
    securityPadsFullCreateCreate: (
      data: Partial<ISecurityPadsFull>,
      params: RequestParams = {},
    ) =>
      this.request<ISecurityPadsFull, any>({
        path: `/SecurityPadsFull/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SecurityPadsFull
     * @name SecurityPadsFullPatchPartialUpdate
     * @request PATCH:/api/SecurityPadsFull/Patch/{id}
     * @secure
     */
    securityPadsFullPatchPartialUpdate: (
      { id }: ISecurityPadsFullPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/SecurityPadsFull/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SecurityPadsFull
     * @name SecurityPadsFullDeleteDelete
     * @request DELETE:/api/SecurityPadsFull/Delete/{id}
     * @secure
     */
    securityPadsFullDeleteDelete: (
      { id }: ISecurityPadsFullDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<ISecurityPadsFull, any>({
        path: `/SecurityPadsFull/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Series
     * @name SeriesGetMetaDataList
     * @request GET:/api/Series/GetMetaData
     * @secure
     */
    seriesGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/Series/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Series
     * @name SeriesGetAllDynamicCreate
     * @request POST:/api/Series/GetAllDynamic
     * @secure
     */
    seriesGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ISeries[], any>({
        path: `/Series/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Series
     * @name SeriesCreateCreate
     * @request POST:/api/Series/Create
     * @secure
     */
    seriesCreateCreate: (data: Partial<ISeries>, params: RequestParams = {}) =>
      this.request<ISeries, any>({
        path: `/Series/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Series
     * @name SeriesPatchPartialUpdate
     * @request PATCH:/api/Series/Patch/{id}
     * @secure
     */
    seriesPatchPartialUpdate: (
      { id }: ISeriesPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/Series/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Series
     * @name SeriesDeleteDelete
     * @request DELETE:/api/Series/Delete/{id}
     * @secure
     */
    seriesDeleteDelete: (
      { id }: ISeriesDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<ISeries, any>({
        path: `/Series/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SeriesClientInitiateRating
     * @name SeriesClientInitiateRatingGetMetaDataList
     * @request GET:/api/SeriesClientInitiateRating/GetMetaData
     * @secure
     */
    seriesClientInitiateRatingGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/SeriesClientInitiateRating/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SeriesClientInitiateRating
     * @name SeriesClientInitiateRatingGetAllDynamicCreate
     * @request POST:/api/SeriesClientInitiateRating/GetAllDynamic
     * @secure
     */
    seriesClientInitiateRatingGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ISeriesClientInitiateRating[], any>({
        path: `/SeriesClientInitiateRating/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SeriesClientInitiateRating
     * @name SeriesClientInitiateRatingCreateCreate
     * @request POST:/api/SeriesClientInitiateRating/Create
     * @secure
     */
    seriesClientInitiateRatingCreateCreate: (
      data: Partial<ISeriesClientInitiateRating>,
      params: RequestParams = {},
    ) =>
      this.request<ISeriesClientInitiateRating, any>({
        path: `/SeriesClientInitiateRating/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SeriesClientInitiateRating
     * @name SeriesClientInitiateRatingPatchPartialUpdate
     * @request PATCH:/api/SeriesClientInitiateRating/Patch/{id}
     * @secure
     */
    seriesClientInitiateRatingPatchPartialUpdate: (
      { id }: ISeriesClientInitiateRatingPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/SeriesClientInitiateRating/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SeriesClientInitiateRating
     * @name SeriesClientInitiateRatingDeleteDelete
     * @request DELETE:/api/SeriesClientInitiateRating/Delete/{id}
     * @secure
     */
    seriesClientInitiateRatingDeleteDelete: (
      { id }: ISeriesClientInitiateRatingDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<ISeriesClientInitiateRating, any>({
        path: `/SeriesClientInitiateRating/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SeriesClientPayRating
     * @name SeriesClientPayRatingGetMetaDataList
     * @request GET:/api/SeriesClientPayRating/GetMetaData
     * @secure
     */
    seriesClientPayRatingGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/SeriesClientPayRating/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SeriesClientPayRating
     * @name SeriesClientPayRatingGetAllDynamicCreate
     * @request POST:/api/SeriesClientPayRating/GetAllDynamic
     * @secure
     */
    seriesClientPayRatingGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ISeriesClientPayRating[], any>({
        path: `/SeriesClientPayRating/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SeriesClientPayRating
     * @name SeriesClientPayRatingCreateCreate
     * @request POST:/api/SeriesClientPayRating/Create
     * @secure
     */
    seriesClientPayRatingCreateCreate: (
      data: Partial<ISeriesClientPayRating>,
      params: RequestParams = {},
    ) =>
      this.request<ISeriesClientPayRating, any>({
        path: `/SeriesClientPayRating/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SeriesClientPayRating
     * @name SeriesClientPayRatingPatchPartialUpdate
     * @request PATCH:/api/SeriesClientPayRating/Patch/{id}
     * @secure
     */
    seriesClientPayRatingPatchPartialUpdate: (
      { id }: ISeriesClientPayRatingPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/SeriesClientPayRating/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SeriesClientPayRating
     * @name SeriesClientPayRatingDeleteDelete
     * @request DELETE:/api/SeriesClientPayRating/Delete/{id}
     * @secure
     */
    seriesClientPayRatingDeleteDelete: (
      { id }: ISeriesClientPayRatingDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<ISeriesClientPayRating, any>({
        path: `/SeriesClientPayRating/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SeriesDetail
     * @name SeriesDetailGetMetaDataList
     * @request GET:/api/SeriesDetail/GetMetaData
     * @secure
     */
    seriesDetailGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/SeriesDetail/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SeriesDetail
     * @name SeriesDetailGetAllDynamicCreate
     * @request POST:/api/SeriesDetail/GetAllDynamic
     * @secure
     */
    seriesDetailGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ISeriesDetail[], any>({
        path: `/SeriesDetail/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SeriesDetail
     * @name SeriesDetailCreateCreate
     * @request POST:/api/SeriesDetail/Create
     * @secure
     */
    seriesDetailCreateCreate: (
      data: Partial<ISeriesDetail>,
      params: RequestParams = {},
    ) =>
      this.request<ISeriesDetail, any>({
        path: `/SeriesDetail/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SeriesDetail
     * @name SeriesDetailPatchPartialUpdate
     * @request PATCH:/api/SeriesDetail/Patch/{id}
     * @secure
     */
    seriesDetailPatchPartialUpdate: (
      { id }: ISeriesDetailPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/SeriesDetail/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SeriesDetail
     * @name SeriesDetailDeleteDelete
     * @request DELETE:/api/SeriesDetail/Delete/{id}
     * @secure
     */
    seriesDetailDeleteDelete: (
      { id }: ISeriesDetailDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<ISeriesDetail, any>({
        path: `/SeriesDetail/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SignedOfficerStatement
     * @name SignedOfficerStatementGetMetaDataList
     * @request GET:/api/SignedOfficerStatement/GetMetaData
     * @secure
     */
    signedOfficerStatementGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/SignedOfficerStatement/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SignedOfficerStatement
     * @name SignedOfficerStatementGetAllDynamicCreate
     * @request POST:/api/SignedOfficerStatement/GetAllDynamic
     * @secure
     */
    signedOfficerStatementGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ISignedOfficerStatement[], any>({
        path: `/SignedOfficerStatement/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SignedOfficerStatement
     * @name SignedOfficerStatementCreateCreate
     * @request POST:/api/SignedOfficerStatement/Create
     * @secure
     */
    signedOfficerStatementCreateCreate: (
      data: Partial<ISignedOfficerStatement>,
      params: RequestParams = {},
    ) =>
      this.request<ISignedOfficerStatement, any>({
        path: `/SignedOfficerStatement/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SignedOfficerStatement
     * @name SignedOfficerStatementPatchPartialUpdate
     * @request PATCH:/api/SignedOfficerStatement/Patch/{id}
     * @secure
     */
    signedOfficerStatementPatchPartialUpdate: (
      { id }: ISignedOfficerStatementPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/SignedOfficerStatement/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SignedOfficerStatement
     * @name SignedOfficerStatementDeleteDelete
     * @request DELETE:/api/SignedOfficerStatement/Delete/{id}
     * @secure
     */
    signedOfficerStatementDeleteDelete: (
      { id }: ISignedOfficerStatementDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<ISignedOfficerStatement, any>({
        path: `/SignedOfficerStatement/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemLog
     * @name SystemLogGetMetaDataList
     * @request GET:/api/SystemLog/GetMetaData
     * @secure
     */
    systemLogGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/SystemLog/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemLog
     * @name SystemLogGetAllDynamicCreate
     * @request POST:/api/SystemLog/GetAllDynamic
     * @secure
     */
    systemLogGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ISystemLog[], any>({
        path: `/SystemLog/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemLog
     * @name SystemLogCreateCreate
     * @request POST:/api/SystemLog/Create
     * @secure
     */
    systemLogCreateCreate: (
      data: Partial<ISystemLog>,
      params: RequestParams = {},
    ) =>
      this.request<ISystemLog, any>({
        path: `/SystemLog/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemLog
     * @name SystemLogPatchPartialUpdate
     * @request PATCH:/api/SystemLog/Patch/{id}
     * @secure
     */
    systemLogPatchPartialUpdate: (
      { id }: ISystemLogPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/SystemLog/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemLog
     * @name SystemLogDeleteDelete
     * @request DELETE:/api/SystemLog/Delete/{id}
     * @secure
     */
    systemLogDeleteDelete: (
      { id }: ISystemLogDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<ISystemLog, any>({
        path: `/SystemLog/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemReport
     * @name SystemReportGetAllCommitteeReportDynamicCreate
     * @request POST:/api/SystemReport/GetAllCommitteeReportDynamic
     * @secure
     */
    systemReportGetAllCommitteeReportDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ICommitteeReport[], any>({
        path: `/SystemReport/GetAllCommitteeReportDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemReport
     * @name SystemReportGetAllRatedEntityReportDynamicCreate
     * @request POST:/api/SystemReport/GetAllRatedEntityReportDynamic
     * @secure
     */
    systemReportGetAllRatedEntityReportDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatedEntityReport[], any>({
        path: `/SystemReport/GetAllRatedEntityReportDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemReport
     * @name SystemReportGetAllComplianceOfficerReportDynamicCreate
     * @request POST:/api/SystemReport/GetAllComplianceOfficerReportDynamic
     * @secure
     */
    systemReportGetAllComplianceOfficerReportDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IComplianceOfficerReport[], any>({
        path: `/SystemReport/GetAllComplianceOfficerReportDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemReport
     * @name SystemReportGetAllRatingProcessReportDynamicCreate
     * @request POST:/api/SystemReport/GetAllRatingProcessReportDynamic
     * @secure
     */
    systemReportGetAllRatingProcessReportDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessReport[], any>({
        path: `/SystemReport/GetAllRatingProcessReportDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemReport
     * @name SystemReportGetAllCreditReviewReportDynamicCreate
     * @request POST:/api/SystemReport/GetAllCreditReviewReportDynamic
     * @secure
     */
    systemReportGetAllCreditReviewReportDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ICreditReviewReport[], any>({
        path: `/SystemReport/GetAllCreditReviewReportDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemReport
     * @name SystemReportGetAllSeriesReportDynamicCreate
     * @request POST:/api/SystemReport/GetAllSeriesReportDynamic
     * @secure
     */
    systemReportGetAllSeriesReportDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ISeriesReport[], any>({
        path: `/SystemReport/GetAllSeriesReportDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemReport
     * @name SystemReportGetAllRaisingCapitalReportDynamicCreate
     * @request POST:/api/SystemReport/GetAllRaisingCapitalReportDynamic
     * @secure
     */
    systemReportGetAllRaisingCapitalReportDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRaisingCapitalReport[], any>({
        path: `/SystemReport/GetAllRaisingCapitalReportDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemReport
     * @name SystemReportGetAllPreliminaryRatingReportDynamicCreate
     * @request POST:/api/SystemReport/GetAllPreliminaryRatingReportDynamic
     * @secure
     */
    systemReportGetAllPreliminaryRatingReportDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IPreliminaryRatingReport[], any>({
        path: `/SystemReport/GetAllPreliminaryRatingReportDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemReport
     * @name SystemReportGetAllTrainingReportDynamicCreate
     * @request POST:/api/SystemReport/GetAllTrainingReportDynamic
     * @secure
     */
    systemReportGetAllTrainingReportDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ITrainingReport[], any>({
        path: `/SystemReport/GetAllTrainingReportDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemReport
     * @name SystemReportGetAllMonitoringReportDynamicCreate
     * @request POST:/api/SystemReport/GetAllMonitoringReportDynamic
     * @secure
     */
    systemReportGetAllMonitoringReportDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IMonitoringReport[], any>({
        path: `/SystemReport/GetAllMonitoringReportDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemReport
     * @name SystemReportGetAllOrderReportDynamicCreate
     * @request POST:/api/SystemReport/GetAllOrderReportDynamic
     * @secure
     */
    systemReportGetAllOrderReportDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IOrderReport[], any>({
        path: `/SystemReport/GetAllOrderReportDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemReport
     * @name SystemReportGetAllFinanceForRatingProcessReportDynamicCreate
     * @request POST:/api/SystemReport/GetAllFinanceForRatingProcessReportDynamic
     * @secure
     */
    systemReportGetAllFinanceForRatingProcessReportDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingProcessFinanceReport[], any>({
        path: `/SystemReport/GetAllFinanceForRatingProcessReportDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemReport
     * @name SystemReportGetAllFinanceForMonitoringReportDynamicCreate
     * @request POST:/api/SystemReport/GetAllFinanceForMonitoringReportDynamic
     * @secure
     */
    systemReportGetAllFinanceForMonitoringReportDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IMonitoringFinanceReport[], any>({
        path: `/SystemReport/GetAllFinanceForMonitoringReportDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemReport
     * @name SystemReportGetAllMagnaReportDynamicCreate
     * @request POST:/api/SystemReport/GetAllMagnaReportDynamic
     * @secure
     */
    systemReportGetAllMagnaReportDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IMagnaReport[], any>({
        path: `/SystemReport/GetAllMagnaReportDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemReport
     * @name SystemReportGetAllRatingHistoryReportDynamicCreate
     * @request POST:/api/SystemReport/GetAllRatingHistoryReportDynamic
     * @secure
     */
    systemReportGetAllRatingHistoryReportDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IRatingHistoryReport[], any>({
        path: `/SystemReport/GetAllRatingHistoryReportDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemReport
     * @name SystemReportGetAllCharacteristicsReportDynamicCreate
     * @request POST:/api/SystemReport/GetAllCharacteristicsReportDynamic
     * @secure
     */
    systemReportGetAllCharacteristicsReportDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ICharacteristicsReport[], any>({
        path: `/SystemReport/GetAllCharacteristicsReportDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Training
     * @name TrainingGetMetaDataList
     * @request GET:/api/Training/GetMetaData
     * @secure
     */
    trainingGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/Training/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Training
     * @name TrainingGetAllDynamicCreate
     * @request POST:/api/Training/GetAllDynamic
     * @secure
     */
    trainingGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<ITraining[], any>({
        path: `/Training/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Training
     * @name TrainingCreateCreate
     * @request POST:/api/Training/Create
     * @secure
     */
    trainingCreateCreate: (
      data: Partial<ITraining>,
      params: RequestParams = {},
    ) =>
      this.request<ITraining, any>({
        path: `/Training/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Training
     * @name TrainingPatchPartialUpdate
     * @request PATCH:/api/Training/Patch/{id}
     * @secure
     */
    trainingPatchPartialUpdate: (
      { id }: ITrainingPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/Training/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Training
     * @name TrainingDeleteDelete
     * @request DELETE:/api/Training/Delete/{id}
     * @secure
     */
    trainingDeleteDelete: (
      { id }: ITrainingDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<ITraining, any>({
        path: `/Training/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserCategoryVotingCertification
     * @name UserCategoryVotingCertificationGetMetaDataList
     * @request GET:/api/UserCategoryVotingCertification/GetMetaData
     * @secure
     */
    userCategoryVotingCertificationGetMetaDataList: (
      params: RequestParams = {},
    ) =>
      this.request<ILayoutMetaData, any>({
        path: `/UserCategoryVotingCertification/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserCategoryVotingCertification
     * @name UserCategoryVotingCertificationGetAllDynamicCreate
     * @request POST:/api/UserCategoryVotingCertification/GetAllDynamic
     * @secure
     */
    userCategoryVotingCertificationGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IUserCategoryVotingCertification[], any>({
        path: `/UserCategoryVotingCertification/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserCategoryVotingCertification
     * @name UserCategoryVotingCertificationCreateCreate
     * @request POST:/api/UserCategoryVotingCertification/Create
     * @secure
     */
    userCategoryVotingCertificationCreateCreate: (
      data: Partial<IUserCategoryVotingCertification>,
      params: RequestParams = {},
    ) =>
      this.request<IUserCategoryVotingCertification, any>({
        path: `/UserCategoryVotingCertification/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserCategoryVotingCertification
     * @name UserCategoryVotingCertificationPatchPartialUpdate
     * @request PATCH:/api/UserCategoryVotingCertification/Patch/{id}
     * @secure
     */
    userCategoryVotingCertificationPatchPartialUpdate: (
      { id }: IUserCategoryVotingCertificationPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/UserCategoryVotingCertification/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserCategoryVotingCertification
     * @name UserCategoryVotingCertificationDeleteDelete
     * @request DELETE:/api/UserCategoryVotingCertification/Delete/{id}
     * @secure
     */
    userCategoryVotingCertificationDeleteDelete: (
      { id }: IUserCategoryVotingCertificationDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IUserCategoryVotingCertification, any>({
        path: `/UserCategoryVotingCertification/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserCompanyConflictOfInterest
     * @name UserCompanyConflictOfInterestGetMetaDataList
     * @request GET:/api/UserCompanyConflictOfInterest/GetMetaData
     * @secure
     */
    userCompanyConflictOfInterestGetMetaDataList: (
      params: RequestParams = {},
    ) =>
      this.request<ILayoutMetaData, any>({
        path: `/UserCompanyConflictOfInterest/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserCompanyConflictOfInterest
     * @name UserCompanyConflictOfInterestGetAllDynamicCreate
     * @request POST:/api/UserCompanyConflictOfInterest/GetAllDynamic
     * @secure
     */
    userCompanyConflictOfInterestGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IUserCompanyConflictOfInterest[], any>({
        path: `/UserCompanyConflictOfInterest/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserCompanyConflictOfInterest
     * @name UserCompanyConflictOfInterestCreateCreate
     * @request POST:/api/UserCompanyConflictOfInterest/Create
     * @secure
     */
    userCompanyConflictOfInterestCreateCreate: (
      data: Partial<IUserCompanyConflictOfInterest>,
      params: RequestParams = {},
    ) =>
      this.request<IUserCompanyConflictOfInterest, any>({
        path: `/UserCompanyConflictOfInterest/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserCompanyConflictOfInterest
     * @name UserCompanyConflictOfInterestPatchPartialUpdate
     * @request PATCH:/api/UserCompanyConflictOfInterest/Patch/{id}
     * @secure
     */
    userCompanyConflictOfInterestPatchPartialUpdate: (
      { id }: IUserCompanyConflictOfInterestPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/UserCompanyConflictOfInterest/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserCompanyConflictOfInterest
     * @name UserCompanyConflictOfInterestDeleteDelete
     * @request DELETE:/api/UserCompanyConflictOfInterest/Delete/{id}
     * @secure
     */
    userCompanyConflictOfInterestDeleteDelete: (
      { id }: IUserCompanyConflictOfInterestDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IUserCompanyConflictOfInterest, any>({
        path: `/UserCompanyConflictOfInterest/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserDepartmentVotingCertification
     * @name UserDepartmentVotingCertificationGetMetaDataList
     * @request GET:/api/UserDepartmentVotingCertification/GetMetaData
     * @secure
     */
    userDepartmentVotingCertificationGetMetaDataList: (
      params: RequestParams = {},
    ) =>
      this.request<ILayoutMetaData, any>({
        path: `/UserDepartmentVotingCertification/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserDepartmentVotingCertification
     * @name UserDepartmentVotingCertificationGetAllDynamicCreate
     * @request POST:/api/UserDepartmentVotingCertification/GetAllDynamic
     * @secure
     */
    userDepartmentVotingCertificationGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IUserDepartmentVotingCertification[], any>({
        path: `/UserDepartmentVotingCertification/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserDepartmentVotingCertification
     * @name UserDepartmentVotingCertificationCreateCreate
     * @request POST:/api/UserDepartmentVotingCertification/Create
     * @secure
     */
    userDepartmentVotingCertificationCreateCreate: (
      data: Partial<IUserDepartmentVotingCertification>,
      params: RequestParams = {},
    ) =>
      this.request<IUserDepartmentVotingCertification, any>({
        path: `/UserDepartmentVotingCertification/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserDepartmentVotingCertification
     * @name UserDepartmentVotingCertificationPatchPartialUpdate
     * @request PATCH:/api/UserDepartmentVotingCertification/Patch/{id}
     * @secure
     */
    userDepartmentVotingCertificationPatchPartialUpdate: (
      { id }: IUserDepartmentVotingCertificationPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/UserDepartmentVotingCertification/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserDepartmentVotingCertification
     * @name UserDepartmentVotingCertificationDeleteDelete
     * @request DELETE:/api/UserDepartmentVotingCertification/Delete/{id}
     * @secure
     */
    userDepartmentVotingCertificationDeleteDelete: (
      { id }: IUserDepartmentVotingCertificationDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IUserDepartmentVotingCertification, any>({
        path: `/UserDepartmentVotingCertification/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserDetail
     * @name UserDetailGetMetaDataList
     * @request GET:/api/UserDetail/GetMetaData
     * @secure
     */
    userDetailGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/UserDetail/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserDetail
     * @name UserDetailGetAllDynamicCreate
     * @request POST:/api/UserDetail/GetAllDynamic
     * @secure
     */
    userDetailGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IUserDetail[], any>({
        path: `/UserDetail/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserDetail
     * @name UserDetailCreateCreate
     * @request POST:/api/UserDetail/Create
     * @secure
     */
    userDetailCreateCreate: (
      data: Partial<IUserDetail>,
      params: RequestParams = {},
    ) =>
      this.request<IUserDetail, any>({
        path: `/UserDetail/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserDetail
     * @name UserDetailPatchPartialUpdate
     * @request PATCH:/api/UserDetail/Patch/{id}
     * @secure
     */
    userDetailPatchPartialUpdate: (
      { id }: IUserDetailPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/UserDetail/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserDetail
     * @name UserDetailDeleteDelete
     * @request DELETE:/api/UserDetail/Delete/{id}
     * @secure
     */
    userDetailDeleteDelete: (
      { id }: IUserDetailDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IUserDetail, any>({
        path: `/UserDetail/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserPosition
     * @name UserPositionGetMetaDataList
     * @request GET:/api/UserPosition/GetMetaData
     * @secure
     */
    userPositionGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/UserPosition/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserPosition
     * @name UserPositionGetAllDynamicCreate
     * @request POST:/api/UserPosition/GetAllDynamic
     * @secure
     */
    userPositionGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IUserPosition[], any>({
        path: `/UserPosition/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserPosition
     * @name UserPositionCreateCreate
     * @request POST:/api/UserPosition/Create
     * @secure
     */
    userPositionCreateCreate: (
      data: Partial<IUserPosition>,
      params: RequestParams = {},
    ) =>
      this.request<IUserPosition, any>({
        path: `/UserPosition/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserPosition
     * @name UserPositionPatchPartialUpdate
     * @request PATCH:/api/UserPosition/Patch/{id}
     * @secure
     */
    userPositionPatchPartialUpdate: (
      { id }: IUserPositionPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/UserPosition/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserPosition
     * @name UserPositionDeleteDelete
     * @request DELETE:/api/UserPosition/Delete/{id}
     * @secure
     */
    userPositionDeleteDelete: (
      { id }: IUserPositionDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IUserPosition, any>({
        path: `/UserPosition/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTraining
     * @name UserTrainingGetMetaDataList
     * @request GET:/api/UserTraining/GetMetaData
     * @secure
     */
    userTrainingGetMetaDataList: (params: RequestParams = {}) =>
      this.request<ILayoutMetaData, any>({
        path: `/UserTraining/GetMetaData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTraining
     * @name UserTrainingGetAllDynamicCreate
     * @request POST:/api/UserTraining/GetAllDynamic
     * @secure
     */
    userTrainingGetAllDynamicCreate: (
      data: Partial<IQueryOption>,
      params: RequestParams = {},
    ) =>
      this.request<IUserTraining[], any>({
        path: `/UserTraining/GetAllDynamic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTraining
     * @name UserTrainingCreateCreate
     * @request POST:/api/UserTraining/Create
     * @secure
     */
    userTrainingCreateCreate: (
      data: Partial<IUserTraining>,
      params: RequestParams = {},
    ) =>
      this.request<IUserTraining, any>({
        path: `/UserTraining/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTraining
     * @name UserTrainingPatchPartialUpdate
     * @request PATCH:/api/UserTraining/Patch/{id}
     * @secure
     */
    userTrainingPatchPartialUpdate: (
      { id }: IUserTrainingPatchPartialUpdateParams,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/UserTraining/Patch/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTraining
     * @name UserTrainingDeleteDelete
     * @request DELETE:/api/UserTraining/Delete/{id}
     * @secure
     */
    userTrainingDeleteDelete: (
      { id }: IUserTrainingDeleteDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<IUserTraining, any>({
        path: `/UserTraining/Delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}


// API Paths - This section is auto-generated. Do not edit it manually.
export const apiPaths = {
  "accountGetCurrentAppUserList": "/Account/GetCurrentAppUser",
  "authGeneratePasswordCreate": "/Auth/GeneratePassword",
  "authLoginWithCodeCreate": "/Auth/LoginWithCode",
  "authRefreshTokenCreate": "/Auth/RefreshToken",
  "authLogoutCreate": "/Auth/Logout",
  "authCheckAuthList": "/Auth/CheckAuth",
  "baseCommitteeMaterialGetMetaDataList": "/BaseCommitteeMaterial/GetMetaData",
  "baseCommitteeMaterialGetAllDynamicCreate": "/BaseCommitteeMaterial/GetAllDynamic",
  "baseCommitteeMaterialCreateCreate": "/BaseCommitteeMaterial/Create",
  "baseCommitteeMaterialPatchPartialUpdate": "/BaseCommitteeMaterial/Patch/${id}",
  "baseCommitteeMaterialDeleteDelete": "/BaseCommitteeMaterial/Delete/${id}",
  "baseCommitteeResourceGetMetaDataList": "/BaseCommitteeResource/GetMetaData",
  "baseCommitteeResourceGetAllDynamicCreate": "/BaseCommitteeResource/GetAllDynamic",
  "baseCommitteeResourceCreateCreate": "/BaseCommitteeResource/Create",
  "baseCommitteeResourcePatchPartialUpdate": "/BaseCommitteeResource/Patch/${id}",
  "baseCommitteeResourceDeleteDelete": "/BaseCommitteeResource/Delete/${id}",
  "baseCommitteeSignificantChangeGetMetaDataList": "/BaseCommitteeSignificantChange/GetMetaData",
  "baseCommitteeSignificantChangeGetAllDynamicCreate": "/BaseCommitteeSignificantChange/GetAllDynamic",
  "baseCommitteeSignificantChangeCreateCreate": "/BaseCommitteeSignificantChange/Create",
  "baseCommitteeSignificantChangePatchPartialUpdate": "/BaseCommitteeSignificantChange/Patch/${id}",
  "baseCommitteeSignificantChangeDeleteDelete": "/BaseCommitteeSignificantChange/Delete/${id}",
  "baseReportCheckupGetMetaDataList": "/BaseReportCheckup/GetMetaData",
  "baseReportCheckupGetAllDynamicCreate": "/BaseReportCheckup/GetAllDynamic",
  "baseReportCheckupCreateCreate": "/BaseReportCheckup/Create",
  "baseReportCheckupPatchPartialUpdate": "/BaseReportCheckup/Patch/${id}",
  "baseReportCheckupDeleteDelete": "/BaseReportCheckup/Delete/${id}",
  "basisPointGetMetaDataList": "/BasisPoint/GetMetaData",
  "basisPointGetAllDynamicCreate": "/BasisPoint/GetAllDynamic",
  "basisPointCreateCreate": "/BasisPoint/Create",
  "basisPointPatchPartialUpdate": "/BasisPoint/Patch/${id}",
  "basisPointDeleteDelete": "/BasisPoint/Delete/${id}",
  "categoryGetMetaDataList": "/Category/GetMetaData",
  "categoryGetAllDynamicCreate": "/Category/GetAllDynamic",
  "categoryCreateCreate": "/Category/Create",
  "categoryPatchPartialUpdate": "/Category/Patch/${id}",
  "categoryDeleteDelete": "/Category/Delete/${id}",
  "checkModelsAssumptionGetMetaDataList": "/CheckModelsAssumption/GetMetaData",
  "checkModelsAssumptionGetAllDynamicCreate": "/CheckModelsAssumption/GetAllDynamic",
  "checkModelsAssumptionCreateCreate": "/CheckModelsAssumption/Create",
  "checkModelsAssumptionPatchPartialUpdate": "/CheckModelsAssumption/Patch/${id}",
  "checkModelsAssumptionDeleteDelete": "/CheckModelsAssumption/Delete/${id}",
  "clientDecisionGetMetaDataList": "/ClientDecision/GetMetaData",
  "clientDecisionGetAllDynamicCreate": "/ClientDecision/GetAllDynamic",
  "clientDecisionCreateCreate": "/ClientDecision/Create",
  "clientDecisionPatchPartialUpdate": "/ClientDecision/Patch/${id}",
  "clientDecisionDeleteDelete": "/ClientDecision/Delete/${id}",
  "clientInitiateRatingGetMetaDataList": "/ClientInitiateRating/GetMetaData",
  "clientInitiateRatingGetAllDynamicCreate": "/ClientInitiateRating/GetAllDynamic",
  "clientInitiateRatingCreateCreate": "/ClientInitiateRating/Create",
  "clientInitiateRatingPatchPartialUpdate": "/ClientInitiateRating/Patch/${id}",
  "clientInitiateRatingDeleteDelete": "/ClientInitiateRating/Delete/${id}",
  "clientPayRatingGetMetaDataList": "/ClientPayRating/GetMetaData",
  "clientPayRatingGetAllDynamicCreate": "/ClientPayRating/GetAllDynamic",
  "clientPayRatingCreateCreate": "/ClientPayRating/Create",
  "clientPayRatingPatchPartialUpdate": "/ClientPayRating/Patch/${id}",
  "clientPayRatingDeleteDelete": "/ClientPayRating/Delete/${id}",
  "committeeMannerGetMetaDataList": "/CommitteeManner/GetMetaData",
  "committeeMannerGetAllDynamicCreate": "/CommitteeManner/GetAllDynamic",
  "committeeMannerCreateCreate": "/CommitteeManner/Create",
  "committeeMannerPatchPartialUpdate": "/CommitteeManner/Patch/${id}",
  "committeeMannerDeleteDelete": "/CommitteeManner/Delete/${id}",
  "committeePositionGetMetaDataList": "/CommitteePosition/GetMetaData",
  "committeePositionGetAllDynamicCreate": "/CommitteePosition/GetAllDynamic",
  "committeePositionCreateCreate": "/CommitteePosition/Create",
  "committeePositionPatchPartialUpdate": "/CommitteePosition/Patch/${id}",
  "committeePositionDeleteDelete": "/CommitteePosition/Delete/${id}",
  "committeeSignificantChangeTypeGetMetaDataList": "/CommitteeSignificantChangeType/GetMetaData",
  "committeeSignificantChangeTypeGetAllDynamicCreate": "/CommitteeSignificantChangeType/GetAllDynamic",
  "committeeSignificantChangeTypeCreateCreate": "/CommitteeSignificantChangeType/Create",
  "committeeSignificantChangeTypePatchPartialUpdate": "/CommitteeSignificantChangeType/Patch/${id}",
  "committeeSignificantChangeTypeDeleteDelete": "/CommitteeSignificantChangeType/Delete/${id}",
  "committeeTypeGetMetaDataList": "/CommitteeType/GetMetaData",
  "committeeTypeGetAllDynamicCreate": "/CommitteeType/GetAllDynamic",
  "committeeTypeCreateCreate": "/CommitteeType/Create",
  "committeeTypePatchPartialUpdate": "/CommitteeType/Patch/${id}",
  "committeeTypeDeleteDelete": "/CommitteeType/Delete/${id}",
  "companyGetMetaDataList": "/Company/GetMetaData",
  "companyGetAllDynamicCreate": "/Company/GetAllDynamic",
  "companyCreateCreate": "/Company/Create",
  "companyPatchPartialUpdate": "/Company/Patch/${id}",
  "companyDeleteDelete": "/Company/Delete/${id}",
  "companyForMagnaReportGetMetaDataList": "/CompanyForMagnaReport/GetMetaData",
  "companyForMagnaReportGetAllDynamicCreate": "/CompanyForMagnaReport/GetAllDynamic",
  "companyForMagnaReportCreateCreate": "/CompanyForMagnaReport/Create",
  "companyForMagnaReportPatchPartialUpdate": "/CompanyForMagnaReport/Patch/${id}",
  "companyForMagnaReportDeleteDelete": "/CompanyForMagnaReport/Delete/${id}",
  "companyRatedEntityGetMetaDataList": "/CompanyRatedEntity/GetMetaData",
  "companyRatedEntityGetAllDynamicCreate": "/CompanyRatedEntity/GetAllDynamic",
  "companyRatedEntityCreateCreate": "/CompanyRatedEntity/Create",
  "companyRatedEntityPatchPartialUpdate": "/CompanyRatedEntity/Patch/${id}",
  "companyRatedEntityDeleteDelete": "/CompanyRatedEntity/Delete/${id}",
  "companyTypeGetMetaDataList": "/CompanyType/GetMetaData",
  "companyTypeGetAllDynamicCreate": "/CompanyType/GetAllDynamic",
  "companyTypeCreateCreate": "/CompanyType/Create",
  "companyTypePatchPartialUpdate": "/CompanyType/Patch/${id}",
  "companyTypeDeleteDelete": "/CompanyType/Delete/${id}",
  "contactGetMetaDataList": "/Contact/GetMetaData",
  "contactGetAllDynamicCreate": "/Contact/GetAllDynamic",
  "contactCreateCreate": "/Contact/Create",
  "contactPatchPartialUpdate": "/Contact/Patch/${id}",
  "contactDeleteDelete": "/Contact/Delete/${id}",
  "controllingGroupGetMetaDataList": "/ControllingGroup/GetMetaData",
  "controllingGroupGetAllDynamicCreate": "/ControllingGroup/GetAllDynamic",
  "controllingGroupCreateCreate": "/ControllingGroup/Create",
  "controllingGroupPatchPartialUpdate": "/ControllingGroup/Patch/${id}",
  "controllingGroupDeleteDelete": "/ControllingGroup/Delete/${id}",
  "controllingGroupCompanyGetMetaDataList": "/ControllingGroupCompany/GetMetaData",
  "controllingGroupCompanyGetAllDynamicCreate": "/ControllingGroupCompany/GetAllDynamic",
  "controllingGroupCompanyCreateCreate": "/ControllingGroupCompany/Create",
  "controllingGroupCompanyPatchPartialUpdate": "/ControllingGroupCompany/Patch/${id}",
  "controllingGroupCompanyDeleteDelete": "/ControllingGroupCompany/Delete/${id}",
  "dashboardReportsGetKpIsCreate": "/DashboardReports/GetKPIs",
  "dashboardReportsGetDepartmentsForProfessionalList": "/DashboardReports/GetDepartmentsForProfessional",
  "dashboardReportsGetDepartmentsList": "/DashboardReports/GetDepartments",
  "dashboardReportsGetOpenRPsByCurrentStepTotalsCreate": "/DashboardReports/GetOpenRPsByCurrentStepTotals",
  "dashboardReportsGetOpenRPsByCurrentStepItemsCreate": "/DashboardReports/GetOpenRPsByCurrentStepItems",
  "dashboardReportsGetOpenRPsByTypeTotalsCreate": "/DashboardReports/GetOpenRPsByTypeTotals",
  "dashboardReportsGetOpenRPsByTypeItemsCreate": "/DashboardReports/GetOpenRPsByTypeItems",
  "dashboardReportsGetMonitorsToOpenItemsCreate": "/DashboardReports/GetMonitorsToOpenItems",
  "dashboardReportsGetLeadAnalystPerformanceItemsCreate": "/DashboardReports/GetLeadAnalystPerformanceItems",
  "dashboardReportsGetRaisedCapitalOrderItemsCreate": "/DashboardReports/GetRaisedCapitalOrderItems",
  "dashboardReportsGetRequestedOrderItemsCreate": "/DashboardReports/GetRequestedOrderItems",
  "dashboardReportsGetRpCommercialItemsCreate": "/DashboardReports/GetRPCommercialItems",
  "dashboardReportsGetWebsitePublicationItemsCreate": "/DashboardReports/GetWebsitePublicationItems",
  "dashboardReportsGetWithdrawalRatingProcessesCreate": "/DashboardReports/GetWithdrawalRatingProcesses",
  "dashboardReportsGetComplianceItemsCreate": "/DashboardReports/GetComplianceItems",
  "dashboardReportsGetCreditReviewReportItemsCreate": "/DashboardReports/GetCreditReviewReportItems",
  "departmentGetMetaDataList": "/Department/GetMetaData",
  "departmentGetAllDynamicCreate": "/Department/GetAllDynamic",
  "departmentCreateCreate": "/Department/Create",
  "departmentPatchPartialUpdate": "/Department/Patch/${id}",
  "departmentDeleteDelete": "/Department/Delete/${id}",
  "differentThanForecastGetMetaDataList": "/DifferentThanForecast/GetMetaData",
  "differentThanForecastGetAllDynamicCreate": "/DifferentThanForecast/GetAllDynamic",
  "differentThanForecastCreateCreate": "/DifferentThanForecast/Create",
  "differentThanForecastPatchPartialUpdate": "/DifferentThanForecast/Patch/${id}",
  "differentThanForecastDeleteDelete": "/DifferentThanForecast/Delete/${id}",
  "diplomaGetMetaDataList": "/Diploma/GetMetaData",
  "diplomaGetAllDynamicCreate": "/Diploma/GetAllDynamic",
  "diplomaCreateCreate": "/Diploma/Create",
  "diplomaPatchPartialUpdate": "/Diploma/Patch/${id}",
  "diplomaDeleteDelete": "/Diploma/Delete/${id}",
  "documentationStatusGetMetaDataList": "/DocumentationStatus/GetMetaData",
  "documentationStatusGetAllDynamicCreate": "/DocumentationStatus/GetAllDynamic",
  "documentationStatusCreateCreate": "/DocumentationStatus/Create",
  "documentationStatusPatchPartialUpdate": "/DocumentationStatus/Patch/${id}",
  "documentationStatusDeleteDelete": "/DocumentationStatus/Delete/${id}",
  "financialConventionTypeGetMetaDataList": "/FinancialConventionType/GetMetaData",
  "financialConventionTypeGetAllDynamicCreate": "/FinancialConventionType/GetAllDynamic",
  "financialConventionTypeCreateCreate": "/FinancialConventionType/Create",
  "financialConventionTypePatchPartialUpdate": "/FinancialConventionType/Patch/${id}",
  "financialConventionTypeDeleteDelete": "/FinancialConventionType/Delete/${id}",
  "financialStatementTrendTypeGetMetaDataList": "/FinancialStatementTrendType/GetMetaData",
  "financialStatementTrendTypeGetAllDynamicCreate": "/FinancialStatementTrendType/GetAllDynamic",
  "financialStatementTrendTypeCreateCreate": "/FinancialStatementTrendType/Create",
  "financialStatementTrendTypePatchPartialUpdate": "/FinancialStatementTrendType/Patch/${id}",
  "financialStatementTrendTypeDeleteDelete": "/FinancialStatementTrendType/Delete/${id}",
  "labelGetMetaDataList": "/Label/GetMetaData",
  "labelGetAllDynamicCreate": "/Label/GetAllDynamic",
  "labelCreateCreate": "/Label/Create",
  "labelPatchPartialUpdate": "/Label/Patch/${id}",
  "labelDeleteDelete": "/Label/Delete/${id}",
  "labelCreateBulkCreate": "/Label/CreateBulk",
  "languageGetMetaDataList": "/Language/GetMetaData",
  "languageGetAllDynamicCreate": "/Language/GetAllDynamic",
  "languageCreateCreate": "/Language/Create",
  "languagePatchPartialUpdate": "/Language/Patch/${id}",
  "languageDeleteDelete": "/Language/Delete/${id}",
  "linkageBasisTypeGetMetaDataList": "/LinkageBasisType/GetMetaData",
  "linkageBasisTypeGetAllDynamicCreate": "/LinkageBasisType/GetAllDynamic",
  "linkageBasisTypeCreateCreate": "/LinkageBasisType/Create",
  "linkageBasisTypePatchPartialUpdate": "/LinkageBasisType/Patch/${id}",
  "linkageBasisTypeDeleteDelete": "/LinkageBasisType/Delete/${id}",
  "maalotOutlookGetMetaDataList": "/MaalotOutlook/GetMetaData",
  "maalotOutlookGetAllDynamicCreate": "/MaalotOutlook/GetAllDynamic",
  "maalotOutlookCreateCreate": "/MaalotOutlook/Create",
  "maalotOutlookPatchPartialUpdate": "/MaalotOutlook/Patch/${id}",
  "maalotOutlookDeleteDelete": "/MaalotOutlook/Delete/${id}",
  "maalotRatingGetMetaDataList": "/MaalotRating/GetMetaData",
  "maalotRatingGetAllDynamicCreate": "/MaalotRating/GetAllDynamic",
  "maalotRatingCreateCreate": "/MaalotRating/Create",
  "maalotRatingPatchPartialUpdate": "/MaalotRating/Patch/${id}",
  "maalotRatingDeleteDelete": "/MaalotRating/Delete/${id}",
  "magnaReportHelperExportMagnaReportForRatingProcessDetail": "/MagnaReportHelper/ExportMagnaReportForRatingProcess/${ratingProcessId}",
  "magnaReportHelperExportMagnaReportForRatingProcessFullCreate": "/MagnaReportHelper/ExportMagnaReportForRatingProcessFull",
  "magnaReportHelperGetExportMagnaReportForRatingProcessFileNameDetail": "/MagnaReportHelper/GetExportMagnaReportForRatingProcessFileName/${ratingProcessId}",
  "magnaReportHelperExportMagnaReportForReportDetail": "/MagnaReportHelper/ExportMagnaReportForReport/${fromDate}/${toDate}",
  "magnaReportHelperGetExportMagnaReportForReportFileNameDetail": "/MagnaReportHelper/GetExportMagnaReportForReportFileName/${fromDate}/${toDate}",
  "magnaReportHelperAttachToRatingProcessDetail": "/MagnaReportHelper/AttachToRatingProcess/${seriesDetailId}/${ratingProcessId}",
  "magnaReportHelperGetMagnaReportForRatingProcessDetail": "/MagnaReportHelper/GetMagnaReportForRatingProcess/${ratingProcessId}",
  "mediaUploadUploadFileToCloudCreate": "/MediaUpload/UploadFileToCloud",
  "mediaUploadRemoveFileFromCloudUpdate": "/MediaUpload/RemoveFileFromCloud",
  "mediaUploadGetHtmlFromCloudCreate": "/MediaUpload/GetHtmlFromCloud",
  "meetingGetMetaDataList": "/Meeting/GetMetaData",
  "meetingGetAllDynamicCreate": "/Meeting/GetAllDynamic",
  "meetingCreateCreate": "/Meeting/Create",
  "meetingPatchPartialUpdate": "/Meeting/Patch/${id}",
  "meetingDeleteDelete": "/Meeting/Delete/${id}",
  "meetingTypeGetMetaDataList": "/MeetingType/GetMetaData",
  "meetingTypeGetAllDynamicCreate": "/MeetingType/GetAllDynamic",
  "meetingTypeCreateCreate": "/MeetingType/Create",
  "meetingTypePatchPartialUpdate": "/MeetingType/Patch/${id}",
  "meetingTypeDeleteDelete": "/MeetingType/Delete/${id}",
  "meetingUserGetMetaDataList": "/MeetingUser/GetMetaData",
  "meetingUserGetAllDynamicCreate": "/MeetingUser/GetAllDynamic",
  "meetingUserCreateCreate": "/MeetingUser/Create",
  "meetingUserPatchPartialUpdate": "/MeetingUser/Patch/${id}",
  "meetingUserDeleteDelete": "/MeetingUser/Delete/${id}",
  "methodologyGetMetaDataList": "/Methodology/GetMetaData",
  "methodologyGetAllDynamicCreate": "/Methodology/GetAllDynamic",
  "methodologyCreateCreate": "/Methodology/Create",
  "methodologyPatchPartialUpdate": "/Methodology/Patch/${id}",
  "methodologyDeleteDelete": "/Methodology/Delete/${id}",
  "methodologyDocumentGetMetaDataList": "/MethodologyDocument/GetMetaData",
  "methodologyDocumentGetAllDynamicCreate": "/MethodologyDocument/GetAllDynamic",
  "methodologyDocumentCreateCreate": "/MethodologyDocument/Create",
  "methodologyDocumentPatchPartialUpdate": "/MethodologyDocument/Patch/${id}",
  "methodologyDocumentDeleteDelete": "/MethodologyDocument/Delete/${id}",
  "methodologyProfessionalDocumentGetMetaDataList": "/MethodologyProfessionalDocument/GetMetaData",
  "methodologyProfessionalDocumentGetAllDynamicCreate": "/MethodologyProfessionalDocument/GetAllDynamic",
  "methodologyProfessionalDocumentCreateCreate": "/MethodologyProfessionalDocument/Create",
  "methodologyProfessionalDocumentPatchPartialUpdate": "/MethodologyProfessionalDocument/Patch/${id}",
  "methodologyProfessionalDocumentDeleteDelete": "/MethodologyProfessionalDocument/Delete/${id}",
  "midroogOutlookGetMetaDataList": "/MidroogOutlook/GetMetaData",
  "midroogOutlookGetAllDynamicCreate": "/MidroogOutlook/GetAllDynamic",
  "midroogOutlookCreateCreate": "/MidroogOutlook/Create",
  "midroogOutlookPatchPartialUpdate": "/MidroogOutlook/Patch/${id}",
  "midroogOutlookDeleteDelete": "/MidroogOutlook/Delete/${id}",
  "midroogRatingGetMetaDataList": "/MidroogRating/GetMetaData",
  "midroogRatingGetAllDynamicCreate": "/MidroogRating/GetAllDynamic",
  "midroogRatingCreateCreate": "/MidroogRating/Create",
  "midroogRatingPatchPartialUpdate": "/MidroogRating/Patch/${id}",
  "midroogRatingDeleteDelete": "/MidroogRating/Delete/${id}",
  "midroogRatingSymbolGetMetaDataList": "/MidroogRatingSymbol/GetMetaData",
  "midroogRatingSymbolGetAllDynamicCreate": "/MidroogRatingSymbol/GetAllDynamic",
  "midroogRatingSymbolCreateCreate": "/MidroogRatingSymbol/Create",
  "midroogRatingSymbolPatchPartialUpdate": "/MidroogRatingSymbol/Patch/${id}",
  "midroogRatingSymbolDeleteDelete": "/MidroogRatingSymbol/Delete/${id}",
  "monitorDecisionTypeGetMetaDataList": "/MonitorDecisionType/GetMetaData",
  "monitorDecisionTypeGetAllDynamicCreate": "/MonitorDecisionType/GetAllDynamic",
  "monitorDecisionTypeCreateCreate": "/MonitorDecisionType/Create",
  "monitorDecisionTypePatchPartialUpdate": "/MonitorDecisionType/Patch/${id}",
  "monitorDecisionTypeDeleteDelete": "/MonitorDecisionType/Delete/${id}",
  "monitorStatusGetMetaDataList": "/MonitorStatus/GetMetaData",
  "monitorStatusGetAllDynamicCreate": "/MonitorStatus/GetAllDynamic",
  "monitorStatusCreateCreate": "/MonitorStatus/Create",
  "monitorStatusPatchPartialUpdate": "/MonitorStatus/Patch/${id}",
  "monitorStatusDeleteDelete": "/MonitorStatus/Delete/${id}",
  "moodysOutlookGetMetaDataList": "/MoodysOutlook/GetMetaData",
  "moodysOutlookGetAllDynamicCreate": "/MoodysOutlook/GetAllDynamic",
  "moodysOutlookCreateCreate": "/MoodysOutlook/Create",
  "moodysOutlookPatchPartialUpdate": "/MoodysOutlook/Patch/${id}",
  "moodysOutlookDeleteDelete": "/MoodysOutlook/Delete/${id}",
  "moodysRatingGetMetaDataList": "/MoodysRating/GetMetaData",
  "moodysRatingGetAllDynamicCreate": "/MoodysRating/GetAllDynamic",
  "moodysRatingCreateCreate": "/MoodysRating/Create",
  "moodysRatingPatchPartialUpdate": "/MoodysRating/Patch/${id}",
  "moodysRatingDeleteDelete": "/MoodysRating/Delete/${id}",
  "orderGetMetaDataList": "/Order/GetMetaData",
  "orderGetAllDynamicCreate": "/Order/GetAllDynamic",
  "orderCreateCreate": "/Order/Create",
  "orderPatchPartialUpdate": "/Order/Patch/${id}",
  "orderDeleteDelete": "/Order/Delete/${id}",
  "orderDetailGetMetaDataList": "/OrderDetail/GetMetaData",
  "orderDetailGetAllDynamicCreate": "/OrderDetail/GetAllDynamic",
  "orderDetailCreateCreate": "/OrderDetail/Create",
  "orderDetailPatchPartialUpdate": "/OrderDetail/Patch/${id}",
  "orderDetailDeleteDelete": "/OrderDetail/Delete/${id}",
  "orderHelperGetOrdersDynamicCreate": "/OrderHelper/GetOrdersDynamic",
  "orderHelperCalculatePaymentFromCapitalRaisedDetail": "/OrderHelper/CalculatePaymentFromCapitalRaised/${orderId}/${capitalRaised}",
  "orderHelperCheckDuplicateOrderPriorityIdDetail": "/OrderHelper/CheckDuplicateOrderPriorityID/${priorityOrderId}/${currentOrderId}",
  "orderSourceGetMetaDataList": "/OrderSource/GetMetaData",
  "orderSourceGetAllDynamicCreate": "/OrderSource/GetAllDynamic",
  "orderSourceCreateCreate": "/OrderSource/Create",
  "orderSourcePatchPartialUpdate": "/OrderSource/Patch/${id}",
  "orderSourceDeleteDelete": "/OrderSource/Delete/${id}",
  "orderStatusGetMetaDataList": "/OrderStatus/GetMetaData",
  "orderStatusGetAllDynamicCreate": "/OrderStatus/GetAllDynamic",
  "orderStatusCreateCreate": "/OrderStatus/Create",
  "orderStatusPatchPartialUpdate": "/OrderStatus/Patch/${id}",
  "orderStatusDeleteDelete": "/OrderStatus/Delete/${id}",
  "paymentTransactionGetMetaDataList": "/PaymentTransaction/GetMetaData",
  "paymentTransactionGetAllDynamicCreate": "/PaymentTransaction/GetAllDynamic",
  "paymentTransactionCreateCreate": "/PaymentTransaction/Create",
  "paymentTransactionPatchPartialUpdate": "/PaymentTransaction/Patch/${id}",
  "paymentTransactionDeleteDelete": "/PaymentTransaction/Delete/${id}",
  "paymentTransactionHelperSyncMonitorPaymentsList": "/PaymentTransactionHelper/SyncMonitorPayments",
  "paymentTransactionHelperAddFromBasisPointDetail": "/PaymentTransactionHelper/AddFromBasisPoint/${orderId}/${amount}",
  "pdfGeneratorHelperGetPdfFromFileCreate": "/PdfGeneratorHelper/GetPdfFromFile",
  "productGetMetaDataList": "/Product/GetMetaData",
  "productGetAllDynamicCreate": "/Product/GetAllDynamic",
  "productCreateCreate": "/Product/Create",
  "productPatchPartialUpdate": "/Product/Patch/${id}",
  "productDeleteDelete": "/Product/Delete/${id}",
  "productStepGetMetaDataList": "/ProductStep/GetMetaData",
  "productStepGetAllDynamicCreate": "/ProductStep/GetAllDynamic",
  "productStepCreateCreate": "/ProductStep/Create",
  "productStepPatchPartialUpdate": "/ProductStep/Patch/${id}",
  "productStepDeleteDelete": "/ProductStep/Delete/${id}",
  "publicationApprovalTypeGetMetaDataList": "/PublicationApprovalType/GetMetaData",
  "publicationApprovalTypeGetAllDynamicCreate": "/PublicationApprovalType/GetAllDynamic",
  "publicationApprovalTypeCreateCreate": "/PublicationApprovalType/Create",
  "publicationApprovalTypePatchPartialUpdate": "/PublicationApprovalType/Patch/${id}",
  "publicationApprovalTypeDeleteDelete": "/PublicationApprovalType/Delete/${id}",
  "publishTypeGetMetaDataList": "/PublishType/GetMetaData",
  "publishTypeGetAllDynamicCreate": "/PublishType/GetAllDynamic",
  "publishTypeCreateCreate": "/PublishType/Create",
  "publishTypePatchPartialUpdate": "/PublishType/Patch/${id}",
  "publishTypeDeleteDelete": "/PublishType/Delete/${id}",
  "quarterlyMonitoringGetMetaDataList": "/QuarterlyMonitoring/GetMetaData",
  "quarterlyMonitoringGetAllDynamicCreate": "/QuarterlyMonitoring/GetAllDynamic",
  "quarterlyMonitoringCreateCreate": "/QuarterlyMonitoring/Create",
  "quarterlyMonitoringPatchPartialUpdate": "/QuarterlyMonitoring/Patch/${id}",
  "quarterlyMonitoringDeleteDelete": "/QuarterlyMonitoring/Delete/${id}",
  "quarterlyMonitoringPeriodGetMetaDataList": "/QuarterlyMonitoringPeriod/GetMetaData",
  "quarterlyMonitoringPeriodGetAllDynamicCreate": "/QuarterlyMonitoringPeriod/GetAllDynamic",
  "quarterlyMonitoringPeriodCreateCreate": "/QuarterlyMonitoringPeriod/Create",
  "quarterlyMonitoringPeriodPatchPartialUpdate": "/QuarterlyMonitoringPeriod/Patch/${id}",
  "quarterlyMonitoringPeriodDeleteDelete": "/QuarterlyMonitoringPeriod/Delete/${id}",
  "quarterlyMonitoringPeriodSyncQuarterlyMonitoringDetail": "/QuarterlyMonitoringPeriod/SyncQuarterlyMonitoring/${id}",
  "quarterlyMonitoringPeriodCompleteQuarterlyMonitoringDetail": "/QuarterlyMonitoringPeriod/CompleteQuarterlyMonitoring/${id}",
  "quarterlyMonitoringPeriodInitQuarterlyMonitoringCreate": "/QuarterlyMonitoringPeriod/InitQuarterlyMonitoring/${duplicate}",
  "quarterlyMonitoringPeriodUserGetMetaDataList": "/QuarterlyMonitoringPeriodUser/GetMetaData",
  "quarterlyMonitoringPeriodUserGetAllDynamicCreate": "/QuarterlyMonitoringPeriodUser/GetAllDynamic",
  "quarterlyMonitoringPeriodUserCreateCreate": "/QuarterlyMonitoringPeriodUser/Create",
  "quarterlyMonitoringPeriodUserPatchPartialUpdate": "/QuarterlyMonitoringPeriodUser/Patch/${id}",
  "quarterlyMonitoringPeriodUserDeleteDelete": "/QuarterlyMonitoringPeriodUser/Delete/${id}",
  "ratingAndTrackingMessageGetMetaDataList": "/RatingAndTrackingMessage/GetMetaData",
  "ratingAndTrackingMessageGetAllDynamicCreate": "/RatingAndTrackingMessage/GetAllDynamic",
  "ratingAndTrackingMessageCreateCreate": "/RatingAndTrackingMessage/Create",
  "ratingAndTrackingMessagePatchPartialUpdate": "/RatingAndTrackingMessage/Patch/${id}",
  "ratingAndTrackingMessageDeleteDelete": "/RatingAndTrackingMessage/Delete/${id}",
  "ratingHistoryGetMetaDataList": "/RatingHistory/GetMetaData",
  "ratingHistoryGetAllDynamicCreate": "/RatingHistory/GetAllDynamic",
  "ratingHistoryCreateCreate": "/RatingHistory/Create",
  "ratingHistoryPatchPartialUpdate": "/RatingHistory/Patch/${id}",
  "ratingHistoryDeleteDelete": "/RatingHistory/Delete/${id}",
  "ratingInitiativeGetMetaDataList": "/RatingInitiative/GetMetaData",
  "ratingInitiativeGetAllDynamicCreate": "/RatingInitiative/GetAllDynamic",
  "ratingInitiativeCreateCreate": "/RatingInitiative/Create",
  "ratingInitiativePatchPartialUpdate": "/RatingInitiative/Patch/${id}",
  "ratingInitiativeDeleteDelete": "/RatingInitiative/Delete/${id}",
  "ratingMatrixGetMetaDataList": "/RatingMatrix/GetMetaData",
  "ratingMatrixGetAllDynamicCreate": "/RatingMatrix/GetAllDynamic",
  "ratingMatrixCreateCreate": "/RatingMatrix/Create",
  "ratingMatrixPatchPartialUpdate": "/RatingMatrix/Patch/${id}",
  "ratingMatrixDeleteDelete": "/RatingMatrix/Delete/${id}",
  "ratingMatrixDocumentGetMetaDataList": "/RatingMatrixDocument/GetMetaData",
  "ratingMatrixDocumentGetAllDynamicCreate": "/RatingMatrixDocument/GetAllDynamic",
  "ratingMatrixDocumentCreateCreate": "/RatingMatrixDocument/Create",
  "ratingMatrixDocumentPatchPartialUpdate": "/RatingMatrixDocument/Patch/${id}",
  "ratingMatrixDocumentDeleteDelete": "/RatingMatrixDocument/Delete/${id}",
  "ratingMatrixDocumentHelperExportRatingMatrixCreate": "/RatingMatrixDocumentHelper/ExportRatingMatrix",
  "ratingMatrixFrameworkGetMetaDataList": "/RatingMatrixFramework/GetMetaData",
  "ratingMatrixFrameworkGetAllDynamicCreate": "/RatingMatrixFramework/GetAllDynamic",
  "ratingMatrixFrameworkGetListDynamicCreate": "/RatingMatrixFramework/GetListDynamic",
  "ratingMatrixFrameworkGetFullFrameworkDetail": "/RatingMatrixFramework/GetFullFramework/${id}",
  "ratingMatrixFrameworkDeleteDelete": "/RatingMatrixFramework/Delete/${id}",
  "ratingMatrixFrameworkCreateCreate": "/RatingMatrixFramework/Create",
  "ratingMatrixFrameworkPatchPartialUpdate": "/RatingMatrixFramework/Patch/${id}",
  "ratingMatrixFrameworkCloneCreate": "/RatingMatrixFramework/Clone/${id}",
  "ratingMatrixFrameworkArchiveCreate": "/RatingMatrixFramework/Archive/${id}",
  "ratingMatrixFrameworkConsiderationGetMetaDataList": "/RatingMatrixFrameworkConsideration/GetMetaData",
  "ratingMatrixFrameworkConsiderationGetAllDynamicCreate": "/RatingMatrixFrameworkConsideration/GetAllDynamic",
  "ratingMatrixFrameworkConsiderationCreateCreate": "/RatingMatrixFrameworkConsideration/Create",
  "ratingMatrixFrameworkConsiderationPatchPartialUpdate": "/RatingMatrixFrameworkConsideration/Patch/${id}",
  "ratingMatrixFrameworkConsiderationDeleteDelete": "/RatingMatrixFrameworkConsideration/Delete/${id}",
  "ratingMatrixFrameworkGradeScoreGetMetaDataList": "/RatingMatrixFrameworkGradeScore/GetMetaData",
  "ratingMatrixFrameworkGradeScoreGetAllDynamicCreate": "/RatingMatrixFrameworkGradeScore/GetAllDynamic",
  "ratingMatrixFrameworkGradeScoreCreateCreate": "/RatingMatrixFrameworkGradeScore/Create",
  "ratingMatrixFrameworkGradeScoreSaveScoreMapCreate": "/RatingMatrixFrameworkGradeScore/SaveScoreMap",
  "ratingMatrixFrameworkGradeScorePatchPartialUpdate": "/RatingMatrixFrameworkGradeScore/Patch/${id}",
  "ratingMatrixFrameworkGradeScoreDeleteDelete": "/RatingMatrixFrameworkGradeScore/Delete/${id}",
  "ratingMatrixFrameworkOptionGetMetaDataList": "/RatingMatrixFrameworkOption/GetMetaData",
  "ratingMatrixFrameworkOptionGetAllDynamicCreate": "/RatingMatrixFrameworkOption/GetAllDynamic",
  "ratingMatrixFrameworkOptionCreateCreate": "/RatingMatrixFrameworkOption/Create",
  "ratingMatrixFrameworkOptionSaveBulkCreate": "/RatingMatrixFrameworkOption/SaveBulk",
  "ratingMatrixFrameworkOptionPatchPartialUpdate": "/RatingMatrixFrameworkOption/Patch/${id}",
  "ratingMatrixFrameworkOptionDeleteDelete": "/RatingMatrixFrameworkOption/Delete/${id}",
  "ratingMatrixFrameworkParameterGetMetaDataList": "/RatingMatrixFrameworkParameter/GetMetaData",
  "ratingMatrixFrameworkParameterGetAllDynamicCreate": "/RatingMatrixFrameworkParameter/GetAllDynamic",
  "ratingMatrixFrameworkParameterCreateCreate": "/RatingMatrixFrameworkParameter/Create",
  "ratingMatrixFrameworkParameterPatchPartialUpdate": "/RatingMatrixFrameworkParameter/Patch/${id}",
  "ratingMatrixFrameworkParameterDeleteDelete": "/RatingMatrixFrameworkParameter/Delete/${id}",
  "ratingMatrixFrameworkRangeGetMetaDataList": "/RatingMatrixFrameworkRange/GetMetaData",
  "ratingMatrixFrameworkRangeGetAllDynamicCreate": "/RatingMatrixFrameworkRange/GetAllDynamic",
  "ratingMatrixFrameworkRangeCreateCreate": "/RatingMatrixFrameworkRange/Create",
  "ratingMatrixFrameworkRangeSaveBulkCreate": "/RatingMatrixFrameworkRange/SaveBulk",
  "ratingMatrixFrameworkRangePatchPartialUpdate": "/RatingMatrixFrameworkRange/Patch/${id}",
  "ratingMatrixFrameworkRangeDeleteDelete": "/RatingMatrixFrameworkRange/Delete/${id}",
  "ratingMatrixFrameworkSubParameterGetMetaDataList": "/RatingMatrixFrameworkSubParameter/GetMetaData",
  "ratingMatrixFrameworkSubParameterGetAllDynamicCreate": "/RatingMatrixFrameworkSubParameter/GetAllDynamic",
  "ratingMatrixFrameworkSubParameterCreateCreate": "/RatingMatrixFrameworkSubParameter/Create",
  "ratingMatrixFrameworkSubParameterPatchPartialUpdate": "/RatingMatrixFrameworkSubParameter/Patch/${id}",
  "ratingMatrixFrameworkSubParameterDeleteDelete": "/RatingMatrixFrameworkSubParameter/Delete/${id}",
  "ratingMatrixFrameworkTemplateGetMetaDataList": "/RatingMatrixFrameworkTemplate/GetMetaData",
  "ratingMatrixFrameworkTemplateGetAllDynamicCreate": "/RatingMatrixFrameworkTemplate/GetAllDynamic",
  "ratingMatrixFrameworkTemplateGetFullTemplateDetail": "/RatingMatrixFrameworkTemplate/GetFullTemplate/${id}",
  "ratingMatrixFrameworkTemplateCreateCreate": "/RatingMatrixFrameworkTemplate/Create",
  "ratingMatrixFrameworkTemplatePatchPartialUpdate": "/RatingMatrixFrameworkTemplate/Patch/${id}",
  "ratingMatrixFrameworkTemplateDeleteDelete": "/RatingMatrixFrameworkTemplate/Delete/${id}",
  "ratingMatrixFrameworkTemplateCloneCreate": "/RatingMatrixFrameworkTemplate/Clone/${id}",
  "ratingMatrixFrameworkTemplateActivateCreate": "/RatingMatrixFrameworkTemplate/Activate/${id}",
  "ratingMatrixFrameworkTemplateLockCreate": "/RatingMatrixFrameworkTemplate/Lock/${id}",
  "ratingMatrixFrameworkTemplateUnlockCreate": "/RatingMatrixFrameworkTemplate/Unlock/${id}",
  "ratingMatrixFrameworkTemplateApproveCreate": "/RatingMatrixFrameworkTemplate/Approve/${id}",
  "ratingMatrixFrameworkTemplateArchiveCreate": "/RatingMatrixFrameworkTemplate/Archive/${id}",
  "ratingMatrixFrameworkTemplateUnarchiveCreate": "/RatingMatrixFrameworkTemplate/Unarchive/${id}",
  "ratingMatrixFrameworkTemplateValidateWeightsDetail": "/RatingMatrixFrameworkTemplate/ValidateWeights/${id}",
  "ratingMatrixFrameworkTemplateCalculateCreate": "/RatingMatrixFrameworkTemplate/Calculate/${id}",
  "ratingMatrixFrameworkTemplateGradeLadderDetail": "/RatingMatrixFrameworkTemplate/GradeLadder/${id}",
  "ratingMatrixFrameworkTemplateImportPreviewCreate": "/RatingMatrixFrameworkTemplate/ImportPreview/${frameworkId}",
  "ratingPerformanceCategoryGetMetaDataList": "/RatingPerformanceCategory/GetMetaData",
  "ratingPerformanceCategoryGetAllDynamicCreate": "/RatingPerformanceCategory/GetAllDynamic",
  "ratingPerformanceCategoryCreateCreate": "/RatingPerformanceCategory/Create",
  "ratingPerformanceCategoryPatchPartialUpdate": "/RatingPerformanceCategory/Patch/${id}",
  "ratingPerformanceCategoryDeleteDelete": "/RatingPerformanceCategory/Delete/${id}",
  "ratingPerformanceHelperGetAllForRatingPerformanceDynamicCreate": "/RatingPerformanceHelper/GetAllForRatingPerformanceDynamic",
  "ratingPerformanceHelperUpdateForRatingPerformanceUpdate": "/RatingPerformanceHelper/UpdateForRatingPerformance/${id}",
  "ratingPerformanceHelperUpdateSeriesForRatingPerformanceUpdate": "/RatingPerformanceHelper/UpdateSeriesForRatingPerformance/${id}",
  "ratingPerformanceHelperSyncRatingMatrixList": "/RatingPerformanceHelper/SyncRatingMatrix",
  "ratingPerformanceHelperExportMatrixList": "/RatingPerformanceHelper/ExportMatrix",
  "ratingPerformanceHelperSyncRatingPerformanceList": "/RatingPerformanceHelper/SyncRatingPerformance",
  "ratingPerformanceHelperCloneRatingMatrixDetail": "/RatingPerformanceHelper/CloneRatingMatrix/${id}",
  "ratingPerformanceHelperUpdateRatingMatrixUpdate": "/RatingPerformanceHelper/UpdateRatingMatrix/${id}",
  "ratingPerformanceHelperDeleteRatingMatrixDelete": "/RatingPerformanceHelper/DeleteRatingMatrix/${id}",
  "ratingProcessGetMetaDataList": "/RatingProcess/GetMetaData",
  "ratingProcessGetAllDynamicCreate": "/RatingProcess/GetAllDynamic",
  "ratingProcessCreateCreate": "/RatingProcess/Create",
  "ratingProcessPatchPartialUpdate": "/RatingProcess/Patch/${id}",
  "ratingProcessDeleteDelete": "/RatingProcess/Delete/${id}",
  "ratingProcessDocumentationGetMetaDataList": "/RatingProcessDocumentation/GetMetaData",
  "ratingProcessDocumentationGetAllDynamicCreate": "/RatingProcessDocumentation/GetAllDynamic",
  "ratingProcessDocumentationCreateCreate": "/RatingProcessDocumentation/Create",
  "ratingProcessDocumentationPatchPartialUpdate": "/RatingProcessDocumentation/Patch/${id}",
  "ratingProcessDocumentationDeleteDelete": "/RatingProcessDocumentation/Delete/${id}",
  "ratingProcessHelperCreateRatingProcessCreate": "/RatingProcessHelper/CreateRatingProcess",
  "ratingProcessHelperInitRatingProcessList": "/RatingProcessHelper/InitRatingProcess",
  "ratingProcessHelperInitRatingProcessForUpdateList": "/RatingProcessHelper/InitRatingProcessForUpdate",
  "ratingProcessHelperRejectRatingProcessCreate": "/RatingProcessHelper/RejectRatingProcess",
  "ratingProcessHelperApproveRatingProcessStepCreate": "/RatingProcessHelper/ApproveRatingProcessStep",
  "ratingProcessHelperAddNewReviewList": "/RatingProcessHelper/AddNewReview",
  "ratingProcessHelperAddNewCommitteeList": "/RatingProcessHelper/AddNewCommittee",
  "ratingProcessHelperUpdateRatingProcessTypeList": "/RatingProcessHelper/UpdateRatingProcessType",
  "ratingProcessHelperAddNewDraftReportList": "/RatingProcessHelper/AddNewDraftReport",
  "ratingProcessHelperImportUsersForCommitteeRatedEntityVotingsList": "/RatingProcessHelper/ImportUsersForCommitteeRatedEntityVotings",
  "ratingProcessHelperImportUsersForCommitteeSeriesVotingsList": "/RatingProcessHelper/ImportUsersForCommitteeSeriesVotings",
  "ratingProcessHelperApplyVotingForCommitteeSeriesList": "/RatingProcessHelper/ApplyVotingForCommitteeSeries",
  "ratingProcessHelperApplyUserVotingForCommitteeSeriesList": "/RatingProcessHelper/ApplyUserVotingForCommitteeSeries",
  "ratingProcessHelperApplyAllUsersVotingForCommitteeSeriesList": "/RatingProcessHelper/ApplyAllUsersVotingForCommitteeSeries",
  "ratingProcessHelperFinishRatingProcessList": "/RatingProcessHelper/FinishRatingProcess",
  "ratingProcessHelperFinishRatingProcessForUpdateList": "/RatingProcessHelper/FinishRatingProcessForUpdate",
  "ratingProcessHelperGetDefaultCommitteeDetail": "/RatingProcessHelper/GetDefaultCommittee/${companyId}",
  "ratingProcessStatusGetMetaDataList": "/RatingProcessStatus/GetMetaData",
  "ratingProcessStatusGetAllDynamicCreate": "/RatingProcessStatus/GetAllDynamic",
  "ratingProcessStatusCreateCreate": "/RatingProcessStatus/Create",
  "ratingProcessStatusPatchPartialUpdate": "/RatingProcessStatus/Patch/${id}",
  "ratingProcessStatusDeleteDelete": "/RatingProcessStatus/Delete/${id}",
  "ratingProcessStepGetMetaDataList": "/RatingProcessStep/GetMetaData",
  "ratingProcessStepGetAllDynamicCreate": "/RatingProcessStep/GetAllDynamic",
  "ratingProcessStepCreateCreate": "/RatingProcessStep/Create",
  "ratingProcessStepPatchPartialUpdate": "/RatingProcessStep/Patch/${id}",
  "ratingProcessStepDeleteDelete": "/RatingProcessStep/Delete/${id}",
  "ratingProcessStepCommitteeGetMetaDataList": "/RatingProcessStepCommittee/GetMetaData",
  "ratingProcessStepCommitteeGetAllDynamicCreate": "/RatingProcessStepCommittee/GetAllDynamic",
  "ratingProcessStepCommitteeCreateCreate": "/RatingProcessStepCommittee/Create",
  "ratingProcessStepCommitteePatchPartialUpdate": "/RatingProcessStepCommittee/Patch/${id}",
  "ratingProcessStepCommitteeDeleteDelete": "/RatingProcessStepCommittee/Delete/${id}",
  "ratingProcessStepCommitteeMaterialGetMetaDataList": "/RatingProcessStepCommitteeMaterial/GetMetaData",
  "ratingProcessStepCommitteeMaterialGetAllDynamicCreate": "/RatingProcessStepCommitteeMaterial/GetAllDynamic",
  "ratingProcessStepCommitteeMaterialCreateCreate": "/RatingProcessStepCommitteeMaterial/Create",
  "ratingProcessStepCommitteeMaterialPatchPartialUpdate": "/RatingProcessStepCommitteeMaterial/Patch/${id}",
  "ratingProcessStepCommitteeMaterialDeleteDelete": "/RatingProcessStepCommitteeMaterial/Delete/${id}",
  "ratingProcessStepCommitteeRatingMatrixFrameworkGetMetaDataList": "/RatingProcessStepCommitteeRatingMatrixFramework/GetMetaData",
  "ratingProcessStepCommitteeRatingMatrixFrameworkGetAllDynamicCreate": "/RatingProcessStepCommitteeRatingMatrixFramework/GetAllDynamic",
  "ratingProcessStepCommitteeRatingMatrixFrameworkDeleteDelete": "/RatingProcessStepCommitteeRatingMatrixFramework/Delete/${id}",
  "ratingProcessStepCommitteeRatingMatrixFrameworkCreateCreate": "/RatingProcessStepCommitteeRatingMatrixFramework/Create",
  "ratingProcessStepCommitteeRatingMatrixFrameworkPatchPartialUpdate": "/RatingProcessStepCommitteeRatingMatrixFramework/Patch/${id}",
  "ratingProcessStepCommitteeResourceGetMetaDataList": "/RatingProcessStepCommitteeResource/GetMetaData",
  "ratingProcessStepCommitteeResourceGetAllDynamicCreate": "/RatingProcessStepCommitteeResource/GetAllDynamic",
  "ratingProcessStepCommitteeResourceCreateCreate": "/RatingProcessStepCommitteeResource/Create",
  "ratingProcessStepCommitteeResourcePatchPartialUpdate": "/RatingProcessStepCommitteeResource/Patch/${id}",
  "ratingProcessStepCommitteeResourceDeleteDelete": "/RatingProcessStepCommitteeResource/Delete/${id}",
  "ratingProcessStepCommitteeScenarioGetMetaDataList": "/RatingProcessStepCommitteeScenario/GetMetaData",
  "ratingProcessStepCommitteeScenarioGetAllDynamicCreate": "/RatingProcessStepCommitteeScenario/GetAllDynamic",
  "ratingProcessStepCommitteeScenarioCreateCreate": "/RatingProcessStepCommitteeScenario/Create",
  "ratingProcessStepCommitteeScenarioPatchPartialUpdate": "/RatingProcessStepCommitteeScenario/Patch/${id}",
  "ratingProcessStepCommitteeScenarioDeleteDelete": "/RatingProcessStepCommitteeScenario/Delete/${id}",
  "ratingProcessStepCommitteeSeriesRatingGetMetaDataList": "/RatingProcessStepCommitteeSeriesRating/GetMetaData",
  "ratingProcessStepCommitteeSeriesRatingGetAllDynamicCreate": "/RatingProcessStepCommitteeSeriesRating/GetAllDynamic",
  "ratingProcessStepCommitteeSeriesRatingCreateCreate": "/RatingProcessStepCommitteeSeriesRating/Create",
  "ratingProcessStepCommitteeSeriesRatingPatchPartialUpdate": "/RatingProcessStepCommitteeSeriesRating/Patch/${id}",
  "ratingProcessStepCommitteeSeriesRatingDeleteDelete": "/RatingProcessStepCommitteeSeriesRating/Delete/${id}",
  "ratingProcessStepCommitteeSignificantChangeGetMetaDataList": "/RatingProcessStepCommitteeSignificantChange/GetMetaData",
  "ratingProcessStepCommitteeSignificantChangeGetAllDynamicCreate": "/RatingProcessStepCommitteeSignificantChange/GetAllDynamic",
  "ratingProcessStepCommitteeSignificantChangeCreateCreate": "/RatingProcessStepCommitteeSignificantChange/Create",
  "ratingProcessStepCommitteeSignificantChangePatchPartialUpdate": "/RatingProcessStepCommitteeSignificantChange/Patch/${id}",
  "ratingProcessStepCommitteeSignificantChangeDeleteDelete": "/RatingProcessStepCommitteeSignificantChange/Delete/${id}",
  "ratingProcessStepCommitteeUserGetMetaDataList": "/RatingProcessStepCommitteeUser/GetMetaData",
  "ratingProcessStepCommitteeUserGetAllDynamicCreate": "/RatingProcessStepCommitteeUser/GetAllDynamic",
  "ratingProcessStepCommitteeUserCreateCreate": "/RatingProcessStepCommitteeUser/Create",
  "ratingProcessStepCommitteeUserPatchPartialUpdate": "/RatingProcessStepCommitteeUser/Patch/${id}",
  "ratingProcessStepCommitteeUserDeleteDelete": "/RatingProcessStepCommitteeUser/Delete/${id}",
  "ratingProcessStepCommitteeUserRatesEntityVotingGetMetaDataList": "/RatingProcessStepCommitteeUserRatesEntityVoting/GetMetaData",
  "ratingProcessStepCommitteeUserRatesEntityVotingGetAllDynamicCreate": "/RatingProcessStepCommitteeUserRatesEntityVoting/GetAllDynamic",
  "ratingProcessStepCommitteeUserRatesEntityVotingCreateCreate": "/RatingProcessStepCommitteeUserRatesEntityVoting/Create",
  "ratingProcessStepCommitteeUserRatesEntityVotingPatchPartialUpdate": "/RatingProcessStepCommitteeUserRatesEntityVoting/Patch/${id}",
  "ratingProcessStepCommitteeUserRatesEntityVotingDeleteDelete": "/RatingProcessStepCommitteeUserRatesEntityVoting/Delete/${id}",
  "ratingProcessStepCommitteeUserScenarioVotingGetMetaDataList": "/RatingProcessStepCommitteeUserScenarioVoting/GetMetaData",
  "ratingProcessStepCommitteeUserScenarioVotingGetAllDynamicCreate": "/RatingProcessStepCommitteeUserScenarioVoting/GetAllDynamic",
  "ratingProcessStepCommitteeUserScenarioVotingCreateCreate": "/RatingProcessStepCommitteeUserScenarioVoting/Create",
  "ratingProcessStepCommitteeUserScenarioVotingPatchPartialUpdate": "/RatingProcessStepCommitteeUserScenarioVoting/Patch/${id}",
  "ratingProcessStepCommitteeUserScenarioVotingDeleteDelete": "/RatingProcessStepCommitteeUserScenarioVoting/Delete/${id}",
  "ratingProcessStepCommitteeUserSeriesVotingGetMetaDataList": "/RatingProcessStepCommitteeUserSeriesVoting/GetMetaData",
  "ratingProcessStepCommitteeUserSeriesVotingGetAllDynamicCreate": "/RatingProcessStepCommitteeUserSeriesVoting/GetAllDynamic",
  "ratingProcessStepCommitteeUserSeriesVotingCreateCreate": "/RatingProcessStepCommitteeUserSeriesVoting/Create",
  "ratingProcessStepCommitteeUserSeriesVotingPatchPartialUpdate": "/RatingProcessStepCommitteeUserSeriesVoting/Patch/${id}",
  "ratingProcessStepCommitteeUserSeriesVotingDeleteDelete": "/RatingProcessStepCommitteeUserSeriesVoting/Delete/${id}",
  "ratingProcessStepPublicationGetMetaDataList": "/RatingProcessStepPublication/GetMetaData",
  "ratingProcessStepPublicationGetAllDynamicCreate": "/RatingProcessStepPublication/GetAllDynamic",
  "ratingProcessStepPublicationCreateCreate": "/RatingProcessStepPublication/Create",
  "ratingProcessStepPublicationPatchPartialUpdate": "/RatingProcessStepPublication/Patch/${id}",
  "ratingProcessStepPublicationDeleteDelete": "/RatingProcessStepPublication/Delete/${id}",
  "ratingProcessStepPublicationCheckupGetMetaDataList": "/RatingProcessStepPublicationCheckup/GetMetaData",
  "ratingProcessStepPublicationCheckupGetAllDynamicCreate": "/RatingProcessStepPublicationCheckup/GetAllDynamic",
  "ratingProcessStepPublicationCheckupCreateCreate": "/RatingProcessStepPublicationCheckup/Create",
  "ratingProcessStepPublicationCheckupPatchPartialUpdate": "/RatingProcessStepPublicationCheckup/Patch/${id}",
  "ratingProcessStepPublicationCheckupDeleteDelete": "/RatingProcessStepPublicationCheckup/Delete/${id}",
  "ratingProcessStepReportGetMetaDataList": "/RatingProcessStepReport/GetMetaData",
  "ratingProcessStepReportGetAllDynamicCreate": "/RatingProcessStepReport/GetAllDynamic",
  "ratingProcessStepReportCreateCreate": "/RatingProcessStepReport/Create",
  "ratingProcessStepReportPatchPartialUpdate": "/RatingProcessStepReport/Patch/${id}",
  "ratingProcessStepReportDeleteDelete": "/RatingProcessStepReport/Delete/${id}",
  "ratingProcessStepReviewGetMetaDataList": "/RatingProcessStepReview/GetMetaData",
  "ratingProcessStepReviewGetAllDynamicCreate": "/RatingProcessStepReview/GetAllDynamic",
  "ratingProcessStepReviewCreateCreate": "/RatingProcessStepReview/Create",
  "ratingProcessStepReviewPatchPartialUpdate": "/RatingProcessStepReview/Patch/${id}",
  "ratingProcessStepReviewDeleteDelete": "/RatingProcessStepReview/Delete/${id}",
  "ratingProcessStepReviewUserGetMetaDataList": "/RatingProcessStepReviewUser/GetMetaData",
  "ratingProcessStepReviewUserGetAllDynamicCreate": "/RatingProcessStepReviewUser/GetAllDynamic",
  "ratingProcessStepReviewUserCreateCreate": "/RatingProcessStepReviewUser/Create",
  "ratingProcessStepReviewUserPatchPartialUpdate": "/RatingProcessStepReviewUser/Patch/${id}",
  "ratingProcessStepReviewUserDeleteDelete": "/RatingProcessStepReviewUser/Delete/${id}",
  "ratingProcessStepTypeGetMetaDataList": "/RatingProcessStepType/GetMetaData",
  "ratingProcessStepTypeGetAllDynamicCreate": "/RatingProcessStepType/GetAllDynamic",
  "ratingProcessStepTypeCreateCreate": "/RatingProcessStepType/Create",
  "ratingProcessStepTypePatchPartialUpdate": "/RatingProcessStepType/Patch/${id}",
  "ratingProcessStepTypeDeleteDelete": "/RatingProcessStepType/Delete/${id}",
  "ratingProcessStepUpdateGetMetaDataList": "/RatingProcessStepUpdate/GetMetaData",
  "ratingProcessStepUpdateGetAllDynamicCreate": "/RatingProcessStepUpdate/GetAllDynamic",
  "ratingProcessStepUpdateCreateCreate": "/RatingProcessStepUpdate/Create",
  "ratingProcessStepUpdatePatchPartialUpdate": "/RatingProcessStepUpdate/Patch/${id}",
  "ratingProcessStepUpdateDeleteDelete": "/RatingProcessStepUpdate/Delete/${id}",
  "ratingProcessStepUpdateStatusGetMetaDataList": "/RatingProcessStepUpdateStatus/GetMetaData",
  "ratingProcessStepUpdateStatusGetAllDynamicCreate": "/RatingProcessStepUpdateStatus/GetAllDynamic",
  "ratingProcessStepUpdateStatusCreateCreate": "/RatingProcessStepUpdateStatus/Create",
  "ratingProcessStepUpdateStatusPatchPartialUpdate": "/RatingProcessStepUpdateStatus/Patch/${id}",
  "ratingProcessStepUpdateStatusDeleteDelete": "/RatingProcessStepUpdateStatus/Delete/${id}",
  "ratingProcessTypeGetMetaDataList": "/RatingProcessType/GetMetaData",
  "ratingProcessTypeGetAllDynamicCreate": "/RatingProcessType/GetAllDynamic",
  "ratingProcessTypeCreateCreate": "/RatingProcessType/Create",
  "ratingProcessTypePatchPartialUpdate": "/RatingProcessType/Patch/${id}",
  "ratingProcessTypeDeleteDelete": "/RatingProcessType/Delete/${id}",
  "ratingProcessTypeGroupGetMetaDataList": "/RatingProcessTypeGroup/GetMetaData",
  "ratingProcessTypeGroupGetAllDynamicCreate": "/RatingProcessTypeGroup/GetAllDynamic",
  "ratingProcessTypeGroupCreateCreate": "/RatingProcessTypeGroup/Create",
  "ratingProcessTypeGroupPatchPartialUpdate": "/RatingProcessTypeGroup/Patch/${id}",
  "ratingProcessTypeGroupDeleteDelete": "/RatingProcessTypeGroup/Delete/${id}",
  "ratingProcessTypeOptionGetMetaDataList": "/RatingProcessTypeOption/GetMetaData",
  "ratingProcessTypeOptionGetAllDynamicCreate": "/RatingProcessTypeOption/GetAllDynamic",
  "ratingProcessTypeOptionCreateCreate": "/RatingProcessTypeOption/Create",
  "ratingProcessTypeOptionPatchPartialUpdate": "/RatingProcessTypeOption/Patch/${id}",
  "ratingProcessTypeOptionDeleteDelete": "/RatingProcessTypeOption/Delete/${id}",
  "ratingProcessUserGetMetaDataList": "/RatingProcessUser/GetMetaData",
  "ratingProcessUserGetAllDynamicCreate": "/RatingProcessUser/GetAllDynamic",
  "ratingProcessUserCreateCreate": "/RatingProcessUser/Create",
  "ratingProcessUserPatchPartialUpdate": "/RatingProcessUser/Patch/${id}",
  "ratingProcessUserDeleteDelete": "/RatingProcessUser/Delete/${id}",
  "ratingStatusGetMetaDataList": "/RatingStatus/GetMetaData",
  "ratingStatusGetAllDynamicCreate": "/RatingStatus/GetAllDynamic",
  "ratingStatusCreateCreate": "/RatingStatus/Create",
  "ratingStatusPatchPartialUpdate": "/RatingStatus/Patch/${id}",
  "ratingStatusDeleteDelete": "/RatingStatus/Delete/${id}",
  "ratingStoppedReasonGetMetaDataList": "/RatingStoppedReason/GetMetaData",
  "ratingStoppedReasonGetAllDynamicCreate": "/RatingStoppedReason/GetAllDynamic",
  "ratingStoppedReasonCreateCreate": "/RatingStoppedReason/Create",
  "ratingStoppedReasonPatchPartialUpdate": "/RatingStoppedReason/Patch/${id}",
  "ratingStoppedReasonDeleteDelete": "/RatingStoppedReason/Delete/${id}",
  "ratingSubjectGetMetaDataList": "/RatingSubject/GetMetaData",
  "ratingSubjectGetAllDynamicCreate": "/RatingSubject/GetAllDynamic",
  "ratingSubjectCreateCreate": "/RatingSubject/Create",
  "ratingSubjectPatchPartialUpdate": "/RatingSubject/Patch/${id}",
  "ratingSubjectDeleteDelete": "/RatingSubject/Delete/${id}",
  "ratingToolGetMetaDataList": "/RatingTool/GetMetaData",
  "ratingToolGetAllDynamicCreate": "/RatingTool/GetAllDynamic",
  "ratingToolCreateCreate": "/RatingTool/Create",
  "ratingToolPatchPartialUpdate": "/RatingTool/Patch/${id}",
  "ratingToolDeleteDelete": "/RatingTool/Delete/${id}",
  "reportGetMetaDataList": "/Report/GetMetaData",
  "reportGetAllDynamicCreate": "/Report/GetAllDynamic",
  "reportCreateCreate": "/Report/Create",
  "reportPatchPartialUpdate": "/Report/Patch/${id}",
  "reportDeleteDelete": "/Report/Delete/${id}",
  "reportCheckupTypeGetMetaDataList": "/ReportCheckupType/GetMetaData",
  "reportCheckupTypeGetAllDynamicCreate": "/ReportCheckupType/GetAllDynamic",
  "reportCheckupTypeCreateCreate": "/ReportCheckupType/Create",
  "reportCheckupTypePatchPartialUpdate": "/ReportCheckupType/Patch/${id}",
  "reportCheckupTypeDeleteDelete": "/ReportCheckupType/Delete/${id}",
  "reportPublicationOptionGetMetaDataList": "/ReportPublicationOption/GetMetaData",
  "reportPublicationOptionGetAllDynamicCreate": "/ReportPublicationOption/GetAllDynamic",
  "reportPublicationOptionCreateCreate": "/ReportPublicationOption/Create",
  "reportPublicationOptionPatchPartialUpdate": "/ReportPublicationOption/Patch/${id}",
  "reportPublicationOptionDeleteDelete": "/ReportPublicationOption/Delete/${id}",
  "reportSeriesGetMetaDataList": "/ReportSeries/GetMetaData",
  "reportSeriesGetAllDynamicCreate": "/ReportSeries/GetAllDynamic",
  "reportSeriesCreateCreate": "/ReportSeries/Create",
  "reportSeriesPatchPartialUpdate": "/ReportSeries/Patch/${id}",
  "reportSeriesDeleteDelete": "/ReportSeries/Delete/${id}",
  "sectorGetMetaDataList": "/Sector/GetMetaData",
  "sectorGetAllDynamicCreate": "/Sector/GetAllDynamic",
  "sectorCreateCreate": "/Sector/Create",
  "sectorPatchPartialUpdate": "/Sector/Patch/${id}",
  "sectorDeleteDelete": "/Sector/Delete/${id}",
  "securityPadsFullGetMetaDataList": "/SecurityPadsFull/GetMetaData",
  "securityPadsFullGetAllDynamicCreate": "/SecurityPadsFull/GetAllDynamic",
  "securityPadsFullCreateCreate": "/SecurityPadsFull/Create",
  "securityPadsFullPatchPartialUpdate": "/SecurityPadsFull/Patch/${id}",
  "securityPadsFullDeleteDelete": "/SecurityPadsFull/Delete/${id}",
  "seriesGetMetaDataList": "/Series/GetMetaData",
  "seriesGetAllDynamicCreate": "/Series/GetAllDynamic",
  "seriesCreateCreate": "/Series/Create",
  "seriesPatchPartialUpdate": "/Series/Patch/${id}",
  "seriesDeleteDelete": "/Series/Delete/${id}",
  "seriesClientInitiateRatingGetMetaDataList": "/SeriesClientInitiateRating/GetMetaData",
  "seriesClientInitiateRatingGetAllDynamicCreate": "/SeriesClientInitiateRating/GetAllDynamic",
  "seriesClientInitiateRatingCreateCreate": "/SeriesClientInitiateRating/Create",
  "seriesClientInitiateRatingPatchPartialUpdate": "/SeriesClientInitiateRating/Patch/${id}",
  "seriesClientInitiateRatingDeleteDelete": "/SeriesClientInitiateRating/Delete/${id}",
  "seriesClientPayRatingGetMetaDataList": "/SeriesClientPayRating/GetMetaData",
  "seriesClientPayRatingGetAllDynamicCreate": "/SeriesClientPayRating/GetAllDynamic",
  "seriesClientPayRatingCreateCreate": "/SeriesClientPayRating/Create",
  "seriesClientPayRatingPatchPartialUpdate": "/SeriesClientPayRating/Patch/${id}",
  "seriesClientPayRatingDeleteDelete": "/SeriesClientPayRating/Delete/${id}",
  "seriesDetailGetMetaDataList": "/SeriesDetail/GetMetaData",
  "seriesDetailGetAllDynamicCreate": "/SeriesDetail/GetAllDynamic",
  "seriesDetailCreateCreate": "/SeriesDetail/Create",
  "seriesDetailPatchPartialUpdate": "/SeriesDetail/Patch/${id}",
  "seriesDetailDeleteDelete": "/SeriesDetail/Delete/${id}",
  "signedOfficerStatementGetMetaDataList": "/SignedOfficerStatement/GetMetaData",
  "signedOfficerStatementGetAllDynamicCreate": "/SignedOfficerStatement/GetAllDynamic",
  "signedOfficerStatementCreateCreate": "/SignedOfficerStatement/Create",
  "signedOfficerStatementPatchPartialUpdate": "/SignedOfficerStatement/Patch/${id}",
  "signedOfficerStatementDeleteDelete": "/SignedOfficerStatement/Delete/${id}",
  "systemLogGetMetaDataList": "/SystemLog/GetMetaData",
  "systemLogGetAllDynamicCreate": "/SystemLog/GetAllDynamic",
  "systemLogCreateCreate": "/SystemLog/Create",
  "systemLogPatchPartialUpdate": "/SystemLog/Patch/${id}",
  "systemLogDeleteDelete": "/SystemLog/Delete/${id}",
  "systemReportGetAllCommitteeReportDynamicCreate": "/SystemReport/GetAllCommitteeReportDynamic",
  "systemReportGetAllRatedEntityReportDynamicCreate": "/SystemReport/GetAllRatedEntityReportDynamic",
  "systemReportGetAllComplianceOfficerReportDynamicCreate": "/SystemReport/GetAllComplianceOfficerReportDynamic",
  "systemReportGetAllRatingProcessReportDynamicCreate": "/SystemReport/GetAllRatingProcessReportDynamic",
  "systemReportGetAllCreditReviewReportDynamicCreate": "/SystemReport/GetAllCreditReviewReportDynamic",
  "systemReportGetAllSeriesReportDynamicCreate": "/SystemReport/GetAllSeriesReportDynamic",
  "systemReportGetAllRaisingCapitalReportDynamicCreate": "/SystemReport/GetAllRaisingCapitalReportDynamic",
  "systemReportGetAllPreliminaryRatingReportDynamicCreate": "/SystemReport/GetAllPreliminaryRatingReportDynamic",
  "systemReportGetAllTrainingReportDynamicCreate": "/SystemReport/GetAllTrainingReportDynamic",
  "systemReportGetAllMonitoringReportDynamicCreate": "/SystemReport/GetAllMonitoringReportDynamic",
  "systemReportGetAllOrderReportDynamicCreate": "/SystemReport/GetAllOrderReportDynamic",
  "systemReportGetAllFinanceForRatingProcessReportDynamicCreate": "/SystemReport/GetAllFinanceForRatingProcessReportDynamic",
  "systemReportGetAllFinanceForMonitoringReportDynamicCreate": "/SystemReport/GetAllFinanceForMonitoringReportDynamic",
  "systemReportGetAllMagnaReportDynamicCreate": "/SystemReport/GetAllMagnaReportDynamic",
  "systemReportGetAllRatingHistoryReportDynamicCreate": "/SystemReport/GetAllRatingHistoryReportDynamic",
  "systemReportGetAllCharacteristicsReportDynamicCreate": "/SystemReport/GetAllCharacteristicsReportDynamic",
  "trainingGetMetaDataList": "/Training/GetMetaData",
  "trainingGetAllDynamicCreate": "/Training/GetAllDynamic",
  "trainingCreateCreate": "/Training/Create",
  "trainingPatchPartialUpdate": "/Training/Patch/${id}",
  "trainingDeleteDelete": "/Training/Delete/${id}",
  "userCategoryVotingCertificationGetMetaDataList": "/UserCategoryVotingCertification/GetMetaData",
  "userCategoryVotingCertificationGetAllDynamicCreate": "/UserCategoryVotingCertification/GetAllDynamic",
  "userCategoryVotingCertificationCreateCreate": "/UserCategoryVotingCertification/Create",
  "userCategoryVotingCertificationPatchPartialUpdate": "/UserCategoryVotingCertification/Patch/${id}",
  "userCategoryVotingCertificationDeleteDelete": "/UserCategoryVotingCertification/Delete/${id}",
  "userCompanyConflictOfInterestGetMetaDataList": "/UserCompanyConflictOfInterest/GetMetaData",
  "userCompanyConflictOfInterestGetAllDynamicCreate": "/UserCompanyConflictOfInterest/GetAllDynamic",
  "userCompanyConflictOfInterestCreateCreate": "/UserCompanyConflictOfInterest/Create",
  "userCompanyConflictOfInterestPatchPartialUpdate": "/UserCompanyConflictOfInterest/Patch/${id}",
  "userCompanyConflictOfInterestDeleteDelete": "/UserCompanyConflictOfInterest/Delete/${id}",
  "userDepartmentVotingCertificationGetMetaDataList": "/UserDepartmentVotingCertification/GetMetaData",
  "userDepartmentVotingCertificationGetAllDynamicCreate": "/UserDepartmentVotingCertification/GetAllDynamic",
  "userDepartmentVotingCertificationCreateCreate": "/UserDepartmentVotingCertification/Create",
  "userDepartmentVotingCertificationPatchPartialUpdate": "/UserDepartmentVotingCertification/Patch/${id}",
  "userDepartmentVotingCertificationDeleteDelete": "/UserDepartmentVotingCertification/Delete/${id}",
  "userDetailGetMetaDataList": "/UserDetail/GetMetaData",
  "userDetailGetAllDynamicCreate": "/UserDetail/GetAllDynamic",
  "userDetailCreateCreate": "/UserDetail/Create",
  "userDetailPatchPartialUpdate": "/UserDetail/Patch/${id}",
  "userDetailDeleteDelete": "/UserDetail/Delete/${id}",
  "userPositionGetMetaDataList": "/UserPosition/GetMetaData",
  "userPositionGetAllDynamicCreate": "/UserPosition/GetAllDynamic",
  "userPositionCreateCreate": "/UserPosition/Create",
  "userPositionPatchPartialUpdate": "/UserPosition/Patch/${id}",
  "userPositionDeleteDelete": "/UserPosition/Delete/${id}",
  "userTrainingGetMetaDataList": "/UserTraining/GetMetaData",
  "userTrainingGetAllDynamicCreate": "/UserTraining/GetAllDynamic",
  "userTrainingCreateCreate": "/UserTraining/Create",
  "userTrainingPatchPartialUpdate": "/UserTraining/Patch/${id}",
  "userTrainingDeleteDelete": "/UserTraining/Delete/${id}"
} as const;
export type ApiPaths = typeof apiPaths;
